import { makeStyles, mergeClasses, Input, tokens, Toolbar, ToolbarButton, ToolbarDivider, Menu, MenuTrigger, MenuPopover, MenuList, MenuItemRadio, Button, createLightTheme, createDarkTheme, makeStaticStyles, MessageBar, MessageBarBody, Dropdown, Option, Spinner, Field, Textarea, Switch, Checkbox, Label, TabList, Tab, Tooltip, Dialog, DialogSurface, DialogBody, DialogTitle, DialogContent, DialogActions, RadioGroup, Radio, useId as useId$1, Text, Overflow, OverflowItem, SearchBox, CounterBadge, Popover, PopoverTrigger, PopoverSurface, MenuItem, Combobox, TagPicker, TagPickerControl, TagPickerGroup, Tag, TagPickerInput, TagPickerList, TagPickerOption, webDarkTheme, webLightTheme, teamsDarkTheme, teamsLightTheme, FluentProvider, Avatar, Divider, OverlayDrawer, DrawerHeader, DrawerHeaderTitle, DrawerBody, useOverflowMenu, useIsOverflowItemVisible, Title3, Table, TableHeader, TableRow, TableHeaderCell, TableBody, TableCell, MessageBarTitle, DialogTrigger } from '@fluentui/react-components';
import { MaskMode, useMaskedTextField, useT, usePowerPortalsPro, useRecordContext, useColumnMetadata, useLocale, MainContext, useTableMetadata, useWarnAboutUnsavedChanges, useMainContext, useViewsForTable, useViewMetadata, QueryStatus, useGridData, RecordContext, DialogServiceProvider, useUrlCultureStrategy, useDefaultLocale, useSupportedLocales, setAspNetCultureCookie, buildLocalePath, useAuth, AuthStatus, useOverlayServiceState, OverlayServiceProvider, useOverlayForTarget, useLocalization, useLocalizationLoaded, useValidationContext, useDialogService, useRunWithOverlay, useRecordContextOptional, useOrganizationSettings, useUnsavedChangesGuard, useColumnValidationErrors } from '@powerportalspro/react';
import { forwardRef, useRef, useImperativeHandle, useState, useEffect, useCallback, createContext, useMemo, useId, useLayoutEffect, useContext, useTransition, Children, isValidElement } from 'react';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { ArrowRotateCounterclockwise20Regular, ArrowRotateClockwise20Regular, FlipHorizontal20Regular, FlipVertical20Regular, ZoomIn20Regular, ZoomOut20Regular, ArrowReset20Regular, ChevronDown16Regular, Grid20Regular, Crop20Regular, FullScreenMinimize20Regular, FullScreenMaximize20Regular, ArrowDownload20Regular, Prohibited20Regular, Checkmark20Filled, ArrowDownload24Regular, ArrowClockwise24Regular, ChevronUp12Regular, ChevronDown12Regular, DocumentArrowLeft24Regular, ChevronDown20Regular, ChevronRight20Regular, Folder20Regular, Document20Regular, ErrorCircle20Regular, Eye20Regular, Dismiss20Regular, Edit20Regular, Add16Regular, Edit16Regular, LinkAdd16Regular, LinkDismiss16Regular, Delete16Regular, Settings20Regular, Search20Regular, ArrowClockwise20Regular, ArrowSortDown16Regular, ArrowSortUp16Regular, Dismiss24Regular, LinkAdd20Regular, QuestionCircle24Regular, Info24Regular, DismissCircle24Regular, Warning24Regular, CheckmarkCircle24Regular, ArrowExit20Regular, PersonEdit20Regular, ArrowSwap20Regular, SignOut20Regular, MoreVerticalRegular, ArrowSyncRegular, ArrowDownloadRegular, Save24Regular, Delete24Regular, Add20Regular, Delete20Regular, LinkDismiss20Regular, ArrowUpload32Regular, ArrowUpload24Regular, ArrowSync24Regular, DrawerArrowDownload24Regular, Money20Regular, ErrorCircle12Filled, MoreHorizontal20Regular, ChevronDoubleLeft20Regular, ChevronLeft20Regular, ChevronDoubleRight20Regular, Info12Regular, Checkmark16Regular, Dismiss16Regular, DocumentText20Regular, FolderZip20Regular, MusicNote220Regular, Video20Regular, Image20Regular, SlideText20Regular, DocumentTable20Regular, DocumentPdf20Regular } from '@fluentui/react-icons';
import { RequiredLevel, DateTimeBehavior, getRecordReferenceId, RelationshipFilterMode, SwitchIdentityResult, TableSecurityPermission } from '@powerportalspro/core';
import { DatePicker } from '@fluentui/react-datepicker-compat';
import { TimePicker } from '@fluentui/react-timepicker-compat';
import { unzipSync } from 'fflate';
import Markdown from 'react-markdown';
import hljs from 'highlight.js/lib/core';
import csharp from 'highlight.js/lib/languages/csharp';
import css from 'highlight.js/lib/languages/css';
import javascript from 'highlight.js/lib/languages/javascript';
import json from 'highlight.js/lib/languages/json';
import markdown from 'highlight.js/lib/languages/markdown';
import typescript from 'highlight.js/lib/languages/typescript';
import xml from 'highlight.js/lib/languages/xml';
import yaml from 'highlight.js/lib/languages/yaml';
import { createColumnHelper, useReactTable, getCoreRowModel } from '@tanstack/react-table';
import { Nav, NavCategory, NavCategoryItem, NavSubItemGroup, NavSubItem } from '@fluentui/react-nav';
import { useLocation, useNavigate, useBlocker } from 'react-router-dom';
import { useWizard, Wizard } from 'react-use-wizard';
import { ChartType, AggregateDataverseChartDataSource, ViewDataverseChartDataSource, Chart, DataverseChartDataSource, toIndexAxis } from '@powerportalspro/react-charts';

// src/edits/base/masked-text-field.tsx
var useMaskedTextFieldStyles = makeStyles({
  alignLeft: { "& input": { textAlign: "left" } },
  alignRight: { "& input": { textAlign: "right" } },
  alignCenter: { "& input": { textAlign: "center" } }
});
function defined(obj) {
  const result = {};
  for (const k of Object.keys(obj)) {
    const v = obj[k];
    if (v !== void 0) result[k] = v;
  }
  return result;
}
var MaskedTextField = forwardRef(
  function MaskedTextField2(props, ref) {
    const {
      value,
      onValueChange,
      onFocus,
      onBlur,
      mode = MaskMode.None,
      pattern = null,
      allowedPattern = null,
      numeric = null,
      valueIncludesMask = false,
      immediate = false,
      id,
      size,
      appearance,
      type = "text",
      placeholder,
      disabled,
      readOnly,
      maxLength,
      autoComplete,
      inputMode,
      ariaLabel,
      textAlign,
      contentBefore,
      contentAfter,
      className,
      style
    } = props;
    const useHookPath = mode !== MaskMode.None || immediate;
    const alignStyles = useMaskedTextFieldStyles();
    const inputAlignClass = textAlign === "right" ? alignStyles.alignRight : textAlign === "center" ? alignStyles.alignCenter : textAlign === "left" ? alignStyles.alignLeft : void 0;
    const elementRef = useRef(null);
    const {
      displayValue,
      onChange: hookOnChange,
      inputRef: hookInputRef,
      forceValue: hookForceValue
    } = useMaskedTextField({
      value,
      onValueChange,
      mode,
      pattern,
      allowedPattern,
      numeric,
      valueIncludesMask
    });
    const fastForceValue = (next) => {
      onValueChange(next);
    };
    useImperativeHandle(
      ref,
      () => ({
        forceValue: useHookPath ? hookForceValue : fastForceValue,
        focus: () => elementRef.current?.focus(),
        blur: () => elementRef.current?.blur()
      }),
      [useHookPath, hookForceValue, onValueChange]
    );
    const composedInputRef = (el) => {
      elementRef.current = el;
      if (useHookPath) {
        hookInputRef(el);
      }
    };
    const rootClassName = mergeClasses(className, inputAlignClass);
    const commonInputProps = defined({
      id,
      className: rootClassName === "" ? void 0 : rootClassName,
      style,
      size,
      appearance,
      type,
      placeholder,
      maxLength,
      readOnly,
      disabled,
      autoComplete,
      inputMode
    });
    if (!useHookPath) {
      return /* @__PURE__ */ jsx(
        Input,
        {
          ...commonInputProps,
          value: value ?? "",
          contentBefore: contentBefore ?? null,
          contentAfter: contentAfter ?? null,
          input: {
            "aria-label": ariaLabel,
            ref: composedInputRef
          },
          onChange: (_, data) => onValueChange(data.value === "" ? null : data.value),
          ...onFocus && { onFocus: () => onFocus() },
          ...onBlur && { onBlur: () => onBlur(value ?? null) }
        }
      );
    }
    return /* @__PURE__ */ jsx(
      Input,
      {
        ...commonInputProps,
        value: displayValue,
        onChange: hookOnChange,
        contentBefore: contentBefore ?? null,
        contentAfter: contentAfter ?? null,
        input: { "aria-label": ariaLabel, ref: composedInputRef },
        ...onFocus && { onFocus: () => onFocus() },
        ...onBlur && { onBlur: () => onBlur(value ?? null) }
      }
    );
  }
);

// src/edits/base/column-edit-types.ts
var DescriptionLocation = {
  None: "none",
  Tooltip: "tooltip",
  BelowControl: "belowControl"
};
var HOVER_OPEN_DELAY_MS = 500;
var HOVER_CLOSE_DELAY_MS = 200;
var useStyles = makeStyles({
  // Plain <button> rather than Fluent's `Button` — Fluent's size variants
  // impose a 24px+ min-height frame that overwhelms a small inline icon.
  // A naked button gives us a tight bounding box around just the SVG.
  trigger: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "12px",
    height: "12px",
    padding: 0,
    marginLeft: tokens.spacingHorizontalXS,
    verticalAlign: "middle",
    border: "none",
    background: "transparent",
    color: tokens.colorBrandForeground1,
    cursor: "pointer",
    borderRadius: tokens.borderRadiusSmall,
    lineHeight: 0,
    fontSize: 0,
    ":hover": {
      color: tokens.colorBrandForeground2Hover
    },
    ":focus-visible": {
      outlineStyle: "solid",
      outlineWidth: "1px",
      outlineColor: tokens.colorStrokeFocus2,
      outlineOffset: "1px"
    }
  },
  // Pin font-size on the icon — Fluent's react-icons render at `1em`, so
  // without this they pick up the surrounding label's text size.
  icon: {
    fontSize: "12px",
    width: "12px",
    height: "12px",
    display: "block"
  },
  surface: {
    maxWidth: "320px",
    whiteSpace: "pre-wrap"
  }
});
function DescriptionIcon({ description, ariaLabel }) {
  const styles = useStyles();
  const [open, setOpen] = useState(false);
  const openTimerRef = useRef(void 0);
  const lastInteractionRef = useRef("hover");
  const clearOpenTimer = useCallback(() => {
    if (openTimerRef.current !== void 0) {
      window.clearTimeout(openTimerRef.current);
      openTimerRef.current = void 0;
    }
  }, []);
  useEffect(() => () => clearOpenTimer(), [clearOpenTimer]);
  return /* @__PURE__ */ jsx(
    "span",
    {
      onClick: (e) => e.stopPropagation(),
      onMouseDown: (e) => {
        lastInteractionRef.current = "click";
        e.stopPropagation();
      },
      onPointerEnter: () => {
        lastInteractionRef.current = "hover";
      },
      children: /* @__PURE__ */ jsxs(
        Popover,
        {
          withArrow: true,
          openOnHover: true,
          mouseLeaveDelay: HOVER_CLOSE_DELAY_MS,
          open,
          onOpenChange: (_, data) => {
            if (data.open === false) {
              clearOpenTimer();
              setOpen(false);
              return;
            }
            if (lastInteractionRef.current === "click") {
              clearOpenTimer();
              setOpen(true);
              return;
            }
            if (openTimerRef.current !== void 0) return;
            openTimerRef.current = window.setTimeout(() => {
              openTimerRef.current = void 0;
              setOpen(true);
            }, HOVER_OPEN_DELAY_MS);
          },
          children: [
            /* @__PURE__ */ jsx(PopoverTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                tabIndex: -1,
                className: styles.trigger,
                "aria-label": ariaLabel ? `Show description for ${ariaLabel}` : "Show description",
                children: /* @__PURE__ */ jsx(Info12Regular, { className: styles.icon })
              }
            ) }),
            /* @__PURE__ */ jsx(PopoverSurface, { className: styles.surface, children: description })
          ]
        }
      )
    }
  );
}
function isMetadataRequired(metadata) {
  if (!metadata) return false;
  return metadata.requiredLevel === RequiredLevel.SystemRequired || metadata.requiredLevel === RequiredLevel.ApplicationRequired;
}
function isMetadataReadOnly(metadata, isNewRecord2) {
  if (!metadata) return false;
  const typeCode = metadata.$type;
  if (typeCode === 41 || typeCode === 42) return false;
  return isNewRecord2 ? !metadata.isValidForCreate : !metadata.isValidForUpdate;
}
function isNewRecord(record) {
  if (!record) return true;
  if (!record.id || record.id === "00000000-0000-0000-0000-000000000000") return true;
  return record.permissions === void 0;
}
function isRecordWriteDenied(record) {
  if (!record) return false;
  if (isNewRecord(record)) return false;
  const perms = record.permissions ?? 0;
  return (perms & TableSecurityPermission.Write) === 0;
}
function resolveEditState(metadata, record, explicitReadOnly, explicitDisabled) {
  if (isRecordWriteDenied(record)) {
    return { readOnly: true, disabled: true };
  }
  return {
    readOnly: explicitReadOnly ?? isMetadataReadOnly(metadata, isNewRecord(record)),
    disabled: explicitDisabled ?? false
  };
}
function getDisplayLabel(metadata, columnName, tableName, t) {
  if (tableName) {
    return t(`tables.${tableName}.columns.${columnName}.label`);
  }
  return metadata?.displayName || columnName;
}
function getDisplayDescription(metadata, columnName, tableName, t) {
  if (tableName) {
    const key = `tables.${tableName}.columns.${columnName}.description`;
    const resolved = t(key);
    return resolved !== key ? resolved : void 0;
  }
  return metadata?.description ?? void 0;
}
function getStringMaxLength(metadata) {
  if (!metadata) return void 0;
  const m = metadata;
  if (m.maxLength === void 0 || m.maxLength === null) return void 0;
  return Number(m.maxLength);
}
function getChoiceMetadata(metadata) {
  if (!metadata) return void 0;
  const m = metadata;
  if (m.$type !== 11 && m.$type !== 40) return void 0;
  if (m.choiceLogicalName === void 0 || m.choices === void 0) return void 0;
  return {
    choiceLogicalName: m.choiceLogicalName,
    isGlobal: m.isGlobal ?? false,
    choices: m.choices.map((c) => ({
      value: Number(c.value),
      displayName: c.displayName
    }))
  };
}
function getLookupMetadata(metadata) {
  if (!metadata) return void 0;
  const m = metadata;
  if (m.$type !== 6) return void 0;
  if (!m.targetTables || m.targetTables.length === 0) return void 0;
  return { targetTables: m.targetTables };
}
function getNumberLimits(metadata) {
  if (!metadata) return {};
  const m = metadata;
  const result = {};
  if (m.min !== void 0) result.min = Number(m.min);
  if (m.max !== void 0) result.max = Number(m.max);
  if (m.precision !== void 0) result.precision = Number(m.precision);
  return result;
}
function resolveNumberValueType(metadata) {
  const t = metadata?.$type;
  switch (t) {
    case 3:
      return "decimal";
    case 4:
      return "double";
    case 5:
      return "int";
    case 18:
      return "bigint";
    default:
      return void 0;
  }
}
function buildFieldValidationProps(errors, displayValidationErrorMessage) {
  const firstError = displayValidationErrorMessage && errors && errors.length > 0 ? errors[0] : void 0;
  if (!firstError) return {};
  return {
    validationState: "error",
    validationMessage: firstError,
    validationMessageIcon: /* @__PURE__ */ jsx(ErrorCircle12Filled, {})
  };
}
function defaultBuiltInErrors(state, localizer) {
  const errors = [];
  const labelText = state.label ?? "";
  if (state.required) {
    const v = state.value;
    const isEmpty = v === null || v === void 0 || typeof v === "string" && v.trim() === "" || Array.isArray(v) && v.length === 0;
    if (isEmpty) {
      errors.push(localizer.t("app.messages.column-required", [labelText]));
      return errors;
    }
  }
  switch (state.kind) {
    case "string": {
      const v = state.value;
      if (typeof v !== "string") break;
      if (state.maxLength !== void 0 && v.length > state.maxLength) {
        errors.push(localizer.t("app.messages.column-max-length", [state.maxLength]));
      }
      if (state.minLength !== void 0 && v.length < state.minLength) {
        errors.push(localizer.t("app.messages.column-min-length", [state.minLength]));
      }
      break;
    }
    case "number": {
      const v = state.value;
      if (typeof v !== "number" || !Number.isFinite(v)) break;
      if (state.max !== void 0 && v > state.max) {
        errors.push(localizer.t("app.messages.column-max-value", [state.max]));
      }
      if (state.min !== void 0 && v < state.min) {
        errors.push(localizer.t("app.messages.column-min-value", [state.min]));
      }
      break;
    }
    case "array": {
      const v = state.value;
      if (!Array.isArray(v)) break;
      if (state.maxCount !== void 0 && v.length > state.maxCount) {
        errors.push(localizer.t("app.errors.value-max-count", [state.maxCount]));
      }
      if (state.minCount !== void 0 && v.length < state.minCount) {
        errors.push(localizer.t("app.errors.value-min-count", [state.minCount]));
      }
      break;
    }
  }
  return errors;
}
function useColumnValidation(columnName, state, customValidator) {
  const validation = useValidationContext();
  const errors = useColumnValidationErrors(columnName);
  const t = useT();
  const stateRef = useRef(state);
  stateRef.current = state;
  const customValidatorRef = useRef(customValidator);
  customValidatorRef.current = customValidator;
  const localizerRef = useRef({ t });
  localizerRef.current = { t };
  const validationRef = useRef(validation);
  validationRef.current = validation;
  useEffect(() => {
    const v = validationRef.current;
    if (!v) return;
    const validator = async () => {
      const current = stateRef.current;
      const errs = defaultBuiltInErrors(current, localizerRef.current);
      if (customValidatorRef.current) {
        const custom = await customValidatorRef.current();
        return [...errs, ...custom];
      }
      return errs;
    };
    return v.register(columnName, validator);
  }, [columnName]);
  const touchedRef = useRef(false);
  const lastValueJsonRef = useRef(JSON.stringify(state.value));
  useEffect(() => {
    const v = validationRef.current;
    if (!v) return;
    const currentValueJson = JSON.stringify(state.value);
    if (currentValueJson !== lastValueJsonRef.current) {
      lastValueJsonRef.current = currentValueJson;
      touchedRef.current = true;
    }
    if (!touchedRef.current) return;
    void v.validateColumn(columnName);
  }, [columnName, JSON.stringify(state)]);
  return errors;
}
function useGuardedSetValue(rawSetValue, readOnly, disabled) {
  return useCallback(
    (next) => {
      if (readOnly || disabled) return;
      rawSetValue(next);
    },
    [rawSetValue, readOnly, disabled]
  );
}
function useStringColumn(columnName) {
  const ctx = useRecordContext();
  const raw = ctx.record?.properties?.[columnName];
  const value = raw?.value ?? void 0;
  const setValue = useCallback(
    (next) => {
      if (next === null || next === void 0) {
        ctx.setColumnValue(columnName, null);
      } else {
        ctx.setColumnValue(columnName, { $type: 14, value: next });
      }
    },
    [columnName, ctx]
  );
  return { value, setValue };
}
function useBoolColumn(columnName) {
  const ctx = useRecordContext();
  const raw = ctx.record?.properties?.[columnName];
  const value = raw?.value ?? void 0;
  const setValue = useCallback(
    (next) => {
      if (next === null || next === void 0) {
        ctx.setColumnValue(columnName, null);
      } else {
        ctx.setColumnValue(columnName, { $type: 0, value: next });
      }
    },
    [columnName, ctx]
  );
  return { value, setValue };
}
function useNumberColumn(columnName, valueType = "int") {
  const ctx = useRecordContext();
  const raw = ctx.record?.properties?.[columnName];
  const rawValue = raw?.value;
  const value = rawValue === void 0 || rawValue === null ? void 0 : Number(rawValue);
  const setValue = useCallback(
    (next) => {
      if (next === null || next === void 0) {
        ctx.setColumnValue(columnName, null);
        return;
      }
      const wireValue = valueType === "int" ? { $type: 5, value: next } : valueType === "decimal" ? { $type: 3, value: next } : valueType === "double" ? { $type: 4, value: next } : { $type: 18, value: next };
      ctx.setColumnValue(columnName, wireValue);
    },
    [columnName, ctx, valueType]
  );
  return { value, setValue };
}
function useChoiceColumn(columnName) {
  const ctx = useRecordContext();
  const raw = ctx.record?.properties?.[columnName];
  const rawValue = raw?.value;
  const value = rawValue === void 0 || rawValue === null ? void 0 : Number(rawValue);
  const setValue = useCallback(
    (next) => {
      if (next === null || next === void 0) {
        ctx.setColumnValue(columnName, null);
      } else {
        ctx.setColumnValue(columnName, { $type: 11, value: next });
      }
    },
    [columnName, ctx]
  );
  return { value, setValue };
}
function useMultiSelectChoiceColumn(columnName) {
  const ctx = useRecordContext();
  const raw = ctx.record?.properties?.[columnName];
  const value = (raw?.value ?? []).map((c) => Number(c.value));
  const setValue = useCallback(
    (next) => {
      if (next === null || next === void 0 || next.length === 0) {
        ctx.setColumnValue(columnName, null);
      } else {
        ctx.setColumnValue(columnName, {
          $type: 40,
          value: next.map((v) => ({ value: v }))
        });
      }
    },
    [columnName, ctx]
  );
  return { value, setValue };
}
function useLookupColumn(columnName) {
  const ctx = useRecordContext();
  const raw = ctx.record?.properties?.[columnName];
  let value;
  if (raw?.value && raw.value !== "00000000-0000-0000-0000-000000000000") {
    value = {
      id: raw.value,
      name: raw.name ?? null,
      tableName: raw.tableName
    };
  }
  const setValue = useCallback(
    (next) => {
      if (next === null || next === void 0) {
        ctx.setColumnValue(columnName, null);
      } else {
        ctx.setColumnValue(columnName, {
          $type: 6,
          value: next.id,
          name: next.name,
          tableName: next.tableName
        });
      }
    },
    [columnName, ctx]
  );
  return { value, setValue };
}
function useMoneyColumn(columnName) {
  const ctx = useRecordContext();
  const raw = ctx.record?.properties?.[columnName];
  const rawValue = raw?.value;
  const value = rawValue === void 0 || rawValue === null ? void 0 : Number(rawValue);
  const setValue = useCallback(
    (next) => {
      if (next === null || next === void 0) {
        ctx.setColumnValue(columnName, null);
      } else {
        ctx.setColumnValue(columnName, { $type: 8, value: next });
      }
    },
    [columnName, ctx]
  );
  return { value, setValue };
}
function useDateColumn(columnName) {
  const ctx = useRecordContext();
  const raw = ctx.record?.properties?.[columnName];
  const value = raw?.value ?? void 0;
  const setValue = useCallback(
    (next) => {
      if (next === null || next === void 0) {
        ctx.setColumnValue(columnName, null);
      } else {
        ctx.setColumnValue(columnName, { $type: 2, value: next });
      }
    },
    [columnName, ctx]
  );
  return { value, setValue };
}
function useFileColumn(columnName) {
  const ctx = useRecordContext();
  const properties = ctx.record?.properties;
  const dataColumn = properties?.[columnName];
  const dataColumnType = dataColumn?.$type;
  let value;
  let fileId;
  if (dataColumnType === "FileValue") {
    const fv = dataColumn;
    value = fv;
    if (fv.id && fv.id !== "00000000-0000-0000-0000-000000000000") {
      fileId = fv.id;
    }
  } else if (dataColumnType === 15) {
    const guidValue = dataColumn;
    if (guidValue.value && guidValue.value !== "00000000-0000-0000-0000-000000000000") {
      const nameColumn = properties?.[`${columnName}_name`];
      value = {
        fileName: nameColumn?.value ?? "",
        id: guidValue.value,
        value: null
      };
      fileId = guidValue.value;
    }
  } else {
    const idColumn = properties?.[`${columnName}id`];
    if (idColumn?.value && idColumn.value !== "00000000-0000-0000-0000-000000000000") {
      fileId = idColumn.value;
    }
  }
  const setValue = useCallback(
    (next) => {
      if (next === null || next === void 0) {
        ctx.setColumnValue(columnName, null);
      } else {
        ctx.setColumnValue(columnName, {
          $type: "FileValue",
          fileName: next.fileName,
          id: next.id,
          value: next.value ?? null
        });
      }
    },
    [columnName, ctx]
  );
  const hydrateValue = useCallback(
    (next) => {
      if (next === null) {
        ctx.hydrateColumnValue(columnName, null);
      } else {
        ctx.hydrateColumnValue(columnName, {
          $type: "FileValue",
          fileName: next.fileName,
          id: next.id,
          value: next.value ?? null
        });
      }
    },
    [columnName, ctx]
  );
  return { value, setValue, fileId, hydrateValue };
}
function TextEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  type = "text",
  minLength,
  maxLength,
  autoComplete,
  placeholder,
  mask = MaskMode.None,
  pattern,
  allowedPattern,
  numeric,
  storeMaskedValue = false,
  immediate = false,
  validate
}) {
  const { value, setValue: rawSetValue } = useStringColumn(columnName);
  const { record } = useRecordContext();
  const metadata = useColumnMetadata(columnName);
  const t = useT();
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = description ?? getDisplayDescription(metadata, columnName, record?.tableName, t);
  const resolvedMaxLength = maxLength ?? getStringMaxLength(metadata);
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled
  );
  const setValue = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const validationErrors = useColumnValidation(
    columnName,
    {
      kind: "string",
      required: resolvedRequired,
      label: resolvedLabel,
      value: value ?? "",
      ...minLength !== void 0 && { minLength },
      ...resolvedMaxLength !== void 0 && { maxLength: resolvedMaxLength }
    },
    validate
  );
  if (!isVisible) return null;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  const fieldValidationProps = buildFieldValidationProps(
    validationErrors,
    displayValidationErrorMessage
  );
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: mergeClasses("ppp-text-edit"),
      label: labelSlot,
      hint: fieldHint,
      required: resolvedRequired,
      ...fieldValidationProps,
      children: /* @__PURE__ */ jsx(
        MaskedTextField,
        {
          id,
          className,
          style,
          type,
          value,
          onValueChange: (next) => setValue(next),
          ...maxLength !== void 0 && { maxLength: resolvedMaxLength },
          readOnly: resolvedReadOnly,
          disabled: resolvedDisabled,
          placeholder,
          autoComplete: autoComplete ? "on" : "off",
          mode: mask,
          pattern,
          allowedPattern,
          numeric,
          valueIncludesMask: storeMaskedValue,
          immediate
        }
      )
    }
  );
}
function MemoEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  minLength,
  maxLength,
  rows = 3,
  placeholder,
  resize = "vertical",
  validate
}) {
  const { value, setValue: rawSetValue } = useStringColumn(columnName);
  const { record } = useRecordContext();
  const metadata = useColumnMetadata(columnName);
  const t = useT();
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = description ?? getDisplayDescription(metadata, columnName, record?.tableName, t);
  const resolvedMaxLength = maxLength ?? getStringMaxLength(metadata);
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled
  );
  const setValue = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const validationErrors = useColumnValidation(
    columnName,
    {
      kind: "string",
      required: resolvedRequired,
      label: resolvedLabel,
      value: value ?? "",
      ...minLength !== void 0 && { minLength },
      ...resolvedMaxLength !== void 0 && { maxLength: resolvedMaxLength }
    },
    validate
  );
  if (!isVisible) return null;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  const fieldValidationProps = buildFieldValidationProps(
    validationErrors,
    displayValidationErrorMessage
  );
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: mergeClasses("ppp-memo-edit"),
      label: labelSlot,
      hint: fieldHint,
      required: resolvedRequired,
      ...fieldValidationProps,
      children: /* @__PURE__ */ jsx(
        Textarea,
        {
          id,
          className,
          style,
          value: value ?? "",
          rows,
          minLength,
          maxLength: resolvedMaxLength,
          disabled: resolvedDisabled || resolvedReadOnly,
          placeholder,
          resize,
          onChange: (_, data) => {
            setValue(data.value === "" ? null : data.value);
          }
        }
      )
    }
  );
}
var BoolEditorType = {
  Checkbox: "checkbox",
  Switch: "switch"
};
var LabelPosition = {
  /** Label rendered next to the control via Fluent's built-in `label` prop on Checkbox/Switch. */
  Inline: "inline",
  /** Label rendered above the control via a wrapping {@link Field}. */
  Default: "default"
};
var useStyles2 = makeStyles({
  // Inline layout for `LabelPosition.Inline` mode: Checkbox/Switch indicator
  // and the external label sit side-by-side.
  // `ppp-bool-edit-inline` div pattern. Gap matches FluentUI's own internal
  // checkbox-to-label spacing so a swap to / from inline-label mode doesn't
  // visibly shift positions.
  inlineWrapper: {
    display: "inline-flex",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS
  },
  // Pointer cursor on the label — signals to the user that the label is
  // clickable (matching the native browser behavior of clicking a
  // `<label htmlFor=...>` to toggle its associated input). Applied to
  // both the inline external label AND the Field-mode label above the
  // control so the cursor hint is consistent across LabelPosition modes.
  clickableLabel: {
    cursor: "pointer"
  }
});
function BoolEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  editorType = BoolEditorType.Checkbox,
  labelPosition = LabelPosition.Inline,
  validate
}) {
  const { value, setValue: rawSetValue } = useBoolColumn(columnName);
  const { record } = useRecordContext();
  const metadata = useColumnMetadata(columnName);
  const t = useT();
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled
  );
  const setValue = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const isInactive = resolvedDisabled || resolvedReadOnly;
  const styles = useStyles2();
  const generatedId = useId();
  const inputId = id ?? generatedId;
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = description ?? getDisplayDescription(metadata, columnName, record?.tableName, t);
  const showLabel = displayLabelWhenAvailable;
  const validationErrors = useColumnValidation(
    columnName,
    {
      kind: "bool",
      required: resolvedRequired,
      label: resolvedLabel,
      value: value ?? null
    },
    validate
  );
  if (!isVisible) return null;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelChildren = /* @__PURE__ */ jsxs(Fragment, { children: [
    resolvedLabel,
    showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
  ] });
  const fieldValidationProps = buildFieldValidationProps(
    validationErrors,
    displayValidationErrorMessage
  );
  const hasError = "validationState" in fieldValidationProps;
  const needsFieldWrapper = labelPosition === LabelPosition.Default || descriptionLocation === DescriptionLocation.BelowControl || hasError;
  const showInlineLabel = showLabel && labelPosition === LabelPosition.Inline;
  const controlClassName = needsFieldWrapper || showInlineLabel ? className : mergeClasses("ppp-bool-edit", className);
  const control = editorType === BoolEditorType.Switch ? /* @__PURE__ */ jsx(
    Switch,
    {
      id: inputId,
      className: controlClassName,
      style,
      checked: value ?? false,
      disabled: isInactive,
      required: resolvedRequired,
      onChange: (_, data) => setValue(data.checked === true)
    }
  ) : /* @__PURE__ */ jsx(
    Checkbox,
    {
      id: inputId,
      className: controlClassName,
      style,
      checked: value == null ? "mixed" : value,
      disabled: isInactive,
      required: resolvedRequired,
      onChange: () => {
        if (value === null || value === void 0) {
          setValue(false);
        } else if (value === false) {
          setValue(true);
        } else {
          setValue(null);
        }
      }
    }
  );
  const inlineLabelEl = /* @__PURE__ */ jsx(
    Label,
    {
      htmlFor: inputId,
      disabled: isInactive,
      required: resolvedRequired,
      className: styles.clickableLabel,
      children: labelChildren
    }
  );
  if (needsFieldWrapper) {
    const fieldLabelSlot = showLabel && labelPosition === LabelPosition.Default ? { children: labelChildren, htmlFor: inputId, className: styles.clickableLabel } : null;
    const fieldBody = showInlineLabel ? /* @__PURE__ */ jsxs("div", { className: styles.inlineWrapper, children: [
      control,
      inlineLabelEl
    ] }) : control;
    return /* @__PURE__ */ jsx(
      Field,
      {
        className: mergeClasses("ppp-bool-edit"),
        label: fieldLabelSlot,
        hint: fieldHint,
        required: resolvedRequired,
        ...fieldValidationProps,
        children: fieldBody
      }
    );
  }
  if (showInlineLabel) {
    return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-bool-edit", styles.inlineWrapper), children: [
      control,
      inlineLabelEl
    ] });
  }
  return control;
}
var useNumberEditStyles = makeStyles({
  // Stack of two chevron buttons rendered in the input's `contentAfter` slot.
  // Mirrors markup — same compact dual-button
  // layout that aligns with the input's vertical center.
  spinner: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "center",
    height: "100%",
    // Tighten the gap between up/down so the two buttons read as one control.
    rowGap: "1px"
  },
  spinnerButton: {
    // Compact buttons — same visual footprint as.
    // `minWidth: 0` overrides Fluent's default Button width so we can shrink
    // to the icon's natural size.
    minWidth: 0,
    width: "18px",
    height: "14px",
    padding: 0,
    borderRadius: tokens.borderRadiusSmall,
    // Lift the icon's stroke weight to match
    // default button color is too pale against the input chrome.
    color: tokens.colorNeutralForeground2,
    ":hover": {
      color: tokens.colorNeutralForeground1
    },
    ":disabled": {
      color: tokens.colorNeutralForegroundDisabled
    }
  }
});
function NumberEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  valueType,
  min,
  max,
  precision,
  hideStep = false,
  format: _format,
  step = 1,
  placeholder,
  validate
}) {
  const { record } = useRecordContext();
  const metadata = useColumnMetadata(columnName);
  const resolvedValueType = valueType ?? resolveNumberValueType(metadata) ?? "int";
  const { value, setValue: rawSetValue } = useNumberColumn(columnName, resolvedValueType);
  const styles = useNumberEditStyles();
  const t = useT();
  const limits = getNumberLimits(metadata);
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = description ?? getDisplayDescription(metadata, columnName, record?.tableName, t);
  const resolvedMin = min ?? limits.min;
  const resolvedMax = max ?? limits.max;
  const resolvedPrecision = precision ?? limits.precision;
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled
  );
  const setValue = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const validationErrors = useColumnValidation(
    columnName,
    {
      kind: "number",
      required: resolvedRequired,
      label: resolvedLabel,
      value: value ?? null,
      ...resolvedMin !== void 0 && { min: resolvedMin },
      ...resolvedMax !== void 0 && { max: resolvedMax }
    },
    validate
  );
  const numericOptions = useMemo(
    () => ({
      decimalSeparator: ".",
      groupSeparator: ",",
      // Negatives are allowed unless the metadata pins min ≥ 0. When `min`
      // is undefined we err on the permissive side so int columns without
      // an explicit floor still accept e.g. `-100`.
      allowNegative: resolvedMin === void 0 || resolvedMin < 0,
      // `int` / `bigint` are whole numbers; everything else (decimal / double
      // / money) can carry a fractional portion.
      allowDecimal: resolvedValueType !== "int" && resolvedValueType !== "bigint",
      maxDecimals: resolvedPrecision ?? null
    }),
    [resolvedMin, resolvedValueType, resolvedPrecision]
  );
  const [isFocused, setIsFocused] = useState(false);
  if (!isVisible) return null;
  const formatForDisplay = (val) => {
    if (val === null || val === void 0) return null;
    const num = typeof val === "bigint" ? Number(val) : val;
    if (resolvedValueType === "int" || resolvedValueType === "bigint") {
      return String(Math.trunc(num));
    }
    if (!isFocused && resolvedPrecision !== void 0) {
      return num.toFixed(resolvedPrecision);
    }
    return String(num);
  };
  const displayValue = formatForDisplay(value);
  const handleValueChange = (raw) => {
    if (raw === null || raw === "" || raw === "-") {
      setValue(null);
      return;
    }
    const parsed = resolvedValueType === "int" || resolvedValueType === "bigint" ? Number.parseInt(raw, 10) : Number.parseFloat(raw);
    if (Number.isNaN(parsed)) return;
    const rounded = resolvedPrecision !== void 0 ? Number(parsed.toFixed(resolvedPrecision)) : parsed;
    setValue(rounded);
  };
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  const fieldValidationProps = buildFieldValidationProps(
    validationErrors,
    displayValidationErrorMessage
  );
  const currentNumber = value === null || value === void 0 ? 0 : typeof value === "bigint" ? Number(value) : value;
  const canIncrement = !resolvedReadOnly && !resolvedDisabled && (resolvedMax === void 0 || currentNumber < resolvedMax);
  const canDecrement = !resolvedReadOnly && !resolvedDisabled && (resolvedMin === void 0 || currentNumber > resolvedMin);
  const stepBy = useCallback(
    (direction) => {
      const base = value === null || value === void 0 ? 0 : typeof value === "bigint" ? Number(value) : value;
      let next = base + step * direction;
      if (resolvedMin !== void 0) next = Math.max(next, resolvedMin);
      if (resolvedMax !== void 0) next = Math.min(next, resolvedMax);
      if (resolvedPrecision !== void 0) next = Number(next.toFixed(resolvedPrecision));
      if (resolvedValueType === "int" || resolvedValueType === "bigint") {
        next = Math.trunc(next);
      }
      setValue(next);
    },
    [value, step, resolvedMin, resolvedMax, resolvedPrecision, resolvedValueType, setValue]
  );
  const repeatTimerRef = useRef(null);
  const repeatIntervalRef = useRef(null);
  const stopRepeat = useCallback(() => {
    if (repeatTimerRef.current !== null) {
      clearTimeout(repeatTimerRef.current);
      repeatTimerRef.current = null;
    }
    if (repeatIntervalRef.current !== null) {
      clearInterval(repeatIntervalRef.current);
      repeatIntervalRef.current = null;
    }
  }, []);
  const startRepeat = useCallback(
    (direction) => {
      stepBy(direction);
      stopRepeat();
      repeatTimerRef.current = setTimeout(() => {
        repeatIntervalRef.current = setInterval(() => stepBy(direction), 60);
      }, 400);
    },
    [stepBy, stopRepeat]
  );
  useEffect(() => stopRepeat, [stopRepeat]);
  const spinnerButtons = !hideStep ? /* @__PURE__ */ jsxs("div", { className: styles.spinner, children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        appearance: "transparent",
        className: styles.spinnerButton,
        icon: /* @__PURE__ */ jsx(ChevronUp12Regular, {}),
        "aria-hidden": true,
        tabIndex: -1,
        disabled: !canIncrement,
        onMouseDown: (e) => {
          e.preventDefault();
          startRepeat(1);
        },
        onMouseUp: stopRepeat,
        onMouseLeave: stopRepeat,
        onTouchStart: (e) => {
          e.preventDefault();
          startRepeat(1);
        },
        onTouchEnd: stopRepeat
      }
    ),
    /* @__PURE__ */ jsx(
      Button,
      {
        appearance: "transparent",
        className: styles.spinnerButton,
        icon: /* @__PURE__ */ jsx(ChevronDown12Regular, {}),
        "aria-hidden": true,
        tabIndex: -1,
        disabled: !canDecrement,
        onMouseDown: (e) => {
          e.preventDefault();
          startRepeat(-1);
        },
        onMouseUp: stopRepeat,
        onMouseLeave: stopRepeat,
        onTouchStart: (e) => {
          e.preventDefault();
          startRepeat(-1);
        },
        onTouchEnd: stopRepeat
      }
    )
  ] }) : null;
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: mergeClasses("ppp-number-edit"),
      label: labelSlot,
      hint: fieldHint,
      required: resolvedRequired,
      ...fieldValidationProps,
      children: /* @__PURE__ */ jsx(
        MaskedTextField,
        {
          id,
          className,
          style,
          type: "text",
          inputMode: numericOptions.allowDecimal ? "decimal" : "numeric",
          value: displayValue,
          onValueChange: handleValueChange,
          readOnly: resolvedReadOnly,
          disabled: resolvedDisabled,
          placeholder,
          mode: MaskMode.Numeric,
          numeric: numericOptions,
          textAlign: "right",
          onFocus: () => setIsFocused(true),
          onBlur: () => setIsFocused(false),
          ...spinnerButtons !== null && { contentAfter: spinnerButtons }
        }
      )
    }
  );
}

// src/edits/base/format-value.ts
function formatValue(value, format, locale) {
  if (value === null || value === void 0 || value === "") return "";
  const trimmed = format.trim();
  if (trimmed === "") return String(value);
  if (typeof value === "number" || typeof value === "string" && value.length <= 24) {
    const n = typeof value === "number" ? value : Number(value);
    if (Number.isFinite(n)) {
      const numeric = tryFormatNumber(n, trimmed, locale);
      if (numeric !== void 0) return numeric;
    }
  }
  if (isStandardDateCode(trimmed)) {
    const date = value instanceof Date ? value : new Date(String(value));
    if (!Number.isNaN(date.getTime())) {
      return formatDate(date, trimmed, locale);
    }
  }
  return String(value);
}
var NUMERIC_STD_RE = /^([NnFfDdCcPpEeXx])(\d+)?$/;
var NUMERIC_CUSTOM_RE = /^([#0,]+)(?:\.([0#]+))?$/;
function tryFormatNumber(n, format, locale) {
  const std = format.match(NUMERIC_STD_RE);
  if (std) {
    const letter = std[1];
    const code = letter.toUpperCase();
    const digits = std[2] !== void 0 ? Number(std[2]) : void 0;
    switch (code) {
      case "N": {
        const opts = { useGrouping: true };
        applyDigits(opts, digits ?? 2);
        return new Intl.NumberFormat(locale, opts).format(n);
      }
      case "F": {
        const opts = { useGrouping: false };
        applyDigits(opts, digits ?? 2);
        return new Intl.NumberFormat(locale, opts).format(n);
      }
      case "D": {
        const int = Math.trunc(n);
        const absStr = String(Math.abs(int));
        const padded = digits !== void 0 ? absStr.padStart(digits, "0") : absStr;
        return int < 0 ? "-" + padded : padded;
      }
      case "C": {
        const opts = {
          style: "currency",
          currency: currencyForLocale(locale)
        };
        applyDigits(opts, digits ?? 2);
        return new Intl.NumberFormat(locale, opts).format(n);
      }
      case "P": {
        const opts = { style: "percent" };
        applyDigits(opts, digits ?? 2);
        return new Intl.NumberFormat(locale, opts).format(n);
      }
      case "E": {
        const opts = { notation: "scientific" };
        applyDigits(opts, digits ?? 6);
        return new Intl.NumberFormat(locale, opts).format(n);
      }
      case "X": {
        let hex = Math.trunc(n).toString(16);
        if (letter === "X") hex = hex.toUpperCase();
        if (digits !== void 0) hex = hex.padStart(digits, "0");
        return hex;
      }
    }
  }
  const custom = format.match(NUMERIC_CUSTOM_RE);
  if (custom) {
    const useGrouping = custom[1].includes(",");
    const decimals = custom[2] !== void 0 ? custom[2].length : 0;
    return new Intl.NumberFormat(locale, {
      useGrouping,
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    }).format(n);
  }
  return void 0;
}
function applyDigits(opts, digits) {
  opts.minimumFractionDigits = digits;
  opts.maximumFractionDigits = digits;
}
function currencyForLocale(locale) {
  if (!locale) return "USD";
  const region = locale.split("-")[1]?.toUpperCase();
  switch (region) {
    case "GB":
      return "GBP";
    case "EU":
    case "DE":
    case "FR":
    case "IT":
    case "ES":
    case "NL":
      return "EUR";
    case "JP":
      return "JPY";
    case "CA":
      return "CAD";
    case "AU":
      return "AUD";
    case "IN":
      return "INR";
    default:
      return "USD";
  }
}
function isStandardDateCode(format) {
  if (format.length !== 1) return false;
  return "dDfFgGtTMmYysoOuR".includes(format);
}
function formatDate(date, code, locale) {
  switch (code) {
    case "d":
      return new Intl.DateTimeFormat(locale, { dateStyle: "short" }).format(date);
    case "D":
      return new Intl.DateTimeFormat(locale, { dateStyle: "long" }).format(date);
    case "f":
      return new Intl.DateTimeFormat(locale, { dateStyle: "long", timeStyle: "short" }).format(date);
    case "F":
      return new Intl.DateTimeFormat(locale, { dateStyle: "full", timeStyle: "long" }).format(date);
    case "g":
      return new Intl.DateTimeFormat(locale, { dateStyle: "short", timeStyle: "short" }).format(date);
    case "G":
      return new Intl.DateTimeFormat(locale, { dateStyle: "short", timeStyle: "medium" }).format(date);
    case "t":
      return new Intl.DateTimeFormat(locale, { timeStyle: "short" }).format(date);
    case "T":
      return new Intl.DateTimeFormat(locale, { timeStyle: "medium" }).format(date);
    case "M":
    case "m":
      return new Intl.DateTimeFormat(locale, { month: "long", day: "numeric" }).format(date);
    case "Y":
    case "y":
      return new Intl.DateTimeFormat(locale, { year: "numeric", month: "long" }).format(date);
    case "s":
      return date.toISOString().slice(0, 19);
    case "o":
    case "O":
      return date.toISOString();
    case "u":
      return date.toISOString().slice(0, 19).replace("T", " ") + "Z";
    case "R":
      return date.toUTCString();
    default:
      return date.toLocaleString(locale);
  }
}
var useMoneyEditStyles = makeStyles({
  // Read-only / disabled display. Renders the formatted value as plain
  // text instead of a locked <Input> so:
  // * the server's locale-aware `record.formattedValues[columnName]`
  // (currency symbol + grouping) can show through verbatim — a
  // number input can't display "$1,234.56", only "1234.56";
  // * the `format` prop has somewhere to land.
  // Sized to the same vertical rhythm as a Fluent `<Input>` so a
  // permission-flipped read-only MoneyEdit doesn't shift adjacent edit
  // fields on the form.
  readOnlyValue: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS,
    minHeight: tokens.lineHeightBase300,
    padding: `${tokens.spacingVerticalXS} 0`,
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase300,
    lineHeight: tokens.lineHeightBase300,
    whiteSpace: "normal",
    wordBreak: "break-word"
  },
  // Currency-symbol start adornment. Reserves the same 20px footprint as
  // the fallback Money icon so single-glyph "$" and multi-character "CHF"
  // rows line their input start up consistently. Left-aligns the glyph
  // inside that box — centering left a visible gap to the left of narrow
  // symbols (the 20px box minus a ~6px "$") that didn't exist with the
  // original icon. `colorNeutralForeground2` matches the visual weight
  // Fluent's Input slots already render their icons at.
  currencySymbol: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "flex-start",
    minWidth: "20px",
    color: tokens.colorNeutralForeground2,
    fontSize: tokens.fontSizeBase300,
    lineHeight: tokens.lineHeightBase300,
    userSelect: "none"
  },
  // Spinner buttons (`contentAfter`). Same shape as NumberEdit's spinner
  // duplicated here rather than shared because MoneyEdit's makeStyles call
  // is already this file's; cross-file Griffel style import would double-
  // generate selectors.
  spinner: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "center",
    height: "100%",
    rowGap: "1px"
  },
  spinnerButton: {
    minWidth: 0,
    width: "18px",
    height: "14px",
    padding: 0,
    borderRadius: tokens.borderRadiusSmall,
    color: tokens.colorNeutralForeground2,
    ":hover": {
      color: tokens.colorNeutralForeground1
    },
    ":disabled": {
      color: tokens.colorNeutralForegroundDisabled
    }
  }
});
function MoneyEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  min,
  max,
  precision,
  hideStep = false,
  format,
  step = 0.01,
  placeholder,
  validate
}) {
  const { value, setValue: rawSetValue } = useMoneyColumn(columnName);
  const { record } = useRecordContext();
  const metadata = useColumnMetadata(columnName);
  const { locale } = useLocale();
  const styles = useMoneyEditStyles();
  const t = useT();
  const limits = getNumberLimits(metadata);
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = description ?? getDisplayDescription(metadata, columnName, record?.tableName, t);
  const resolvedMin = min ?? limits.min;
  const resolvedMax = max ?? limits.max;
  const resolvedPrecision = precision ?? limits.precision;
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled
  );
  const setValue = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const validationErrors = useColumnValidation(
    columnName,
    {
      kind: "number",
      required: resolvedRequired,
      label: resolvedLabel,
      value: value ?? null,
      ...resolvedMin !== void 0 && { min: resolvedMin },
      ...resolvedMax !== void 0 && { max: resolvedMax }
    },
    validate
  );
  const numericOptions = useMemo(
    () => ({
      decimalSeparator: ".",
      groupSeparator: ",",
      allowNegative: resolvedMin === void 0 || resolvedMin < 0,
      allowDecimal: true,
      maxDecimals: resolvedPrecision ?? 2
    }),
    [resolvedMin, resolvedPrecision]
  );
  const [isFocused, setIsFocused] = useState(false);
  if (!isVisible) return null;
  const displayValue = value === void 0 || value === null ? null : !isFocused && resolvedPrecision !== void 0 ? value.toFixed(resolvedPrecision) : String(value);
  const isReadOnlyDisplay = resolvedReadOnly || resolvedDisabled;
  const handleValueChange = (raw) => {
    if (raw === null || raw === "" || raw === "-") {
      setValue(null);
      return;
    }
    const parsed = Number.parseFloat(raw);
    if (Number.isNaN(parsed)) return;
    const rounded = resolvedPrecision !== void 0 ? Number(parsed.toFixed(resolvedPrecision)) : parsed;
    setValue(rounded);
  };
  let readOnlyDisplayText = "";
  let textIncludesSymbol = false;
  if (isReadOnlyDisplay) {
    const formattedFromServer = record?.formattedValues?.[columnName];
    if (formattedFromServer !== void 0 && formattedFromServer !== null && formattedFromServer !== "") {
      readOnlyDisplayText = formattedFromServer;
      textIncludesSymbol = true;
    } else if (value !== void 0 && value !== null) {
      if (format) {
        readOnlyDisplayText = formatValue(value, format, locale);
        textIncludesSymbol = /^c/i.test(format);
      } else {
        readOnlyDisplayText = String(value);
      }
    }
  }
  const currencySymbol = record?.currency?.symbol;
  const renderCurrencyAdornment = () => currencySymbol ? /* @__PURE__ */ jsx("span", { className: styles.currencySymbol, "aria-hidden": "true", children: currencySymbol }) : /* @__PURE__ */ jsx(Money20Regular, { "aria-hidden": "true" });
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  const fieldValidationProps = buildFieldValidationProps(
    validationErrors,
    displayValidationErrorMessage
  );
  const currentNumber = value === null || value === void 0 ? 0 : value;
  const canIncrement = !resolvedReadOnly && !resolvedDisabled && (resolvedMax === void 0 || currentNumber < resolvedMax);
  const canDecrement = !resolvedReadOnly && !resolvedDisabled && (resolvedMin === void 0 || currentNumber > resolvedMin);
  const stepBy = useCallback(
    (direction) => {
      const base = value === null || value === void 0 ? 0 : value;
      let next = base + step * direction;
      if (resolvedMin !== void 0) next = Math.max(next, resolvedMin);
      if (resolvedMax !== void 0) next = Math.min(next, resolvedMax);
      if (resolvedPrecision !== void 0) next = Number(next.toFixed(resolvedPrecision));
      setValue(next);
    },
    [value, step, resolvedMin, resolvedMax, resolvedPrecision, setValue]
  );
  const repeatTimerRef = useRef(null);
  const repeatIntervalRef = useRef(null);
  const stopRepeat = useCallback(() => {
    if (repeatTimerRef.current !== null) {
      clearTimeout(repeatTimerRef.current);
      repeatTimerRef.current = null;
    }
    if (repeatIntervalRef.current !== null) {
      clearInterval(repeatIntervalRef.current);
      repeatIntervalRef.current = null;
    }
  }, []);
  const startRepeat = useCallback(
    (direction) => {
      stepBy(direction);
      stopRepeat();
      repeatTimerRef.current = setTimeout(() => {
        repeatIntervalRef.current = setInterval(() => stepBy(direction), 60);
      }, 400);
    },
    [stepBy, stopRepeat]
  );
  useEffect(() => stopRepeat, [stopRepeat]);
  const spinnerButtons = !hideStep ? /* @__PURE__ */ jsxs("div", { className: styles.spinner, children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        appearance: "transparent",
        className: styles.spinnerButton,
        icon: /* @__PURE__ */ jsx(ChevronUp12Regular, {}),
        "aria-hidden": true,
        tabIndex: -1,
        disabled: !canIncrement,
        onMouseDown: (e) => {
          e.preventDefault();
          startRepeat(1);
        },
        onMouseUp: stopRepeat,
        onMouseLeave: stopRepeat,
        onTouchStart: (e) => {
          e.preventDefault();
          startRepeat(1);
        },
        onTouchEnd: stopRepeat
      }
    ),
    /* @__PURE__ */ jsx(
      Button,
      {
        appearance: "transparent",
        className: styles.spinnerButton,
        icon: /* @__PURE__ */ jsx(ChevronDown12Regular, {}),
        "aria-hidden": true,
        tabIndex: -1,
        disabled: !canDecrement,
        onMouseDown: (e) => {
          e.preventDefault();
          startRepeat(-1);
        },
        onMouseUp: stopRepeat,
        onMouseLeave: stopRepeat,
        onTouchStart: (e) => {
          e.preventDefault();
          startRepeat(-1);
        },
        onTouchEnd: stopRepeat
      }
    )
  ] }) : null;
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: mergeClasses("ppp-money-edit"),
      label: labelSlot,
      hint: fieldHint,
      required: resolvedRequired,
      ...fieldValidationProps,
      children: isReadOnlyDisplay ? /* @__PURE__ */ jsxs(
        "div",
        {
          id,
          className: mergeClasses(styles.readOnlyValue, className),
          style,
          children: [
            !textIncludesSymbol && renderCurrencyAdornment(),
            /* @__PURE__ */ jsx("span", { children: readOnlyDisplayText })
          ]
        }
      ) : /* @__PURE__ */ jsx(
        MaskedTextField,
        {
          id,
          className,
          style,
          contentBefore: renderCurrencyAdornment(),
          type: "text",
          inputMode: "decimal",
          value: displayValue,
          onValueChange: handleValueChange,
          placeholder,
          mode: MaskMode.Numeric,
          numeric: numericOptions,
          textAlign: "right",
          onFocus: () => setIsFocused(true),
          onBlur: () => setIsFocused(false),
          ...spinnerButtons !== null && { contentAfter: spinnerButtons }
        }
      )
    }
  );
}

// src/edits/base/column-display.ts
function readColumnRawValue(property) {
  if (property == null) return void 0;
  if (typeof property !== "object") return property;
  const wrapped = property;
  if (wrapped.$type === "RelatedRecordValue") {
    return readColumnRawValue(wrapped.value);
  }
  return wrapped.value;
}
function resolveColumnDisplayValue(record, columnName, _metadata) {
  const formatted = record.formattedValues?.[columnName];
  if (formatted !== void 0 && formatted !== null) {
    return formatted;
  }
  let property = record.properties?.[columnName];
  if (!property) return null;
  if (property.$type === "RelatedRecordValue") {
    const wrapper = property;
    if (!wrapper.value) return null;
    const innerFormatted = wrapper.value.formattedValue;
    if (innerFormatted) return innerFormatted;
    property = wrapper.value;
  }
  const t = property.$type;
  switch (t) {
    case 14: {
      const v = property.value;
      return v ?? null;
    }
    case 6: {
      const lookup = property;
      return lookup.name ?? lookup.value ?? null;
    }
    case 0:
    case 2:
    case 3:
    case 4:
    case 5:
    case 8:
    case 11:
    case 18: {
      const raw = property.value;
      return raw === void 0 || raw === null ? null : String(raw);
    }
    case 15: {
      const companion = record.properties?.[`${columnName}_name`];
      if (companion?.value) return companion.value;
      const v = property.value;
      return v ?? null;
    }
    case 40: {
      const list = property.value;
      if (!list || list.length === 0) return null;
      return list.map((c) => String(c.value)).join(", ");
    }
    case "FileValue": {
      const fv = property;
      return fv.fileName ?? null;
    }
    default: {
      return null;
    }
  }
}
var useColumnDisplayValueStyles = makeStyles({
  value: {
    // Match the vertical rhythm of a Fluent `<Input>` so a read-only
    // display sits on the same baseline as adjacent edit fields. Tokens
    // (not literal pixel values) so the layout follows theme density
    // changes the consumer might dial in.
    minHeight: tokens.lineHeightBase300,
    padding: `${tokens.spacingVerticalXS} 0`,
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase300,
    lineHeight: tokens.lineHeightBase300,
    // Long lookups / multi-select labels can exceed the field width;
    // wrap rather than overflow so the form layout stays predictable.
    whiteSpace: "normal",
    wordBreak: "break-word"
  },
  empty: {
    color: tokens.colorNeutralForeground3
  }
});
function ColumnDisplayValue({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  isVisible = true,
  emptyPlaceholder = "\u2014",
  format,
  className,
  style,
  id
}) {
  const { record } = useRecordContext();
  const metadata = useColumnMetadata(columnName);
  const { locale } = useLocale();
  const styles = useColumnDisplayValueStyles();
  const t = useT();
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = description ?? getDisplayDescription(metadata, columnName, record?.tableName, t);
  if (!isVisible) return null;
  let display;
  if (record && format) {
    const raw = readColumnRawValue(record.properties?.[columnName]);
    if (raw === void 0 || raw === null) {
      display = null;
    } else if (Array.isArray(raw)) {
      display = raw.map((entry) => formatValue(entry.value, format, locale)).filter((s) => s.length > 0).join(", ");
      if (display.length === 0) display = null;
    } else {
      display = formatValue(raw, format, locale);
    }
  } else {
    display = record ? resolveColumnDisplayValue(record, columnName) : null;
  }
  const isEmpty = display === null || display === "";
  const displayText = isEmpty ? emptyPlaceholder : display;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  const valueClass = `${styles.value}${isEmpty ? ` ${styles.empty}` : ""}${className ? ` ${className}` : ""}`;
  return /* @__PURE__ */ jsx(Field, { className: mergeClasses("ppp-column-display-value"), label: labelSlot, hint: fieldHint, children: /* @__PURE__ */ jsx("div", { id, className: valueClass, style, children: displayText }) });
}
var DateTimeEditorType = {
  DateTime: "dateTime",
  DateOnly: "dateOnly",
  TimeOnly: "timeOnly"
};
var useDateTimeStyles = makeStyles({
  // Side-by-side date + time pickers when editorType is `dateTime`. Stack
  // vertically on narrow screens — each picker's input is ~120px wide so
  // they fit comfortably in the typical form column at desktop widths.
  row: {
    display: "flex",
    flexWrap: "wrap",
    gap: tokens.spacingHorizontalS,
    alignItems: "center"
  },
  // Applied only when BOTH pickers render: date gets 2 shares, time gets 1
  // share (≈67/33 split). The date picker's content — full month-name + day
  // + four-digit year — needs more room than the time picker's hh:mm, so a
  // straight 50/50 left the date side cramped while the time side had slack.
  // `flex-basis: 100px` (NOT 0) is what triggers flex-wrap when the row can't
  // fit both side-by-side — wrap checks the items' hypothetical main size
  // (= basis), so with basis:0 it would never trigger and `min-width` would
  // instead force overflow. `min-width: 0` lets each picker shrink freely
  // down to its flex share, overriding the wrapper's intrinsic min-width.
  // The TimePicker overrides are critical: Fluent's Combobox-based TimePicker
  // uses `display: inline-grid` with `grid-template-columns: '1fr auto'` (input
  // + chevron). The `1fr` track has an implicit `min-content` floor equal to
  // the bare `<input>`'s default `size="20"` — about 150px — so the picker
  // refuses to shrink past ~180px even with `min-width: 0` on the wrapper, and
  // the chevron protrudes out of the field in narrow layouts. Switching the
  // track to `minmax(0, 1fr) auto` defeats that floor, and `min-width: 0` on
  // the inner `<input>` lets the browser ignore the `size`-derived min-content.
  // Together: the picker actually shrinks to whatever flex allocates.
  bothPickers: {
    // First child is the DatePicker (rendered before the TimePicker in the
    // JSX), second is the TimePicker. `nth-child` rather than `first-child` /
    // `last-child` so future siblings (e.g. an inline validation icon) don't
    // silently inherit the time-side share.
    "& > *:nth-child(1)": {
      flex: "2 1 100px",
      minWidth: 0
    },
    "& > *:nth-child(2)": {
      flex: "1 1 100px",
      minWidth: 0
    },
    "& .fui-TimePicker": {
      minWidth: 0,
      gridTemplateColumns: "minmax(0, 1fr) auto"
    },
    "& .fui-TimePicker__input": {
      minWidth: 0
    }
  }
});
function DateTimeEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  editorType,
  placeholder,
  disabledDateFunc,
  validate
}) {
  const { value, setValue: rawSetValue } = useDateColumn(columnName);
  const { record } = useRecordContext();
  const metadata = useColumnMetadata(columnName);
  const styles = useDateTimeStyles();
  const t = useT();
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = description ?? getDisplayDescription(metadata, columnName, record?.tableName, t);
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled
  );
  const setValue = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const resolvedEditorType = editorType ?? resolveEditorTypeFromMetadata(metadata);
  const restrictedDates = useMemo(() => {
    if (!disabledDateFunc) return void 0;
    const out = [];
    const cursor = /* @__PURE__ */ new Date();
    cursor.setFullYear(cursor.getFullYear() - 2);
    cursor.setHours(0, 0, 0, 0);
    const end = /* @__PURE__ */ new Date();
    end.setFullYear(end.getFullYear() + 2);
    while (cursor <= end) {
      if (disabledDateFunc(new Date(cursor))) {
        out.push(new Date(cursor));
      }
      cursor.setDate(cursor.getDate() + 1);
    }
    return out.length > 0 ? out : void 0;
  }, [disabledDateFunc]);
  const validationErrors = useColumnValidation(
    columnName,
    {
      kind: "datetime",
      required: resolvedRequired,
      label: resolvedLabel,
      value: value ?? null
    },
    validate
  );
  if (!isVisible) return null;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  const fieldValidationProps = buildFieldValidationProps(
    validationErrors,
    displayValidationErrorMessage
  );
  const currentDate = value ? parseWireValueForPicker(value, resolvedEditorType) : null;
  const handleDateSelected = (selected) => {
    if (!selected) {
      setValue(null);
      return;
    }
    if (resolvedEditorType === DateTimeEditorType.DateOnly) {
      const utcMidnight = new Date(
        Date.UTC(selected.getFullYear(), selected.getMonth(), selected.getDate())
      );
      setValue(utcMidnight.toISOString());
      return;
    }
    const merged = new Date(selected);
    if (currentDate) {
      merged.setHours(
        currentDate.getHours(),
        currentDate.getMinutes(),
        currentDate.getSeconds(),
        currentDate.getMilliseconds()
      );
    } else {
      merged.setHours(0, 0, 0, 0);
    }
    setValue(merged.toISOString());
  };
  const handleTimeSelected = (_ev, data) => {
    if (!data.selectedTime) {
      if (data.errorType === "invalid-input" || data.errorType === "out-of-bounds") return;
      setValue(null);
      return;
    }
    const baseDate = currentDate ?? /* @__PURE__ */ new Date();
    const merged = new Date(baseDate);
    merged.setHours(
      data.selectedTime.getHours(),
      data.selectedTime.getMinutes(),
      data.selectedTime.getSeconds(),
      data.selectedTime.getMilliseconds()
    );
    setValue(merged.toISOString());
  };
  const dateAnchor = currentDate ?? /* @__PURE__ */ new Date();
  const showDate = resolvedEditorType === DateTimeEditorType.DateOnly || resolvedEditorType === DateTimeEditorType.DateTime;
  const showTime = resolvedEditorType === DateTimeEditorType.TimeOnly || resolvedEditorType === DateTimeEditorType.DateTime;
  const isLocked = resolvedDisabled || resolvedReadOnly;
  const timeDisplayValue = currentDate ? currentDate.toLocaleTimeString(void 0, { hour: "numeric", minute: "2-digit" }) : "";
  const [timeInputText, setTimeInputText] = useState(timeDisplayValue);
  useEffect(() => {
    setTimeInputText(timeDisplayValue);
  }, [timeDisplayValue]);
  const handleTimeInputChange = (ev) => {
    setTimeInputText(ev.currentTarget.value);
  };
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: mergeClasses("ppp-date-time-edit"),
      label: labelSlot,
      hint: fieldHint,
      required: resolvedRequired,
      ...fieldValidationProps,
      children: /* @__PURE__ */ jsxs(
        "div",
        {
          className: mergeClasses(styles.row, showDate && showTime && styles.bothPickers, className),
          style,
          children: [
            showDate && /* @__PURE__ */ jsx(
              DatePicker,
              {
                value: currentDate,
                onSelectDate: handleDateSelected,
                disabled: isLocked,
                allowTextInput: true,
                ...restrictedDates !== void 0 && {
                  calendar: { restrictedDates }
                },
                ...id !== void 0 && { id },
                ...placeholder !== void 0 && { placeholder }
              }
            ),
            showTime && /* @__PURE__ */ jsx(
              TimePicker,
              {
                freeform: true,
                selectedTime: currentDate,
                onTimeChange: handleTimeSelected,
                disabled: isLocked,
                dateAnchor,
                value: timeInputText,
                onChange: handleTimeInputChange,
                ...!showDate && id !== void 0 && { id },
                ...placeholder !== void 0 && { placeholder }
              }
            )
          ]
        }
      )
    }
  );
}
function resolveEditorTypeFromMetadata(metadata) {
  const m = metadata;
  if (m?.dateTimeBehavior === DateTimeBehavior.DateOnly) {
    return DateTimeEditorType.DateOnly;
  }
  return DateTimeEditorType.DateTime;
}
function parseWireValueForPicker(wireValue, editorType) {
  const utc = new Date(wireValue);
  if (Number.isNaN(utc.getTime())) return null;
  if (editorType === DateTimeEditorType.DateOnly) {
    return new Date(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate());
  }
  return utc;
}

// src/edits/base/file-helpers.ts
var EMPTY_GUID = "00000000-0000-0000-0000-000000000000";
function readFileAsBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== "string") {
        reject(new Error("FileReader returned non-string result."));
        return;
      }
      const commaIndex = result.indexOf(",");
      resolve(commaIndex >= 0 ? result.substring(commaIndex + 1) : result);
    };
    reader.onerror = () => reject(reader.error ?? new Error("FileReader error"));
    reader.readAsDataURL(file);
  });
}
function base64ToBytes(base64) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
}
async function fetchFileBytes(ppp, tableName, recordId, columnName) {
  if (!tableName || !recordId) return null;
  const info = await ppp.getFileInfoAsync(tableName, recordId, columnName, true);
  if (!info.fileData) return null;
  return base64ToBytes(info.fileData);
}
function triggerBlobDownload(bytes, fileName) {
  const blob = new Blob([bytes.buffer]);
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
function guessImageMimeType(fileName) {
  const ext = fileName.toLowerCase().split(".").pop() ?? "";
  switch (ext) {
    case "png":
      return "image/png";
    case "gif":
      return "image/gif";
    case "webp":
      return "image/webp";
    case "svg":
      return "image/svg+xml";
    case "bmp":
      return "image/bmp";
    case "jpg":
    case "jpeg":
    default:
      return "image/jpeg";
  }
}
function bytesToText(bytes) {
  return new TextDecoder("utf-8").decode(bytes);
}
function base64ToText(base64) {
  return bytesToText(base64ToBytes(base64));
}
function getFileExtension(fileName) {
  if (!fileName) return "";
  const lastDot = fileName.lastIndexOf(".");
  if (lastDot < 0 || lastDot === fileName.length - 1) return "";
  return fileName.slice(lastDot + 1).toLowerCase();
}
function getMimeFromFileName(fileName) {
  const ext = getFileExtension(fileName);
  switch (ext) {
    case "png":
      return "image/png";
    case "gif":
      return "image/gif";
    case "webp":
      return "image/webp";
    case "svg":
      return "image/svg+xml";
    case "bmp":
      return "image/bmp";
    case "jpg":
    case "jpeg":
      return "image/jpeg";
    case "pdf":
      return "application/pdf";
    case "html":
    case "htm":
      return "text/html";
    case "md":
    case "markdown":
      return "text/markdown";
    case "json":
      return "application/json";
    case "xml":
      return "application/xml";
    case "csv":
      return "text/csv";
    case "txt":
    case "log":
      return "text/plain";
    case "zip":
      return "application/zip";
    default:
      return "application/octet-stream";
  }
}
function categorizeFile({
  mimeType,
  fileName
}) {
  const mime = (mimeType ?? "").toLowerCase();
  if (mime.startsWith("image/")) return "image";
  if (mime === "text/markdown" || mime === "text/x-markdown") return "markdown";
  if (mime === "application/pdf") return "embedded";
  if (mime === "application/zip" || mime === "application/x-zip-compressed") return "zip";
  const ext = getFileExtension(fileName);
  if (IMAGE_EXTS.has(ext)) return "image";
  if (MARKDOWN_EXTS.has(ext)) return "markdown";
  if (ext === "pdf") return "embedded";
  if (ext === "zip") return "zip";
  if (TEXT_EXTS.has(ext)) return "text";
  if (mime.startsWith("text/") || mime === "application/json" || mime === "application/xml") {
    return "text";
  }
  return "download";
}
var IMAGE_EXTS = /* @__PURE__ */ new Set(["png", "gif", "webp", "svg", "bmp", "jpg", "jpeg", "ico", "avif"]);
var MARKDOWN_EXTS = /* @__PURE__ */ new Set(["md", "markdown"]);
var TEXT_EXTS = /* @__PURE__ */ new Set([
  "txt",
  "log",
  "csv",
  "tsv",
  "json",
  "xml",
  "yaml",
  "yml",
  "toml",
  "ini",
  "js",
  "jsx",
  "mjs",
  "cjs",
  "ts",
  "tsx",
  "html",
  "htm",
  "css",
  "scss",
  "less",
  "cs",
  "vb",
  "fs",
  "razor",
  "cshtml",
  "vbhtml",
  "csproj",
  "vbproj",
  "fsproj",
  "sln",
  "py",
  "rb",
  "go",
  "rs",
  "java",
  "kt",
  "swift",
  "php",
  "pl",
  "lua",
  "sql",
  "sh",
  "bash",
  "ps1",
  "cmd",
  "bat",
  "config",
  "props",
  "targets"
]);
function getHighlightLanguage(fileName) {
  const ext = getFileExtension(fileName);
  switch (ext) {
    case "js":
    case "mjs":
    case "cjs":
    case "jsx":
      return "javascript";
    case "ts":
    case "tsx":
      return "typescript";
    case "json":
      return "json";
    case "html":
    case "htm":
    case "xml":
    case "csproj":
    case "vbproj":
    case "fsproj":
    case "config":
    case "props":
    case "targets":
    case "razor":
    case "cshtml":
    case "vbhtml":
      return "xml";
    case "css":
    case "scss":
    case "less":
      return "css";
    case "yaml":
    case "yml":
      return "yaml";
    case "cs":
      return "csharp";
    case "md":
    case "markdown":
      return "markdown";
    case "csv":
    case "tsv":
    case "log":
    case "txt":
    default:
      return "plaintext";
  }
}
function useFileUpload(options) {
  const { setValue, maxFileSizeBytes, enabled, warnPrefix } = options;
  const dialog = useDialogService();
  const t = useT();
  const inputRef = useRef(null);
  const [isDragOver, setIsDragOver] = useState(false);
  const handleFileSelected = useCallback(
    async (file) => {
      if (maxFileSizeBytes !== void 0 && file.size > maxFileSizeBytes) {
        console.warn(
          `${warnPrefix}: rejected ${file.name} (${file.size} bytes) \u2014 exceeds maxFileSizeBytes (${maxFileSizeBytes}).`
        );
        await dialog.showErrorAsync(
          t("app.messages.file-upload-max-file-size-error", [maxFileSizeBytes, file.size]),
          { title: t("app.messages.file-upload-max-file-size-error-title") }
        );
        return;
      }
      const base64 = await readFileAsBase64(file);
      setValue({
        fileName: file.name,
        id: EMPTY_GUID,
        value: base64
      });
    },
    [dialog, maxFileSizeBytes, setValue, t, warnPrefix]
  );
  const onInputChange = useCallback(
    (ev) => {
      const file = ev.target.files?.[0];
      if (file) void handleFileSelected(file);
      ev.target.value = "";
    },
    [handleFileSelected]
  );
  const dropZoneHandlers = useMemo(
    () => ({
      role: "button",
      tabIndex: enabled ? 0 : -1,
      "aria-disabled": !enabled,
      onClick: () => {
        if (enabled) inputRef.current?.click();
      },
      onKeyDown: (ev) => {
        if (!enabled) return;
        if (ev.key === "Enter" || ev.key === " ") {
          ev.preventDefault();
          inputRef.current?.click();
        }
      },
      onDragOver: (ev) => {
        if (!enabled) return;
        ev.preventDefault();
        setIsDragOver(true);
      },
      onDragLeave: () => setIsDragOver(false),
      onDrop: (ev) => {
        if (!enabled) return;
        ev.preventDefault();
        setIsDragOver(false);
        const file = ev.dataTransfer.files?.[0];
        if (file) void handleFileSelected(file);
      }
    }),
    [enabled, handleFileSelected]
  );
  return { inputRef, isDragOver, onInputChange, dropZoneHandlers };
}
var ZOOM_MIN = 0.25;
var ZOOM_MAX = 8;
var ZOOM_STEP = 1.25;
var ImageViewer = forwardRef(function ImageViewer2({
  source,
  alt,
  className,
  style,
  id,
  framed = false,
  toolbar = false,
  downloadable = false,
  fileName,
  onClick,
  fallback,
  croppable = false,
  onCropApplied,
  onDirtyChanged,
  onSave,
  onCancel,
  outputFormat = "auto",
  outputQuality = 0.9
}, ref) {
  const styles = useImageViewerStyles();
  const t = useT();
  const [croppedSource, setCroppedSource] = useState(null);
  const displaySource = croppedSource ?? source;
  const resolvedFileName = fileName ?? extractFileName(displaySource) ?? "image";
  const resolvedAlt = alt ?? resolvedFileName;
  const src = useImageSrc(displaySource);
  const cropEnabled = toolbar && croppable;
  const [angle, setAngle] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [pan, setPan] = useState({ x: 0, y: 0 });
  const [flipH, setFlipH] = useState(false);
  const [flipV, setFlipV] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showThirds, setShowThirds] = useState(false);
  const [baseline, setBaseline] = useState({ angle: 0, flipH: false, flipV: false, croppedSource: null });
  const isDirty = angle !== baseline.angle || flipH !== baseline.flipH || flipV !== baseline.flipV || croppedSource !== baseline.croppedSource;
  const wrapperRef = useRef(null);
  const imageContainerRef = useRef(null);
  const imgRef = useRef(null);
  const [aspectRatio, setAspectRatio] = useState("free");
  const [selection, setSelection] = useState(null);
  const selectionRef = useRef(selection);
  selectionRef.current = selection;
  const prevTransformRef = useRef({ angle, zoom, pan, flipH, flipV });
  const dragRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const zoomRef = useRef(zoom);
  const panRef = useRef(pan);
  const angleRef = useRef(angle);
  const flipHRef = useRef(flipH);
  const flipVRef = useRef(flipV);
  zoomRef.current = zoom;
  panRef.current = pan;
  angleRef.current = angle;
  flipHRef.current = flipH;
  flipVRef.current = flipV;
  useEffect(() => {
    setAngle(0);
    setZoom(1);
    setPan({ x: 0, y: 0 });
    setFlipH(false);
    setFlipV(false);
    setSelection(null);
    setBaseline({ angle: 0, flipH: false, flipV: false, croppedSource: null });
  }, [src]);
  useEffect(() => {
    setCroppedSource(null);
  }, [source]);
  useEffect(() => {
    const prev = prevTransformRef.current;
    const cur = { angle, zoom, pan, flipH, flipV };
    const transformChanged = prev.angle !== cur.angle || prev.zoom !== cur.zoom || prev.pan.x !== cur.pan.x || prev.pan.y !== cur.pan.y || prev.flipH !== cur.flipH || prev.flipV !== cur.flipV;
    if (transformChanged) {
      const sel = selectionRef.current;
      const imgEl = imgRef.current;
      if (sel && imgEl) {
        const natural = containerRectToImageNatural(
          sel,
          imgEl,
          prev.angle,
          prev.zoom,
          prev.pan,
          prev.flipH,
          prev.flipV
        );
        if (natural) {
          const reprojected = imageNaturalRectToContainer(
            natural,
            imgEl,
            cur.angle,
            cur.zoom,
            cur.pan,
            cur.flipH,
            cur.flipV
          );
          if (reprojected) {
            setSelection(reprojected);
          }
        }
      }
    }
    prevTransformRef.current = cur;
  }, [angle, zoom, pan, flipH, flipV]);
  const onDirtyChangedRef = useRef(onDirtyChanged);
  onDirtyChangedRef.current = onDirtyChanged;
  useEffect(() => {
    onDirtyChangedRef.current?.(isDirty);
  }, [isDirty]);
  useEffect(() => {
    if (!toolbar) return;
    const handler = () => {
      setIsFullscreen(document.fullscreenElement === wrapperRef.current);
    };
    document.addEventListener("fullscreenchange", handler);
    return () => document.removeEventListener("fullscreenchange", handler);
  }, [toolbar]);
  useEffect(() => {
    if (!toolbar) return;
    const node = imageContainerRef.current;
    if (!node) return;
    const handler = (e) => {
      e.preventDefault();
      const factor = Math.exp(-e.deltaY * 223e-5);
      const prevZoom = zoomRef.current;
      const nextZoom = Math.min(Math.max(prevZoom * factor, ZOOM_MIN), ZOOM_MAX);
      if (nextZoom === prevZoom) return;
      setZoom(nextZoom);
      if (nextZoom <= 1) {
        setPan({ x: 0, y: 0 });
        return;
      }
      const rect = node.getBoundingClientRect();
      const cursorRelCenterX = e.clientX - (rect.left + rect.width / 2);
      const cursorRelCenterY = e.clientY - (rect.top + rect.height / 2);
      const r = nextZoom / prevZoom;
      const prevPan = panRef.current;
      setPan({
        x: (1 - r) * cursorRelCenterX + r * prevPan.x,
        y: (1 - r) * cursorRelCenterY + r * prevPan.y
      });
    };
    node.addEventListener("wheel", handler, { passive: false });
    return () => node.removeEventListener("wheel", handler);
  }, [toolbar]);
  useEffect(() => {
    if (!toolbar) return;
    wrapperRef.current?.focus();
  }, [toolbar, isFullscreen]);
  useEffect(() => {
    if (!toolbar || !cropEnabled) return;
    const wrapper = wrapperRef.current;
    if (!wrapper) return;
    const handler = (e) => {
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      const key = e.key;
      if (key !== "ArrowUp" && key !== "ArrowDown" && key !== "ArrowLeft" && key !== "ArrowRight") {
        return;
      }
      const sel = selectionRef.current;
      if (!sel) return;
      e.preventDefault();
      e.stopPropagation();
      const step = e.shiftKey ? 10 : 1;
      const dx = key === "ArrowLeft" ? -step : key === "ArrowRight" ? step : 0;
      const dy = key === "ArrowUp" ? -step : key === "ArrowDown" ? step : 0;
      const bounds = imgRef.current ? getDisplayedImageBounds(
        imgRef.current,
        angleRef.current,
        zoomRef.current,
        panRef.current,
        flipHRef.current,
        flipVRef.current
      ) : null;
      const rect = imageContainerRef.current?.getBoundingClientRect();
      const cw = rect?.width ?? Number.POSITIVE_INFINITY;
      const ch = rect?.height ?? Number.POSITIVE_INFINITY;
      const minX = Math.max(0, bounds ? bounds.x : 0);
      const minY = Math.max(0, bounds ? bounds.y : 0);
      const maxX = Math.min(cw, bounds ? bounds.x + bounds.w : cw);
      const maxY = Math.min(ch, bounds ? bounds.y + bounds.h : ch);
      setSelection({
        x: Math.max(minX, Math.min(sel.x + dx, maxX - sel.w)),
        y: Math.max(minY, Math.min(sel.y + dy, maxY - sel.h)),
        w: sel.w,
        h: sel.h
      });
    };
    wrapper.addEventListener("keydown", handler, true);
    return () => wrapper.removeEventListener("keydown", handler, true);
  }, [toolbar, cropEnabled]);
  const handleDownload = useCallback(() => {
    if (!displaySource) return;
    void downloadSource(displaySource, resolvedFileName);
  }, [displaySource, resolvedFileName]);
  const handleRotateCw = useCallback(() => setAngle((a) => a + 90), []);
  const handleRotateCcw = useCallback(() => setAngle((a) => a - 90), []);
  const handleZoomIn = useCallback(() => setZoom((z) => Math.min(z * ZOOM_STEP, ZOOM_MAX)), []);
  const handleZoomOut = useCallback(() => {
    setZoom((z) => {
      const next = Math.max(z / ZOOM_STEP, ZOOM_MIN);
      if (next <= 1) setPan({ x: 0, y: 0 });
      return next;
    });
  }, []);
  const handleReset = useCallback(() => {
    const snappedAngle = Math.round(angle / 360) * 360;
    setAngle(snappedAngle);
    setZoom(1);
    setPan({ x: 0, y: 0 });
    setFlipH(false);
    setFlipV(false);
    setSelection(null);
    setCroppedSource(null);
    setBaseline({ angle: snappedAngle, flipH: false, flipV: false, croppedSource: null });
  }, [angle]);
  const handleFlipH = useCallback(() => setFlipH((f) => !f), []);
  const handleFlipV = useCallback(() => setFlipV((f) => !f), []);
  const handleToggleFullscreen = useCallback(() => {
    if (document.fullscreenElement) {
      void document.exitFullscreen();
    } else {
      void wrapperRef.current?.requestFullscreen();
    }
  }, []);
  const aspectValue = aspectRatioToNumber(aspectRatio);
  const onContainerPointerDown = useCallback(
    (e) => {
      if (!toolbar) return;
      if (e.button !== 0) return;
      if (dragRef.current) return;
      if (cropEnabled) {
        e.preventDefault();
        const rect = e.currentTarget.getBoundingClientRect();
        const localX = e.clientX - rect.left;
        const localY = e.clientY - rect.top;
        const sel = selectionRef.current;
        if (sel && localX >= sel.x && localX <= sel.x + sel.w && localY >= sel.y && localY <= sel.y + sel.h) {
          e.currentTarget.setPointerCapture(e.pointerId);
          dragRef.current = {
            kind: "move",
            pointerId: e.pointerId,
            originX: localX,
            originY: localY,
            startSelection: sel,
            imageBounds: imgRef.current ? getDisplayedImageBounds(imgRef.current, angle, zoom, pan, flipH, flipV) : null
          };
          return;
        }
        e.currentTarget.setPointerCapture(e.pointerId);
        dragRef.current = {
          kind: "select",
          pointerId: e.pointerId,
          originX: localX,
          originY: localY,
          moved: false,
          imageBounds: imgRef.current ? getDisplayedImageBounds(imgRef.current, angle, zoom, pan, flipH, flipV) : null
        };
        setSelection({ x: localX, y: localY, w: 0, h: 0 });
        return;
      }
      if (zoom > 1) {
        e.currentTarget.setPointerCapture(e.pointerId);
        dragRef.current = {
          kind: "pan",
          pointerId: e.pointerId,
          startX: e.clientX,
          startY: e.clientY,
          startPan: pan
        };
        setIsDragging(true);
      }
    },
    [toolbar, cropEnabled, zoom, pan, angle, flipH, flipV]
  );
  const onHandlePointerDown = useCallback(
    (e) => {
      if (e.button !== 0) return;
      if (dragRef.current) return;
      const handle = e.currentTarget.dataset.handle;
      if (!handle) return;
      const containerEl = imageContainerRef.current;
      const sel = selectionRef.current;
      if (!containerEl || !sel) return;
      e.stopPropagation();
      e.preventDefault();
      containerEl.setPointerCapture(e.pointerId);
      dragRef.current = {
        kind: "resize",
        pointerId: e.pointerId,
        handle,
        startSelection: sel,
        imageBounds: imgRef.current ? getDisplayedImageBounds(imgRef.current, angle, zoom, pan, flipH, flipV) : null,
        aspectValue
      };
    },
    [angle, zoom, pan, flipH, flipV, aspectValue]
  );
  const onContainerPointerMove = useCallback(
    (e) => {
      const drag = dragRef.current;
      if (!drag || drag.pointerId !== e.pointerId) return;
      if (drag.kind === "pan") {
        setPan({
          x: drag.startPan.x + (e.clientX - drag.startX),
          y: drag.startPan.y + (e.clientY - drag.startY)
        });
        return;
      }
      if (drag.kind === "move") {
        const rect2 = e.currentTarget.getBoundingClientRect();
        const localX2 = e.clientX - rect2.left;
        const localY2 = e.clientY - rect2.top;
        const dx2 = localX2 - drag.originX;
        const dy2 = localY2 - drag.originY;
        const { x: x2, y: y2, w: w2, h: h2 } = drag.startSelection;
        const ib2 = drag.imageBounds;
        const minX2 = Math.max(0, ib2 ? ib2.x : 0);
        const minY2 = Math.max(0, ib2 ? ib2.y : 0);
        const maxX2 = Math.min(rect2.width, ib2 ? ib2.x + ib2.w : rect2.width);
        const maxY2 = Math.min(rect2.height, ib2 ? ib2.y + ib2.h : rect2.height);
        const newX = Math.max(minX2, Math.min(x2 + dx2, maxX2 - w2));
        const newY = Math.max(minY2, Math.min(y2 + dy2, maxY2 - h2));
        setSelection({ x: newX, y: newY, w: w2, h: h2 });
        return;
      }
      if (drag.kind === "resize") {
        const rect2 = e.currentTarget.getBoundingClientRect();
        const localX2 = e.clientX - rect2.left;
        const localY2 = e.clientY - rect2.top;
        const ib2 = drag.imageBounds;
        const minX2 = Math.max(0, ib2 ? ib2.x : 0);
        const minY2 = Math.max(0, ib2 ? ib2.y : 0);
        const maxX2 = Math.min(rect2.width, ib2 ? ib2.x + ib2.w : rect2.width);
        const maxY2 = Math.min(rect2.height, ib2 ? ib2.y + ib2.h : rect2.height);
        const start = drag.startSelection;
        const startRight = start.x + start.w;
        const startBottom = start.y + start.h;
        const startCenterX = (start.x + startRight) / 2;
        const startCenterY = (start.y + startBottom) / 2;
        const movesLeft = drag.handle === "w" || drag.handle === "nw" || drag.handle === "sw";
        const movesRight = drag.handle === "e" || drag.handle === "ne" || drag.handle === "se";
        const movesTop = drag.handle === "n" || drag.handle === "nw" || drag.handle === "ne";
        const movesBottom = drag.handle === "s" || drag.handle === "sw" || drag.handle === "se";
        let newLeft = movesLeft ? Math.max(minX2, Math.min(localX2, startRight - 1)) : start.x;
        let newRight = movesRight ? Math.min(maxX2, Math.max(localX2, start.x + 1)) : startRight;
        let newTop = movesTop ? Math.max(minY2, Math.min(localY2, startBottom - 1)) : start.y;
        let newBottom = movesBottom ? Math.min(maxY2, Math.max(localY2, start.y + 1)) : startBottom;
        let newW = newRight - newLeft;
        let newH = newBottom - newTop;
        const isCornerDrag = (movesLeft || movesRight) && (movesTop || movesBottom);
        const isEdgeDrag = !isCornerDrag && (movesLeft || movesRight || movesTop || movesBottom);
        if (drag.aspectValue !== null && isCornerDrag) {
          const anchorX = movesLeft ? startRight : start.x;
          const anchorY = movesTop ? startBottom : start.y;
          const aspect = drag.aspectValue;
          if (newW / aspect > newH) {
            newH = newW / aspect;
          } else {
            newW = newH * aspect;
          }
          const maxAllowedW = movesLeft ? anchorX - minX2 : maxX2 - anchorX;
          const maxAllowedH = movesTop ? anchorY - minY2 : maxY2 - anchorY;
          if (newW > maxAllowedW) {
            const scale = maxAllowedW / newW;
            newW *= scale;
            newH *= scale;
          }
          if (newH > maxAllowedH) {
            const scale = maxAllowedH / newH;
            newW *= scale;
            newH *= scale;
          }
          newLeft = movesLeft ? anchorX - newW : anchorX;
          newTop = movesTop ? anchorY - newH : anchorY;
        } else if (drag.aspectValue !== null && isEdgeDrag) {
          const aspect = drag.aspectValue;
          if (movesTop || movesBottom) {
            const maxHalfW = Math.min(startCenterX - minX2, maxX2 - startCenterX);
            let h2 = newH;
            let w2 = h2 * aspect;
            if (w2 / 2 > maxHalfW) {
              w2 = maxHalfW * 2;
              h2 = w2 / aspect;
              if (movesTop) newTop = newBottom - h2;
              else newBottom = newTop + h2;
            }
            newLeft = startCenterX - w2 / 2;
            newRight = startCenterX + w2 / 2;
            newW = w2;
            newH = h2;
          } else {
            const maxHalfH = Math.min(startCenterY - minY2, maxY2 - startCenterY);
            let w2 = newW;
            let h2 = w2 / aspect;
            if (h2 / 2 > maxHalfH) {
              h2 = maxHalfH * 2;
              w2 = h2 * aspect;
              if (movesLeft) newLeft = newRight - w2;
              else newRight = newLeft + w2;
            }
            newTop = startCenterY - h2 / 2;
            newBottom = startCenterY + h2 / 2;
            newW = w2;
            newH = h2;
          }
        }
        setSelection({ x: newLeft, y: newTop, w: newW, h: newH });
        return;
      }
      const rect = e.currentTarget.getBoundingClientRect();
      const localX = e.clientX - rect.left;
      const localY = e.clientY - rect.top;
      let dx = localX - drag.originX;
      let dy = localY - drag.originY;
      if (!drag.moved && Math.abs(dx) + Math.abs(dy) > 3) {
        drag.moved = true;
      }
      if (aspectValue !== null) {
        const absX = Math.abs(dx);
        const absY = Math.abs(dy);
        if (absX / aspectValue > absY) {
          const newAbsY = absX / aspectValue;
          dy = dy === 0 ? newAbsY : Math.sign(dy) * newAbsY;
        } else {
          const newAbsX = absY * aspectValue;
          dx = dx === 0 ? newAbsX : Math.sign(dx) * newAbsX;
        }
      }
      let x = drag.originX;
      let y = drag.originY;
      let w = dx;
      let h = dy;
      if (w < 0) {
        x += w;
        w = -w;
      }
      if (h < 0) {
        y += h;
        h = -h;
      }
      const ib = drag.imageBounds;
      const minX = Math.max(0, ib ? ib.x : 0);
      const minY = Math.max(0, ib ? ib.y : 0);
      const maxX = Math.min(rect.width, ib ? ib.x + ib.w : rect.width);
      const maxY = Math.min(rect.height, ib ? ib.y + ib.h : rect.height);
      if (x < minX) {
        w -= minX - x;
        x = minX;
      }
      if (y < minY) {
        h -= minY - y;
        y = minY;
      }
      w = Math.min(w, maxX - x);
      h = Math.min(h, maxY - y);
      if (w < 0) w = 0;
      if (h < 0) h = 0;
      setSelection({ x, y, w, h });
    },
    [aspectValue]
  );
  const onContainerPointerUp = useCallback((e) => {
    const drag = dragRef.current;
    if (!drag || drag.pointerId !== e.pointerId) return;
    e.currentTarget.releasePointerCapture(e.pointerId);
    if (drag.kind === "pan") {
      setIsDragging(false);
    } else if (drag.kind === "move") ; else if (drag.kind === "resize") ; else {
      if (!drag.moved) {
        setSelection(null);
      } else {
        setSelection((prev) => {
          if (!prev || prev.w < 5 || prev.h < 5) return null;
          return prev;
        });
      }
    }
    dragRef.current = null;
  }, []);
  const handleAspectChange = useCallback((next) => {
    setAspectRatio(next);
    setSelection(null);
  }, []);
  const handleCrop = useCallback(async () => {
    if (!selection || !imgRef.current || !displaySource) return;
    if (selection.w < 1 || selection.h < 1) return;
    const result = await renderCrop({
      imageEl: imgRef.current,
      selection,
      angle,
      zoom,
      pan,
      flipH,
      flipV,
      sourceFileName: extractFileName(displaySource) ?? "image",
      outputFormat,
      outputQuality
    });
    if (!result) return;
    setCroppedSource({
      kind: "bytes",
      value: result.bytes,
      mimeType: result.mimeType,
      fileName: result.fileName
    });
    setSelection(null);
    onCropApplied?.(result);
  }, [selection, angle, zoom, pan, flipH, flipV, displaySource, onCropApplied, outputFormat, outputQuality]);
  const onWrapperKeyDown = useCallback(
    (e) => {
      if (!toolbar) return;
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      const sel = selectionRef.current;
      switch (e.key) {
        case "Escape":
          if (onCancel) {
            e.preventDefault();
            onCancel();
          }
          return;
        case "Enter":
          if (sel && sel.w >= 5 && sel.h >= 5) {
            e.preventDefault();
            void handleCrop();
          } else if (onSave && isDirty) {
            e.preventDefault();
            void onSave();
          }
          return;
        case "+":
        case "=":
          e.preventDefault();
          handleZoomIn();
          return;
        case "-":
        case "_":
          e.preventDefault();
          handleZoomOut();
          return;
        case "0":
          e.preventDefault();
          setZoom(1);
          setPan({ x: 0, y: 0 });
          return;
        case "Delete":
        case "Backspace":
          if (sel) {
            e.preventDefault();
            setSelection(null);
          }
          return;
      }
    },
    [toolbar, onCancel, onSave, isDirty, handleCrop, handleZoomIn, handleZoomOut]
  );
  useImperativeHandle(
    ref,
    () => ({
      isDirty,
      resetDirty: () => {
        setBaseline({ angle, flipH, flipV, croppedSource });
      },
      commit: async () => {
        if (!isDirty) return null;
        if (!imgRef.current) return null;
        return await renderBakedImage({
          imageEl: imgRef.current,
          angle,
          flipH,
          flipV,
          sourceFileName: extractFileName(displaySource) ?? "image",
          outputFormat,
          outputQuality
        });
      },
      revertCrop: () => {
        setCroppedSource(null);
      }
    }),
    [isDirty, angle, flipH, flipV, croppedSource, displaySource, outputFormat, outputQuality]
  );
  if (!source || !src) {
    return /* @__PURE__ */ jsx(Fragment, { children: fallback ?? null });
  }
  const wrapped = framed || toolbar;
  const wantsClickDownload = downloadable && !wrapped && !onClick;
  const imgClickHandler = onClick ?? (wantsClickDownload ? () => handleDownload() : void 0);
  const scaleX = zoom * (flipH ? -1 : 1);
  const scaleY = zoom * (flipV ? -1 : 1);
  const transform = toolbar ? `translate(${pan.x}px, ${pan.y}px) rotate(${angle}deg) scale(${scaleX}, ${scaleY})` : void 0;
  const imgStyle = (() => {
    if (!toolbar && !wrapped) return style;
    if (!toolbar) return void 0;
    return {
      transform,
      // Drop the easing while the user is mid-drag; otherwise pan would lag
      // a frame behind the pointer.
      transition: isDragging ? "none" : "transform 120ms ease-out",
      // Pointer events pass through the image to the container so the
      // container's pan/select handlers see the pointer. Cursor styling
      // lives on the container too.
      pointerEvents: "none"
    };
  })();
  const img = /* @__PURE__ */ jsx(
    "img",
    {
      ref: imgRef,
      id: !wrapped ? id : void 0,
      src,
      alt: resolvedAlt,
      crossOrigin: croppable ? "anonymous" : void 0,
      className: mergeClasses(
        wrapped ? styles.framedImage : styles.bareImage,
        isFullscreen && styles.framedImageFullscreen,
        wantsClickDownload && styles.clickable,
        !wrapped && className
      ),
      style: imgStyle,
      onClick: imgClickHandler,
      draggable: false
    }
  );
  if (!wrapped) return img;
  const isResettable = angle % 360 !== 0 || zoom !== 1 || pan.x !== 0 || pan.y !== 0 || flipH || flipV || croppedSource !== null || selection !== null;
  const selectionNaturalDims = (() => {
    if (!selection || !imgRef.current) return null;
    const nat = containerRectToImageNatural(
      selection,
      imgRef.current,
      angle,
      zoom,
      pan,
      flipH,
      flipV
    );
    if (!nat) return null;
    return { w: Math.max(0, Math.round(nat.w)), h: Math.max(0, Math.round(nat.h)) };
  })();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: wrapperRef,
      id,
      className: mergeClasses(
        styles.wrapper,
        isFullscreen && styles.wrapperFullscreen,
        className
      ),
      style,
      tabIndex: toolbar ? 0 : void 0,
      onKeyDown: toolbar ? onWrapperKeyDown : void 0,
      children: [
        toolbar && /* @__PURE__ */ jsxs(
          Toolbar,
          {
            size: "small",
            "aria-label": t("app.components.image-viewer.toolbar", [resolvedFileName]),
            className: styles.toolbar,
            children: [
              /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t("app.components.image-viewer.rotate-ccw"),
                  icon: /* @__PURE__ */ jsx(ArrowRotateCounterclockwise20Regular, {}),
                  onClick: handleRotateCcw
                }
              ),
              /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t("app.components.image-viewer.rotate-cw"),
                  icon: /* @__PURE__ */ jsx(ArrowRotateClockwise20Regular, {}),
                  onClick: handleRotateCw
                }
              ),
              /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t(
                    flipH ? "app.components.image-viewer.unflip-horizontal" : "app.components.image-viewer.flip-horizontal"
                  ),
                  icon: /* @__PURE__ */ jsx(FlipHorizontal20Regular, {}),
                  ...flipH ? { appearance: "primary" } : {},
                  onClick: handleFlipH
                }
              ),
              /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t(
                    flipV ? "app.components.image-viewer.unflip-vertical" : "app.components.image-viewer.flip-vertical"
                  ),
                  icon: /* @__PURE__ */ jsx(FlipVertical20Regular, {}),
                  ...flipV ? { appearance: "primary" } : {},
                  onClick: handleFlipV
                }
              ),
              /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t("app.components.image-viewer.zoom-in"),
                  icon: /* @__PURE__ */ jsx(ZoomIn20Regular, {}),
                  disabled: zoom >= ZOOM_MAX,
                  onClick: handleZoomIn
                }
              ),
              /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t("app.components.image-viewer.zoom-out"),
                  icon: /* @__PURE__ */ jsx(ZoomOut20Regular, {}),
                  disabled: zoom <= ZOOM_MIN,
                  onClick: handleZoomOut
                }
              ),
              /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t("app.components.image-viewer.reset-view"),
                  icon: /* @__PURE__ */ jsx(ArrowReset20Regular, {}),
                  disabled: !isResettable,
                  onClick: handleReset
                }
              ),
              cropEnabled && /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx(ToolbarDivider, {}),
                /* @__PURE__ */ jsxs(
                  Menu,
                  {
                    checkedValues: { aspect: [aspectRatio] },
                    onCheckedValueChange: (_e, data) => {
                      const next = data.checkedItems[0];
                      if (next) handleAspectChange(next);
                    },
                    ...isFullscreen && wrapperRef.current ? { mountNode: wrapperRef.current } : {},
                    children: [
                      /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(
                        ToolbarButton,
                        {
                          "aria-label": t("app.components.image-viewer.crop-aspect-ratio", [aspectRatio]),
                          icon: /* @__PURE__ */ jsx(ChevronDown16Regular, {}),
                          children: aspectRatioLabel(aspectRatio)
                        }
                      ) }),
                      /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsxs(MenuList, { children: [
                        /* @__PURE__ */ jsx(MenuItemRadio, { name: "aspect", value: "free", children: "Free" }),
                        /* @__PURE__ */ jsx(MenuItemRadio, { name: "aspect", value: "1:1", children: "Square (1:1)" }),
                        /* @__PURE__ */ jsx(MenuItemRadio, { name: "aspect", value: "4:3", children: "4:3" }),
                        /* @__PURE__ */ jsx(MenuItemRadio, { name: "aspect", value: "16:9", children: "16:9" })
                      ] }) })
                    ]
                  }
                ),
                /* @__PURE__ */ jsx(
                  ToolbarButton,
                  {
                    "aria-label": t(
                      showThirds ? "app.components.image-viewer.hide-thirds" : "app.components.image-viewer.show-thirds"
                    ),
                    icon: /* @__PURE__ */ jsx(Grid20Regular, {}),
                    ...showThirds ? { appearance: "primary" } : {},
                    onClick: () => setShowThirds((s) => !s)
                  }
                ),
                /* @__PURE__ */ jsx(
                  ToolbarButton,
                  {
                    "aria-label": t("app.components.image-viewer.crop-to-selection"),
                    icon: /* @__PURE__ */ jsx(Crop20Regular, {}),
                    disabled: selection === null,
                    onClick: () => void handleCrop()
                  }
                )
              ] }),
              /* @__PURE__ */ jsx(ToolbarDivider, {}),
              /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t(
                    isFullscreen ? "app.components.image-viewer.exit-fullscreen" : "app.components.image-viewer.enter-fullscreen"
                  ),
                  icon: isFullscreen ? /* @__PURE__ */ jsx(FullScreenMinimize20Regular, {}) : /* @__PURE__ */ jsx(FullScreenMaximize20Regular, {}),
                  onClick: handleToggleFullscreen
                }
              ),
              downloadable && /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t("app.buttons.download-item", [resolvedFileName]),
                  icon: /* @__PURE__ */ jsx(ArrowDownload20Regular, {}),
                  onClick: handleDownload
                }
              ),
              (onSave || onCancel) && /* @__PURE__ */ jsx(ToolbarDivider, {}),
              onCancel && // Red prohibited-circle = "discard / exit". Color comes from a
              // palette token so it stays semantically red across light/dark
              // theme switches and consumer accent customizations.
              /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t("app.buttons.cancel.label"),
                  icon: /* @__PURE__ */ jsx(Prohibited20Regular, { className: styles.cancelIcon }),
                  onClick: onCancel
                }
              ),
              onSave && // Filled green checkmark = "commit changes". Disabled while the
              // viewer is clean so the consumer doesn't fire a no-op commit
              // (matches the `commit() returns null when !isDirty` contract).
              /* @__PURE__ */ jsx(
                ToolbarButton,
                {
                  "aria-label": t("app.buttons.save.label"),
                  icon: /* @__PURE__ */ jsx(Checkmark20Filled, { className: styles.saveIcon }),
                  disabled: !isDirty,
                  onClick: () => void onSave()
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            ref: imageContainerRef,
            className: mergeClasses(
              styles.imageContainer,
              isFullscreen && styles.imageContainerFullscreen
            ),
            onPointerDown: toolbar ? onContainerPointerDown : void 0,
            onPointerMove: toolbar ? onContainerPointerMove : void 0,
            onPointerUp: toolbar ? onContainerPointerUp : void 0,
            onPointerCancel: toolbar ? onContainerPointerUp : void 0,
            style: cropEnabled ? { cursor: "crosshair" } : toolbar && zoom > 1 ? { cursor: isDragging ? "grabbing" : "grab" } : void 0,
            children: [
              img,
              selection && // Dashed selection rectangle over the image. The huge spread
              // box-shadow dims everything outside the rectangle inside the
              // container — clipped by the container's overflow:hidden.
              /* @__PURE__ */ jsxs(
                "div",
                {
                  className: styles.selectionOverlay,
                  style: {
                    left: `${selection.x}px`,
                    top: `${selection.y}px`,
                    width: `${selection.w}px`,
                    height: `${selection.h}px`,
                    // Match the image's 120ms ease-out (see `imgStyle.transition`)
                    // so a transform-driven re-projection animates in lockstep
                    // with the image. Disabled while a drag is active so user
                    // drags track the cursor 1:1 instead of trailing 120ms
                    // behind. dragRef is a ref rather than state, but every
                    // pointermove (which is what changes the selection during
                    // a drag) calls setSelection — that triggers a re-render
                    // which reads the current dragRef value.
                    transition: dragRef.current ? "none" : "left 120ms ease-out, top 120ms ease-out, width 120ms ease-out, height 120ms ease-out"
                  },
                  children: [
                    showThirds && /* @__PURE__ */ jsxs("div", { className: styles.thirdsGuide, "aria-hidden": "true", children: [
                      /* @__PURE__ */ jsx("div", { className: styles.thirdsLineV1 }),
                      /* @__PURE__ */ jsx("div", { className: styles.thirdsLineV2 }),
                      /* @__PURE__ */ jsx("div", { className: styles.thirdsLineH1 }),
                      /* @__PURE__ */ jsx("div", { className: styles.thirdsLineH2 })
                    ] }),
                    selectionNaturalDims && /* @__PURE__ */ jsxs("div", { className: styles.dimensionBadge, "aria-hidden": "true", children: [
                      selectionNaturalDims.w,
                      " \xD7 ",
                      selectionNaturalDims.h,
                      " px"
                    ] }),
                    /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: mergeClasses(styles.resizeHandle, styles.handleNW),
                        "data-handle": "nw",
                        onPointerDown: onHandlePointerDown,
                        "aria-label": t("app.components.image-viewer.resize-top-left")
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: mergeClasses(styles.resizeHandle, styles.handleNE),
                        "data-handle": "ne",
                        onPointerDown: onHandlePointerDown,
                        "aria-label": t("app.components.image-viewer.resize-top-right")
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: mergeClasses(styles.resizeHandle, styles.handleSE),
                        "data-handle": "se",
                        onPointerDown: onHandlePointerDown,
                        "aria-label": t("app.components.image-viewer.resize-bottom-right")
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: mergeClasses(styles.resizeHandle, styles.handleSW),
                        "data-handle": "sw",
                        onPointerDown: onHandlePointerDown,
                        "aria-label": t("app.components.image-viewer.resize-bottom-left")
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: mergeClasses(styles.resizeHandle, styles.handleN),
                        "data-handle": "n",
                        onPointerDown: onHandlePointerDown,
                        "aria-label": t("app.components.image-viewer.resize-top")
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: mergeClasses(styles.resizeHandle, styles.handleS),
                        "data-handle": "s",
                        onPointerDown: onHandlePointerDown,
                        "aria-label": t("app.components.image-viewer.resize-bottom")
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: mergeClasses(styles.resizeHandle, styles.handleE),
                        "data-handle": "e",
                        onPointerDown: onHandlePointerDown,
                        "aria-label": t("app.components.image-viewer.resize-right")
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: mergeClasses(styles.resizeHandle, styles.handleW),
                        "data-handle": "w",
                        onPointerDown: onHandlePointerDown,
                        "aria-label": t("app.components.image-viewer.resize-left")
                      }
                    )
                  ]
                }
              ),
              downloadable && !toolbar && /* @__PURE__ */ jsx(
                Button,
                {
                  appearance: "subtle",
                  size: "small",
                  icon: /* @__PURE__ */ jsx(ArrowDownload20Regular, {}),
                  "aria-label": t("app.buttons.download-item", [resolvedFileName]),
                  className: styles.downloadButton,
                  onClick: (ev) => {
                    ev.stopPropagation();
                    handleDownload();
                  }
                }
              )
            ]
          }
        )
      ]
    }
  );
});
function extractFileName(source) {
  if (!source) return void 0;
  if (source.kind === "url") {
    try {
      const url = new URL(source.value, "http://_resolve");
      const last = url.pathname.split("/").filter(Boolean).pop();
      return last ? decodeURIComponent(last) : void 0;
    } catch {
      return void 0;
    }
  }
  return source.fileName;
}
function resolveMimeType(source) {
  if (source.kind === "url") return "image/*";
  if (source.mimeType) return source.mimeType;
  if (source.fileName) return guessImageMimeType(source.fileName);
  return "image/jpeg";
}
function useImageSrc(source) {
  const lastSourceRef = useRef(void 0);
  const bytesUrlRef = useRef(null);
  const isBytes = source != null && source.kind === "bytes";
  if (source !== lastSourceRef.current || isBytes && bytesUrlRef.current === null) {
    if (bytesUrlRef.current !== null) {
      URL.revokeObjectURL(bytesUrlRef.current);
      bytesUrlRef.current = null;
    }
    if (isBytes && source) {
      const blob = new Blob([source.value.buffer], {
        type: resolveMimeType(source)
      });
      bytesUrlRef.current = URL.createObjectURL(blob);
    }
    lastSourceRef.current = source;
  }
  useEffect(() => {
    return () => {
      if (bytesUrlRef.current !== null) {
        URL.revokeObjectURL(bytesUrlRef.current);
        bytesUrlRef.current = null;
      }
    };
  }, []);
  if (!source) return null;
  if (source.kind === "url") return source.value || null;
  if (source.kind === "base64")
    return source.value ? `data:${resolveMimeType(source)};base64,${source.value}` : null;
  return bytesUrlRef.current;
}
function getDisplayedImageBounds(imageEl, angle, zoom, pan, flipH, flipV) {
  const layoutW = imageEl.offsetWidth;
  const layoutH = imageEl.offsetHeight;
  const naturalW = imageEl.naturalWidth;
  const naturalH = imageEl.naturalHeight;
  if (layoutW === 0 || layoutH === 0 || naturalW === 0 || naturalH === 0) return null;
  const containScale = Math.min(layoutW / naturalW, layoutH / naturalH);
  const displayW = naturalW * containScale;
  const displayH = naturalH * containScale;
  const imgCenterX = imageEl.offsetLeft + layoutW / 2;
  const imgCenterY = imageEl.offsetTop + layoutH / 2;
  const halfW = displayW / 2;
  const halfH = displayH / 2;
  const sx = zoom * (flipH ? -1 : 1);
  const sy = zoom * (flipV ? -1 : 1);
  const rad = angle * Math.PI / 180;
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);
  const corners = [
    [-halfW, -halfH],
    [halfW, -halfH],
    [halfW, halfH],
    [-halfW, halfH]
  ];
  let minX = Infinity;
  let maxX = -Infinity;
  let minY = Infinity;
  let maxY = -Infinity;
  for (const [cx, cy] of corners) {
    const x1 = cx * sx;
    const y1 = cy * sy;
    const x2 = x1 * cos - y1 * sin;
    const y2 = x1 * sin + y1 * cos;
    const x3 = x2 + pan.x + imgCenterX;
    const y3 = y2 + pan.y + imgCenterY;
    if (x3 < minX) minX = x3;
    if (x3 > maxX) maxX = x3;
    if (y3 < minY) minY = y3;
    if (y3 > maxY) maxY = y3;
  }
  return { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
}
function containerRectToImageNatural(rect, imageEl, angle, zoom, pan, flipH, flipV) {
  const layoutW = imageEl.offsetWidth;
  const layoutH = imageEl.offsetHeight;
  const naturalW = imageEl.naturalWidth;
  const naturalH = imageEl.naturalHeight;
  if (layoutW === 0 || layoutH === 0 || naturalW === 0 || naturalH === 0) return null;
  const containScale = Math.min(layoutW / naturalW, layoutH / naturalH);
  const imgCenterX = imageEl.offsetLeft + layoutW / 2;
  const imgCenterY = imageEl.offsetTop + layoutH / 2;
  const sx = zoom * (flipH ? -1 : 1);
  const sy = zoom * (flipV ? -1 : 1);
  if (sx === 0 || sy === 0) return null;
  const rad = angle * Math.PI / 180;
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);
  const corners = [
    [rect.x, rect.y],
    [rect.x + rect.w, rect.y],
    [rect.x + rect.w, rect.y + rect.h],
    [rect.x, rect.y + rect.h]
  ];
  let minX = Infinity;
  let maxX = -Infinity;
  let minY = Infinity;
  let maxY = -Infinity;
  for (const [cx, cy] of corners) {
    const px = cx - imgCenterX - pan.x;
    const py = cy - imgCenterY - pan.y;
    const rx = px * cos + py * sin;
    const ry = -px * sin + py * cos;
    const tx = rx / sx;
    const ty = ry / sy;
    const nx = tx / containScale + naturalW / 2;
    const ny = ty / containScale + naturalH / 2;
    if (nx < minX) minX = nx;
    if (nx > maxX) maxX = nx;
    if (ny < minY) minY = ny;
    if (ny > maxY) maxY = ny;
  }
  return { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
}
function imageNaturalRectToContainer(rect, imageEl, angle, zoom, pan, flipH, flipV) {
  const layoutW = imageEl.offsetWidth;
  const layoutH = imageEl.offsetHeight;
  const naturalW = imageEl.naturalWidth;
  const naturalH = imageEl.naturalHeight;
  if (layoutW === 0 || layoutH === 0 || naturalW === 0 || naturalH === 0) return null;
  const containScale = Math.min(layoutW / naturalW, layoutH / naturalH);
  const imgCenterX = imageEl.offsetLeft + layoutW / 2;
  const imgCenterY = imageEl.offsetTop + layoutH / 2;
  const sx = zoom * (flipH ? -1 : 1);
  const sy = zoom * (flipV ? -1 : 1);
  const rad = angle * Math.PI / 180;
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);
  const corners = [
    [rect.x, rect.y],
    [rect.x + rect.w, rect.y],
    [rect.x + rect.w, rect.y + rect.h],
    [rect.x, rect.y + rect.h]
  ];
  let minX = Infinity;
  let maxX = -Infinity;
  let minY = Infinity;
  let maxY = -Infinity;
  for (const [nx, ny] of corners) {
    const cx = (nx - naturalW / 2) * containScale;
    const cy = (ny - naturalH / 2) * containScale;
    const sxv = cx * sx;
    const syv = cy * sy;
    const rx = sxv * cos - syv * sin;
    const ry = sxv * sin + syv * cos;
    const tx = rx + pan.x + imgCenterX;
    const ty = ry + pan.y + imgCenterY;
    if (tx < minX) minX = tx;
    if (tx > maxX) maxX = tx;
    if (ty < minY) minY = ty;
    if (ty > maxY) maxY = ty;
  }
  return { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
}
async function downloadSource(source, fileName) {
  if (source.kind === "url") {
    const anchor = document.createElement("a");
    anchor.href = source.value;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    return;
  }
  const bytes = source.kind === "base64" ? base64ToBytes(source.value) : source.value;
  triggerBlobDownload(bytes, fileName);
}
function resolveAutoOutputFormat(sourceFileName) {
  const dot = sourceFileName.lastIndexOf(".");
  if (dot < 0) return "png";
  const ext = sourceFileName.slice(dot + 1).toLowerCase();
  return ext === "jpg" || ext === "jpeg" || ext === "jpe" ? "jpeg" : "png";
}
function aspectRatioToNumber(aspect) {
  switch (aspect) {
    case "1:1":
      return 1;
    case "4:3":
      return 4 / 3;
    case "16:9":
      return 16 / 9;
    case "free":
    default:
      return null;
  }
}
function aspectRatioLabel(aspect) {
  return aspect === "free" ? "Free" : aspect;
}
async function renderCrop(args) {
  const { imageEl, selection, angle, zoom, pan, flipH, flipV, sourceFileName, outputQuality } = args;
  const outputFormat = args.outputFormat === "auto" ? resolveAutoOutputFormat(sourceFileName) : args.outputFormat;
  const layoutW = imageEl.offsetWidth;
  const layoutH = imageEl.offsetHeight;
  const naturalW = imageEl.naturalWidth;
  const naturalH = imageEl.naturalHeight;
  if (layoutW === 0 || layoutH === 0 || naturalW === 0 || naturalH === 0) return null;
  const containScale = Math.min(layoutW / naturalW, layoutH / naturalH);
  const imgCenterX = imageEl.offsetLeft + layoutW / 2;
  const imgCenterY = imageEl.offsetTop + layoutH / 2;
  const angleNorm = (angle % 360 + 360) % 360;
  const isQuarterTurn = angleNorm === 90 || angleNorm === 270;
  const rotatedW = isQuarterTurn ? naturalH : naturalW;
  const rotatedH = isQuarterTurn ? naturalW : naturalH;
  const scale = containScale * zoom;
  const corners = [
    [selection.x, selection.y],
    [selection.x + selection.w, selection.y],
    [selection.x + selection.w, selection.y + selection.h],
    [selection.x, selection.y + selection.h]
  ];
  let minX = Infinity;
  let maxX = -Infinity;
  let minY = Infinity;
  let maxY = -Infinity;
  for (const [cx, cy] of corners) {
    const qx = rotatedW / 2 + (cx - imgCenterX - pan.x) / scale;
    const qy = rotatedH / 2 + (cy - imgCenterY - pan.y) / scale;
    if (qx < minX) minX = qx;
    if (qx > maxX) maxX = qx;
    if (qy < minY) minY = qy;
    if (qy > maxY) maxY = qy;
  }
  const cropLeft = Math.max(0, minX);
  const cropTop = Math.max(0, minY);
  const cropRight = Math.min(rotatedW, maxX);
  const cropBottom = Math.min(rotatedH, maxY);
  const cropSrcW = cropRight - cropLeft;
  const cropSrcH = cropBottom - cropTop;
  if (cropSrcW < 1 || cropSrcH < 1) return null;
  const naturalCanvas = document.createElement("canvas");
  naturalCanvas.width = rotatedW;
  naturalCanvas.height = rotatedH;
  const nCtx = naturalCanvas.getContext("2d");
  if (!nCtx) return null;
  nCtx.translate(rotatedW / 2, rotatedH / 2);
  nCtx.rotate(angleNorm * Math.PI / 180);
  nCtx.scale(flipH ? -1 : 1, flipV ? -1 : 1);
  nCtx.drawImage(imageEl, -naturalW / 2, -naturalH / 2, naturalW, naturalH);
  const out = document.createElement("canvas");
  out.width = Math.max(1, Math.round(cropSrcW));
  out.height = Math.max(1, Math.round(cropSrcH));
  const oCtx = out.getContext("2d");
  if (!oCtx) return null;
  oCtx.drawImage(
    naturalCanvas,
    cropLeft,
    cropTop,
    cropSrcW,
    cropSrcH,
    0,
    0,
    out.width,
    out.height
  );
  const mimeType = outputFormat === "jpeg" ? "image/jpeg" : "image/png";
  const ext = outputFormat === "jpeg" ? "jpg" : "png";
  const blob = await new Promise(
    (resolve) => out.toBlob((b) => resolve(b), mimeType, outputQuality)
  );
  if (!blob) return null;
  const arrayBuffer = await blob.arrayBuffer();
  const bytes = new Uint8Array(arrayBuffer);
  const base64 = bytesToBase64(bytes);
  const dot = sourceFileName.lastIndexOf(".");
  const stem = dot >= 0 ? sourceFileName.slice(0, dot) : sourceFileName;
  const fileName = `${stem}-cropped.${ext}`;
  return {
    bytes,
    base64,
    mimeType,
    fileName,
    width: out.width,
    height: out.height
  };
}
async function renderBakedImage(args) {
  const { imageEl, angle, flipH, flipV, sourceFileName, outputQuality } = args;
  const outputFormat = args.outputFormat === "auto" ? resolveAutoOutputFormat(sourceFileName) : args.outputFormat;
  const naturalW = imageEl.naturalWidth;
  const naturalH = imageEl.naturalHeight;
  if (naturalW === 0 || naturalH === 0) return null;
  const angleNorm = (angle % 360 + 360) % 360;
  const isQuarterTurn = angleNorm === 90 || angleNorm === 270;
  const outputW = isQuarterTurn ? naturalH : naturalW;
  const outputH = isQuarterTurn ? naturalW : naturalH;
  const canvas = document.createElement("canvas");
  canvas.width = outputW;
  canvas.height = outputH;
  const ctx = canvas.getContext("2d");
  if (!ctx) return null;
  ctx.translate(outputW / 2, outputH / 2);
  ctx.rotate(angleNorm * Math.PI / 180);
  ctx.scale(flipH ? -1 : 1, flipV ? -1 : 1);
  ctx.drawImage(imageEl, -naturalW / 2, -naturalH / 2, naturalW, naturalH);
  const mimeType = outputFormat === "jpeg" ? "image/jpeg" : "image/png";
  const ext = outputFormat === "jpeg" ? "jpg" : "png";
  const blob = await new Promise(
    (resolve) => canvas.toBlob((b) => resolve(b), mimeType, outputQuality)
  );
  if (!blob) return null;
  const arrayBuffer = await blob.arrayBuffer();
  const bytes = new Uint8Array(arrayBuffer);
  const base64 = bytesToBase64(bytes);
  const dot = sourceFileName.lastIndexOf(".");
  const stem = dot >= 0 ? sourceFileName.slice(0, dot) : sourceFileName;
  const fileName = `${stem}-edited.${ext}`;
  return {
    bytes,
    base64,
    mimeType,
    fileName,
    width: outputW,
    height: outputH
  };
}
function bytesToBase64(bytes) {
  const chunkSize = 32768;
  let binary = "";
  for (let i = 0; i < bytes.length; i += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
  }
  return btoa(binary);
}
var useImageViewerStyles = makeStyles({
  bareImage: {
    maxWidth: "100%",
    height: "auto",
    display: "block"
  },
  clickable: {
    cursor: "pointer"
  },
  wrapper: {
    display: "inline-flex",
    flexDirection: "column",
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground2,
    overflow: "hidden"
  },
  wrapperFullscreen: {
    width: "100vw",
    height: "100vh",
    border: "none",
    borderRadius: 0,
    backgroundColor: tokens.colorNeutralBackground1
  },
  toolbar: {
    flex: "0 0 auto",
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground1
  },
  imageContainer: {
    position: "relative",
    flex: "1 1 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: tokens.spacingHorizontalM,
    minHeight: "120px",
    overflow: "hidden"
  },
  imageContainerFullscreen: {
    padding: 0
  },
  framedImage: {
    maxWidth: "100%",
    maxHeight: "320px",
    objectFit: "contain",
    display: "block",
    userSelect: "none",
    WebkitUserSelect: "none"
  },
  framedImageFullscreen: {
    maxHeight: "100%",
    maxWidth: "100%"
  },
  selectionOverlay: {
    position: "absolute",
    border: `${tokens.strokeWidthThicker} dashed ${tokens.colorNeutralStrokeOnBrand}`,
    // Spread shadow dims everything outside the rectangle. The container's
    // `overflow: hidden` clips the shadow to the visible viewer area.
    boxShadow: "0 0 0 9999px rgba(0, 0, 0, 0.45)",
    // `auto` (not `none`) so the overlay can show a `move` cursor while
    // the pointer is inside the selection — the pointerdown still bubbles
    // up to the container's handler (currentTarget is the container), so
    // hit-testing and pointer capture continue to work the same way.
    pointerEvents: "auto",
    cursor: "move",
    boxSizing: "border-box",
    // Drag-handle hardening: stop the browser from interpreting the
    // press-and-drag as a text-selection or touch gesture. Without
    // these, the browser intermittently steals pointer capture mid-
    // move (the move drag freezes; the user has to click to "reset"
    // before they can drag again).
    userSelect: "none",
    WebkitUserSelect: "none",
    touchAction: "none"
  },
  // Rule-of-thirds guide. A pointer-transparent container that fills the
  // selection rectangle and holds four thin lines (two vertical, two
  // horizontal) at the 1/3 and 2/3 marks. Lines are translucent white so
  // they read against any image content without overpowering it.
  thirdsGuide: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: "none"
  },
  thirdsLineV1: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: "33.3333%",
    width: "1px",
    backgroundColor: "rgba(255, 255, 255, 0.55)"
  },
  thirdsLineV2: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: "66.6667%",
    width: "1px",
    backgroundColor: "rgba(255, 255, 255, 0.55)"
  },
  thirdsLineH1: {
    position: "absolute",
    left: 0,
    right: 0,
    top: "33.3333%",
    height: "1px",
    backgroundColor: "rgba(255, 255, 255, 0.55)"
  },
  thirdsLineH2: {
    position: "absolute",
    left: 0,
    right: 0,
    top: "66.6667%",
    height: "1px",
    backgroundColor: "rgba(255, 255, 255, 0.55)"
  },
  // Live dimension readout. Anchored to the top-left of the selection,
  // sitting just outside the dashed border. Opaque background so it
  // shows clearly over the dimmed surrounding area. `pointer-events:
  // none` so the badge can't accidentally start a move-drag (the
  // overlay-level `cursor: move` and pointer handlers would otherwise
  // see it as a hit target).
  dimensionBadge: {
    position: "absolute",
    top: 0,
    left: 0,
    transform: "translateY(calc(-100% - 4px))",
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorNeutralForeground1,
    paddingTop: "2px",
    paddingBottom: "2px",
    paddingLeft: tokens.spacingHorizontalXS,
    paddingRight: tokens.spacingHorizontalXS,
    borderTopLeftRadius: tokens.borderRadiusSmall,
    borderTopRightRadius: tokens.borderRadiusSmall,
    borderBottomLeftRadius: tokens.borderRadiusSmall,
    borderBottomRightRadius: tokens.borderRadiusSmall,
    fontSize: tokens.fontSizeBase200,
    fontFamily: tokens.fontFamilyMonospace,
    lineHeight: 1.2,
    whiteSpace: "nowrap",
    pointerEvents: "none",
    userSelect: "none",
    WebkitUserSelect: "none",
    boxShadow: tokens.shadow4,
    zIndex: 2
  },
  // Resize handles. Small filled squares on each corner (always) and edge
  // midpoint (free aspect only). Positioned on the overlay's border with
  // a half-size translate so the visible square straddles the edge — gives
  // a wide hit target without the handle "moving" the visual edge of the
  // selection.
  resizeHandle: {
    position: "absolute",
    width: "12px",
    height: "12px",
    backgroundColor: tokens.colorNeutralBackground1,
    borderTopWidth: tokens.strokeWidthThin,
    borderRightWidth: tokens.strokeWidthThin,
    borderBottomWidth: tokens.strokeWidthThin,
    borderLeftWidth: tokens.strokeWidthThin,
    borderTopStyle: "solid",
    borderRightStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftStyle: "solid",
    borderTopColor: tokens.colorNeutralStrokeAccessible,
    borderRightColor: tokens.colorNeutralStrokeAccessible,
    borderBottomColor: tokens.colorNeutralStrokeAccessible,
    borderLeftColor: tokens.colorNeutralStrokeAccessible,
    borderTopLeftRadius: tokens.borderRadiusSmall,
    borderTopRightRadius: tokens.borderRadiusSmall,
    borderBottomLeftRadius: tokens.borderRadiusSmall,
    borderBottomRightRadius: tokens.borderRadiusSmall,
    pointerEvents: "auto",
    userSelect: "none",
    WebkitUserSelect: "none",
    touchAction: "none",
    // Sit above the dashed border so the user can grab them.
    zIndex: 1,
    boxSizing: "border-box"
  },
  handleNW: {
    top: 0,
    left: 0,
    transform: "translate(-50%, -50%)",
    cursor: "nwse-resize"
  },
  handleNE: {
    top: 0,
    right: 0,
    transform: "translate(50%, -50%)",
    cursor: "nesw-resize"
  },
  handleSE: {
    bottom: 0,
    right: 0,
    transform: "translate(50%, 50%)",
    cursor: "nwse-resize"
  },
  handleSW: {
    bottom: 0,
    left: 0,
    transform: "translate(-50%, 50%)",
    cursor: "nesw-resize"
  },
  handleN: {
    top: 0,
    left: "50%",
    transform: "translate(-50%, -50%)",
    cursor: "ns-resize"
  },
  handleS: {
    bottom: 0,
    left: "50%",
    transform: "translate(-50%, 50%)",
    cursor: "ns-resize"
  },
  handleE: {
    top: "50%",
    right: 0,
    transform: "translate(50%, -50%)",
    cursor: "ew-resize"
  },
  handleW: {
    top: "50%",
    left: 0,
    transform: "translate(-50%, -50%)",
    cursor: "ew-resize"
  },
  downloadButton: {
    position: "absolute",
    top: tokens.spacingVerticalXS,
    right: tokens.spacingHorizontalXS,
    backgroundColor: tokens.colorNeutralBackground1
  },
  // Palette tokens (not bare hex) so the colors track the theme — Fluent's
  // light/dark switch picks the right contrast, and the disabled state
  // overlay still applies cleanly on top.
  saveIcon: {
    color: tokens.colorPaletteGreenForeground1
  },
  cancelIcon: {
    color: tokens.colorPaletteRedForeground1
  }
});
hljs.registerLanguage("xml", xml);
hljs.registerLanguage("json", json);
hljs.registerLanguage("yaml", yaml);
hljs.registerLanguage("javascript", javascript);
hljs.registerLanguage("typescript", typescript);
hljs.registerLanguage("csharp", csharp);
hljs.registerLanguage("css", css);
hljs.registerLanguage("markdown", markdown);
function highlightToHtml(code, language) {
  if (language && language !== "plaintext" && hljs.getLanguage(language)) {
    return hljs.highlight(code, { language, ignoreIllegals: true }).value;
  }
  return escapeHtml(code);
}
function escapeHtml(value) {
  return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}
function FileViewer({
  source,
  fileName,
  className,
  style,
  id,
  fallback,
  maxHeight = "60vh",
  downloadable = true
}) {
  const styles = useFileViewerStyles();
  if (!source) return /* @__PURE__ */ jsx(Fragment, { children: fallback ?? null });
  const resolvedFileName = fileName ?? (source.kind === "url" ? source.fileName ?? extractFileNameFromUrl(source.value) : source.fileName) ?? "file";
  const resolvedMime = source.mimeType ?? getMimeFromFileName(resolvedFileName);
  const category = categorizeFile({
    mimeType: resolvedMime,
    fileName: resolvedFileName
  });
  const wrapperClass = mergeClasses(styles.wrapper, className);
  const wrapperStyle = { ...style };
  switch (category) {
    case "image":
      return /* @__PURE__ */ jsx("div", { className: styles.imageCenter, children: /* @__PURE__ */ jsx(
        ImageViewer,
        {
          source: toImageSource(source),
          fileName: resolvedFileName,
          framed: true,
          downloadable,
          ...className !== void 0 && { className },
          ...style !== void 0 && { style },
          ...id !== void 0 && { id }
        }
      ) });
    case "markdown":
      return /* @__PURE__ */ jsx(
        MarkdownRenderer,
        {
          source,
          fileName: resolvedFileName,
          className: wrapperClass,
          style: wrapperStyle,
          id,
          maxHeight,
          downloadable
        }
      );
    case "text":
      return /* @__PURE__ */ jsx(
        TextRenderer,
        {
          source,
          fileName: resolvedFileName,
          className: wrapperClass,
          style: wrapperStyle,
          id,
          maxHeight,
          downloadable
        }
      );
    case "embedded":
      return /* @__PURE__ */ jsx(
        EmbeddedRenderer,
        {
          source,
          fileName: resolvedFileName,
          mimeType: resolvedMime,
          className: wrapperClass,
          style: wrapperStyle,
          id,
          maxHeight,
          downloadable
        }
      );
    case "zip":
      return /* @__PURE__ */ jsx(
        ZipViewer,
        {
          source,
          fileName: resolvedFileName,
          className: wrapperClass,
          style: wrapperStyle,
          id,
          maxHeight,
          downloadable
        }
      );
    case "download":
    default:
      return /* @__PURE__ */ jsx(
        DownloadCard,
        {
          source,
          fileName: resolvedFileName,
          mimeType: resolvedMime,
          className: wrapperClass,
          style: wrapperStyle,
          id
        }
      );
  }
}
function toImageSource(source) {
  if (source.kind === "url") return { kind: "url", value: source.value };
  const base = { kind: source.kind, value: source.value };
  return {
    ...base,
    ...source.mimeType !== void 0 && { mimeType: source.mimeType },
    ...source.fileName !== void 0 && { fileName: source.fileName }
  };
}
function extractFileNameFromUrl(url) {
  try {
    const parsed = new URL(url, "http://_resolve");
    const last = parsed.pathname.split("/").filter(Boolean).pop();
    return last ? decodeURIComponent(last) : void 0;
  } catch {
    return void 0;
  }
}
function DownloadOverlayButton({ source, fileName }) {
  const styles = useFileViewerStyles();
  const t = useT();
  return /* @__PURE__ */ jsx(
    Button,
    {
      appearance: "subtle",
      icon: /* @__PURE__ */ jsx(ArrowDownload20Regular, {}),
      title: t("app.components.file-viewer.download"),
      "aria-label": t("app.components.file-viewer.download"),
      onClick: () => void downloadFileSource(source, fileName),
      className: styles.downloadOverlay
    }
  );
}
function TextRenderer({
  source,
  fileName,
  className,
  style,
  id,
  maxHeight,
  downloadable
}) {
  const styles = useFileViewerStyles();
  const { text, error, isLoading } = useFileText(source);
  const language = getHighlightLanguage(fileName);
  const html = useHighlightedHtml(text, language);
  if (isLoading) return /* @__PURE__ */ jsx(LoadingShell, { className, style, id });
  if (error) return /* @__PURE__ */ jsx(ErrorShell, { className, style, id, message: error });
  if (text === null) return null;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      id,
      className: mergeClasses(styles.codeFrame, className),
      style: { height: "100%", maxHeight, ...style },
      children: [
        html !== null ? /* @__PURE__ */ jsx(HighlightedCodeBlock, { html }) : /* @__PURE__ */ jsx("pre", { className: styles.fallbackPre, children: text }),
        downloadable && /* @__PURE__ */ jsx(DownloadOverlayButton, { source, fileName })
      ]
    }
  );
}
function MarkdownRenderer({
  source,
  fileName,
  className,
  style,
  id,
  maxHeight,
  downloadable
}) {
  const styles = useFileViewerStyles();
  const t = useT();
  const { text, error, isLoading } = useFileText(source);
  const [tab, setTab] = useState("preview");
  const sourceHtml = useHighlightedHtml(tab === "source" ? text : null, "markdown");
  if (isLoading) return /* @__PURE__ */ jsx(LoadingShell, { className, style, id });
  if (error) return /* @__PURE__ */ jsx(ErrorShell, { className, style, id, message: error });
  if (text === null) return null;
  return /* @__PURE__ */ jsxs("div", { id, className: mergeClasses(styles.markdownFrame, className), style, children: [
    /* @__PURE__ */ jsxs(
      TabList,
      {
        selectedValue: tab,
        onTabSelect: (_, data) => setTab(data.value),
        size: "small",
        children: [
          /* @__PURE__ */ jsx(Tab, { value: "preview", children: t("app.components.file-viewer.preview-tab") }),
          /* @__PURE__ */ jsx(Tab, { value: "source", children: t("app.components.file-viewer.source-tab") })
        ]
      }
    ),
    /* @__PURE__ */ jsx("div", { className: styles.markdownBody, style: { maxHeight }, children: tab === "preview" ? /* @__PURE__ */ jsx("div", { className: styles.markdownPreview, children: /* @__PURE__ */ jsx(Markdown, { children: text }) }) : sourceHtml !== null ? /* @__PURE__ */ jsx(HighlightedCodeBlock, { html: sourceHtml }) : /* @__PURE__ */ jsx("pre", { className: styles.fallbackPre, children: text }) }),
    downloadable && /* @__PURE__ */ jsx(DownloadOverlayButton, { source, fileName })
  ] });
}
function EmbeddedRenderer({
  source,
  fileName,
  mimeType,
  className,
  style,
  id,
  maxHeight,
  downloadable
}) {
  const styles = useFileViewerStyles();
  const objectUrl = useObjectUrl(source, mimeType);
  if (source.kind === "url") {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        id,
        className: mergeClasses(styles.embeddedWrapper, className),
        style: { ...style, height: maxHeight },
        children: [
          /* @__PURE__ */ jsx("iframe", { title: fileName, src: source.value, className: styles.iframe }),
          downloadable && /* @__PURE__ */ jsx(DownloadOverlayButton, { source, fileName })
        ]
      }
    );
  }
  if (!objectUrl) return /* @__PURE__ */ jsx(LoadingShell, { className, style, id });
  return /* @__PURE__ */ jsxs(
    "div",
    {
      id,
      className: mergeClasses(styles.embeddedWrapper, className),
      style: { ...style, height: maxHeight },
      children: [
        /* @__PURE__ */ jsx("iframe", { title: fileName, src: objectUrl, className: styles.iframe }),
        downloadable && /* @__PURE__ */ jsx(DownloadOverlayButton, { source, fileName })
      ]
    }
  );
}
var ZIP_TREE_MIN_WIDTH = 180;
var ZIP_TREE_MIN_PREVIEW = 280;
var ZIP_TREE_INITIAL_WIDTH = 280;
var ZIP_SPLITTER_KEY_STEP = 16;
var ZIP_TREE_WIDTH_STORAGE_KEY = "powerportalspro:zipViewer:treeWidth";
var ZIP_TREE_WIDTH_PERSIST_DEBOUNCE_MS = 250;
function ZipViewer({
  source,
  fileName,
  className,
  style,
  id,
  maxHeight,
  downloadable
}) {
  const styles = useFileViewerStyles();
  const t = useT();
  const { bytes, error, isLoading } = useFileBytes(source);
  const [entries, treeError] = useMemo(() => {
    if (!bytes) return [null, null];
    try {
      return [unzipSync(bytes), null];
    } catch (err) {
      return [null, err instanceof Error ? err.message : "Failed to read archive."];
    }
  }, [bytes]);
  const tree = useMemo(() => entries ? buildZipTree(entries) : [], [entries]);
  const [selected, setSelected] = useState(null);
  const [expanded, setExpanded] = useState(() => /* @__PURE__ */ new Set());
  useEffect(() => {
    setSelected(null);
    setExpanded(/* @__PURE__ */ new Set());
  }, [entries]);
  const frameRef = useRef(null);
  const [treeWidth, setTreeWidth] = useState(() => {
    if (typeof window === "undefined") return ZIP_TREE_INITIAL_WIDTH;
    try {
      const stored = window.localStorage.getItem(ZIP_TREE_WIDTH_STORAGE_KEY);
      if (stored !== null) {
        const parsed = Number.parseInt(stored, 10);
        if (Number.isFinite(parsed) && parsed >= ZIP_TREE_MIN_WIDTH) return parsed;
      }
    } catch {
    }
    return ZIP_TREE_INITIAL_WIDTH;
  });
  const dragStateRef = useRef(
    null
  );
  useEffect(() => {
    if (typeof window === "undefined") return;
    const handle = window.setTimeout(() => {
      try {
        window.localStorage.setItem(
          ZIP_TREE_WIDTH_STORAGE_KEY,
          String(Math.round(treeWidth))
        );
      } catch {
      }
    }, ZIP_TREE_WIDTH_PERSIST_DEBOUNCE_MS);
    return () => window.clearTimeout(handle);
  }, [treeWidth]);
  const computeMaxTreeWidth = () => {
    const totalWidth = frameRef.current?.getBoundingClientRect().width ?? 0;
    return Math.max(ZIP_TREE_MIN_WIDTH, totalWidth - ZIP_TREE_MIN_PREVIEW);
  };
  const onSplitterPointerDown = (ev) => {
    ev.preventDefault();
    ev.currentTarget.setPointerCapture(ev.pointerId);
    dragStateRef.current = {
      startX: ev.clientX,
      startWidth: treeWidth,
      maxWidth: computeMaxTreeWidth()
    };
  };
  const onSplitterPointerMove = (ev) => {
    const drag = dragStateRef.current;
    if (!drag) return;
    if (!ev.currentTarget.hasPointerCapture(ev.pointerId)) return;
    const delta = ev.clientX - drag.startX;
    const next = Math.min(Math.max(drag.startWidth + delta, ZIP_TREE_MIN_WIDTH), drag.maxWidth);
    setTreeWidth(next);
  };
  const onSplitterPointerUp = (ev) => {
    if (ev.currentTarget.hasPointerCapture(ev.pointerId)) {
      ev.currentTarget.releasePointerCapture(ev.pointerId);
    }
    dragStateRef.current = null;
  };
  const onSplitterKeyDown = (ev) => {
    if (ev.key !== "ArrowLeft" && ev.key !== "ArrowRight") return;
    ev.preventDefault();
    const max = computeMaxTreeWidth();
    setTreeWidth((current) => {
      const step = ev.key === "ArrowLeft" ? -ZIP_SPLITTER_KEY_STEP : ZIP_SPLITTER_KEY_STEP;
      return Math.min(Math.max(current + step, ZIP_TREE_MIN_WIDTH), max);
    });
  };
  const onSplitterDoubleClick = () => {
    setTreeWidth(ZIP_TREE_INITIAL_WIDTH);
  };
  if (isLoading) return /* @__PURE__ */ jsx(LoadingShell, { className, style, id });
  if (error) return /* @__PURE__ */ jsx(ErrorShell, { className, style, id, message: error });
  if (treeError)
    return /* @__PURE__ */ jsx(ErrorShell, { className, style, id, message: treeError });
  if (!entries) return null;
  const toggleFolder = (path) => {
    setExpanded((prev) => {
      const next = new Set(prev);
      if (next.has(path)) next.delete(path);
      else next.add(path);
      return next;
    });
  };
  const selectedBytes = selected !== null ? entries[selected] ?? null : null;
  const selectedLeafName = selected !== null ? leafName(selected) : "";
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: frameRef,
      id,
      className: mergeClasses(styles.zipFrame, className),
      style: { ...style, height: maxHeight },
      children: [
        /* @__PURE__ */ jsx("div", { className: styles.zipTree, style: { width: `${treeWidth}px` }, children: tree.length === 0 ? /* @__PURE__ */ jsx("div", { className: styles.zipEmpty, children: /* @__PURE__ */ jsx("span", { children: "Archive is empty." }) }) : tree.map((node) => /* @__PURE__ */ jsx(
          ZipTreeNode,
          {
            node,
            depth: 0,
            expanded,
            selected,
            onToggle: toggleFolder,
            onSelect: setSelected
          },
          node.fullPath
        )) }),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: styles.zipSplitter,
            role: "separator",
            "aria-orientation": "vertical",
            "aria-label": t("app.components.file-viewer.resize-tree"),
            "aria-valuenow": Math.round(treeWidth),
            "aria-valuemin": ZIP_TREE_MIN_WIDTH,
            tabIndex: 0,
            onPointerDown: onSplitterPointerDown,
            onPointerMove: onSplitterPointerMove,
            onPointerUp: onSplitterPointerUp,
            onPointerCancel: onSplitterPointerUp,
            onKeyDown: onSplitterKeyDown,
            onDoubleClick: onSplitterDoubleClick,
            children: /* @__PURE__ */ jsx("span", { className: styles.zipSplitterGrip, "aria-hidden": true })
          }
        ),
        /* @__PURE__ */ jsx("div", { className: styles.zipPreview, children: selectedBytes ? /* @__PURE__ */ jsx(
          FileViewer,
          {
            source: { kind: "bytes", value: selectedBytes, fileName: selectedLeafName },
            fileName: selectedLeafName,
            maxHeight: "100%"
          },
          selected
        ) : /* @__PURE__ */ jsxs("div", { className: styles.zipEmpty, children: [
          /* @__PURE__ */ jsx(DocumentArrowLeft24Regular, {}),
          /* @__PURE__ */ jsx("span", { children: "Select a file to preview." })
        ] }) }),
        downloadable && /* @__PURE__ */ jsx(DownloadOverlayButton, { source, fileName })
      ]
    }
  );
}
function ZipTreeNode({ node, depth, expanded, selected, onToggle, onSelect }) {
  const styles = useFileViewerStyles();
  const isExpanded = expanded.has(node.fullPath);
  const isSelected = !node.isFolder && node.fullPath === selected;
  const indent = { paddingLeft: `${depth * 20}px` };
  if (node.isFolder) {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: styles.zipRow,
          role: "button",
          tabIndex: 0,
          onClick: () => onToggle(node.fullPath),
          onKeyDown: (ev) => {
            if (ev.key === "Enter" || ev.key === " ") {
              ev.preventDefault();
              onToggle(node.fullPath);
            }
          },
          style: indent,
          children: [
            /* @__PURE__ */ jsx("span", { className: styles.zipChevron, children: isExpanded ? /* @__PURE__ */ jsx(ChevronDown20Regular, {}) : /* @__PURE__ */ jsx(ChevronRight20Regular, {}) }),
            /* @__PURE__ */ jsx(Folder20Regular, { className: styles.zipIconAccent }),
            /* @__PURE__ */ jsx("span", { className: styles.zipName, children: node.name })
          ]
        }
      ),
      isExpanded && node.children.map((child) => /* @__PURE__ */ jsx(
        ZipTreeNode,
        {
          node: child,
          depth: depth + 1,
          expanded,
          selected,
          onToggle,
          onSelect
        },
        child.fullPath
      ))
    ] });
  }
  return /* @__PURE__ */ jsx(Tooltip, { relationship: "description", content: `Size: ${formatSize(node.size)}`, children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: mergeClasses(styles.zipRow, isSelected && styles.zipRowSelected),
      role: "button",
      tabIndex: 0,
      onClick: () => onSelect(node.fullPath),
      onKeyDown: (ev) => {
        if (ev.key === "Enter" || ev.key === " ") {
          ev.preventDefault();
          onSelect(node.fullPath);
        }
      },
      style: indent,
      children: [
        /* @__PURE__ */ jsx("span", { className: styles.zipChevronSpacer }),
        /* @__PURE__ */ jsx(Document20Regular, { className: styles.zipIcon }),
        /* @__PURE__ */ jsx("span", { className: styles.zipName, children: node.name })
      ]
    }
  ) });
}
function buildZipTree(entries) {
  const root = [];
  for (const [path, bytes] of Object.entries(entries)) {
    const normalized = path.replace(/\\/g, "/");
    const isExplicitFolder = normalized.endsWith("/");
    const segments = normalized.split("/").filter(Boolean);
    if (segments.length === 0) continue;
    let current = root;
    let runningPath = "";
    for (let i = 0; i < segments.length - 1; i++) {
      const folderName = segments[i];
      runningPath = runningPath.length === 0 ? folderName : `${runningPath}/${folderName}`;
      let folder = current.find((n) => n.isFolder && n.name === folderName);
      if (!folder) {
        folder = { name: folderName, fullPath: runningPath, isFolder: true, size: 0, children: [] };
        current.push(folder);
      }
      current = folder.children;
    }
    const leaf = segments[segments.length - 1];
    if (isExplicitFolder) {
      if (!current.some((n) => n.isFolder && n.name === leaf)) {
        const folderPath = segments.join("/");
        current.push({ name: leaf, fullPath: folderPath, isFolder: true, size: 0, children: [] });
      }
    } else {
      current.push({
        name: leaf,
        fullPath: path,
        isFolder: false,
        size: bytes.length,
        children: []
      });
    }
  }
  sortZipNodes(root);
  return root;
}
function sortZipNodes(nodes) {
  nodes.sort((a, b) => {
    if (a.isFolder !== b.isFolder) return a.isFolder ? -1 : 1;
    return a.name.localeCompare(b.name, void 0, { sensitivity: "base" });
  });
  for (const node of nodes) {
    if (node.isFolder) sortZipNodes(node.children);
  }
}
function leafName(fullPath) {
  const trimmed = fullPath.endsWith("/") ? fullPath.slice(0, -1) : fullPath;
  const idx = trimmed.lastIndexOf("/");
  return idx < 0 ? trimmed : trimmed.slice(idx + 1);
}
function formatSize(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  let value = bytes;
  for (const unit of ["KB", "MB", "GB", "TB"]) {
    value /= 1024;
    if (value < 1024 || unit === "TB") return `${value.toFixed(1)} ${unit}`;
  }
  return `${bytes} B`;
}
function DownloadCard({
  source,
  fileName,
  mimeType,
  className,
  style,
  id
}) {
  const styles = useFileViewerStyles();
  return /* @__PURE__ */ jsxs("div", { id, className: mergeClasses(styles.card, className), style, children: [
    /* @__PURE__ */ jsx(Document20Regular, { className: styles.cardIcon }),
    /* @__PURE__ */ jsxs("div", { className: styles.cardBody, children: [
      /* @__PURE__ */ jsx("div", { className: styles.cardName, children: fileName }),
      /* @__PURE__ */ jsx("div", { className: styles.cardMime, children: mimeType })
    ] }),
    /* @__PURE__ */ jsx(DownloadOverlayButton, { source, fileName })
  ] });
}
function LoadingShell({
  className,
  style,
  id
}) {
  const styles = useFileViewerStyles();
  return /* @__PURE__ */ jsx("div", { id, className: mergeClasses(styles.statusShell, className), style, children: /* @__PURE__ */ jsx(Spinner, { size: "small" }) });
}
function ErrorShell({
  className,
  style,
  id,
  message
}) {
  const styles = useFileViewerStyles();
  return /* @__PURE__ */ jsxs("div", { id, className: mergeClasses(styles.statusShell, styles.errorShell, className), style, children: [
    /* @__PURE__ */ jsx(ErrorCircle20Regular, {}),
    /* @__PURE__ */ jsx("span", { children: message })
  ] });
}
function HighlightedCodeBlock({ html }) {
  const styles = useFileViewerStyles();
  const { probeRef, isDark } = useFluentColorScheme();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: mergeClasses(styles.codeHost, isDark ? styles.codeHostDark : styles.codeHostLight),
      children: [
        /* @__PURE__ */ jsx("span", { ref: probeRef, className: styles.themeProbe, "aria-hidden": true }),
        /* @__PURE__ */ jsx("pre", { children: /* @__PURE__ */ jsx("code", { className: "hljs", dangerouslySetInnerHTML: { __html: html } }) })
      ]
    }
  );
}
function useFluentColorScheme() {
  const probeRef = useRef(null);
  const [isDark, setIsDark] = useState(false);
  useLayoutEffect(() => {
    const probe = probeRef.current;
    if (!probe) return;
    const measure = () => {
      const bg = window.getComputedStyle(probe).backgroundColor;
      const match = /^rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(bg);
      if (!match) return;
      const r = Number(match[1]);
      const g = Number(match[2]);
      const b = Number(match[3]);
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      setIsDark(luminance < 0.5);
    };
    measure();
    const observer = new MutationObserver(measure);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
      subtree: true
    });
    return () => observer.disconnect();
  }, []);
  return { probeRef, isDark };
}
function useFileText(source) {
  const fetchUrl = source.kind === "url" ? source.value : null;
  const [urlState, setUrlState] = useState({
    text: null,
    error: null,
    isLoading: fetchUrl !== null
  });
  useEffect(() => {
    if (fetchUrl === null) {
      setUrlState({ text: null, error: null, isLoading: false });
      return;
    }
    let cancelled = false;
    setUrlState({ text: null, error: null, isLoading: true });
    (async () => {
      try {
        const response = await fetch(fetchUrl);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        const text = await response.text();
        if (cancelled) return;
        setUrlState({ text, error: null, isLoading: false });
      } catch (err) {
        if (cancelled) return;
        setUrlState({
          text: null,
          error: err instanceof Error ? err.message : "Failed to load file.",
          isLoading: false
        });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [fetchUrl]);
  const inlineValue = source.kind === "url" ? null : source.value;
  const inlineKind = source.kind;
  return useMemo(() => {
    if (inlineKind === "url") return urlState;
    try {
      const text = inlineKind === "base64" ? base64ToText(inlineValue) : bytesToText(inlineValue);
      return { text, error: null, isLoading: false };
    } catch (err) {
      return {
        text: null,
        error: err instanceof Error ? err.message : "Failed to decode file.",
        isLoading: false
      };
    }
  }, [inlineKind, inlineValue, urlState]);
}
function useFileBytes(source) {
  const fetchUrl = source.kind === "url" ? source.value : null;
  const [urlState, setUrlState] = useState({
    bytes: null,
    error: null,
    isLoading: fetchUrl !== null
  });
  useEffect(() => {
    if (fetchUrl === null) {
      setUrlState({ bytes: null, error: null, isLoading: false });
      return;
    }
    let cancelled = false;
    setUrlState({ bytes: null, error: null, isLoading: true });
    (async () => {
      try {
        const response = await fetch(fetchUrl);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const buffer = await response.arrayBuffer();
        if (cancelled) return;
        setUrlState({ bytes: new Uint8Array(buffer), error: null, isLoading: false });
      } catch (err) {
        if (cancelled) return;
        setUrlState({
          bytes: null,
          error: err instanceof Error ? err.message : "Failed to load file.",
          isLoading: false
        });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [fetchUrl]);
  const inlineValue = source.kind === "url" ? null : source.value;
  const inlineKind = source.kind;
  return useMemo(() => {
    if (inlineKind === "url") return urlState;
    try {
      const bytes = inlineKind === "base64" ? base64ToBytes(inlineValue) : inlineValue;
      return { bytes, error: null, isLoading: false };
    } catch (err) {
      return {
        bytes: null,
        error: err instanceof Error ? err.message : "Failed to decode file.",
        isLoading: false
      };
    }
  }, [inlineKind, inlineValue, urlState]);
}
function useObjectUrl(source, mimeType) {
  const inlineValue = source.kind === "url" ? null : source.value;
  const inlineKind = source.kind;
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (inlineKind === "url" || inlineValue === null) {
      setUrl(null);
      return;
    }
    const bytes = inlineKind === "base64" ? base64ToBytes(inlineValue) : inlineValue;
    const blob = new Blob([bytes.buffer], { type: mimeType });
    const next = URL.createObjectURL(blob);
    setUrl(next);
    return () => {
      URL.revokeObjectURL(next);
    };
  }, [inlineKind, inlineValue, mimeType]);
  return url;
}
function useHighlightedHtml(text, language) {
  return useMemo(
    () => text === null ? null : highlightToHtml(text, language),
    [text, language]
  );
}
async function downloadFileSource(source, fileName) {
  if (source.kind === "url") {
    const anchor = document.createElement("a");
    anchor.href = source.value;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    return;
  }
  const bytes = source.kind === "base64" ? base64ToBytes(source.value) : source.value;
  triggerBlobDownload(bytes, fileName);
}
var useFileViewerStyles = makeStyles({
  wrapper: {
    width: "100%"
  },
  imageCenter: {
    // Left-align the framed `ImageViewer` (which is `inline-flex` and
    // shrink-to-content) inside its parent. Previously this wrapper centered
    // the image horizontally for the zip-preview case where the parent
    // provided a fixed height — but the zip viewer now renders image entries
    // through a different code path (see ZipViewer), so the centering only
    // affected the standalone image arm, where the parent always collapses
    // to content height. `flex-start` keeps the image hugging the left edge
    // of its column under the Section's column-flex layout. The class
    // name stays `imageCenter` for continuity with the surrounding code;
    // the styling no longer centers.
    display: "flex",
    justifyContent: "flex-start",
    width: "100%"
  },
  codeFrame: {
    position: "relative",
    overflow: "auto",
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground2
  },
  codeHost: {
    // Position relative so the absolutely-placed theme probe sits inside our
    // box. Column-flex chain so the inner <pre> (the actual scrollable content
    // surface) can stretch to fill the host. `height: 100%` resolves to
    // `auto` when the parent has no defined height — keeps non-zip usage
    // sized to content. minHeight: 0 lets `overflow:auto` on the pre take
    // effect instead of pushing the host taller than the parent.
    position: "relative",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    minHeight: 0,
    "& pre": {
      margin: 0,
      padding: tokens.spacingHorizontalM,
      fontFamily: tokens.fontFamilyMonospace,
      fontSize: tokens.fontSizeBase200,
      lineHeight: tokens.lineHeightBase200,
      // Claim the remaining height in the column-flex chain and own the
      // scroll. Without `flex: 1` the pre would shrink to its content height
      // and leave the host's background visible below it.
      flex: "1 1 auto",
      minHeight: 0,
      overflow: "auto",
      // The code surface sits on the neutral-1 layer; the surrounding
      // `codeFrame` uses neutral-2 so the two read as nested panes. Token
      // colors come from the palette below; the base text color is the
      // theme's foreground.
      backgroundColor: tokens.colorNeutralBackground1,
      color: tokens.colorNeutralForeground1
    },
    "& code.hljs": {
      background: "transparent",
      padding: 0
    }
  },
  // github.css-inspired light palette. Syntax tokens are a semantic
  // palette (not expressible as neutral design tokens), so hex literals
  // are appropriate here — same exception the FluentMessageBar intent
  // colors take.
  codeHostLight: {
    "& .hljs-comment, & .hljs-quote": { color: "#6a737d", fontStyle: "italic" },
    "& .hljs-keyword, & .hljs-selector-tag, & .hljs-literal, & .hljs-section, & .hljs-doctag": {
      color: "#d73a49"
    },
    "& .hljs-string, & .hljs-attr, & .hljs-attribute, & .hljs-addition, & .hljs-template-tag": {
      color: "#032f62"
    },
    "& .hljs-number, & .hljs-symbol, & .hljs-bullet, & .hljs-meta, & .hljs-link": {
      color: "#005cc5"
    },
    "& .hljs-title, & .hljs-type, & .hljs-built_in": { color: "#6f42c1" },
    "& .hljs-tag .hljs-name, & .hljs-variable, & .hljs-template-variable, & .hljs-params": {
      color: "#e36209"
    },
    "& .hljs-regexp, & .hljs-deletion": { color: "#b31d28" },
    "& .hljs-strong": { fontWeight: "bold" },
    "& .hljs-emphasis": { fontStyle: "italic" }
  },
  // github-dark.css-inspired dark palette.
  codeHostDark: {
    "& .hljs-comment, & .hljs-quote": { color: "#8b949e", fontStyle: "italic" },
    "& .hljs-keyword, & .hljs-selector-tag, & .hljs-literal, & .hljs-section, & .hljs-doctag": {
      color: "#ff7b72"
    },
    "& .hljs-string, & .hljs-attr, & .hljs-attribute, & .hljs-addition, & .hljs-template-tag": {
      color: "#a5d6ff"
    },
    "& .hljs-number, & .hljs-symbol, & .hljs-bullet, & .hljs-meta, & .hljs-link": {
      color: "#79c0ff"
    },
    "& .hljs-title, & .hljs-type, & .hljs-built_in": { color: "#d2a8ff" },
    "& .hljs-tag .hljs-name, & .hljs-variable, & .hljs-template-variable, & .hljs-params": {
      color: "#ffa657"
    },
    "& .hljs-regexp, & .hljs-deletion": { color: "#ffa198" },
    "& .hljs-strong": { fontWeight: "bold" },
    "& .hljs-emphasis": { fontStyle: "italic" }
  },
  themeProbe: {
    // Hidden 1×1 probe carrying `tokens.colorNeutralBackground1` so the
    // luminance check in `useFluentColorScheme` resolves the active theme.
    // Visibility-hidden (not display-none) so getComputedStyle returns the
    // resolved color in every browser.
    position: "absolute",
    visibility: "hidden",
    pointerEvents: "none",
    width: "1px",
    height: "1px",
    backgroundColor: tokens.colorNeutralBackground1
  },
  fallbackPre: {
    margin: 0,
    padding: tokens.spacingHorizontalM,
    fontFamily: tokens.fontFamilyMonospace,
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase200,
    whiteSpace: "pre",
    overflow: "auto"
  },
  markdownFrame: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground1,
    overflow: "hidden",
    // Claim full parent height when there is one. Resolves to `auto` (i.e.
    // shrink-to-content) when the parent's height is undefined, so default
    // non-zip usage still sizes to the markdown content.
    height: "100%"
  },
  markdownBody: {
    overflow: "auto",
    borderTop: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    // Fills the remaining frame height inside the column-flex parent
    // pairs with `markdownFrame: height 100%` so the Source tab's pre
    // (and the Preview tab's content) get a real container height to
    // anchor against. minHeight: 0 lets overflow:auto kick in instead of
    // being suppressed by the flex child's content-min-size default.
    flex: "1 1 auto",
    minHeight: 0,
    display: "flex",
    flexDirection: "column"
  },
  markdownPreview: {
    padding: tokens.spacingHorizontalL,
    fontFamily: tokens.fontFamilyBase,
    color: tokens.colorNeutralForeground1,
    "& h1, & h2, & h3, & h4, & h5, & h6": {
      marginTop: tokens.spacingVerticalL,
      marginBottom: tokens.spacingVerticalS
    },
    "& p": {
      marginTop: 0,
      marginBottom: tokens.spacingVerticalM,
      lineHeight: tokens.lineHeightBase300
    },
    "& code": {
      fontFamily: tokens.fontFamilyMonospace,
      fontSize: "0.9em",
      padding: `0 ${tokens.spacingHorizontalXS}`,
      backgroundColor: tokens.colorNeutralBackground3,
      borderRadius: tokens.borderRadiusSmall
    },
    "& pre": {
      padding: tokens.spacingHorizontalM,
      backgroundColor: tokens.colorNeutralBackground3,
      borderRadius: tokens.borderRadiusMedium,
      overflow: "auto"
    },
    "& pre code": {
      padding: 0,
      backgroundColor: "transparent"
    },
    "& a": {
      color: tokens.colorBrandForegroundLink
    },
    "& blockquote": {
      margin: 0,
      paddingLeft: tokens.spacingHorizontalM,
      borderLeft: `${tokens.strokeWidthThicker} solid ${tokens.colorNeutralStroke2}`,
      color: tokens.colorNeutralForeground2
    },
    "& table": {
      borderCollapse: "collapse"
    },
    "& th, & td": {
      padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalS}`,
      border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`
    }
  },
  iframe: {
    width: "100%",
    height: "100%",
    border: "none",
    backgroundColor: tokens.colorNeutralBackground2,
    borderRadius: tokens.borderRadiusMedium
  },
  // Anchor the download overlay against the iframe's host. The iframe itself
  // can't host the positioned button — its absolute children would target
  // its embedded document, not the page — so we wrap one layer up.
  embeddedWrapper: {
    position: "relative",
    width: "100%",
    boxSizing: "border-box"
  },
  // Corner download icon button. Mirrors the
  // metrics: top:4 right:4, layer-1 background, subtle button appearance so
  // it sits over the viewer body without competing for attention.
  downloadOverlay: {
    position: "absolute",
    top: "4px",
    right: "4px",
    zIndex: 1,
    backgroundColor: tokens.colorNeutralBackground1
  },
  card: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalM,
    padding: tokens.spacingHorizontalM,
    // Reserve right-side room for the corner download icon so the file
    // name / MIME row doesn't slide under the overlay button on narrow
    // widths.
    paddingRight: tokens.spacingHorizontalXXXL,
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground2,
    position: "relative"
  },
  cardIcon: {
    flexShrink: 0,
    color: tokens.colorNeutralForeground2
  },
  cardBody: {
    flex: "1 1 auto",
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalXXS
  },
  cardName: {
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  cardMime: {
    fontFamily: tokens.fontFamilyMonospace,
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3
  },
  statusShell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: tokens.spacingHorizontalS,
    padding: tokens.spacingHorizontalL,
    minHeight: "120px",
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground2
  },
  errorShell: {
    color: tokens.colorPaletteRedForeground1
  },
  zipFrame: {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    minHeight: "0",
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground1,
    overflow: "hidden"
  },
  zipTree: {
    flexShrink: 0,
    overflow: "auto",
    backgroundColor: tokens.colorNeutralBackground2
    // Width is set inline by ZipViewer (driven by the splitter); we just
    // own the scroll + background here.
  },
  zipSplitter: {
    flexShrink: 0,
    width: "6px",
    cursor: "col-resize",
    position: "relative",
    backgroundColor: tokens.colorNeutralStroke2,
    transitionProperty: "background-color",
    transitionDuration: tokens.durationFast,
    ":hover": {
      backgroundColor: tokens.colorBrandStroke2
    },
    ":focus-visible": {
      outline: `${tokens.strokeWidthThick} solid ${tokens.colorStrokeFocus2}`,
      outlineOffset: "0"
    },
    // Wider invisible hit-target so the divider grabs cleanly even on
    // trackpads where 6px is unforgiving. The visible bar stays 6px;
    // ::before extends the hover/grab area ±4px on each side.
    "::before": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      left: "-4px",
      right: "-4px"
    }
  },
  zipSplitterGrip: {
    // Subtle three-dot grip in the middle of the divider; visual only,
    // pointer-events pass through to the splitter container.
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "2px",
    height: "24px",
    borderRadius: tokens.borderRadiusCircular,
    backgroundColor: tokens.colorNeutralForeground3,
    pointerEvents: "none",
    opacity: 0.5
  },
  zipPreview: {
    flex: "1 1 auto",
    minWidth: "0",
    overflow: "auto",
    padding: tokens.spacingHorizontalM,
    backgroundColor: tokens.colorNeutralBackground1
  },
  zipRow: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS,
    padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalS}`,
    cursor: "pointer",
    userSelect: "none",
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground1,
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground2Hover
    },
    ":focus-visible": {
      outline: `${tokens.strokeWidthThin} solid ${tokens.colorStrokeFocus2}`,
      outlineOffset: "-1px"
    }
  },
  zipRowSelected: {
    backgroundColor: tokens.colorBrandBackground2,
    color: tokens.colorBrandForeground2,
    ":hover": {
      backgroundColor: tokens.colorBrandBackground2Hover
    }
  },
  zipChevron: {
    flexShrink: 0,
    display: "inline-flex",
    width: "20px",
    height: "20px",
    alignItems: "center",
    justifyContent: "center",
    color: tokens.colorNeutralForeground3
  },
  zipChevronSpacer: {
    flexShrink: 0,
    width: "20px",
    height: "20px"
  },
  zipIcon: {
    flexShrink: 0,
    color: tokens.colorNeutralForeground3
  },
  zipIconAccent: {
    flexShrink: 0,
    color: tokens.colorBrandForeground1
  },
  zipName: {
    flex: "1 1 auto",
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  zipEmpty: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: tokens.spacingVerticalS,
    padding: tokens.spacingHorizontalL,
    minHeight: "160px",
    color: tokens.colorNeutralForeground3,
    textAlign: "center"
  }
});
function FileEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  accept,
  maxFileSizeBytes,
  uploadHintText,
  validate
}) {
  const { value, setValue: rawSetValue, fileId, hydrateValue } = useFileColumn(columnName);
  const { record } = useRecordContext();
  const metadata = useColumnMetadata(columnName);
  const { ppp } = usePowerPortalsPro();
  const styles = useFileEditStyles();
  const t = useT();
  const reactId = useId();
  const inputId = id ?? reactId;
  const [isDownloading, setIsDownloading] = useState(false);
  const [isLoadingMetadata, setIsLoadingMetadata] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [previewSource, setPreviewSource] = useState(null);
  useEffect(() => {
    if (value) return;
    if (!fileId) return;
    if (!record?.tableName || !record.id) return;
    if (record.id === EMPTY_GUID) return;
    let cancelled = false;
    setIsLoadingMetadata(true);
    (async () => {
      try {
        const info = await ppp.getFileInfoAsync(record.tableName, record.id, columnName, false);
        if (cancelled) return;
        if (info.fileName) {
          hydrateValue({
            fileName: info.fileName,
            id: fileId,
            value: null
          });
        }
      } catch (err) {
        if (cancelled) return;
        console.warn(`PowerPortalsPro FileEdit: metadata fetch failed for ${columnName}`, err);
      } finally {
        if (!cancelled) setIsLoadingMetadata(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [columnName, fileId, hydrateValue, ppp, record?.id, record?.tableName, value]);
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = description ?? getDisplayDescription(metadata, columnName, record?.tableName, t);
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled
  );
  const setValue = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const isInteractable = !resolvedReadOnly && !resolvedDisabled;
  const validationErrors = useColumnValidation(
    columnName,
    {
      kind: "string",
      required: resolvedRequired,
      label: resolvedLabel,
      // The required check just needs "is there a value" semantics; the file
      // name is the natural sentinel — empty string means no file, present
      // means there is one. Using the string-kind validator avoids defining
      // a dedicated `file` kind that has the same required-only behavior.
      value: value?.fileName ?? ""
    },
    validate
  );
  const upload = useFileUpload({
    setValue,
    enabled: isInteractable,
    warnPrefix: "PowerPortalsPro FileEdit",
    ...maxFileSizeBytes !== void 0 && { maxFileSizeBytes }
  });
  const handleDownload = useCallback(async () => {
    if (!value) return;
    setIsDownloading(true);
    try {
      const bytes = value.value ? base64ToBytes(value.value) : await fetchFileBytes(ppp, record?.tableName, record?.id, columnName);
      if (bytes === null) return;
      triggerBlobDownload(bytes, value.fileName);
    } finally {
      setIsDownloading(false);
    }
  }, [columnName, ppp, record, value]);
  const isPreviewable = useMemo(() => {
    if (!value?.fileName) return false;
    const mime = getMimeFromFileName(value.fileName);
    return categorizeFile({ mimeType: mime, fileName: value.fileName }) !== "download";
  }, [value?.fileName]);
  const handlePreview = useCallback(async () => {
    if (!value) return;
    setIsPreviewLoading(true);
    try {
      let base64 = value.value ?? null;
      let resolvedFileName = value.fileName;
      if (!base64) {
        if (!record?.tableName || !record.id) return;
        const info = await ppp.getFileInfoAsync(record.tableName, record.id, columnName, true);
        if (!info.fileData) return;
        base64 = info.fileData;
        resolvedFileName = info.fileName || value.fileName;
        hydrateValue({
          fileName: resolvedFileName,
          id: value.id,
          value: base64
        });
      }
      const mime = getMimeFromFileName(resolvedFileName);
      setPreviewSource({
        kind: "base64",
        value: base64,
        mimeType: mime,
        fileName: resolvedFileName
      });
    } finally {
      setIsPreviewLoading(false);
    }
  }, [columnName, hydrateValue, ppp, record, value]);
  if (!isVisible) return null;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  const fieldValidationProps = buildFieldValidationProps(
    validationErrors,
    displayValidationErrorMessage
  );
  const dropZoneClass = mergeClasses(
    styles.dropZone,
    upload.isDragOver && styles.dropZoneActive,
    !isInteractable && styles.dropZoneDisabled,
    className
  );
  return /* @__PURE__ */ jsxs(
    Field,
    {
      className: mergeClasses("ppp-file-edit"),
      label: labelSlot,
      hint: fieldHint,
      required: resolvedRequired,
      ...fieldValidationProps,
      children: [
        /* @__PURE__ */ jsxs("div", { className: styles.wrapper, style, children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              ref: upload.inputRef,
              id: inputId,
              type: "file",
              accept,
              disabled: !isInteractable,
              className: styles.hiddenInput,
              onChange: upload.onInputChange
            }
          ),
          /* @__PURE__ */ jsxs("div", { className: dropZoneClass, ...upload.dropZoneHandlers, children: [
            /* @__PURE__ */ jsx("span", { className: styles.dropZoneText, children: value ? value.fileName : fileId ? isLoadingMetadata ? t("app.components.file-edit.loading-metadata") : "" : uploadHintText ?? t("app.messages.file-upload-drop-zone") }),
            value && // Action overlay — top-right of the drop zone, sitting on top
            // of the filename text. Translucent backdrop + blur match
            // ImageEdit's overlay so the two edits look like siblings.
            // Each button stops click propagation so triggering an action
            // doesn't also fire the drop zone's "open file picker"
            // handler.
            /* @__PURE__ */ jsxs("div", { className: styles.actions, children: [
              isPreviewable && /* @__PURE__ */ jsx(
                Button,
                {
                  appearance: "subtle",
                  icon: /* @__PURE__ */ jsx(Eye20Regular, {}),
                  "aria-label": t("app.buttons.preview-item", [value.fileName]),
                  disabled: isPreviewLoading,
                  onClick: (ev) => {
                    ev.stopPropagation();
                    void handlePreview();
                  }
                }
              ),
              /* @__PURE__ */ jsx(
                Button,
                {
                  appearance: "subtle",
                  icon: /* @__PURE__ */ jsx(ArrowDownload20Regular, {}),
                  "aria-label": t("app.buttons.download-item", [value.fileName]),
                  disabled: isDownloading,
                  onClick: (ev) => {
                    ev.stopPropagation();
                    void handleDownload();
                  }
                }
              ),
              isInteractable && /* @__PURE__ */ jsx(
                Button,
                {
                  appearance: "subtle",
                  icon: /* @__PURE__ */ jsx(Dismiss20Regular, {}),
                  "aria-label": t("app.buttons.remove-item", [value.fileName]),
                  onClick: (ev) => {
                    ev.stopPropagation();
                    setValue(null);
                  }
                }
              )
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsx(
          Dialog,
          {
            open: previewSource !== null,
            onOpenChange: (_, data) => {
              if (!data.open) setPreviewSource(null);
            },
            modalType: "modal",
            children: /* @__PURE__ */ jsx(DialogSurface, { className: styles.previewDialogSurface, children: previewSource && value && /* @__PURE__ */ jsxs(DialogBody, { children: [
              /* @__PURE__ */ jsx(DialogTitle, { children: value.fileName }),
              /* @__PURE__ */ jsx(DialogContent, { className: styles.previewDialogContent, children: /* @__PURE__ */ jsx(FileViewer, { source: previewSource, fileName: value.fileName }) }),
              /* @__PURE__ */ jsx(DialogActions, { children: /* @__PURE__ */ jsx(Button, { appearance: "secondary", onClick: () => setPreviewSource(null), children: t("app.buttons.close.label") }) })
            ] }) })
          }
        )
      ]
    }
  );
}
var useFileEditStyles = makeStyles({
  wrapper: {
    width: "100%"
  },
  hiddenInput: {
    position: "absolute",
    width: "1px",
    height: "1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    border: "none"
  },
  dropZone: {
    // Position-relative so the action overlay can sit inside the drop
    // zone in the top-right corner. Mirrors ImageEdit's `previewFrame`
    // pattern so the two edits feel like siblings.
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "48px",
    paddingInline: tokens.spacingHorizontalM,
    paddingBlock: tokens.spacingVerticalM,
    cursor: "pointer",
    border: `${tokens.strokeWidthThin} dashed ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground2,
    color: tokens.colorNeutralForeground1,
    transition: "background-color 0.15s ease, box-shadow 0.15s ease",
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground2Hover
    },
    ":focus-visible": {
      outline: `${tokens.strokeWidthThick} solid ${tokens.colorStrokeFocus2}`,
      outlineOffset: "2px"
    }
  },
  // Active (drag-over) state. Inset box-shadow rather than overriding
  // borderColor avoids Griffel's strict-typing lockdown that bans mixing
  // `border` shorthand and `borderColor` longhand across rules in the
  // same `makeStyles` call.
  dropZoneActive: {
    backgroundColor: tokens.colorBrandBackground2,
    boxShadow: `inset 0 0 0 ${tokens.strokeWidthThick} ${tokens.colorBrandStroke1}`
  },
  dropZoneDisabled: {
    cursor: "not-allowed",
    opacity: 0.6,
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground2
    }
  },
  dropZoneText: {
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase300,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    // Reserve space on the right for the action overlay so a long
    // filename ellipsizes before colliding with the buttons. ~120px
    // accommodates three buttons (Preview / Download / X) plus their
    // gaps + the overlay's own padding.
    paddingRight: "120px"
  },
  // Overlay corner toolbar — top-right of the drop zone, sitting on top
  // of the filename text. Translucent backdrop keeps the icons readable
  // against any background; rounded corners + soft shadow separate it
  // visually from the frame edge. Same look as ImageEdit's overlay.
  actions: {
    position: "absolute",
    top: tokens.spacingVerticalS,
    right: tokens.spacingHorizontalS,
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS,
    paddingLeft: tokens.spacingHorizontalXS,
    paddingRight: tokens.spacingHorizontalXS,
    paddingTop: "2px",
    paddingBottom: "2px",
    backgroundColor: tokens.colorNeutralBackgroundAlpha,
    backdropFilter: "blur(4px)",
    borderRadius: tokens.borderRadiusMedium,
    boxShadow: tokens.shadow4,
    // Sit above the filename text inside the frame's stacking context.
    zIndex: 1
  },
  // Preview dialog grows wider than Fluent's default surface so PDF /
  // markdown / image renderers have room to breathe. Capped at 90vw/90vh
  // so it stays inside the viewport on smaller screens.
  previewDialogSurface: {
    maxWidth: "min(1200px, 90vw)",
    width: "90vw"
  },
  previewDialogContent: {
    // Let the FileViewer's own inner scroll-area handle overflow; we just
    // need the content slot to not constrain it.
    overflow: "hidden",
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS
  }
});
function ImageEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  accept = "image/*",
  displayImage = true,
  maxFileSizeBytes,
  uploadHintText,
  outputFormat = "auto",
  outputQuality = 0.9,
  validate
}) {
  const { value, setValue: rawSetValue, fileId, hydrateValue } = useFileColumn(columnName);
  const { record } = useRecordContext();
  const metadata = useColumnMetadata(columnName);
  const { ppp } = usePowerPortalsPro();
  const styles = useImageEditStyles();
  const t = useT();
  const reactId = useId();
  const inputId = id ?? reactId;
  const [isDownloading, setIsDownloading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const viewerRef = useRef(null);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled
  );
  const setValue = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const isInteractable = !resolvedReadOnly && !resolvedDisabled;
  const upload = useFileUpload({
    setValue,
    enabled: isInteractable,
    warnPrefix: "PowerPortalsPro ImageEdit",
    ...maxFileSizeBytes !== void 0 && { maxFileSizeBytes }
  });
  useEffect(() => {
    if (!displayImage) return;
    if (value?.value) return;
    if (!fileId) return;
    if (!record?.tableName || !record.id) return;
    if (record.id === EMPTY_GUID) return;
    let cancelled = false;
    (async () => {
      try {
        const info = await ppp.getFileInfoAsync(record.tableName, record.id, columnName, true);
        if (cancelled) return;
        if (info.fileData) {
          hydrateValue({
            fileName: info.fileName ?? value?.fileName ?? "",
            id: fileId,
            value: info.fileData
          });
        }
      } catch (err) {
        if (cancelled) return;
        console.warn(`PowerPortalsPro ImageEdit: preview fetch failed for ${columnName}`, err);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [columnName, displayImage, fileId, hydrateValue, ppp, record?.id, record?.tableName, value?.fileName, value?.value]);
  const handleDownload = useCallback(async () => {
    if (!value) return;
    setIsDownloading(true);
    try {
      const bytes = value.value ? base64ToBytes(value.value) : await fetchFileBytes(ppp, record?.tableName, record?.id, columnName);
      if (bytes === null) return;
      triggerBlobDownload(bytes, value.fileName);
    } finally {
      setIsDownloading(false);
    }
  }, [columnName, ppp, record, value]);
  const handleEnterEdit = useCallback(() => {
    setIsEditing(true);
  }, []);
  const handleCancelEdit = useCallback(() => {
    setIsEditing(false);
  }, []);
  const handleSaveEdit = useCallback(async () => {
    const handle = viewerRef.current;
    if (!handle) {
      setIsEditing(false);
      return;
    }
    const result = await handle.commit();
    if (!result) {
      setIsEditing(false);
      return;
    }
    const origName = value?.fileName ?? "image";
    const dot = origName.lastIndexOf(".");
    const stem = dot >= 0 ? origName.slice(0, dot) : origName;
    const ext = result.mimeType === "image/jpeg" ? "jpg" : "png";
    setValue({
      fileName: `${stem}.${ext}`,
      id: EMPTY_GUID,
      value: result.base64
    });
    setIsEditing(false);
  }, [setValue, value?.fileName]);
  const hasImagePreview = displayImage && value?.value != null;
  const isLoadingImagePreview = displayImage && !value?.value && !!fileId && !!record?.id && record.id !== EMPTY_GUID;
  const imageSource = useMemo(() => {
    if (value?.value == null) return null;
    return {
      kind: "base64",
      value: value.value,
      fileName: value.fileName
    };
  }, [value?.value, value?.fileName]);
  if (!hasImagePreview && !isLoadingImagePreview) {
    const fileEditProps = {
      columnName,
      accept,
      displayLabelWhenAvailable,
      descriptionLocation,
      displayValidationErrorMessage,
      isVisible,
      uploadHintText: uploadHintText ?? t("app.messages.image-upload-drop-zone"),
      ...label !== void 0 && { label },
      ...description !== void 0 && { description },
      ...required !== void 0 && { required },
      ...readOnly !== void 0 && { readOnly },
      ...disabled !== void 0 && { disabled },
      // Fold `ppp-image-edit` into the className forwarded to FileEdit so
      // the marker survives the delegation. FileEdit lands `className` on
      // its inner drop-zone div (not its Field), so the marker won't sit
      // on the outermost element in the delegate branch — but it's still
      // present in the rendered DOM for consumer CSS to target.
      className: mergeClasses("ppp-image-edit", className),
      ...style !== void 0 && { style },
      ...id !== void 0 && { id },
      ...maxFileSizeBytes !== void 0 && { maxFileSizeBytes },
      ...validate !== void 0 && { validate }
    };
    return /* @__PURE__ */ jsx(FileEdit, { ...fileEditProps });
  }
  if (!isVisible) return null;
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = description ?? getDisplayDescription(metadata, columnName, record?.tableName, t);
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  if (isLoadingImagePreview) {
    return /* @__PURE__ */ jsx(
      Field,
      {
        className: mergeClasses("ppp-image-edit"),
        label: labelSlot,
        hint: fieldHint,
        required: resolvedRequired,
        children: /* @__PURE__ */ jsx(
          "div",
          {
            className: mergeClasses(styles.loadingFrame, className),
            ...style !== void 0 && { style },
            children: /* @__PURE__ */ jsx(Spinner, { size: "small", label: t("app.components.image-edit.loading-preview") })
          }
        )
      }
    );
  }
  const source = imageSource;
  if (resolvedReadOnly) {
    return /* @__PURE__ */ jsx(
      Field,
      {
        className: mergeClasses("ppp-image-edit"),
        label: labelSlot,
        hint: fieldHint,
        required: resolvedRequired,
        children: /* @__PURE__ */ jsx(
          ImageViewer,
          {
            source,
            framed: true,
            downloadable: true,
            className: mergeClasses(styles.viewer, className),
            ...style !== void 0 && { style }
          }
        )
      }
    );
  }
  const viewerWrapperClass = mergeClasses(
    styles.viewerWrapper,
    isInteractable && !isEditing && styles.viewerWrapperInteractable,
    upload.isDragOver && !isEditing && styles.viewerWrapperActive
  );
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: mergeClasses("ppp-image-edit"),
      label: labelSlot,
      hint: fieldHint,
      required: resolvedRequired,
      children: /* @__PURE__ */ jsxs("div", { className: mergeClasses(styles.wrapper, className), style, children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            ref: upload.inputRef,
            id: inputId,
            type: "file",
            accept,
            disabled: !isInteractable,
            className: styles.hiddenInput,
            onChange: upload.onInputChange
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: viewerWrapperClass,
            ...isInteractable && !isEditing ? upload.dropZoneHandlers : {},
            children: [
              /* @__PURE__ */ jsx(
                ImageViewer,
                {
                  ref: viewerRef,
                  source,
                  framed: true,
                  toolbar: isEditing,
                  croppable: isEditing,
                  outputFormat,
                  outputQuality,
                  className: styles.viewer,
                  ...isEditing && {
                    onSave: handleSaveEdit,
                    onCancel: handleCancelEdit
                  }
                },
                isEditing ? "edit" : "view"
              ),
              isInteractable && !isEditing && // View-mode overlay: Edit (enters edit mode), Download, Clear.
              // Translucent backdrop keeps icons readable against arbitrary
              // image content; `stopPropagation` on each button stops the
              // click from also firing the wrapper's open-file-picker
              // handler.
              /* @__PURE__ */ jsxs("div", { className: styles.actions, children: [
                /* @__PURE__ */ jsx(
                  Button,
                  {
                    appearance: "subtle",
                    icon: /* @__PURE__ */ jsx(Edit20Regular, {}),
                    "aria-label": t("app.buttons.edit-item", [value.fileName]),
                    onClick: (ev) => {
                      ev.stopPropagation();
                      handleEnterEdit();
                    }
                  }
                ),
                /* @__PURE__ */ jsx(
                  Button,
                  {
                    appearance: "subtle",
                    icon: /* @__PURE__ */ jsx(ArrowDownload20Regular, {}),
                    "aria-label": t("app.buttons.download-item", [value.fileName]),
                    disabled: isDownloading,
                    onClick: (ev) => {
                      ev.stopPropagation();
                      void handleDownload();
                    }
                  }
                ),
                /* @__PURE__ */ jsx(
                  Button,
                  {
                    appearance: "subtle",
                    icon: /* @__PURE__ */ jsx(Dismiss20Regular, {}),
                    "aria-label": t("app.buttons.remove-item", [value.fileName]),
                    onClick: (ev) => {
                      ev.stopPropagation();
                      setValue(null);
                    }
                  }
                )
              ] })
            ]
          }
        )
      ] })
    }
  );
}
var useImageEditStyles = makeStyles({
  wrapper: {
    width: "100%"
  },
  // Placeholder frame shown while the lazy-load is in flight. Same
  // chrome (border, background, rounded corners) as ImageViewer's
  // framed mode so the layout doesn't jump when the bytes arrive and
  // we swap to the real viewer. Min-height matches a reasonable image
  // size so the spinner sits in the middle of a visible area rather
  // than against a 0-height box.
  loadingFrame: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    minHeight: "180px",
    borderTopWidth: tokens.strokeWidthThin,
    borderRightWidth: tokens.strokeWidthThin,
    borderBottomWidth: tokens.strokeWidthThin,
    borderLeftWidth: tokens.strokeWidthThin,
    borderTopStyle: "solid",
    borderRightStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftStyle: "solid",
    borderTopColor: tokens.colorNeutralStroke1,
    borderRightColor: tokens.colorNeutralStroke1,
    borderBottomColor: tokens.colorNeutralStroke1,
    borderLeftColor: tokens.colorNeutralStroke1,
    borderTopLeftRadius: tokens.borderRadiusMedium,
    borderTopRightRadius: tokens.borderRadiusMedium,
    borderBottomLeftRadius: tokens.borderRadiusMedium,
    borderBottomRightRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground2
  },
  hiddenInput: {
    position: "absolute",
    width: "1px",
    height: "1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    border: "none"
  },
  // Positioning context for the absolute-positioned action overlay. Sits
  // outside ImageViewer's own framed wrapper so the overlay can anchor
  // to the field-width edge, not to ImageViewer's intrinsic content
  // width.
  viewerWrapper: {
    position: "relative",
    display: "block"
  },
  // View-mode hover affordance: cursor hints that clicking opens the
  // file picker. Edit mode skips this since the viewer's pan/crop
  // gestures own the cursor in that state.
  viewerWrapperInteractable: {
    cursor: "pointer"
  },
  // Drag-over highlight. Inset box-shadow (instead of overriding
  // borderColor on a `border` shorthand) sidesteps Griffel's strict
  // mixing rules — same trick used in `FileEdit` and the original
  // `previewFrameActive`.
  viewerWrapperActive: {
    boxShadow: `inset 0 0 0 ${tokens.strokeWidthThick} ${tokens.colorBrandStroke1}`,
    borderRadius: tokens.borderRadiusMedium
  },
  // ImageViewer defaults to `display: inline-flex` (sized to content). For
  // a form field we want it to fill the field width so the action overlay
  // anchors to the visible image's right edge.
  viewer: {
    display: "flex",
    width: "100%",
    maxWidth: "100%"
  },
  // Overlay corner toolbar — top-right of the viewer, sitting on top of
  // the image. Translucent backdrop keeps the icons readable against any
  // image content (a near-white photo would wash out a transparent
  // button); rounded corners + a soft shadow separate it visually from
  // the viewer's frame.
  actions: {
    position: "absolute",
    top: tokens.spacingVerticalS,
    right: tokens.spacingHorizontalS,
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS,
    paddingLeft: tokens.spacingHorizontalXS,
    paddingRight: tokens.spacingHorizontalXS,
    paddingTop: "2px",
    paddingBottom: "2px",
    backgroundColor: tokens.colorNeutralBackgroundAlpha,
    backdropFilter: "blur(4px)",
    borderRadius: tokens.borderRadiusMedium,
    boxShadow: tokens.shadow4,
    // Sit above the image inside the viewer's stacking context.
    zIndex: 1
  }
});

// src/edits/base/choice-helpers.ts
var ChoiceValueSort = {
  /** Server order — whatever Dataverse returned. */
  Default: "default",
  /** Alphabetical by localized display label. */
  DisplayName: "displayName",
  /** Alphabetical descending by localized display label. */
  DisplayNameDescending: "displayNameDescending",
  /** Ascending by integer option value. */
  Value: "value",
  /** Descending by integer option value. */
  ValueDescending: "valueDescending"
};
var ChoiceInvalidValueBehavior = {
  /** Hide the option entirely. */
  Remove: "remove",
  /** Keep the option visible but disabled (un-selectable). */
  Disable: "disable"
};
var ChoiceOrientation = {
  Vertical: "vertical",
  Horizontal: "horizontal"
};
function resolveChoiceLabel(t, tableName, columnName, choiceLogicalName, value, fallback) {
  const keys = [];
  if (tableName) {
    keys.push(`tables.${tableName}.columns.${columnName}.values.${value}.label`);
    keys.push(`tables.${tableName}.choices.${choiceLogicalName}.values.${value}.label`);
  }
  keys.push(`choices.${choiceLogicalName}.values.${value}.label`);
  for (const k of keys) {
    const resolved = t(k);
    if (resolved !== k) return resolved;
  }
  return fallback;
}
function buildRenderableChoices(meta, tableName, columnName, options) {
  const isInvalid = (value) => {
    if (options.validChoiceValues !== void 0) {
      return !options.validChoiceValues.includes(value);
    }
    if (options.invalidChoiceValues !== void 0) {
      return options.invalidChoiceValues.includes(value);
    }
    return false;
  };
  let result = meta.choices.map((c) => ({
    value: c.value,
    text: resolveChoiceLabel(
      options.t,
      tableName,
      columnName,
      meta.choiceLogicalName,
      c.value,
      c.displayName
    ),
    disabled: isInvalid(c.value)
  }));
  if (options.invalidValueBehavior === ChoiceInvalidValueBehavior.Remove) {
    result = result.filter((c) => !c.disabled);
  }
  switch (options.sort) {
    case ChoiceValueSort.DisplayName:
      result.sort((a, b) => a.text.localeCompare(b.text));
      break;
    case ChoiceValueSort.DisplayNameDescending:
      result.sort((a, b) => b.text.localeCompare(a.text));
      break;
    case ChoiceValueSort.Value:
      result.sort((a, b) => a.value - b.value);
      break;
    case ChoiceValueSort.ValueDescending:
      result.sort((a, b) => b.value - a.value);
      break;
    case ChoiceValueSort.Default:
  }
  return result;
}
var ChoiceEditorType = {
  Dropdown: "dropdown",
  RadioButtons: "radioButtons"
};
function ChoiceEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  editorType = ChoiceEditorType.Dropdown,
  validChoiceValues,
  invalidChoiceValues,
  sort = ChoiceValueSort.Default,
  invalidValueBehavior = ChoiceInvalidValueBehavior.Remove,
  radioButtonOrientation = ChoiceOrientation.Vertical,
  displayNullChoice,
  validate
}) {
  const { value, setValue: rawSetValue } = useChoiceColumn(columnName);
  const { record, tableMetadata } = useRecordContext();
  const metadata = useColumnMetadata(columnName);
  const t = useT();
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = description ?? getDisplayDescription(metadata, columnName, record?.tableName, t);
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const resolvedDisplayNullChoice = displayNullChoice ?? !resolvedRequired;
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled
  );
  const setValue = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const choiceMeta = getChoiceMetadata(metadata);
  const tableName = tableMetadata?.tableName;
  const validKey = validChoiceValues ? JSON.stringify(validChoiceValues) : "";
  const invalidKey = invalidChoiceValues ? JSON.stringify(invalidChoiceValues) : "";
  const choices = useMemo(
    () => choiceMeta ? buildRenderableChoices(choiceMeta, tableName, columnName, {
      validChoiceValues,
      invalidChoiceValues,
      invalidValueBehavior,
      sort,
      t
    }) : [],
    // `t` is stable across renders within a single localizer cache state, so
    // including it in the dep correctly re-computes labels when localization
    // strings finish loading.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [choiceMeta, tableName, columnName, validKey, invalidKey, invalidValueBehavior, sort, t]
  );
  const validationErrors = useColumnValidation(
    columnName,
    {
      kind: "number",
      required: resolvedRequired,
      label: resolvedLabel,
      value: value ?? null
    },
    validate
  );
  if (!isVisible) return null;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  const fieldValidationProps = buildFieldValidationProps(
    validationErrors,
    displayValidationErrorMessage
  );
  const nullChoiceLabel = t("app.null-choice-label");
  const selectedKey = value === void 0 ? "" : String(value);
  const selectedOption = choices.find((c) => c.value === value);
  const dropdownDisplayText = value === void 0 ? (
    // Unset: show the "(none)" label only when the null choice is offered,
    // otherwise leave the dropdown blank so a required column reads as empty.
    resolvedDisplayNullChoice ? nullChoiceLabel : ""
  ) : selectedOption ? selectedOption.text : String(value);
  const isInactive = resolvedDisabled || resolvedReadOnly;
  let control;
  if (editorType === ChoiceEditorType.RadioButtons) {
    control = /* @__PURE__ */ jsxs(
      RadioGroup,
      {
        id,
        className,
        style,
        value: selectedKey,
        layout: radioButtonOrientation === ChoiceOrientation.Horizontal ? "horizontal" : "vertical",
        disabled: isInactive,
        required: resolvedRequired,
        onChange: (_, data) => {
          if (!data.value) {
            setValue(null);
            return;
          }
          setValue(Number(data.value));
        },
        children: [
          resolvedDisplayNullChoice && /* @__PURE__ */ jsx(Radio, { value: "", label: nullChoiceLabel }, "__null__"),
          choices.map((c) => /* @__PURE__ */ jsx(Radio, { value: String(c.value), label: c.text, disabled: c.disabled }, c.value))
        ]
      }
    );
  } else {
    control = /* @__PURE__ */ jsxs(
      Dropdown,
      {
        id,
        className,
        style,
        selectedOptions: value === void 0 ? resolvedDisplayNullChoice ? [""] : [] : [selectedKey],
        value: dropdownDisplayText,
        disabled: isInactive,
        onOptionSelect: (_, data) => {
          if (!data.optionValue) {
            setValue(null);
            return;
          }
          setValue(Number(data.optionValue));
        },
        children: [
          resolvedDisplayNullChoice && /* @__PURE__ */ jsx(Option, { value: "", children: nullChoiceLabel }, "__null__"),
          choices.map((c) => /* @__PURE__ */ jsx(Option, { value: String(c.value), disabled: c.disabled, children: c.text }, c.value))
        ]
      }
    );
  }
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: mergeClasses("ppp-choice-edit"),
      label: labelSlot,
      hint: fieldHint,
      required: resolvedRequired,
      ...fieldValidationProps,
      children: control
    }
  );
}
var useMultiSelectStyles = makeStyles({
  // Shared base for every orientation. `overflow: auto` (both axes, matching
  //) lets the box scroll naturally on
  // whichever axis genuinely overflows — no axis is force-`hidden`. The padding
  // is load-bearing, not cosmetic: Fluent v9's Checkbox draws its focus ring as
  // an absolutely-positioned `::after` inset by -2px (native outline disabled),
  // so a focused checkbox bleeds ~2px past its own box. The padding keeps that
  // ring inside the padding box so it never adds scrollable overflow (which
  // would otherwise flick a scrollbar / nudge content when you focus an option
  // at the edge).
  // NOTE: a column flex-wrap needs a DEFINITE height to wrap against. Give the
  // editor a fixed `height` (not `max-height`) when you want vertical wrapping
  // `max-height` lets the container collapse to its content, so it has no stable
  // height to wrap into columns against and the layout shifts as items change.
  container: {
    overflow: "auto",
    padding: tokens.spacingHorizontalXS
  },
  // Flex layout — column for vertical, row for horizontal. Gap matches Fluent's
  // standard small spacing so checkbox rows feel related without crowding.
  containerVertical: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalXXS
  },
  // Vertical + wrap: stack checkboxes in a column, then flow into additional
  // columns once the (definite) height is reached.
  containerVerticalWrap: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    rowGap: tokens.spacingVerticalXXS,
    columnGap: tokens.spacingHorizontalM
  },
  containerHorizontal: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    gap: tokens.spacingHorizontalM,
    // Keep each checkbox at its natural height. A row's default
    // `align-items: stretch` would stretch every checkbox to the container's
    // (fixed) height; the checkbox's indicator is `align-self: flex-start`
    // (top) while its label is `align-self: center`, so a stretched checkbox
    // splits them onto separate lines. `flex-start` keeps the row's items
    // their intrinsic height so indicator + label stay inline.
    alignItems: "flex-start"
  },
  containerHorizontalWrap: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    rowGap: tokens.spacingVerticalXXS,
    columnGap: tokens.spacingHorizontalM,
    // Same as the horizontal row above: don't vertically stretch the
    // checkboxes, or the indicator (top) and label (center) separate.
    alignItems: "flex-start"
  },
  // Keep each checkbox at its natural size. In the horizontal `nowrap` row,
  // Fluent's default `flex-shrink: 1` lets items compress below their content
  // width, which pushes each checkbox's absolutely-positioned hidden <input>
  // (it overlays the indicator at full row height) over the neighbouring
  // option — so a click lands on the wrong checkbox. Pinning shrink to 0 keeps
  // the hit targets aligned; the container's `overflow-x: auto` handles the row
  // running wider than its box.
  checkbox: {
    flexShrink: 0
  }
});
function MultiSelectChoiceEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  validChoiceValues,
  invalidChoiceValues,
  sort = ChoiceValueSort.Default,
  invalidValueBehavior = ChoiceInvalidValueBehavior.Remove,
  checkboxOrientation = ChoiceOrientation.Vertical,
  wrapCheckboxes = true,
  minCount,
  maxCount,
  validate
}) {
  const { value, setValue: rawSetValue } = useMultiSelectChoiceColumn(columnName);
  const { record, tableMetadata } = useRecordContext();
  const metadata = useColumnMetadata(columnName);
  const styles = useMultiSelectStyles();
  const t = useT();
  const generatedId = useId();
  const baseId = id ?? generatedId;
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = description ?? getDisplayDescription(metadata, columnName, record?.tableName, t);
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled
  );
  const setValue = useGuardedSetValue(rawSetValue, resolvedReadOnly, resolvedDisabled);
  const choiceMeta = getChoiceMetadata(metadata);
  const tableName = tableMetadata?.tableName;
  const validKey = validChoiceValues ? JSON.stringify(validChoiceValues) : "";
  const invalidKey = invalidChoiceValues ? JSON.stringify(invalidChoiceValues) : "";
  const choices = useMemo(
    () => choiceMeta ? buildRenderableChoices(choiceMeta, tableName, columnName, {
      validChoiceValues,
      invalidChoiceValues,
      invalidValueBehavior,
      sort,
      t
    }) : [],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [choiceMeta, tableName, columnName, validKey, invalidKey, invalidValueBehavior, sort, t]
  );
  const selectedSet = useMemo(() => new Set(value), [value]);
  const validationErrors = useColumnValidation(
    columnName,
    {
      kind: "array",
      required: resolvedRequired,
      label: resolvedLabel,
      value,
      ...minCount !== void 0 && { minCount },
      ...maxCount !== void 0 && { maxCount }
    },
    validate
  );
  if (!isVisible) return null;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  const fieldValidationProps = buildFieldValidationProps(
    validationErrors,
    displayValidationErrorMessage
  );
  const isInactive = resolvedDisabled || resolvedReadOnly;
  const containerClass = checkboxOrientation === ChoiceOrientation.Horizontal ? wrapCheckboxes ? styles.containerHorizontalWrap : styles.containerHorizontal : wrapCheckboxes ? styles.containerVerticalWrap : styles.containerVertical;
  const toggle = (optionValue, checked) => {
    if (checked && !selectedSet.has(optionValue)) {
      setValue([...value, optionValue]);
    } else if (!checked && selectedSet.has(optionValue)) {
      setValue(value.filter((v) => v !== optionValue));
    }
  };
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: mergeClasses("ppp-multi-select-choice-edit"),
      label: labelSlot,
      hint: fieldHint,
      required: resolvedRequired,
      ...fieldValidationProps,
      children: /* @__PURE__ */ jsx("div", { id, className: mergeClasses(styles.container, containerClass, className), style, children: choices.map((c) => /* @__PURE__ */ jsx(
        Checkbox,
        {
          id: `${baseId}_${c.value}`,
          className: styles.checkbox,
          label: c.text,
          required: false,
          checked: selectedSet.has(c.value),
          disabled: isInactive || c.disabled,
          onChange: (_, data) => toggle(c.value, data.checked === true)
        },
        c.value
      )) })
    }
  );
}
var useHighlighterStyles = makeStyles({
  // Inline marker around matched substrings. `colorPaletteYellowBackground3`
  // is the brightest of Fluent's three yellow-background tokens — the lower
  // tints (1, 2) read as "barely tinted" against typical light-theme
  // surfaces; tint 3 stays solidly yellow so matches pop without forcing
  // hardcoded hex. Bold weight reinforces the hit visually while keeping
  // the glyph anatomy unchanged (no shifts).
  // Foreground uses `colorNeutralForeground1Static` rather than the
  // paired `colorPaletteYellowForeground2` because the latter's polarity
  // INVERTS between themes — in dark mode it resolves to a near-white
  // yellow tint that washes out against the bright yellow background.
  // The `Static` variant resolves to a dark grey in both light AND dark
  // themes, which gives consistent contrast against the always-bright
  // yellow background.
  mark: {
    backgroundColor: tokens.colorPaletteYellowBackground3,
    color: tokens.colorNeutralForeground1Static,
    fontWeight: tokens.fontWeightBold,
    padding: 0,
    borderRadius: tokens.borderRadiusSmall
  }
});
function foldString(s, caseSensitive) {
  let folded = "";
  const starts = [];
  const ends = [];
  const combiningMarks = /[̀-ͯ]/g;
  for (let i = 0; i < s.length; i++) {
    const decomposed = s.charAt(i).normalize("NFD").replace(combiningMarks, "");
    const f = caseSensitive ? decomposed : decomposed.toLowerCase();
    if (f.length === 0) {
      if (ends.length > 0) ends[ends.length - 1] = i + 1;
      continue;
    }
    for (let j = 0; j < f.length; j++) {
      folded += f[j];
      starts.push(i);
      ends.push(i + 1);
    }
  }
  return { folded, starts, ends };
}
function tokenizeSearch(search, delimiters) {
  if (!delimiters) return [search];
  const delim = new Set(Array.from(delimiters));
  const tokens43 = [];
  let current = "";
  for (const ch of search) {
    if (delim.has(ch)) {
      if (current.length > 0) {
        tokens43.push(current);
        current = "";
      }
    } else {
      current += ch;
    }
  }
  if (current.length > 0) tokens43.push(current);
  return tokens43;
}
function splitHighlightSegments(text, search, options) {
  if (!text || !search) return [];
  const caseSensitive = options?.caseSensitive ?? false;
  const delimiters = options?.delimiters ?? "";
  const tokens43 = tokenizeSearch(search, delimiters);
  if (tokens43.length === 0) return [{ text, isMatch: false }];
  const folded = foldString(text, caseSensitive);
  const ranges = [];
  for (const token of tokens43) {
    const tokenFolded = foldString(token, caseSensitive).folded;
    if (tokenFolded.length === 0) continue;
    let cursor2 = 0;
    while (cursor2 <= folded.folded.length - tokenFolded.length) {
      const foundAt = folded.folded.indexOf(tokenFolded, cursor2);
      if (foundAt === -1) break;
      ranges.push({
        start: folded.starts[foundAt],
        end: folded.ends[foundAt + tokenFolded.length - 1]
      });
      cursor2 = foundAt + tokenFolded.length;
    }
  }
  if (ranges.length === 0) return [{ text, isMatch: false }];
  ranges.sort((a, b) => a.start - b.start);
  const merged = [];
  for (const r of ranges) {
    const last = merged[merged.length - 1];
    if (last && r.start <= last.end) {
      if (r.end > last.end) last.end = r.end;
    } else {
      merged.push({ start: r.start, end: r.end });
    }
  }
  const segments = [];
  let cursor = 0;
  for (const r of merged) {
    if (r.start > cursor) {
      segments.push({ text: text.slice(cursor, r.start), isMatch: false });
    }
    segments.push({ text: text.slice(r.start, r.end), isMatch: true });
    cursor = r.end;
  }
  if (cursor < text.length) {
    segments.push({ text: text.slice(cursor), isMatch: false });
  }
  return segments;
}
function Highlighter({
  text,
  searchText,
  delimiters,
  caseSensitive,
  className
}) {
  const styles = useHighlighterStyles();
  const cleanSearch = (() => {
    const stripped = (searchText ?? "").replace(/\*/g, "");
    return delimiters?.includes(" ") ? stripped : stripped.trim();
  })();
  const segments = useMemo(
    () => splitHighlightSegments(text ?? "", cleanSearch, {
      ...delimiters !== void 0 && { delimiters },
      ...caseSensitive !== void 0 && { caseSensitive }
    }),
    [text, cleanSearch, delimiters, caseSensitive]
  );
  if (segments.length === 0) {
    return /* @__PURE__ */ jsx("span", { className: mergeClasses("ppp-highlighter", className), children: text ?? "" });
  }
  return /* @__PURE__ */ jsx("span", { className: mergeClasses("ppp-highlighter", className), children: segments.map(
    (seg, idx) => seg.isMatch ? /* @__PURE__ */ jsx("mark", { className: styles.mark, children: seg.text }, idx) : /* @__PURE__ */ jsx("span", { children: seg.text }, idx)
  ) });
}
function HighlightFull({
  text,
  className
}) {
  const styles = useHighlighterStyles();
  return /* @__PURE__ */ jsx("mark", { className: `${styles.mark}${className ? ` ${className}` : ""}`, children: text });
}
function BoolCell({ value, record, columnName }) {
  const t = useT();
  const v = value;
  if (!v) return null;
  const formatted = record.formattedValues?.[columnName];
  if (formatted) return /* @__PURE__ */ jsx("span", { className: "ppp-grid-cell-bool", children: formatted });
  if (v.value === true) {
    return /* @__PURE__ */ jsx(
      Checkmark16Regular,
      {
        "aria-label": t("app.components.grid.bool-true"),
        className: "ppp-grid-cell-bool"
      }
    );
  }
  if (v.value === false) {
    return /* @__PURE__ */ jsx(
      Dismiss16Regular,
      {
        "aria-label": t("app.components.grid.bool-false"),
        className: "ppp-grid-cell-bool"
      }
    );
  }
  return null;
}
function ChoiceCell({ value: _value, record, columnName, metadata, searchText }) {
  const display = resolveColumnDisplayValue(record, columnName);
  if (display == null || display === "") return null;
  return /* @__PURE__ */ jsx(Highlighter, { text: display, searchText: searchText ?? null, className: "ppp-grid-cell-choice" });
}
function DateCell({ value: _value, record, columnName, metadata }) {
  const display = resolveColumnDisplayValue(record, columnName);
  if (display == null || display === "") return null;
  return /* @__PURE__ */ jsx("span", { className: "ppp-grid-cell-date", children: display });
}
function FallbackCell({
  value: _value,
  record,
  columnName,
  metadata,
  searchText
}) {
  const display = resolveColumnDisplayValue(record, columnName);
  if (display == null || display === "") return null;
  return /* @__PURE__ */ jsx(Highlighter, { text: display, searchText: searchText ?? null, className: "ppp-grid-cell-fallback" });
}
var CDN_BASE = "https://res.cdn.office.net/files/fabric-cdn-prod_20240129.001/assets/item-types";
var CDN_SIZE = 20;
var CDN_ICON_NAMES = {
  // Adobe / PDF.
  pdf: "pdf",
  // Microsoft 365 — Word.
  doc: "docx",
  docx: "docx",
  docm: "docx",
  dot: "dotx",
  dotx: "dotx",
  rtf: "rtf",
  // Microsoft 365 — Excel.
  xls: "xlsx",
  xlsx: "xlsx",
  xlsm: "xlsx",
  xlsb: "xlsx",
  csv: "csv",
  // Microsoft 365 — PowerPoint.
  ppt: "pptx",
  pptx: "pptx",
  pptm: "pptx",
  ppsx: "ppsx",
  potx: "potx",
  // Microsoft 365 — OneNote / Visio / Project / Publisher / Access.
  one: "one",
  onetoc: "one",
  onetoc2: "one",
  vsdx: "vsdx",
  vssx: "vssx",
  vstx: "vstx",
  mpp: "mpp",
  mpt: "mpt",
  pub: "pub",
  accdb: "accdb",
  mdb: "mdb",
  // Outlook / email.
  msg: "email",
  eml: "email",
  // Archives.
  zip: "zip",
  "7z": "zip",
  rar: "zip",
  tar: "zip",
  gz: "zip",
  // Images.
  png: "photo",
  jpg: "photo",
  jpeg: "photo",
  gif: "photo",
  bmp: "photo",
  webp: "photo",
  tif: "photo",
  tiff: "photo",
  ico: "photo",
  svg: "photo",
  heic: "photo",
  heif: "photo",
  // Video.
  mp4: "video",
  mov: "video",
  avi: "video",
  mkv: "video",
  webm: "video",
  m4v: "video",
  wmv: "video",
  // Audio.
  mp3: "audio",
  wav: "audio",
  ogg: "audio",
  flac: "audio",
  m4a: "audio",
  aac: "audio",
  wma: "audio",
  // Text / web / data.
  txt: "txt",
  log: "txt",
  md: "txt",
  markdown: "txt",
  html: "html",
  htm: "html",
  xml: "xml",
  yaml: "yaml",
  yml: "yaml",
  css: "css",
  // Source code — CDN has a single 'code' glyph rather than per-language.
  js: "code",
  jsx: "code",
  ts: "code",
  tsx: "code",
  mjs: "code",
  cjs: "code",
  cs: "code",
  vb: "code",
  fs: "code",
  py: "code",
  rb: "code",
  go: "code",
  rs: "code",
  java: "code",
  kt: "code",
  swift: "code",
  php: "code",
  sh: "code",
  bash: "code",
  ps1: "code",
  json: "code",
  sql: "code",
  // Executables / installers.
  exe: "exe",
  msi: "exe"
};
var useStyles3 = makeStyles({
  // Sized via inline width/height attrs on the <img>; height-100% in the
  // class keeps the icon vertically centered inside the cell's flex row.
  cdnIcon: {
    flexShrink: 0,
    display: "block",
    objectFit: "contain"
  }
});
function renderFileTypeIcon(fileName, className) {
  const ext = getFileExtension(fileName);
  const brandedName = CDN_ICON_NAMES[ext];
  if (brandedName) {
    return /* @__PURE__ */ jsx(
      CdnFileTypeIcon,
      {
        name: brandedName,
        alt: ext,
        ...className !== void 0 && { className }
      }
    );
  }
  const Icon = pickFallbackIcon(ext);
  return /* @__PURE__ */ jsx(Icon, { ...className !== void 0 && { className }, "aria-hidden": true });
}
function CdnFileTypeIcon({
  name,
  alt,
  className
}) {
  const styles = useStyles3();
  const [failed, setFailed] = useState(false);
  if (failed) {
    const Icon = pickFallbackIcon(alt);
    return /* @__PURE__ */ jsx(Icon, { ...className !== void 0 && { className }, "aria-hidden": true });
  }
  return /* @__PURE__ */ jsx(
    "img",
    {
      src: `${CDN_BASE}/${CDN_SIZE}/${name}.svg`,
      alt,
      width: CDN_SIZE,
      height: CDN_SIZE,
      className: className ? `${styles.cdnIcon} ${className}` : styles.cdnIcon,
      onError: () => setFailed(true),
      decoding: "async"
    }
  );
}
function pickFallbackIcon(ext) {
  switch (ext) {
    case "pdf":
      return DocumentPdf20Regular;
    case "doc":
    case "docx":
    case "rtf":
    case "odt":
      return Document20Regular;
    case "xls":
    case "xlsx":
    case "csv":
    case "ods":
      return DocumentTable20Regular;
    case "ppt":
    case "pptx":
    case "odp":
      return SlideText20Regular;
    case "png":
    case "jpg":
    case "jpeg":
    case "gif":
    case "bmp":
    case "webp":
    case "svg":
    case "ico":
    case "tif":
    case "tiff":
      return Image20Regular;
    case "mp4":
    case "mov":
    case "avi":
    case "mkv":
    case "webm":
    case "m4v":
      return Video20Regular;
    case "mp3":
    case "wav":
    case "ogg":
    case "flac":
    case "m4a":
    case "aac":
      return MusicNote220Regular;
    case "zip":
    case "7z":
    case "rar":
    case "tar":
    case "gz":
      return FolderZip20Regular;
    case "txt":
    case "md":
    case "markdown":
    case "log":
    case "json":
    case "xml":
    case "yaml":
    case "yml":
    case "html":
    case "htm":
    case "js":
    case "ts":
    case "cs":
    case "css":
      return DocumentText20Regular;
    default:
      return Document20Regular;
  }
}
var GridContext = createContext(null);
var GridContextProvider = GridContext.Provider;
function useGridContext() {
  const ctx = useContext(GridContext);
  if (!ctx) {
    throw new Error(
      "useGridContext() was called outside of <MainGrid>. Grid buttons (NewRecordGridButton, DeleteRecordGridButton, RefreshGridButton, etc.) must be rendered as children of <MainGrid>."
    );
  }
  return ctx;
}
var EMPTY_GUID2 = "00000000-0000-0000-0000-000000000000";
function FileCell({ record, columnName, metadata }) {
  const styles = useFileCellStyles();
  const t = useT();
  const { ppp } = usePowerPortalsPro();
  const { allowPreviewForFileColumns, allowDownloadForFileColumns } = useGridContext();
  const [isBusy, setIsBusy] = useState(false);
  const [previewSource, setPreviewSource] = useState(null);
  const presence = useDialogPresence(previewSource !== null, PREVIEW_EXIT_MS);
  const lastSourceRef = useRef(null);
  if (previewSource) lastSourceRef.current = previewSource;
  const renderedSource = previewSource ?? lastSourceRef.current;
  const isVisible = presence.surfaceState === "open";
  const isClosing = presence.surfaceState === "closing";
  const transitionDuration = isClosing ? `${PREVIEW_EXIT_MS}ms` : `${PREVIEW_ENTER_MS}ms`;
  const transitionTimingFunction = isClosing ? "cubic-bezier(0.7, 0, 1, 0.5)" : "cubic-bezier(0.1, 0.9, 0.2, 1)";
  const surfaceStyle = useMemo(() => ({
    backgroundColor: "transparent",
    boxShadow: "none",
    border: "none",
    padding: 0
  }), []);
  const animationStyle = useMemo(() => ({
    width: "100%",
    transformOrigin: "50% 50%",
    transitionProperty: "opacity, transform",
    transitionDuration,
    transitionTimingFunction,
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "scale(1)" : "scale(0.96)",
    // Chrome that used to live on DialogSurface — now on the
    // animating wrapper so it fades together with the content.
    backgroundColor: "var(--colorNeutralBackground1)",
    color: "var(--colorNeutralForeground1)",
    border: "1px solid var(--colorTransparentStroke)",
    borderRadius: "var(--borderRadiusXLarge)",
    boxShadow: "var(--shadow64)",
    padding: "24px",
    boxSizing: "border-box"
  }), [isVisible, transitionDuration]);
  const fileName = resolveColumnDisplayValue(record, columnName);
  const tableName = record.tableName;
  const recordId = record.id;
  const isPersisted = !!recordId && recordId !== EMPTY_GUID2 && !recordId.startsWith("__pending-create-");
  const handleDownload = useCallback(async () => {
    if (!isPersisted || !tableName || !recordId || !fileName) return;
    setIsBusy(true);
    try {
      const info = await ppp.getFileInfoAsync(tableName, recordId, columnName, true);
      if (!info.fileData) return;
      const bytes = base64ToBytes(info.fileData);
      triggerBlobDownload(bytes, info.fileName || fileName);
    } finally {
      setIsBusy(false);
    }
  }, [columnName, fileName, isPersisted, ppp, recordId, tableName]);
  const handlePreview = useCallback(async () => {
    if (!isPersisted || !tableName || !recordId || !fileName) return;
    setIsBusy(true);
    try {
      const info = await ppp.getFileInfoAsync(tableName, recordId, columnName, true);
      if (!info.fileData) return;
      const resolvedName = info.fileName || fileName;
      setPreviewSource({
        kind: "base64",
        value: info.fileData,
        mimeType: getMimeFromFileName(resolvedName),
        fileName: resolvedName
      });
    } finally {
      setIsBusy(false);
    }
  }, [columnName, fileName, isPersisted, ppp, recordId, tableName]);
  if (!fileName) return null;
  const showPreview = allowPreviewForFileColumns && isPersisted;
  const showDownload = allowDownloadForFileColumns && isPersisted;
  const previewLabel = t("app.components.grid.file-cell-preview-tooltip");
  const downloadLabel = t("app.components.grid.file-cell-download-tooltip");
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-grid-cell-file", styles.cell), children: [
      renderFileTypeIcon(fileName, styles.leadingIcon),
      /* @__PURE__ */ jsx("span", { className: styles.name, children: fileName }),
      showPreview && /* @__PURE__ */ jsx(Tooltip, { content: previewLabel, relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "subtle",
          size: "small",
          icon: /* @__PURE__ */ jsx(Eye20Regular, {}),
          "aria-label": previewLabel,
          disabled: isBusy,
          onClick: (ev) => {
            ev.stopPropagation();
            void handlePreview();
          }
        }
      ) }),
      showDownload && /* @__PURE__ */ jsx(Tooltip, { content: downloadLabel, relationship: "label", withArrow: true, children: /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "subtle",
          size: "small",
          icon: /* @__PURE__ */ jsx(ArrowDownload20Regular, {}),
          "aria-label": downloadLabel,
          disabled: isBusy,
          onClick: (ev) => {
            ev.stopPropagation();
            void handleDownload();
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx(
      Dialog,
      {
        open: presence.mounted,
        onOpenChange: (_, data) => {
          if (!data.open) setPreviewSource(null);
        },
        modalType: "modal",
        children: /* @__PURE__ */ jsx(DialogSurface, { className: styles.previewSurface, style: surfaceStyle, children: /* @__PURE__ */ jsx("div", { style: animationStyle, children: renderedSource && /* @__PURE__ */ jsxs(DialogBody, { children: [
          /* @__PURE__ */ jsx(DialogTitle, { children: renderedSource.fileName }),
          /* @__PURE__ */ jsx(DialogContent, { className: styles.previewContent, children: /* @__PURE__ */ jsx(FileViewer, { source: renderedSource, fileName: renderedSource.fileName ?? fileName }) }),
          /* @__PURE__ */ jsx(DialogActions, { children: /* @__PURE__ */ jsx(DialogTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(Button, { appearance: "primary", children: t("app.buttons.close.label") }) }) })
        ] }) }) })
      }
    )
  ] });
}
var PREVIEW_ENTER_MS = 160;
var PREVIEW_EXIT_MS = 120;
function useDialogPresence(open, exitMs) {
  const [mounted, setMounted] = useState(open);
  const [surfaceState, setSurfaceState] = useState(
    open ? "open" : "hidden"
  );
  const timerRef = useRef(null);
  useEffect(() => {
    if (open) {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      setMounted(true);
      return;
    }
    if (!mounted) return;
    setSurfaceState("closing");
    timerRef.current = setTimeout(() => {
      setMounted(false);
      setSurfaceState("hidden");
      timerRef.current = null;
    }, exitMs);
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [open, mounted, exitMs]);
  useLayoutEffect(() => {
    if (!mounted) return;
    if (surfaceState !== "hidden") return;
    const id = requestAnimationFrame(() => setSurfaceState("open"));
    return () => cancelAnimationFrame(id);
  }, [mounted, surfaceState]);
  useEffect(() => {
    if (open && mounted && surfaceState === "closing") {
      setSurfaceState("hidden");
    }
  }, [open, mounted, surfaceState]);
  return { mounted, surfaceState };
}
var useFileCellStyles = makeStyles({
  cell: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS,
    minWidth: 0
  },
  leadingIcon: {
    flexShrink: 0,
    color: tokens.colorNeutralForeground2
  },
  name: {
    flex: "1 1 auto",
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  // Preview dialog mirrors FileEdit's surface so the two share a layout
  // wider than Fluent's default so PDF / markdown / image renderers have
  // room to breathe, capped at the viewport for small screens.
  previewSurface: {
    maxWidth: "min(1200px, 90vw)",
    width: "90vw"
  },
  // Animation wrapper styles live inline on the wrapper div (see
  // `animationStyle` in FileCell) — earlier Griffel-driven attempts
  // had the from/to values applied but the transition itself didn't
  // run, so inline `style` is the bulletproof path.
  previewContent: {
    overflow: "hidden",
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS
  }
});
function LookupCell({ value: _value, record, columnName, metadata, searchText }) {
  const display = resolveColumnDisplayValue(record, columnName);
  if (display == null || display === "") return null;
  return /* @__PURE__ */ jsx(Highlighter, { text: display, searchText: searchText ?? null, className: "ppp-grid-cell-lookup" });
}

// src/grids/cells/numeric-search-match.ts
function parseNumericSearch(searchText) {
  if (!searchText) return null;
  const trimmed = searchText.replace(/\s+/g, "");
  if (!trimmed) return null;
  let op = "=";
  let residual = trimmed;
  if (residual.startsWith(">=")) {
    op = ">=";
    residual = residual.slice(2);
  } else if (residual.startsWith("<=")) {
    op = "<=";
    residual = residual.slice(2);
  } else if (residual.startsWith(">")) {
    op = ">";
    residual = residual.slice(1);
  } else if (residual.startsWith("<")) {
    op = "<";
    residual = residual.slice(1);
  } else if (residual.startsWith("=")) {
    op = "=";
    residual = residual.slice(1);
  }
  if (!residual) return null;
  const n = Number(residual);
  if (!Number.isFinite(n)) return null;
  return { op, value: n };
}
function matchesNumericSearch(rawCellValue, parsed) {
  if (rawCellValue == null) return false;
  const n = typeof rawCellValue === "number" ? rawCellValue : Number(rawCellValue);
  if (!Number.isFinite(n)) return false;
  switch (parsed.op) {
    case "=":
      return n === parsed.value;
    case "<":
      return n < parsed.value;
    case ">":
      return n > parsed.value;
    case "<=":
      return n <= parsed.value;
    case ">=":
      return n >= parsed.value;
  }
}
function MoneyCell({
  value,
  record,
  columnName,
  metadata,
  searchText
}) {
  const display = resolveColumnDisplayValue(record, columnName);
  if (display == null || display === "") return null;
  const parsed = parseNumericSearch(searchText);
  if (parsed) {
    const raw = value?.value;
    if (matchesNumericSearch(raw, parsed)) {
      return /* @__PURE__ */ jsx(HighlightFull, { text: display, className: "ppp-grid-cell-money" });
    }
  }
  return /* @__PURE__ */ jsx("span", { className: "ppp-grid-cell-money", children: display });
}
function MultiSelectChoiceCell({
  value: _value,
  record,
  columnName,
  metadata,
  searchText
}) {
  const display = resolveColumnDisplayValue(record, columnName);
  if (display == null || display === "") return null;
  return /* @__PURE__ */ jsx(Highlighter, { text: display, searchText: searchText ?? null, className: "ppp-grid-cell-multi-select-choice" });
}
function NumberCell({
  value,
  record,
  columnName,
  metadata,
  searchText
}) {
  const display = resolveColumnDisplayValue(record, columnName);
  if (display == null || display === "") return null;
  const parsed = parseNumericSearch(searchText);
  if (parsed) {
    const raw = value?.value;
    if (matchesNumericSearch(raw, parsed)) {
      return /* @__PURE__ */ jsx(HighlightFull, { text: display, className: "ppp-grid-cell-number" });
    }
  }
  return /* @__PURE__ */ jsx("span", { className: "ppp-grid-cell-number", children: display });
}
function TextCell({ value: _value, record, columnName, metadata, searchText }) {
  const display = resolveColumnDisplayValue(record, columnName);
  if (display == null || display === "") return null;
  return /* @__PURE__ */ jsx(Highlighter, { text: display, searchText: searchText ?? null, className: "ppp-grid-cell-text" });
}

// src/grids/cells/cell-dispatcher.tsx
function getRendererTypeForMetadata(metadata) {
  const typeCode = metadata?.$type;
  switch (typeCode) {
    case 0:
      return "bool";
    case 2:
      return "date";
    case 3:
    case 4:
    case 5:
    case 18:
      return "number";
    case 6:
      return "lookup";
    case 7:
    case 14:
      return "string";
    case 8:
      return "money";
    case 11:
      return "choice";
    case 40:
      return "multiSelectChoice";
    case 41:
      return "file";
    case 42:
      return "image";
    default:
      return "fallback";
  }
}
function getCellRendererByType(typeCode) {
  switch (typeCode) {
    case 0:
      return BoolCell;
    case 2:
      return DateCell;
    case 3:
    case 4:
    case 5:
    case 18:
      return NumberCell;
    case 6:
      return LookupCell;
    case 7:
    case 14:
      return TextCell;
    case 8:
      return MoneyCell;
    case 11:
      return ChoiceCell;
    case 40:
      return MultiSelectChoiceCell;
    case 41:
    case 42:
      return FileCell;
    default:
      return FallbackCell;
  }
}
function getCellRenderer(metadata) {
  const typeCode = metadata?.$type;
  return getCellRendererByType(typeCode);
}
function isColumnSortable(metadata) {
  const typeCode = metadata?.$type;
  return typeCode !== 41 && typeCode !== 42;
}
function getRendererTypeForCode(typeCode) {
  switch (typeCode) {
    case 0:
      return "bool";
    case 2:
      return "date";
    case 3:
    case 4:
    case 5:
    case 18:
      return "number";
    case 6:
      return "lookup";
    case 7:
    case 14:
      return "string";
    case 8:
      return "money";
    case 11:
      return "choice";
    case 40:
      return "multiSelectChoice";
    case 41:
      return "file";
    case 42:
      return "image";
    default:
      return "fallback";
  }
}
function ColumnEdit(props) {
  const metadata = useColumnMetadata(props.columnName);
  const typeCode = metadata?.$type;
  switch (typeCode) {
    case 0:
      return /* @__PURE__ */ jsx(BoolEdit, { ...props });
    case 2:
      return /* @__PURE__ */ jsx(DateTimeEdit, { ...props });
    case 3:
    case 4:
    case 5:
    case 18:
      return /* @__PURE__ */ jsx(NumberEdit, { ...props });
    case 6:
      return /* @__PURE__ */ jsx(LookupEdit, { ...props });
    case 7:
      return /* @__PURE__ */ jsx(MemoEdit, { ...props });
    case 8:
      return /* @__PURE__ */ jsx(MoneyEdit, { ...props });
    case 11:
      return /* @__PURE__ */ jsx(ChoiceEdit, { ...props });
    case 14:
      return /* @__PURE__ */ jsx(TextEdit, { ...props });
    case 40:
      return /* @__PURE__ */ jsx(MultiSelectChoiceEdit, { ...props });
    case 41:
      return /* @__PURE__ */ jsx(FileEdit, { ...props });
    case 42:
      return /* @__PURE__ */ jsx(ImageEdit, { ...props });
    default:
      return null;
  }
}
function getEditComponentForType(typeCode) {
  switch (typeCode) {
    case 0:
      return BoolEdit;
    case 2:
      return DateTimeEdit;
    case 3:
    case 4:
    case 5:
    case 18:
      return NumberEdit;
    case 6:
      return LookupEdit;
    case 7:
      return MemoEdit;
    case 8:
      return MoneyEdit;
    case 11:
      return ChoiceEdit;
    case 14:
      return TextEdit;
    case 40:
      return MultiSelectChoiceEdit;
    case 41:
      return FileEdit;
    case 42:
      return ImageEdit;
    default:
      return null;
  }
}
function getEditComponentForMetadata(metadata) {
  const typeCode = metadata?.$type;
  return getEditComponentForType(typeCode);
}
var GRID_COLUMN_MARKER = /* @__PURE__ */ Symbol.for("@powerportalspro/grid-column");
var GRID_COLUMNS_MARKER = /* @__PURE__ */ Symbol.for("@powerportalspro/grid-columns");
var GRID_TEMPLATE_COLUMN_MARKER = /* @__PURE__ */ Symbol.for(
  "@powerportalspro/grid-template-column"
);
function GridTemplateColumn(_props) {
  return null;
}
GridTemplateColumn[GRID_TEMPLATE_COLUMN_MARKER] = true;
function GridColumn(_props) {
  return null;
}
GridColumn[GRID_COLUMN_MARKER] = true;
function GridColumns(_props) {
  return null;
}
GridColumns[GRID_COLUMNS_MARKER] = true;
function isGridColumnElement(node) {
  if (!isValidElement(node)) return false;
  const type = node.type;
  return !!type && type[GRID_COLUMN_MARKER] === true;
}
function isGridColumnsElement(node) {
  if (!isValidElement(node)) return false;
  const type = node.type;
  return !!type && type[GRID_COLUMNS_MARKER] === true;
}
function isGridTemplateColumnElement(node) {
  if (!isValidElement(node)) return false;
  const type = node.type;
  return !!type && type[GRID_TEMPLATE_COLUMN_MARKER] === true;
}
function extractGridColumnOverrides(children) {
  const declared = [];
  const templates = [];
  const ordered = [];
  const toolbarParts = [];
  let templateIndex = 0;
  function pushTemplate(props) {
    const withId = {
      ...props,
      id: props.id ?? `__template-${templateIndex}`
    };
    templates.push(withId);
    ordered.push({ kind: "template", props: withId });
    templateIndex += 1;
  }
  function pushColumn(props) {
    declared.push(props);
    ordered.push({ kind: "column", props });
  }
  Children.forEach(children, (child) => {
    if (isGridColumnElement(child)) {
      pushColumn(child.props);
      return;
    }
    if (isGridTemplateColumnElement(child)) {
      pushTemplate(child.props);
      return;
    }
    if (isGridColumnsElement(child)) {
      Children.forEach(child.props.children, (nested) => {
        if (isGridColumnElement(nested)) {
          pushColumn(nested.props);
        } else if (isGridTemplateColumnElement(nested)) {
          pushTemplate(nested.props);
        }
      });
      return;
    }
    toolbarParts.push(child);
  });
  return {
    declaredColumns: declared,
    templateColumns: templates,
    orderedDeclarations: ordered,
    toolbarChildren: toolbarParts.length === 0 ? null : toolbarParts
  };
}
var GridToolbarOverflowId = {
  Actions: "grid-actions",
  Search: "grid-search",
  Refresh: "grid-refresh",
  Settings: "grid-settings"
};
function GridToolbarOverflowMenu({
  children,
  ariaLabel
}) {
  const { ref, overflowCount, isOverflowing } = useOverflowMenu();
  if (!isOverflowing) return null;
  return /* @__PURE__ */ jsxs(Menu, { hasIcons: true, children: [
    /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(
      Button,
      {
        ref,
        className: "ppp-grid-toolbar-overflow",
        appearance: "subtle",
        icon: /* @__PURE__ */ jsx(MoreHorizontal20Regular, {}),
        "aria-label": `${ariaLabel} (${overflowCount})`,
        title: ariaLabel
      }
    ) }),
    /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsx(MenuList, { children }) })
  ] });
}
function OverflowMenuItem({
  itemId,
  children
}) {
  const isVisible = useIsOverflowItemVisible(itemId);
  if (isVisible) return null;
  return /* @__PURE__ */ jsx(Fragment, { children });
}
var NARROW_VIEWPORT_BREAKPOINT_PX = 767.98;
function useIsNarrowViewport() {
  const [isNarrow, setIsNarrow] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(`(max-width: ${NARROW_VIEWPORT_BREAKPOINT_PX}px)`).matches;
  });
  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia(`(max-width: ${NARROW_VIEWPORT_BREAKPOINT_PX}px)`);
    const handler = (ev) => setIsNarrow(ev.matches);
    setIsNarrow(mq.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);
  return isNarrow;
}
var PPP_FOOTER_CLASS = "ppp-footer";
var useFooterStyles = makeStyles({
  // Single source of truth for the framework's footer-band visual
  // treatment. Mirrors token-for-token
  // any change here propagates to every consumer (Section footer
  // bands, future grid footers, standalone usage).
  // Token mapping:
  // --neutral-foreground-rest → tokens.colorNeutralForeground1
  // --neutral-layer-2 → tokens.colorNeutralBackground2
  // --neutral-stroke-rest → tokens.colorNeutralStroke1
  // --control-corner-radius → tokens.borderRadiusMedium
  // 2*--design-unit (8px) → tokens.spacingVerticalS
  // 3*--design-unit (12px) → tokens.spacingHorizontalM
  root: {
    width: "100%",
    boxSizing: "border-box",
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    color: tokens.colorNeutralForeground1,
    backgroundColor: tokens.colorNeutralBackground2,
    borderTop: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderBottomLeftRadius: tokens.borderRadiusMedium,
    borderBottomRightRadius: tokens.borderRadiusMedium,
    // keeps the footer
    // flush against whatever sits above (typically a section body).
    marginTop: 0
  }
});
function Footer({ children, className, style, ...rest }) {
  const styles = useFooterStyles();
  return /* @__PURE__ */ jsx(
    "footer",
    {
      ...rest,
      className: mergeClasses(styles.root, PPP_FOOTER_CLASS, className),
      style,
      children
    }
  );
}
var useMainGridStyles = makeStyles({
  // Top-level grid layout:
  // ┌───────────────────────────────────────┐
  // │ toolbar (flex-shrink: 0, fixed top) │
  // ├───────────────────────────────────────┤
  // │ bodyArea (flex: 1, hosts scroll + │
  // │ refetch scrim; centers status │
  // │ messages when no rows) │
  // ├───────────────────────────────────────┤
  // │ paging (flex-shrink: 0, fixed bot.) │
  // └───────────────────────────────────────┘
  // Sizing is configured via {@link MainGridProps.minHeight} /
  // {@link MainGridProps.maxHeight} / {@link MainGridProps.fullSize},
  // / `MaxHeight` / `FullSize` parameters.
  // The base `wrapper` style has no flex sizing — the grid grows to fit
  // content between the configured min/max. The {@link wrapperFullSize}
  // variant adds `flex: 1` for the "fill the parent's height" case.
  wrapper: {
    width: "100%",
    // Mirrors `.ppp-section`'s defensive sizing: in a flex/grid parent the
    // default `min-width: auto` is content-based, which lets the inner
    // table's resized pixel width push the wrapper beyond its parent's
    // bounds. `min-width: 0` clamps it so the wrapper stays at 100% of
    // the parent and the inner `tableContainer`'s `overflow: auto`
    // engages — producing a horizontal scrollbar instead of escaping.
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground1,
    // Mirrors shell: thin neutral outline +
    // rounded corners around the whole grid. `overflow: hidden` clips
    // the rounded corners against children (toolbar tint, body cells)
    // so the corner radius reads cleanly; the inner `tableContainer`
    // owns its own scroll behavior so the clip doesn't fight scrolling.
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    overflow: "hidden"
  },
  // Applied when `fullSize: true`. `flex: 1 1 auto` makes the grid take
  // the parent's available height (must be inside a flex column or
  // fixed-height container), and `min-height: 0` is the critical bit
  // letting the bodyArea's `overflow: auto` actually clip — without it
  // flex children's intrinsic min content size prevents overflow from
  // ever engaging. Min/max-height inline styles are skipped in this
  // mode.
  wrapperFullSize: {
    flex: "1 1 auto",
    minHeight: 0
  },
  // Drops the outer border + rounded corners when `borderVisible: false`.
  // Useful when an embedding card / panel already supplies framing — a
  // double border looks heavier than intended. The inner table's column
  // separators and bottom rules stay; only the wrapper's outer rectangle
  // is suppressed.
  wrapperBorderless: {
    border: "none",
    borderRadius: 0
  },
  // Middle stripe — fills the space between toolbar and paging row.
  // `position: relative` anchors the absolutely-positioned refetch scrim
  // to the body area (scrim covers the scrollable region without
  // scrolling along with the content). When the grid is empty / loading /
  // errored, the bodyArea hosts a centered status message instead of the
  // scroll container.
  bodyArea: {
    position: "relative",
    flex: "1 1 auto",
    minHeight: 0,
    // Same reasoning as wrapper.minWidth: 0 — without this, a flex item's
    // `min-width: auto` resolves to content min-content, and the inner
    // table's pixel width would expand bodyArea past the wrapper, blocking
    // the horizontal scroll trick.
    minWidth: 0,
    display: "flex",
    flexDirection: "column"
  },
  // Top toolbar — view picker on the left, search box + button slot on
  // the right. Locked at the top of the grid (`flexShrink: 0`) so it
  // doesn't compress when the body area takes the available height.
  // Subtle neutral tint + bottom divider stroke. Uses
  // `colorNeutralBackground3` (≈ #f5f5f5 in light theme) rather than
  // `colorNeutralBackground2` — Background3 reads as a clearer toolbar
  // shade against the body's Background1.
  toolbar: {
    flexShrink: 0,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: tokens.spacingHorizontalM,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
    backgroundColor: tokens.colorNeutralBackground3,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`
  },
  viewPicker: {
    minWidth: "220px"
  },
  // Static title shown in the toolbar in place of the view-picker dropdown
  // when the grid is locked to a single view (or the consumer passed `title`
  // on a single-view table). Mirrors rendering.
  title: {
    fontWeight: tokens.fontWeightSemibold,
    paddingLeft: tokens.spacingHorizontalS
  },
  // Flex spacer that pushes the search box to the right end of the
  // toolbar (view picker on the left, search on the right, both
  // anchored even if the picker hides).
  // Header text inside the settings popover — semibold, bottom margin to
  // separate from the settings rows below. Matches the visual weight of
  // slot on `FluentPopover`.
  settingsHeader: {
    fontWeight: tokens.fontWeightSemibold,
    marginBottom: tokens.spacingVerticalM
  },
  // One row inside the settings popover. Horizontal flex layout so the
  // label sits left of the control (matching the page-size group's
  // footer layout). Bottom margin separates stacked rows.
  settingsRow: {
    display: "flex",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    marginBottom: tokens.spacingVerticalS
  },
  // Label text inside a settings row. Matches the footer's page-size
  // label styling so the same control feels at home in both surfaces.
  settingsRowLabel: {
    color: tokens.colorNeutralForeground2
  },
  // Page-size dropdown inside the settings popover — narrower than the
  // toolbar Settings popover's natural width to fit the compact row.
  settingsPageSizeDropdown: {
    minWidth: "70px"
  },
  // Flex container for the toolbar's overflow-aware right cluster. The
  // `<Overflow>` measures this against its own width; OverflowItems
  // inside register their widths via context and get hidden in priority
  // order when they don't all fit. `flex: 1` lets it expand to fill the
  // toolbar's available space (after the spacer); `min-width: 0` is the
  // critical bit that lets Overflow shrink the container — without it
  // flex children's intrinsic min-content prevents the measurement loop
  // from ever signaling overflow. `overflow: hidden` clips items mid-
  // hide-transition (the OverflowItem CSS toggles visibility rather
  // than display, so they occupy zero space but their bounding box can
  // briefly extend during the transition).
  toolbarOverflow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    flex: "1 1 auto",
    minWidth: 0,
    overflow: "hidden",
    justifyContent: "flex-end"
  },
  // Slot wrapper for the consumer's action-button cluster when it lives
  // inside an OverflowItem. Keeps the cluster's internal layout (gap +
  // alignment) intact even though the surrounding `<GridButtons>` div
  // is also a flex container — the OverflowItem treats this whole slot
  // as a single unit for overflow measurement.
  toolbarSlot: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS
  },
  // Plain `<div>` wrapper around each OverflowItem's content (refresh
  // button, settings popover, etc.). Necessary because OverflowItem's
  // ref-forwarding recursively unwraps FluentTrigger components
  // (Tooltip, Popover, MenuTrigger, etc.) until it lands on a non-
  // trigger element — and the `data-overflowing` attribute it toggles
  // for the hide-CSS rule lands on whatever the deepest unwrap is.
  // A plain div is NOT a trigger, so OverflowItem stops here, measures
  // this element's offsetWidth, and toggles `data-overflowing` here.
  // Fluent's `[overflowingItems] [data-overflowing] { display: none }`
  // then collapses the whole wrapper (including its complex Fluent
  // child) cleanly. Display: contents would also work conceptually but
  // breaks ResizeObserver measurement.
  toolbarItemWrapper: {
    display: "flex",
    alignItems: "center"
  },
  // Same pattern as `toolbarItemWrapper` but specifically for the
  // SearchBox, so the OverflowItem measures the wrapper instead of
  // recursively unwrapping into the Tooltip → SearchBox tree. Inherits
  // flex display so the SearchBox's natural minWidth shapes the
  // wrapper width.
  searchBoxWrapper: {
    display: "flex",
    alignItems: "center"
  },
  // Wrapper for a non-MenuItem control rendered inside the overflow
  // menu (search box, settings switch, action buttons cluster). Gives
  // the row consistent padding so it looks at home next to plain
  // MenuItems. `width: 100%` ensures the contained input / button bar
  // fills the menu's surface width.
  menuActionRow: {
    display: "flex",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalXS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    width: "100%"
  },
  // SearchBox sized to fit comfortably inside the overflow menu's
  // surface — the inline toolbar SearchBox has its own `searchBox`
  // sizing that's tuned for the toolbar's narrow strip; the menu
  // version gets a wider min-width to feel like a proper search input
  // when surfaced from the "..." menu.
  menuSearchBox: {
    minWidth: "200px",
    width: "100%"
  },
  searchBox: {
    // Narrower than the original 240px so the SearchBox can shrink with
    // the toolbar before the Overflow algorithm hides it entirely. On
    // narrow viewports where 240px wouldn't fit, the SearchBox still
    // collapses into the overflow menu (where `menuSearchBox` gives it
    // the wider styling).
    minWidth: "160px"
  },
  // Horizontal flex container for the toolbar's action-button area.
  // Children sit at the right end of the toolbar after the search box,
  //. `flexShrink: 0` keeps the cluster
  // intact when the viewport narrows (the view picker / search box flex
  // first); the small gap matches Fluent's typical button-row spacing.
  buttonsBar: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexShrink: 0,
    columnGap: tokens.spacingHorizontalXS
  },
  // Layout for the search-box tooltip. Two stacked sections (string-bucket
  // intro + columns, number-bucket intro + columns), each indented one
  // level under its header, e.g. "Applies begins-with… / Uses number
  // comparisons…".
  searchTooltipBody: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalM,
    maxWidth: "320px"
  },
  searchTooltipSection: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalXXS
  },
  searchTooltipColumnList: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: tokens.spacingHorizontalM
  },
  // Table itself. `border-collapse: separate` + per-row borders gives
  // Fluent's "cards stacked into a list" feel without doubled lines at
  // every cell intersection.
  // `tableLayout: 'fixed'` is required for the resize handles to feel
  // crisp: with `auto`, the browser fights user-set column widths
  // against content width and resize drags look laggy or unstable. With
  // `fixed`, each `<th>`'s `width` style is authoritative and body cells
  // simply ellipsis-overflow within it (already wired via
  // `bodyCell.maxWidth: 0`).
  // No `width: 100%` — that combined with `table-layout: fixed` causes
  // the browser to redistribute leftover space (container width minus
  // sum of declared column widths) proportionally across all columns,
  // INCLUDING the 50px-locked select column. Even `<col width="50px">`
  // and `max-width: 50px` on the cell aren't honored in that case
  // (long-standing Chromium quirk). Setting the table's width to the
  // exact total via inline style at render time eliminates the leftover
  // entirely, so the select column stays at exactly 50px. Tradeoff: a
  // grid narrower than its container leaves visible space on the right
  // instead of stretching.
  table: {
    borderCollapse: "separate",
    borderSpacing: 0,
    tableLayout: "fixed"
  },
  headerRow: {
    backgroundColor: tokens.colorNeutralBackground2
  },
  headerCell: {
    // `position: sticky` pins the header row to the top of the scroll
    // container (`tableContainer`) as the body scrolls beneath it.
    // Sticky must be on the `<th>` cells, not the `<thead>` / `<tr>`
    // Chrome / Safari don't honor sticky on table-row-group elements.
    position: "sticky",
    top: 0,
    // Above body cells (no z-index) but below the refetch scrim
    // (zIndex: 2) — so the scrim covers the header too while still
    // letting the resize handle inside the th catch pointer events.
    zIndex: 1,
    // Background MUST live on the th itself, not just the parent <tr>.
    // When a child is `position: sticky`, the parent row's background
    // paints at the row's natural scroll position — not at the sticky
    // offset — so the cell becomes transparent and body rows scroll
    // through visibly underneath. Painting the background on the th
    // travels with the cell to its sticky position and occludes the
    // rows beneath cleanly.
    backgroundColor: tokens.colorNeutralBackground2,
    textAlign: "left",
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground2,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    // Use `box-shadow` instead of `border-bottom` for the divider: with
    // `position: sticky`, table cell borders don't render correctly
    // (they're collapsed away in some browsers, or attached to the
    // wrong row). An inset box-shadow at -1px draws an internal hairline
    // along the bottom edge that paints reliably across all browsers
    // regardless of the sticky positioning.
    boxShadow: `inset 0 -${tokens.strokeWidthThin} 0 ${tokens.colorNeutralStroke1}`,
    // Wrapping in the header keeps narrow columns from blowing out the
    // grid width when label text is long. Body cells handle their own
    // overflow per-renderer.
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  // Sortable headers — pointer cursor + hover background to advertise
  // clickability. Non-sortable headers (File/Image columns) inherit the
  // base headerCell style only.
  headerCellSortable: {
    cursor: "pointer",
    userSelect: "none",
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground2Hover
    }
  },
  // Inner flex layout for sortable headers: label on the left, sort
  // indicator on the right. Stays a single row even when the label
  // ellipsis-truncates.
  headerCellInner: {
    display: "inline-flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS,
    maxWidth: "100%"
  },
  headerCellLabel: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  sortIcon: {
    flex: "0 0 auto",
    color: tokens.colorNeutralForeground2
  },
  // Small numeric badge that shows the 1-based sort precedence when
  // multiple columns are active. Mirrors the position-indicator pattern
  // most data grids use (AG Grid, Material UI, etc.) — number alone is
  // enough, no need to ape Excel's "↑1" combined glyph.
  sortPosition: {
    flex: "0 0 auto",
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground3,
    minWidth: "12px",
    textAlign: "center"
  },
  // Resize handle — a narrow vertical strip on the right edge of each
  // header cell. Invisible by default so it doesn't clutter the chrome;
  // a subtle accent line appears on hover or while actively dragging.
  // `touchAction: 'none'` is required to keep mobile-Safari from
  // scrolling the page while the user drags.
  resizeHandle: {
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    width: "5px",
    cursor: "col-resize",
    userSelect: "none",
    touchAction: "none",
    backgroundColor: "transparent",
    transitionProperty: "background-color",
    transitionDuration: tokens.durationFaster,
    ":hover": {
      backgroundColor: tokens.colorBrandStroke1
    }
  },
  // Drag-in-progress — keep the indicator visible even after the cursor
  // leaves the strict 5px hit-zone (the OS continues sending mousemove
  // events to the original target until mouseup).
  resizeHandleActive: {
    backgroundColor: tokens.colorBrandStroke1
  },
  // Checkbox column — the column that holds row-selection toggles. Locked
  // to 50px with `width` + `min-width` + `max-width` all three together.
  // With `table-layout: fixed` and `width: 100%` on the table, declaring
  // only `width: 50px` isn't enough: when the sum of all column widths is
  // less than the table's rendered width, the browser distributes the
  // extra space across columns proportionally — including this one — and
  // the cell ends up rendering noticeably wider than 50px. `min-width` /
  // `max-width` clamp the cell so the proportional distribution can't
  // steal width into it; the slack lands on the data columns instead.
  selectCell: {
    width: "50px",
    minWidth: "50px",
    maxWidth: "50px",
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalXS,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalXS
  },
  // Pending-operation column. Same 50px clamp as `selectCell` — matches
  // the visual rhythm of the checkbox column to its left. Same
  // `table-layout: fixed` distribution caveat applies (the width triple
  // is what keeps the column from absorbing slack from the data
  // columns). Header is empty by design; the meaning lives in the per-
  // row icons.
  pendingCell: {
    width: "50px",
    minWidth: "50px",
    maxWidth: "50px",
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalXS,
    paddingLeft: tokens.spacingHorizontalXS,
    paddingRight: tokens.spacingHorizontalXS,
    textAlign: "center"
  },
  // Operation icons. Brand-tinted to draw the eye but kept at icon-only
  // intensity — they're status indicators, not actions. `verticalAlign:
  // middle` aligns to the row's baseline rather than sitting on the
  // text descender line (which would push the icon below cell center).
  pendingIconCreate: {
    color: tokens.colorPaletteGreenForeground1,
    verticalAlign: "middle"
  },
  pendingIconUpdate: {
    color: tokens.colorBrandForeground1,
    verticalAlign: "middle"
  },
  // Toolbar pending-operation summary indicators (Plus/Pencil/Trash + a
  // count badge). Inline-flex so the icon and its badge stay tight; small
  // gap separates them without making the chip feel airy. Each indicator
  // is its own compact unit so multiple can sit side-by-side without
  // any custom spacing logic.
  pendingIndicator: {
    display: "inline-flex",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalXXS,
    paddingLeft: tokens.spacingHorizontalXS,
    paddingRight: tokens.spacingHorizontalXS
  },
  // Row that's currently selected — accent-tinted background so it
  // stands out from hover. Same treatment Fluent's DataGrid uses.
  bodyRowSelected: {
    backgroundColor: tokens.colorNeutralBackground1Selected,
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground1Selected
    }
  },
  bodyRow: {
    backgroundColor: tokens.colorNeutralBackground1,
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground1Hover
    }
  },
  // Click-anywhere selection cursor feedback. Applied when
  // `selectFromEntireRow` is on so the user sees the row as a click target.
  // Interactive children (links, buttons) override this via their own
  // cursor in the cascade.
  bodyRowClickable: {
    cursor: "pointer"
  },
  // Applied when a shared `ViewDataSource.highlight` is set and the
  // row's column value doesn't match — drives the "highlight + dim"
  // chart cross-filter UX. The row data, selection, and pending
  // operations are unaffected; only visual opacity changes so the
  // user can see the full context with the matching subset
  // emphasized. Cleared by `setHighlight(undefined)` on the
  // datasource.
  bodyRowMuted: {
    opacity: 0.4
  },
  // Sentinel rendered after the last body row in virtualize mode.
  // IntersectionObserver watches this against the scroll container; when
  // it enters view, the next page loads. Height + padding give the
  // observer a reasonable target box; the centered spinner indicates
  // "loading the next page" without a layout shift on the rows above.
  loadMoreSentinel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: tokens.spacingVerticalM,
    paddingBottom: tokens.spacingVerticalM,
    minHeight: "32px"
  },
  // Primary-name cell rendered as a clickable link — fires the grid's
  // registered edit handler. Mirrors:
  // accent foreground, no underline at rest, underline on hover/focus.
  // Inherits the surrounding cell's color when there's nothing to
  // navigate to (the cell falls back to plain text in that case, so
  // there's no styled-disabled state to worry about).
  primaryNameLink: {
    color: tokens.colorBrandForegroundLink,
    textDecorationLine: "none",
    cursor: "pointer",
    ":hover": {
      color: tokens.colorBrandForegroundLinkHover,
      textDecorationLine: "underline"
    },
    ":focus-visible": {
      color: tokens.colorBrandForegroundLinkHover,
      textDecorationLine: "underline",
      outlineStyle: "none"
    }
  },
  // Subtle striping. Off by default in this v1 — toggle by setting a
  // `data-striped="true"` attribute on the wrapper in a future phase.
  bodyCell: {
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    borderBottomWidth: tokens.strokeWidthThin,
    borderBottomStyle: "solid",
    borderBottomColor: tokens.colorNeutralStroke2,
    verticalAlign: "middle",
    // Single-line cells with ellipsis. Wrapping rows would be a per-
    // column opt-in (e.g. Memo) handled by the cell renderer setting
    // its own `white-space: normal` on its content.
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 0
  },
  // Inline-edit cell wrapper. Constrains the embedded editor to the
  // column's actual width — without this, Fluent v9's <Input> /
  // <Combobox> / <Dropdown> outer slots carry a default min-width
  // (~200px on `.fui-Input`, similar on the others) that overflows
  // narrow columns and visually leaks into the neighbour cell.
  // Fluent's atomic-CSS rules can land in either order vs ours, so
  // `!important` is the reliable way to win specificity against the
  // outer-slot rule. The descendant cascade (`& *`) covers Field,
  // Input wrapper, Combobox button, Dropdown trigger, etc. without
  // having to enumerate Fluent's per-component class names — the
  // worst that happens elsewhere is that an inner intentional
  // min-width inside a dropdown listbox flattens, which is harmless
  // because the listbox is portaled out of the cell anyway.
  inlineEditCell: {
    width: "100%",
    minWidth: 0,
    // Direct children get width: 100% too so the typed edit's
    // <Field> stretches to fill the cell instead of shrink-wrapping.
    "& > *": {
      width: "100%"
    },
    "& *": {
      minWidth: "0 !important"
    }
  },
  // Scroll container for the table. Fills the bodyArea (`flex: 1`) and
  // shows scrollbars on demand — `overflow: auto` triggers vertical
  // scrolling when rows overflow the height, horizontal scrolling when
  // user-resized columns push the table wider than the container. The
  // sticky `<thead>` cells stay locked at the top of THIS box (not the
  // viewport) while the body scrolls beneath them. `min-height: 0` is
  // again the critical bit for the flex-child overflow trick to work.
  tableContainer: {
    flex: "1 1 auto",
    minHeight: 0,
    // The element that actually owns the horizontal scrollbar — for that to
    // engage, the container must be ALLOWED to be narrower than the table
    // inside it. Without `min-width: 0`, `min-width: auto` resolves to the
    // table's pixel width as content min-content, the container grows to
    // match, and `overflow: auto` never triggers — the table just escapes
    // its ancestors instead.
    minWidth: 0,
    overflow: "auto"
  },
  // Translucent backdrop drawn over the existing rows while a deps-change
  // refetch is in flight (new page / sort / search / view). Mirrors the
  // look so the visual feel is consistent
  // across both UIs — a theme-aware neutral tint (`colorNeutralBackground2`,
  // equivalent to) at 0.7 opacity drawn via a
  // `::before` pseudo-element so the spinner above stays at full opacity.
  // Light + readable in light theme, dark + readable in dark theme; the
  // token swaps automatically with FluentDesignTheme without any
  // additional rules. `pointerEvents: 'auto'` blocks accidental clicks on
  // the dimmed rows; the toolbar above stays interactive.
  // Mounted as a sibling of `tableContainer` (inside `bodyArea`, which is
  // `position: relative`), NOT inside the scroll container — so the
  // scrim stays anchored to the viewport of the body area as the table
  // scrolls under it. `zIndex: 2` keeps it above the sticky header
  // (which sits at zIndex 1 inside its own scroll context).
  refetchScrim: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "auto",
    zIndex: 2,
    "::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      backgroundColor: tokens.colorNeutralBackground2,
      opacity: 0.7,
      zIndex: -1
    }
  },
  // Centered status surface that fills `bodyArea` when the grid has no
  // table to show — cold-start loading (no columns resolved yet) or an
  // error response. Replaces `tableContainer` in those states rather
  // than rendering alongside it.
  statusFill: {
    flex: "1 1 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: tokens.spacingVerticalL,
    color: tokens.colorNeutralForeground3
  },
  statusFillError: {
    color: tokens.colorPaletteRedForeground1
  },
  // "No records found" row when a successful response has zero rows.
  // Lives INSIDE `tableContainer` so the column headers above it stay
  // sticky / scroll horizontally with the empty grid. Padding gives it
  // breathing room from the header divider.
  emptyStateRow: {
    display: "flex",
    justifyContent: "center",
    padding: tokens.spacingVerticalL,
    color: tokens.colorNeutralForeground3
  },
  // Paging strip at the bottom of the grid. Renders inside the
  // `<Footer>` layout component, which paints the background tint +
  // top-border divider (
  // renders a `<Footer>` in its `grid-area: footer` slot). This style
  // only handles the inner flex layout: page-size group on the left,
  // a flex spacer, then record count + nav buttons on the right.
  // Locked at the bottom (`flexShrink: 0`) so it stays visible even
  // when the body area is tall enough to require vertical scrolling.
  // Padding is tightened from the `<Footer>` default (`spacingHorizontalM`)
  // to `spacingHorizontalS` for visual parity with the grid `toolbar`.
  pagingRow: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: tokens.spacingHorizontalM,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
    color: tokens.colorNeutralForeground2
  },
  pagingPageSizeGroup: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS
  },
  pagingPageSizeLabel: {
    color: tokens.colorNeutralForeground2
  },
  // Tight dropdown — page-size options are 2-3 digits so the field
  // doesn't need the default 240px+ minWidth Fluent's Dropdown picks.
  pagingPageSizeDropdown: {
    minWidth: "80px"
  },
  pagingSpacer: {
    flex: "1 1 auto"
  },
  pagingNav: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS
  },
  pagingCount: {
    fontVariantNumeric: "tabular-nums"
  }
});
function MainGridPaging({
  page,
  pageSize,
  totalCount,
  dataLength,
  onPageChange,
  onPageSizeChange,
  pageSizes,
  showPageSize
}) {
  const styles = useMainGridStyles();
  const t = useT();
  const pageSizeLabel = t("app.components.grid.page-size");
  const totalPages = totalCount !== void 0 && totalCount > 0 ? Math.max(1, Math.ceil(totalCount / pageSize)) : void 0;
  const canPrev = page > 1;
  const canNext = totalPages !== void 0 ? page < totalPages : dataLength === pageSize;
  const canFirst = canPrev;
  const canLast = totalPages !== void 0 && page < totalPages;
  return /* @__PURE__ */ jsxs(Footer, { className: mergeClasses("ppp-grid-paging", styles.pagingRow), children: [
    showPageSize && /* @__PURE__ */ jsxs("div", { className: styles.pagingPageSizeGroup, children: [
      /* @__PURE__ */ jsx("span", { className: styles.pagingPageSizeLabel, children: pageSizeLabel }),
      /* @__PURE__ */ jsx(
        Dropdown,
        {
          className: styles.pagingPageSizeDropdown,
          "aria-label": pageSizeLabel,
          value: String(pageSize),
          selectedOptions: [String(pageSize)],
          onOptionSelect: (_, data) => {
            if (data.optionValue) {
              const next = Number(data.optionValue);
              if (Number.isFinite(next) && next > 0) onPageSizeChange(next);
            }
          },
          children: pageSizes.map((size) => /* @__PURE__ */ jsx(Option, { value: String(size), text: String(size), children: String(size) }, size))
        }
      )
    ] }),
    /* @__PURE__ */ jsx("div", { className: styles.pagingSpacer }),
    totalCount !== void 0 && // Singular/plural collapsed into a single "{0} items" form so a
    // single localization key covers all counts. Slight grammatical
    // oddity at count=1 ("1 items") is accepted in trade.
    /* @__PURE__ */ jsx("span", { className: styles.pagingCount, children: t("app.components.grid.record-count", [totalCount]) }),
    /* @__PURE__ */ jsxs("div", { className: styles.pagingNav, children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "subtle",
          icon: /* @__PURE__ */ jsx(ChevronDoubleLeft20Regular, {}),
          "aria-label": t("app.components.grid.first-page"),
          disabled: !canFirst,
          onClick: () => onPageChange(1)
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "subtle",
          icon: /* @__PURE__ */ jsx(ChevronLeft20Regular, {}),
          "aria-label": t("app.components.grid.previous-page"),
          disabled: !canPrev,
          onClick: () => onPageChange(Math.max(1, page - 1))
        }
      ),
      /* @__PURE__ */ jsx("span", { className: styles.pagingCount, children: totalPages !== void 0 ? t("app.components.grid.paging-text", [page, totalPages]) : t("app.components.grid.paging-text-no-total", [page]) }),
      /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "subtle",
          icon: /* @__PURE__ */ jsx(ChevronRight20Regular, {}),
          "aria-label": t("app.components.grid.next-page"),
          disabled: !canNext,
          onClick: () => onPageChange(page + 1)
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "subtle",
          icon: /* @__PURE__ */ jsx(ChevronDoubleRight20Regular, {}),
          "aria-label": t("app.components.grid.last-page"),
          disabled: !canLast,
          onClick: () => {
            if (totalPages !== void 0) onPageChange(totalPages);
          }
        }
      )
    ] })
  ] });
}
function MainGridVirtualizeFooter({
  loadedCount,
  totalCount
}) {
  const styles = useMainGridStyles();
  const t = useT();
  const text = totalCount !== void 0 ? t("app.components.grid.record-count-showing", [totalCount, 1, loadedCount]) : t("app.components.grid.record-count-showing-no-total", [1, loadedCount]);
  return /* @__PURE__ */ jsxs(Footer, { className: mergeClasses("ppp-grid-virtualize-footer", styles.pagingRow), children: [
    /* @__PURE__ */ jsx("div", { className: styles.pagingSpacer }),
    /* @__PURE__ */ jsx("span", { className: styles.pagingCount, children: text })
  ] });
}

// src/grids/persisted-grid-state.ts
function readPersistedGridStateFromUrl(queryParameterName) {
  if (!queryParameterName) return null;
  if (typeof window === "undefined") return null;
  const raw = new URLSearchParams(window.location.search).get(queryParameterName);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object") {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
}
function encodePersistedGridState(state) {
  const compact = {};
  if (state.v) compact.v = state.v;
  if (state.p !== void 0 && state.p > 1) compact.p = state.p;
  if (state.ps !== void 0) compact.ps = state.ps;
  if (state.s && state.s.length > 0) compact.s = state.s;
  if (state.q && state.q.length > 0) compact.q = state.q;
  return JSON.stringify(compact);
}
function serializeSorts(sorts) {
  return sorts.map((s) => s.descending ? { c: s.columnName, d: true } : { c: s.columnName });
}
function deserializeSorts(sorts) {
  if (!sorts) return [];
  return sorts.filter((s) => typeof s?.c === "string" && s.c.length > 0).map((s) => s.d ? { columnName: s.c, descending: true } : { columnName: s.c });
}
function writePersistedGridStateToUrl(queryParameterName, state) {
  if (!queryParameterName) return;
  if (typeof window === "undefined") return;
  const encoded = encodePersistedGridState(state);
  const params = new URLSearchParams(window.location.search);
  if (params.get(queryParameterName) === encoded) return;
  params.set(queryParameterName, encoded);
  const next = `${window.location.pathname}?${params.toString()}${window.location.hash}`;
  window.history.replaceState(window.history.state, "", next);
}

// src/grids/view-options.ts
var PagingMode = {
  /** Classic pager — Prev / Next / page-size selector at the bottom. */
  Paged: "paged",
  /**
   * Infinite scroll. The pager footer is hidden, rows accumulate across page
   * boundaries, and a new page is fetched automatically when the user
   * scrolls past the rendered bottom. Use for long lists where the user
   * scans rather than navigates by page.
   */
  Virtualize: "virtualize"
};
var ViewSort = {
  /** Server-returned order, plus custom views appended in declaration order. */
  Default: "default",
  /** Localized display name, ascending (the framework default). */
  NameAscending: "nameAscending",
  /** Localized display name, descending. */
  NameDescending: "nameDescending"
};
function customToViewMetadata(custom) {
  return {
    id: custom.id,
    fetchXml: custom.fetchXml,
    tableName: custom.tableName,
    columns: [...custom.columns],
    displayName: custom.displayName ?? null,
    name: custom.displayName ?? custom.id,
    isDefault: false,
    quickFindCompatible: false,
    userDefined: true
  };
}
function isCustomViewId(viewId, customViewDefinitions) {
  if (!viewId || !customViewDefinitions) return false;
  for (const v of customViewDefinitions) {
    if (v.id === viewId) return true;
  }
  return false;
}
function sortViews(views, mode) {
  if (mode === ViewSort.Default) return [...views];
  const sorted = [...views];
  sorted.sort((a, b) => {
    const labelA = a.displayName ?? a.name ?? "";
    const labelB = b.displayName ?? b.name ?? "";
    return mode === ViewSort.NameAscending ? labelA.localeCompare(labelB) : labelB.localeCompare(labelA);
  });
  return sorted;
}
function composeViewsList(args) {
  const customs = (args.customViewDefinitions ?? []).map(customToViewMetadata);
  const all = [...args.dataverseViews, ...customs];
  const filtered = args.viewIds && args.viewIds.length > 0 ? all.filter((v) => args.viewIds.includes(v.id)) : all;
  return sortViews(filtered, args.viewSort);
}
var SEARCH_DEBOUNCE_MS = 300;
function parsePixelWidth(value) {
  const trimmed = value.trim();
  if (!trimmed.toLowerCase().endsWith("px")) return void 0;
  const num = Number(trimmed.slice(0, -2));
  return Number.isFinite(num) ? num : void 0;
}
var columnHelper = createColumnHelper();
var EMPTY_RECORDS = [];
var EMPTY_ROW_SELECTION = {};
var EMPTY_RESOLVED_COLUMNS = [];
var EMPTY_VIEW_LIST = [];
var EMPTY_COLUMN_SIZING = {};
var DEFAULT_PAGE_SIZES = [10, 20, 50, 100];
var DEFAULT_PAGE_SIZE = 50;
function computeNextSort(prev, columnName, shiftKey) {
  const existingIndex = prev.findIndex((d) => d.columnName === columnName);
  const existing = existingIndex >= 0 ? prev[existingIndex] : void 0;
  if (shiftKey) {
    if (prev.length === 1 && existing) return [];
    if (!existing) return [...prev, { columnName, descending: false }];
    if (!existing.descending) {
      const next = prev.slice();
      next[existingIndex] = { columnName, descending: true };
      return next;
    }
    return prev.filter((_, i) => i !== existingIndex);
  }
  if (prev.length === 1 && existing) {
    return [{ columnName, descending: !existing.descending }];
  }
  return [{ columnName, descending: false }];
}
function TemplateColumnEditCell({
  rendererProps,
  editRenderer,
  inlineEditCellClass
}) {
  const { record, setColumnValue } = useRecordContext();
  const editProps = {
    ...rendererProps,
    // Read from the live record-context record (loadedRecord + pendingChanges)
    // rather than the TanStack row snapshot in `rendererProps.record`. The
    // snapshot is frozen at fetch time, but `setColumnValue` writes to the
    // context's working copy — so a custom editRenderer reading
    // `record.properties[col]` off the snapshot never sees its own edits
    // (input appears stuck while the row dirties). Bound `<ColumnEdit>` editors
    // already read the context record via their column hooks; this gives the
    // imperative editRenderer the same live view.
    record: record ?? rendererProps.record,
    setValue: setColumnValue
  };
  return /* @__PURE__ */ jsx("div", { className: inlineEditCellClass, children: editRenderer(editProps) });
}
function MainGrid(props) {
  return /* @__PURE__ */ jsx(MainContext, { children: /* @__PURE__ */ jsx(MainGridImpl, { ...props }) });
}
function MainGridImpl({
  tableName,
  viewId,
  pageSize: initialPageSize = DEFAULT_PAGE_SIZE,
  pageSizes = DEFAULT_PAGE_SIZES,
  pagingMode = PagingMode.Paged,
  allowChangingPageSize = true,
  selectionMode = "multiple",
  onSelectedRecordsChange,
  selectedRecords: controlledSelectedRecords,
  onRefresh,
  cellRenderers,
  typeRenderers,
  filters,
  allowNavigateOnPrimaryNameClick = true,
  allowOpenOnRowDoubleClick = true,
  children,
  showRefreshButton = true,
  minHeight = "250px",
  maxHeight,
  fullSize = false,
  parentRecord,
  relationshipName,
  dataSource,
  allowSearch = true,
  hidePaging = false,
  title,
  persistedStateQueryParameter,
  includeSearchInPersistedState = false,
  allowPreviewForFileColumns = true,
  allowDownloadForFileColumns = true,
  columnWidthScale = 1,
  defaultViewId,
  viewIds,
  customViewDefinitions,
  viewSort = ViewSort.NameAscending,
  transformViewAsync,
  borderVisible = true,
  selectFromEntireRow = true,
  allowEdit = false,
  editable: editableProp,
  onEditableChanged,
  className,
  style
}) {
  const styles = useMainGridStyles();
  const t = useT();
  const parentTableMetadataQuery = useTableMetadata(parentRecord?.tableName ?? "", {
    enabled: !!parentRecord?.tableName
  });
  const gridTableMetadataQuery = useTableMetadata(tableName ?? "", {
    enabled: !!tableName
  });
  const gridTableMetadata = gridTableMetadataQuery.data;
  const isManyToManySubGrid = useMemo(() => {
    if (!relationshipName || !parentTableMetadataQuery.data) return false;
    return parentTableMetadataQuery.data.manyToMany?.some(
      (rel) => rel.relationshipName === relationshipName
    ) ?? false;
  }, [relationshipName, parentTableMetadataQuery.data]);
  const { declaredColumns, templateColumns, orderedDeclarations, toolbarChildren } = extractGridColumnOverrides(children);
  const declaredColumnsByName = useMemo(() => {
    const map = /* @__PURE__ */ new Map();
    for (const col of declaredColumns) map.set(col.columnName, col);
    return map;
  }, [declaredColumns]);
  const templateColumnsById = useMemo(() => {
    const map = /* @__PURE__ */ new Map();
    for (const tpl of templateColumns) map.set(tpl.id, tpl);
    return map;
  }, [templateColumns]);
  const hasDeclaredColumns = declaredColumns.length > 0 || templateColumns.length > 0;
  const isVirtualize = pagingMode === PagingMode.Virtualize;
  const warnAboutUnsavedChanges = useWarnAboutUnsavedChanges();
  const parentMainContext = useMainContext();
  const radioGroupName = useId$1("ppp-grid-selection");
  const isNarrowViewport = useIsNarrowViewport();
  const [internalEditable, setInternalEditable] = useState(false);
  const isControlledEditable = editableProp !== void 0;
  const editable = isControlledEditable ? editableProp : internalEditable;
  const [isEditableTransitionPending, startEditableTransition] = useTransition();
  const handleEditableToggle = useCallback(
    async (next) => {
      if (!next && parentMainContext?.isDirty) {
        const proceed = await warnAboutUnsavedChanges();
        if (!proceed) return;
      }
      if (isControlledEditable) {
        onEditableChanged?.(next);
        return;
      }
      startEditableTransition(() => {
        setInternalEditable(next);
      });
      onEditableChanged?.(next);
    },
    [
      isControlledEditable,
      onEditableChanged,
      parentMainContext,
      warnAboutUnsavedChanges
    ]
  );
  const showSettingsEditableRow = allowEdit && !isControlledEditable;
  const showSettingsPageSizeRow = allowChangingPageSize && isNarrowViewport && !isVirtualize;
  const inlineEditDisabled = parentMainContext === null;
  const [initialPersistedState] = useState(
    () => readPersistedGridStateFromUrl(persistedStateQueryParameter)
  );
  const [_internalPage, _setInternalPage] = useState(
    () => pagingMode === PagingMode.Virtualize ? 1 : initialPersistedState?.p ?? 1
  );
  const [_internalPageSize, _setInternalPageSize] = useState(
    () => initialPersistedState?.ps ?? initialPageSize
  );
  const [selectedViewId, setSelectedViewId] = useState(
    () => initialPersistedState?.v ?? void 0
  );
  const [_internalSort, _setInternalSort] = useState(
    () => {
      const persisted = deserializeSorts(initialPersistedState?.s);
      if (persisted.length > 0) return persisted;
      for (const col of declaredColumns) {
        if (col.isDefaultSortColumn) {
          return [
            {
              columnName: col.columnName,
              descending: col.initialSortDirection === "desc"
            }
          ];
        }
      }
      return [];
    }
  );
  const [_internalSearchText, _setInternalSearchText] = useState(
    () => includeSearchInPersistedState ? initialPersistedState?.q ?? "" : ""
  );
  const [_internalDebouncedSearchText, _setInternalDebouncedSearchText] = useState(
    () => includeSearchInPersistedState ? initialPersistedState?.q ?? "" : ""
  );
  const page = dataSource ? dataSource.page : _internalPage;
  const pageSize = dataSource ? dataSource.pageSize : _internalPageSize;
  const sort = dataSource ? dataSource.sort : _internalSort;
  const searchText = dataSource ? dataSource.search : _internalSearchText;
  const debouncedSearchText = dataSource ? dataSource.search : _internalDebouncedSearchText;
  const setPage = useCallback(
    (next) => {
      if (dataSource) dataSource.setPage(next);
      else _setInternalPage(next);
    },
    [dataSource]
  );
  const setPageSize = useCallback(
    (next) => {
      if (dataSource) dataSource.setPageSize(next);
      else _setInternalPageSize(next);
    },
    [dataSource]
  );
  const setSort = useCallback(
    (next) => {
      if (dataSource) dataSource.setSort(next);
      else _setInternalSort(next);
    },
    [dataSource]
  );
  const setSearchText = useCallback(
    (next) => {
      if (dataSource) dataSource.setSearch(next);
      else _setInternalSearchText(next);
    },
    [dataSource]
  );
  const setDebouncedSearchText = useCallback(
    (next) => {
      if (!dataSource) _setInternalDebouncedSearchText(next);
    },
    [dataSource]
  );
  const isSelectionControlled = controlledSelectedRecords !== void 0;
  const [internalRowSelection, setInternalRowSelection] = useState({});
  const controlledRowSelection = useMemo(() => {
    if (!isSelectionControlled) return EMPTY_ROW_SELECTION;
    const map = {};
    for (const r of controlledSelectedRecords) {
      if (r.id) map[r.id] = true;
    }
    return map;
  }, [isSelectionControlled, controlledSelectedRecords]);
  const rowSelection = isSelectionControlled ? controlledRowSelection : internalRowSelection;
  const isSelectionControlledRef = useRef(isSelectionControlled);
  isSelectionControlledRef.current = isSelectionControlled;
  const onSelectedRecordsChangeRef = useRef(onSelectedRecordsChange);
  onSelectedRecordsChangeRef.current = onSelectedRecordsChange;
  const requestEmptySelection = useCallback(() => {
    if (isSelectionControlledRef.current) {
      onSelectedRecordsChangeRef.current?.(EMPTY_RECORDS);
    } else {
      setInternalRowSelection(EMPTY_ROW_SELECTION);
    }
  }, []);
  const [columnSizing, setColumnSizing] = useState({});
  const resizingRef = useRef(false);
  const tableContainerRef = useRef(null);
  const loadMoreSentinelRef = useRef(null);
  const viewsResult = useViewsForTable(tableName ?? "", { enabled: !viewId && !!tableName });
  const dataverseViews = viewsResult.data ?? EMPTY_VIEW_LIST;
  const customViewsKey = customViewDefinitions ? customViewDefinitions.map((v) => v.id).join(",") : "";
  const viewIdsKey = viewIds ? viewIds.join(",") : "";
  const views = useMemo(
    () => composeViewsList({
      dataverseViews,
      customViewDefinitions,
      viewIds,
      viewSort
    }),
    // Structural keys cover content; viewSort is a primitive.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dataverseViews, customViewsKey, viewIdsKey, viewSort]
  );
  useEffect(() => {
    if (selectedViewId) return;
    if (views.length === 0) return;
    const preferred = defaultViewId && views.some((v) => v.id === defaultViewId) ? defaultViewId : views[0]?.id;
    if (preferred) setSelectedViewId(preferred);
  }, [selectedViewId, views, defaultViewId]);
  const resolvedViewId = viewId ?? selectedViewId;
  const isCustomActiveView = isCustomViewId(resolvedViewId, customViewDefinitions);
  const needsFullViewMetadata = !!transformViewAsync && !isCustomActiveView;
  const dataverseViewMetadataResult = useViewMetadata(resolvedViewId ?? "", {
    enabled: needsFullViewMetadata && !!resolvedViewId
  });
  const [transformedView, setTransformedView] = useState(null);
  useEffect(() => {
    if (!resolvedViewId) {
      setTransformedView(null);
      return;
    }
    if (!transformViewAsync && !isCustomActiveView) {
      setTransformedView(null);
      return;
    }
    let source = null;
    if (isCustomActiveView) {
      const customDef = customViewDefinitions?.find((v) => v.id === resolvedViewId);
      if (customDef) source = customToViewMetadata(customDef);
    } else if (dataverseViewMetadataResult.status === QueryStatus.Success && dataverseViewMetadataResult.data) {
      source = dataverseViewMetadataResult.data;
    }
    if (!source) {
      setTransformedView(null);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const result = transformViewAsync ? await transformViewAsync(source) : source;
        if (!cancelled) setTransformedView(result);
      } catch (err) {
        if (!cancelled) {
          console.error("[MainGrid] transformViewAsync threw", err);
          setTransformedView(null);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [
    resolvedViewId,
    transformViewAsync,
    isCustomActiveView,
    dataverseViewMetadataResult.status,
    dataverseViewMetadataResult.data
  ]);
  const [refreshing, setRefreshing] = useState(false);
  const writeStateToUrl = (overrides) => {
    if (!persistedStateQueryParameter) return;
    const state = {};
    const viewIdValue = overrides?.viewId ?? resolvedViewId;
    if (viewIdValue) state.v = viewIdValue;
    if (pagingMode === PagingMode.Paged) {
      const pageValue = overrides?.page ?? page;
      if (pageValue > 1) state.p = pageValue;
    }
    state.ps = overrides?.pageSize ?? pageSize;
    const sortValue = overrides?.sort ?? sort;
    if (sortValue.length > 0) state.s = serializeSorts(sortValue);
    if (includeSearchInPersistedState) {
      const searchValue = overrides?.search ?? debouncedSearchText;
      if (searchValue) state.q = searchValue;
    }
    writePersistedGridStateToUrl(persistedStateQueryParameter, state);
  };
  const handlePageSizeChange = (nextPageSize) => {
    if (nextPageSize === pageSize) return;
    setPageSize(nextPageSize);
    setPage(1);
    requestEmptySelection();
    writeStateToUrl({ pageSize: nextPageSize, page: 1 });
  };
  const handleViewChange = (newViewId) => {
    setSelectedViewId(newViewId);
    setPage(1);
    setSort([]);
    setSearchText("");
    setDebouncedSearchText("");
    requestEmptySelection();
    setColumnSizing(EMPTY_COLUMN_SIZING);
    writeStateToUrl({ viewId: newViewId, page: 1, sort: [], search: "" });
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchText(searchText);
      setPage(1);
      requestEmptySelection();
      writeStateToUrl({ search: searchText, page: 1 });
    }, SEARCH_DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [searchText]);
  const handleSortToggle = (columnName, shiftKey) => {
    const nextSort = computeNextSort(sort, columnName, shiftKey);
    setSort(nextSort);
    setPage(1);
    requestEmptySelection();
    writeStateToUrl({ sort: nextSort, page: 1 });
  };
  const showViewPicker = !viewId && !!tableName && (views?.length ?? 0) > 1;
  const filtersKey = filters ? JSON.stringify(filters) : "";
  const useInlineFetchXml = !!transformedView;
  const inlineFetchXml = transformedView?.fetchXml;
  const columnsKey = useMemo(() => {
    if (!hasDeclaredColumns) return "";
    const seen = /* @__PURE__ */ new Set();
    const ordered = [];
    for (const decl of orderedDeclarations) {
      if (decl.kind === "column") {
        if (decl.props.visible === false) continue;
        if (!seen.has(decl.props.columnName)) {
          seen.add(decl.props.columnName);
          ordered.push(decl.props.columnName);
        }
      } else {
        if (decl.props.visible === false) continue;
        if (!decl.props.dependsOn) continue;
        for (const dep of decl.props.dependsOn) {
          if (!seen.has(dep)) {
            seen.add(dep);
            ordered.push(dep);
          }
        }
      }
    }
    return ordered.join(",");
  }, [hasDeclaredColumns, orderedDeclarations]);
  const columnsOverride = useMemo(
    () => {
      if (columnsKey) return columnsKey.split(",");
      if (transformedView && transformedView.columns.length > 0) {
        return transformedView.columns.map((c) => c.columnName);
      }
      return void 0;
    },
    [columnsKey, transformedView]
  );
  const warnedFetchXmlComboRef = useRef(null);
  useEffect(() => {
    if (!columnsKey || !useInlineFetchXml) return;
    if (warnedFetchXmlComboRef.current === columnsKey) return;
    warnedFetchXmlComboRef.current = columnsKey;
    console.info(
      `[MainGrid] Declared <GridColumn> children override the column projection of the supplied fetchXml (columns: ${columnsKey.split(",").join(", ")}). Drop the children \u2014 or remove the conflicting <attribute> elements from the fetchXml \u2014 to silence this message.`
    );
  }, [columnsKey, useInlineFetchXml]);
  const searchRequest = useMemo(() => {
    const trimmed = debouncedSearchText.trim();
    return {
      ...useInlineFetchXml && inlineFetchXml ? { fetchXml: inlineFetchXml } : resolvedViewId !== void 0 && { viewId: resolvedViewId },
      ...trimmed && { searchText: trimmed },
      // Translate displayed column names to their `sortBy` override (when
      // a declared `<GridColumn sortBy="…">` is present) so the server's
      // ORDER BY targets the physical column. Sort UI state stays keyed
      // on the displayed name so header arrows render against the
      // clicked column.
      ...sort.length > 0 && {
        sorts: sort.map((s) => {
          const declared = declaredColumnsByName.get(s.columnName);
          return declared?.sortBy ? { ...s, columnName: declared.sortBy } : s;
        })
      },
      ...filters && filters.length > 0 && {
        filters
      },
      ...columnsOverride && { columns: [...columnsOverride] },
      pageNumber: page,
      pageSize
    };
  }, [
    resolvedViewId,
    useInlineFetchXml,
    inlineFetchXml,
    debouncedSearchText,
    sort,
    page,
    pageSize,
    filtersKey,
    columnsKey
  ]);
  const transformPending = !!transformViewAsync || isCustomActiveView;
  const recordsResult = useGridData(searchRequest, {
    // When a shared dataSource is set, IT owns the network fetch
    // the grid's local `useGridData` stays idle so we don't issue
    // redundant round-trips. The grid reads rows / columns / paging
    // from `dataSource` instead (see the effective-value resolutions
    // below the hook).
    enabled: !dataSource && (transformPending ? !!inlineFetchXml : !!resolvedViewId),
    // Hold the prior page / sort / search result on screen while the next
    // request is in flight, so the user sees a translucent scrim over the
    // existing rows instead of the grid collapsing to a "Loading…"
    // placeholder between every interaction. The first load still goes
    // through the "loading" state because there's nothing to keep.
    keepPreviousData: true
  });
  const rawResolvedColumns = dataSource ? dataSource.columns.length > 0 ? dataSource.columns : EMPTY_RESOLVED_COLUMNS : recordsResult.data?.columns ?? EMPTY_RESOLVED_COLUMNS;
  const resolvedColumns = useMemo(() => {
    if (rawResolvedColumns.length === 0) return rawResolvedColumns;
    const widthByName = /* @__PURE__ */ new Map();
    if (transformedView) {
      for (const c of transformedView.columns) {
        if (c.width !== void 0 && c.width !== null) widthByName.set(c.columnName, c.width);
      }
    }
    const noOverrides = widthByName.size === 0;
    const noScale = columnWidthScale === 1;
    if (noOverrides && noScale) return rawResolvedColumns;
    return rawResolvedColumns.map((col) => {
      const override = widthByName.get(col.columnName);
      const baseWidth = override !== void 0 ? override : col.width;
      const nextWidth = typeof baseWidth === "number" ? Math.round(baseWidth * columnWidthScale) : baseWidth;
      if (nextWidth === col.width) return col;
      return { ...col, width: nextWidth };
    });
  }, [rawResolvedColumns, transformedView, columnWidthScale]);
  const resolvedColumnsByName = useMemo(() => {
    const map = /* @__PURE__ */ new Map();
    for (const col of resolvedColumns) map.set(col.columnName, col);
    return map;
  }, [resolvedColumns]);
  const { searchableStringColumns, searchableNumberColumns } = useMemo(() => {
    const stringCols = [];
    const numberCols = [];
    for (const col of resolvedColumns) {
      const category = getRendererTypeForCode(col.type);
      if (category === "string" || category === "lookup" || category === "choice" || category === "multiSelectChoice") {
        stringCols.push(col);
      } else if (category === "number" || category === "money") {
        numberCols.push(col);
      }
    }
    const byDisplayName = (a, b) => a.displayName.localeCompare(b.displayName);
    stringCols.sort(byDisplayName);
    numberCols.sort(byDisplayName);
    return { searchableStringColumns: stringCols, searchableNumberColumns: numberCols };
  }, [resolvedColumns]);
  const hasSearchableColumns = searchableStringColumns.length > 0 || searchableNumberColumns.length > 0;
  const openHandlerRef = useRef(null);
  const createReopenHandlerRef = useRef(null);
  const [hasOpenHandler, setHasOpenHandler] = useState(false);
  const [hasCreateReopenHandler, setHasCreateReopenHandler] = useState(false);
  const registerOpenHandler = useCallback(
    (handler) => {
      openHandlerRef.current = handler;
      setHasOpenHandler(true);
      return () => {
        if (openHandlerRef.current === handler) {
          openHandlerRef.current = null;
          setHasOpenHandler(false);
        }
      };
    },
    []
  );
  const registerCreateReopenHandler = useCallback(
    (handler) => {
      createReopenHandlerRef.current = handler;
      setHasCreateReopenHandler(true);
      return () => {
        if (createReopenHandlerRef.current === handler) {
          createReopenHandlerRef.current = null;
          setHasCreateReopenHandler(false);
        }
      };
    },
    []
  );
  const dispatchOpen = useCallback((record) => {
    const id = record.id;
    const isPendingCreate = !!id && id.startsWith("__pending-create-");
    if (isPendingCreate) {
      const idx = Number.parseInt(id.slice("__pending-create-".length), 10);
      const reopen = createReopenHandlerRef.current;
      if (reopen && Number.isFinite(idx)) {
        reopen(record, idx);
        return;
      }
      openHandlerRef.current?.(record);
      return;
    }
    openHandlerRef.current?.(record);
  }, []);
  const hasRowOpenAffordance = hasOpenHandler || hasCreateReopenHandler;
  const effectiveResolvedColumns = useMemo(() => {
    if (!hasDeclaredColumns) return resolvedColumns;
    const out = [];
    for (const declared of declaredColumns) {
      if (declared.visible === false) continue;
      const base = resolvedColumnsByName.get(declared.columnName);
      if (!base) {
        console.warn(
          `[MainGrid] <GridColumn columnName="${declared.columnName}"> declared but the server didn't return metadata for it. The column name likely doesn't exist on the table \u2014 check spelling and the table's column metadata.`
        );
        continue;
      }
      const overridden = {
        ...base,
        ...declared.displayName !== void 0 && { displayName: declared.displayName },
        ...declared.width !== void 0 && { width: declared.width },
        ...declared.sortable !== void 0 && { isSortable: declared.sortable },
        ...declared.tooltip !== void 0 && {
          tooltip: declared.tooltip === "" ? null : declared.tooltip
        }
      };
      out.push(overridden);
    }
    return out;
  }, [hasDeclaredColumns, declaredColumns, resolvedColumns, resolvedColumnsByName]);
  const effectiveColumnsByName = useMemo(() => {
    const map = /* @__PURE__ */ new Map();
    for (const col of effectiveResolvedColumns) map.set(col.columnName, col);
    return map;
  }, [effectiveResolvedColumns]);
  const columns = useMemo(() => {
    const buildRegularColumnDef = (resolvedColumn) => {
      const declared = declaredColumnsByName.get(resolvedColumn.columnName);
      const columnName = resolvedColumn.columnName;
      const typeCode = resolvedColumn.type;
      const Renderer = declared?.cellRenderer ?? cellRenderers?.[columnName] ?? typeRenderers?.[getRendererTypeForCode(typeCode)] ?? getCellRendererByType(typeCode);
      const width = typeof resolvedColumn.width === "number" ? resolvedColumn.width : void 0;
      const isPrimaryNameLinkTarget = resolvedColumn.isPrimaryName && allowNavigateOnPrimaryNameClick;
      const hasEditorForType = getEditComponentForType(typeCode) !== null;
      return columnHelper.accessor(
        (row) => row.properties?.[columnName],
        {
          id: columnName,
          header: () => resolvedColumn.displayName,
          cell: (cellCtx) => {
            const rowRecord = cellCtx.row.original;
            const rowId = rowRecord.id;
            const isPendingCreateRow = !!rowId && rowId.startsWith("__pending-create-");
            if (editable && !isPendingCreateRow && hasEditorForType) {
              return (
                // Sizing wrapper — overrides Fluent v9's default
                // <Input> / <Combobox> / <Dropdown> min-width
                // (~200px) so the editor fits the column's actual
                // width instead of bleeding into the neighbour cell.
                // See `styles.inlineEditCell` for the cascade rules.
                /* @__PURE__ */ jsx("div", { className: styles.inlineEditCell, children: /* @__PURE__ */ jsx(
                  ColumnEdit,
                  {
                    columnName,
                    displayLabelWhenAvailable: false,
                    descriptionLocation: DescriptionLocation.None
                  }
                ) })
              );
            }
            const content = /* @__PURE__ */ jsx(
              Renderer,
              {
                value: cellCtx.getValue(),
                columnName,
                record: rowRecord,
                metadata: gridTableMetadata?.columns.find((c) => c.columnName === columnName),
                ...parentRecord && { parentRecord },
                searchText: searchText || null
              }
            );
            const rowHasOpenAffordance = isPendingCreateRow ? hasCreateReopenHandler : hasOpenHandler;
            if (!isPrimaryNameLinkTarget || !rowHasOpenAffordance) return content;
            return /* @__PURE__ */ jsx(
              "a",
              {
                href: "#",
                className: styles.primaryNameLink,
                onClick: (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  dispatchOpen(cellCtx.row.original);
                },
                children: content
              }
            );
          },
          // Floor for user resize — keep columns from collapsing to a
          // point where neither the header label nor the resize handle
          // is hittable. 40px ≈ checkbox-column + handle width and
          // matches Fluent DataGrid's own minimum.
          minSize: 40,
          ...width !== void 0 && { size: width },
          // Per-column alignment override declared on `<GridColumn>`.
          // Body cell + header cell read this off `columnDef.meta` to
          // apply `textAlign` / `justifyContent`. No type-driven default
          // for now — alignment is purely opt-in via declaration.
          ...declared?.align && { meta: { align: declared.align } }
        }
      );
    };
    const buildTemplateColumnDef = (props) => {
      const width = typeof props.width === "number" ? props.width : typeof props.width === "string" ? parsePixelWidth(props.width) : void 0;
      return columnHelper.display({
        id: props.id,
        header: () => props.displayName,
        cell: (cellCtx) => {
          const rowRecord = cellCtx.row.original;
          const dependsOnMetadata = {};
          if (props.dependsOn) {
            for (const dep of props.dependsOn) {
              dependsOnMetadata[dep] = gridTableMetadata?.columns.find(
                (c) => c.columnName === dep
              );
            }
          }
          const rendererProps = {
            id: props.id,
            record: rowRecord,
            ...parentRecord && { parentRecord },
            searchText: searchText || null,
            dependsOnMetadata
          };
          const rowId = rowRecord.id;
          const isPendingCreateRow = !!rowId && rowId.startsWith("__pending-create-");
          if (editable && !isPendingCreateRow && props.editRenderer) {
            return /* @__PURE__ */ jsx(
              TemplateColumnEditCell,
              {
                rendererProps,
                editRenderer: props.editRenderer,
                inlineEditCellClass: styles.inlineEditCell
              }
            );
          }
          return props.cellRenderer(rendererProps);
        },
        minSize: 40,
        ...width !== void 0 && { size: width },
        ...props.align && { meta: { align: props.align } }
      });
    };
    if (!hasDeclaredColumns) {
      return effectiveResolvedColumns.map(buildRegularColumnDef);
    }
    const defs = [];
    for (const decl of orderedDeclarations) {
      if (decl.kind === "column") {
        if (decl.props.visible === false) continue;
        const resolved = effectiveColumnsByName.get(decl.props.columnName);
        if (!resolved) continue;
        defs.push(buildRegularColumnDef(resolved));
      } else {
        if (decl.props.visible === false) continue;
        defs.push(
          buildTemplateColumnDef(decl.props)
        );
      }
    }
    return defs;
  }, [
    effectiveResolvedColumns,
    effectiveColumnsByName,
    declaredColumnsByName,
    hasDeclaredColumns,
    orderedDeclarations,
    cellRenderers,
    typeRenderers,
    searchText,
    hasRowOpenAffordance,
    hasOpenHandler,
    hasCreateReopenHandler,
    dispatchOpen,
    allowNavigateOnPrimaryNameClick,
    styles,
    editable,
    parentRecord,
    gridTableMetadata
  ]);
  const pageRecords = dataSource ? dataSource.rows : recordsResult.data?.tableRecords ?? EMPTY_RECORDS;
  const [accumulatedRows, setAccumulatedRows] = useState(null);
  const accumulatorResetKey = useMemo(
    () => [
      resolvedViewId ?? "",
      useInlineFetchXml ? inlineFetchXml ?? "" : "",
      debouncedSearchText,
      sort.map((s) => `${s.columnName}:${s.descending ? "d" : "a"}`).join("|"),
      filtersKey,
      pageSize,
      tableName ?? ""
    ].join("|"),
    [resolvedViewId, useInlineFetchXml, inlineFetchXml, debouncedSearchText, sort, filtersKey, pageSize, tableName]
  );
  const resetVirtualizedView = useCallback(() => {
    setAccumulatedRows([]);
    setPage(1);
    tableContainerRef.current?.scrollTo({ top: 0 });
  }, []);
  useEffect(() => {
    if (isVirtualize) {
      resetVirtualizedView();
    } else {
      setAccumulatedRows(null);
    }
  }, [isVirtualize, accumulatorResetKey]);
  useEffect(() => {
    if (!isVirtualize) return;
    if (recordsResult.status !== QueryStatus.Success) return;
    if (pageRecords.length === 0) return;
    setAccumulatedRows((prev) => {
      const base = prev ?? [];
      const seen = /* @__PURE__ */ new Set();
      for (const r of base) if (r.id) seen.add(r.id);
      const additions = pageRecords.filter((r) => r.id && !seen.has(r.id));
      if (additions.length === 0) return base;
      return [...base, ...additions];
    });
  }, [isVirtualize, recordsResult.status, pageRecords]);
  const data = isVirtualize ? accumulatedRows ?? EMPTY_RECORDS : pageRecords;
  const [pendingRowUpdates, setPendingRowUpdates] = useState(() => /* @__PURE__ */ new Map());
  const [pendingRowCreates, setPendingRowCreates] = useState(() => []);
  const [pendingRowAssociates, setPendingRowAssociates] = useState(() => []);
  const [pendingRowDisassociates, setPendingRowDisassociates] = useState(() => []);
  const [pendingRowDeletes, setPendingRowDeletes] = useState(() => []);
  const displayedData = useMemo(() => {
    const overlaid = pendingRowUpdates.size === 0 ? [...data] : data.map((row) => {
      const rowId = row.id;
      if (!rowId) return row;
      const pending = pendingRowUpdates.get(rowId);
      if (!pending) return row;
      const properties = {
        ...row.properties ?? {}
      };
      for (const [col, val] of pending.dirty) {
        if (val === null) {
          delete properties[col];
        } else {
          properties[col] = val;
        }
      }
      return { ...row, properties };
    });
    if (pendingRowCreates.length === 0 && pendingRowAssociates.length === 0) {
      return overlaid;
    }
    const pendingCreateRows = pendingRowCreates.map((create, idx) => ({
      ...create.record,
      id: `__pending-create-${idx}`
    }));
    return [...pendingCreateRows, ...pendingRowAssociates, ...overlaid];
  }, [pendingRowCreates, pendingRowAssociates, pendingRowUpdates, data]);
  const pendingCreateIds = useMemo(() => {
    const set = /* @__PURE__ */ new Set();
    for (let i = 0; i < pendingRowCreates.length; i++) {
      set.add(`__pending-create-${i}`);
    }
    return set;
  }, [pendingRowCreates]);
  const pendingAssociateIds = useMemo(() => {
    const set = /* @__PURE__ */ new Set();
    for (const r of pendingRowAssociates) {
      if (r.id) set.add(r.id);
    }
    return set;
  }, [pendingRowAssociates]);
  const pendingDisassociateIds = useMemo(() => {
    const set = /* @__PURE__ */ new Set();
    for (const r of pendingRowDisassociates) {
      if (r.id) set.add(r.id);
    }
    return set;
  }, [pendingRowDisassociates]);
  const pendingDeleteIds = useMemo(() => {
    const set = /* @__PURE__ */ new Set();
    for (const r of pendingRowDeletes) {
      if (r.id) set.add(r.id);
    }
    return set;
  }, [pendingRowDeletes]);
  const table = useReactTable({
    data: displayedData,
    columns,
    getCoreRowModel: getCoreRowModel(),
    // TanStack's row id defaults to the row index, which means
    // `rowSelection` keys would collide across pages. Key on the
    // record's primary id instead so the selection map is stable.
    getRowId: (row, index) => row.id ?? String(index),
    enableRowSelection: selectionMode !== "none",
    enableMultiRowSelection: selectionMode === "multiple",
    // Column resizing: drag the right edge of any header to resize.
    // `onChange` mode updates `columnSizing` on every mousemove so cells
    // track the drag live; cheap at our page size (25 rows × few
    // columns). `'onEnd'` would defer until release but requires a
    // floating-indicator div to give the user feedback during drag.
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    state: { rowSelection, columnSizing },
    onRowSelectionChange: (updater) => {
      const next = typeof updater === "function" ? updater(rowSelection) : updater;
      if (isSelectionControlled) {
        if (!onSelectedRecordsChangeRef.current) return;
        const records = displayedData.filter((r) => r.id && next[r.id]);
        onSelectedRecordsChangeRef.current(records);
      } else {
        setInternalRowSelection(next);
      }
    },
    onColumnSizingChange: setColumnSizing
  });
  const selectedRecords = useMemo(() => {
    if (selectionMode === "none") return EMPTY_RECORDS;
    return table.getSelectedRowModel().rows.map((r) => r.original);
  }, [rowSelection, selectionMode, data]);
  useEffect(() => {
    if (!onSelectedRecordsChange) return;
    if (isSelectionControlled) return;
    onSelectedRecordsChange(selectedRecords);
  }, [selectedRecords, onSelectedRecordsChange, isSelectionControlled]);
  const isResolvingView = !!tableName && !viewId && viewsResult.status === QueryStatus.Loading;
  const isLoading = dataSource ? dataSource.status === QueryStatus.Loading : isResolvingView || recordsResult.status === QueryStatus.Loading;
  const isRefetching = dataSource ? !isLoading && dataSource.isFetching : !isLoading && recordsResult.isFetching;
  const error = dataSource ? dataSource.error : viewsResult.error ?? recordsResult.error;
  const onRefreshRef = useRef(onRefresh);
  onRefreshRef.current = onRefresh;
  const refresh = useCallback(async () => {
    if (dataSource) {
      if (pagingMode === PagingMode.Virtualize) {
        resetVirtualizedView();
      }
      await dataSource.refresh();
      onRefreshRef.current?.();
      return;
    }
    if (pagingMode === PagingMode.Virtualize) {
      const wasOnFirstPage = page === 1;
      resetVirtualizedView();
      if (wasOnFirstPage) {
        await recordsResult.refetch();
      }
      onRefreshRef.current?.();
      return;
    }
    await recordsResult.refetch();
    onRefreshRef.current?.();
  }, [dataSource, pagingMode, page, recordsResult.refetch, resetVirtualizedView]);
  const pendingRowUpdatesRef = useRef(pendingRowUpdates);
  pendingRowUpdatesRef.current = pendingRowUpdates;
  const pendingRowCreatesRef = useRef(pendingRowCreates);
  pendingRowCreatesRef.current = pendingRowCreates;
  const pendingRowAssociatesRef = useRef(pendingRowAssociates);
  pendingRowAssociatesRef.current = pendingRowAssociates;
  const pendingRowDeletesRef = useRef(pendingRowDeletes);
  pendingRowDeletesRef.current = pendingRowDeletes;
  const pendingRowDisassociatesRef = useRef(pendingRowDisassociates);
  pendingRowDisassociatesRef.current = pendingRowDisassociates;
  const isManyToManySubGridRef = useRef(isManyToManySubGrid);
  isManyToManySubGridRef.current = isManyToManySubGrid;
  const queueRowUpdate = useCallback((update) => {
    setPendingRowUpdates((prev) => {
      const next = new Map(prev);
      if (update.dirty.size === 0) {
        next.delete(update.recordId);
      } else {
        next.set(update.recordId, update);
      }
      return next;
    });
  }, []);
  const queueRowCreate = useCallback((create) => {
    setPendingRowCreates((prev) => [...prev, create]);
  }, []);
  const updatePendingRowCreate = useCallback(
    (index, create) => {
      setPendingRowCreates((prev) => {
        if (index < 0 || index >= prev.length) return prev;
        const next = prev.slice();
        next[index] = create;
        return next;
      });
    },
    []
  );
  const clearPendingRowUpdates = useCallback(() => {
    setPendingRowUpdates(/* @__PURE__ */ new Map());
    setPendingRowCreates([]);
    setPendingRowAssociates([]);
    setPendingRowDisassociates([]);
    setPendingRowDeletes([]);
  }, []);
  const queueRowAssociates = useCallback(
    (records) => {
      if (records.length === 0) return;
      const toAdd = records;
      setPendingRowDisassociates(
        (prev) => prev.filter(
          (r) => !toAdd.some((a) => a.tableName === r.tableName && a.id === r.id)
        )
      );
      setPendingRowAssociates((prev) => {
        const seen = new Set(prev.map((r) => `${r.tableName}:${r.id}`));
        const next = prev.slice();
        for (const r of toAdd) {
          const key = `${r.tableName}:${r.id}`;
          if (!seen.has(key)) {
            seen.add(key);
            next.push(r);
          }
        }
        return next.length === prev.length ? prev : next;
      });
    },
    []
  );
  const queueRowDisassociates = useCallback(
    (records) => {
      if (records.length === 0) return;
      const createSyntheticIdsToDrop = /* @__PURE__ */ new Set();
      const realIds = [];
      for (const r of records) {
        if (!r.id) continue;
        if (r.id.startsWith("__pending-create-")) {
          createSyntheticIdsToDrop.add(r.id);
        } else {
          realIds.push(r);
        }
      }
      if (createSyntheticIdsToDrop.size > 0) {
        setPendingRowCreates((prev) => {
          const next = prev.filter(
            (_, idx) => !createSyntheticIdsToDrop.has(`__pending-create-${idx}`)
          );
          return next.length === prev.length ? prev : next;
        });
      }
      const currentAssociates = pendingRowAssociatesRef.current;
      const associatesToDrop = [];
      const realDisassociates = [];
      for (const r of realIds) {
        const inAssociates = currentAssociates.some(
          (a) => a.tableName === r.tableName && a.id === r.id
        );
        if (inAssociates) {
          associatesToDrop.push(r);
        } else {
          realDisassociates.push(r);
        }
      }
      if (associatesToDrop.length > 0) {
        setPendingRowAssociates(
          (prev) => prev.filter(
            (r) => !associatesToDrop.some(
              (a) => a.tableName === r.tableName && a.id === r.id
            )
          )
        );
      }
      if (realDisassociates.length > 0) {
        setPendingRowDisassociates((prev) => {
          const seen = new Set(prev.map((r) => `${r.tableName}:${r.id}`));
          const next = prev.slice();
          for (const r of realDisassociates) {
            const key = `${r.tableName}:${r.id}`;
            if (!seen.has(key)) {
              seen.add(key);
              next.push(r);
            }
          }
          return next.length === prev.length ? prev : next;
        });
      }
    },
    []
  );
  const queueRowDeletes = useCallback(
    (records) => {
      if (records.length === 0) return;
      const syntheticIdsToDrop = /* @__PURE__ */ new Set();
      const realIds = [];
      for (const r of records) {
        if (!r.id) continue;
        if (r.id.startsWith("__pending-create-")) {
          syntheticIdsToDrop.add(r.id);
        } else {
          realIds.push(r);
        }
      }
      if (syntheticIdsToDrop.size > 0) {
        setPendingRowCreates((prev) => {
          const next = prev.filter(
            (_, idx) => !syntheticIdsToDrop.has(`__pending-create-${idx}`)
          );
          return next.length === prev.length ? prev : next;
        });
      }
      if (realIds.length > 0) {
        setPendingRowDeletes((prev) => {
          const seen = /* @__PURE__ */ new Set();
          for (const r of prev) seen.add(`${r.tableName}:${r.id}`);
          const next = [...prev];
          for (const r of realIds) {
            const key = `${r.tableName}:${r.id}`;
            if (!seen.has(key)) {
              seen.add(key);
              next.push(r);
            }
          }
          return next.length === prev.length ? prev : next;
        });
      }
    },
    []
  );
  const clearSelection = useCallback(async () => {
    requestEmptySelection();
  }, [requestEmptySelection]);
  const validate = useCallback(() => true, []);
  const buildPendingRowChangeRequests = useCallback(() => {
    const updates = pendingRowUpdatesRef.current;
    const creates = pendingRowCreatesRef.current;
    const associates = pendingRowAssociatesRef.current;
    const disassociates = pendingRowDisassociatesRef.current;
    const deletes = pendingRowDeletesRef.current;
    if (updates.size === 0 && creates.length === 0 && associates.length === 0 && disassociates.length === 0 && deletes.length === 0) {
      return [];
    }
    const requests = [];
    for (const update of updates.values()) {
      const properties = {};
      for (const [col, val] of update.dirty) {
        properties[col] = val;
      }
      requests.push({
        $type: "UpdateRequest",
        record: {
          id: update.recordId,
          tableName: update.tableName,
          properties
        }
      });
    }
    for (const create of creates) {
      requests.push({
        $type: "CreateRequest",
        record: create.record
      });
    }
    const parentRefId = parentRecord ? getRecordReferenceId(parentRecord) : void 0;
    if (parentRecord?.tableName && parentRefId && relationshipName) {
      const parentRef = {
        tableName: parentRecord.tableName,
        id: parentRefId
      };
      if (isManyToManySubGridRef.current && creates.length > 0) {
        const createRefs = [];
        for (const c of creates) {
          if (!c.record.tableName) continue;
          const createRefId = getRecordReferenceId(c.record);
          if (!createRefId) continue;
          createRefs.push({ tableName: c.record.tableName, id: createRefId });
        }
        if (createRefs.length > 0) {
          requests.push({
            $type: "AssociateRequest",
            record: parentRef,
            relationshipName,
            relatedRecords: createRefs
          });
        }
      }
      if (associates.length > 0) {
        const relatedRecords = [];
        for (const a of associates) {
          if (!a.tableName || !a.id) continue;
          relatedRecords.push({ tableName: a.tableName, id: a.id });
        }
        if (relatedRecords.length > 0) {
          requests.push({
            $type: "AssociateRequest",
            record: parentRef,
            relationshipName,
            relatedRecords
          });
        }
      }
      if (disassociates.length > 0) {
        requests.push({
          $type: "DisassociateRequest",
          record: parentRef,
          relationshipName,
          relatedRecords: disassociates
        });
      }
    }
    for (const ref of deletes) {
      if (!ref.tableName || !ref.id) continue;
      requests.push({
        $type: "DeleteRequest",
        record: { tableName: ref.tableName, id: ref.id }
      });
    }
    return requests;
  }, [parentRecord, relationshipName]);
  const gridIsDirty = pendingRowUpdates.size > 0 || pendingRowCreates.length > 0 || pendingRowAssociates.length > 0 || pendingRowDisassociates.length > 0 || pendingRowDeletes.length > 0;
  const gridIsDirtyRef = useRef(gridIsDirty);
  gridIsDirtyRef.current = gridIsDirty;
  useEffect(() => {
    if (!parentMainContext) return;
    return parentMainContext.registerDescendant({
      getRequests: () => buildPendingRowChangeRequests(),
      validate,
      refresh: async () => {
        clearPendingRowUpdates();
        await refresh();
      },
      // Cancel/Discard: drop the queued row updates / creates / associates
      // / disassociates without touching the server. Doesn't clear the
      // visible selection — that's a separate primitive (clearSelection).
      resetState: clearPendingRowUpdates,
      isDirty: () => gridIsDirtyRef.current
    });
  }, [parentMainContext?.registerDescendant, refresh, buildPendingRowChangeRequests, clearPendingRowUpdates, validate]);
  const parentMainContextRef = useRef(parentMainContext);
  parentMainContextRef.current = parentMainContext;
  useEffect(() => {
    parentMainContextRef.current?.notifyDescendantDirtyChanged();
  }, [gridIsDirty]);
  const tablePermissions = dataSource ? dataSource.tablePermissions : recordsResult.data?.tablePermissions;
  const gridContextValue = useMemo(
    () => ({
      selectedRecords,
      tableName,
      viewId: resolvedViewId,
      columns: resolvedColumns,
      refresh,
      isDirty: gridIsDirty,
      registerOpenHandler,
      registerCreateReopenHandler,
      dispatchOpen,
      hasRowOpenAffordance,
      tablePermissions,
      pendingRowUpdates,
      pendingRowCreates,
      pendingRowAssociates,
      pendingRowDisassociates,
      parentRecord,
      relationshipName,
      queueRowUpdate,
      queueRowCreate,
      updatePendingRowCreate,
      queueRowAssociates,
      queueRowDisassociates,
      pendingRowDeletes,
      queueRowDeletes,
      clearPendingRowUpdates,
      clearSelection,
      validate,
      loadedRecords: data,
      allowPreviewForFileColumns,
      allowDownloadForFileColumns
    }),
    [
      selectedRecords,
      tableName,
      resolvedViewId,
      resolvedColumns,
      refresh,
      gridIsDirty,
      registerOpenHandler,
      registerCreateReopenHandler,
      dispatchOpen,
      hasRowOpenAffordance,
      tablePermissions,
      pendingRowUpdates,
      pendingRowCreates,
      pendingRowAssociates,
      pendingRowDisassociates,
      pendingRowDeletes,
      parentRecord,
      relationshipName,
      queueRowUpdate,
      queueRowCreate,
      updatePendingRowCreate,
      queueRowAssociates,
      queueRowDisassociates,
      queueRowDeletes,
      clearPendingRowUpdates,
      clearSelection,
      validate,
      data,
      allowPreviewForFileColumns,
      allowDownloadForFileColumns
    ]
  );
  const totalCount = (() => {
    const raw = dataSource ? dataSource.totalCount : recordsResult.data?.pagingInfo?.totalRecordCount;
    if (raw == null) return void 0;
    return typeof raw === "number" ? raw : Number(raw);
  })();
  const hasMoreRowsToLoad = isVirtualize && (totalCount === void 0 || (accumulatedRows?.length ?? 0) < totalCount);
  useEffect(() => {
    if (!isVirtualize) return;
    const sentinel = loadMoreSentinelRef.current;
    const root = tableContainerRef.current;
    if (!sentinel || !root) return;
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry?.isIntersecting) return;
        if (recordsResult.isFetching) return;
        if (!hasMoreRowsToLoad) return;
        setPage(page + 1);
      },
      {
        root,
        // Pre-fetch a half-page before the user actually hits bottom so
        // the scroll doesn't visibly stall while the next page loads.
        rootMargin: "200px 0px 200px 0px",
        threshold: 0
      }
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [isVirtualize, hasMoreRowsToLoad, recordsResult.isFetching, page, setPage]);
  const handlePageChange = (nextPage) => {
    if (nextPage === page) return;
    setPage(nextPage);
    requestEmptySelection();
    writeStateToUrl({ page: nextPage });
  };
  const selectedView = views?.find((v) => v.id === resolvedViewId);
  const selectedViewLabelKey = selectedView ? `tables.${selectedView.tableName}.views.${selectedView.id}.label` : "";
  const selectedViewLabel = selectedView ? t(selectedViewLabelKey) : "";
  const singleViewTitle = selectedView && selectedViewLabel !== selectedViewLabelKey ? selectedViewLabel : selectedView?.displayName ?? void 0;
  return /* @__PURE__ */ jsx(GridContextProvider, { value: gridContextValue, children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: mergeClasses(
        "ppp-main-grid",
        styles.wrapper,
        fullSize && styles.wrapperFullSize,
        !borderVisible && styles.wrapperBorderless,
        className
      ),
      style: {
        ...!fullSize && {
          minHeight: typeof minHeight === "number" ? `${minHeight}px` : minHeight
        },
        ...!fullSize && maxHeight !== void 0 && {
          maxHeight: typeof maxHeight === "number" ? `${maxHeight}px` : maxHeight
        },
        ...style
      },
      children: [
        /* @__PURE__ */ jsxs("div", { className: styles.toolbar, children: [
          showViewPicker && /* @__PURE__ */ jsx(
            Dropdown,
            {
              className: styles.viewPicker,
              "aria-label": t("app.components.view-selector.view-name"),
              value: selectedViewLabel,
              selectedOptions: resolvedViewId ? [resolvedViewId] : [],
              onOptionSelect: (_, data2) => {
                if (data2.optionValue) handleViewChange(data2.optionValue);
              },
              children: views?.map((view) => {
                const label = t(`tables.${view.tableName}.views.${view.id}.label`);
                return /* @__PURE__ */ jsx(Option, { value: view.id, text: label, children: label }, view.id);
              })
            }
          ),
          !showViewPicker && title && /* @__PURE__ */ jsx(Text, { className: styles.title, children: title }),
          !showViewPicker && !title && singleViewTitle && /* @__PURE__ */ jsx(Text, { className: styles.title, children: singleViewTitle }),
          /* @__PURE__ */ jsx(Overflow, { padding: 20, children: /* @__PURE__ */ jsxs("div", { className: styles.toolbarOverflow, children: [
            toolbarChildren !== null && /* @__PURE__ */ jsx(OverflowItem, { id: GridToolbarOverflowId.Actions, children: /* @__PURE__ */ jsx("div", { className: styles.toolbarSlot, children: toolbarChildren }) }),
            allowSearch && // Wrapping the SearchBox (and its optional Tooltip) in a plain
            // `<div>` instead of making it the OverflowItem's direct
            // child sidesteps a measurement / data-attribute drift: with
            // OverflowItem's `applyTriggerPropsToChildren` recursively
            // unwrapping FluentTrigger components (Tooltip is one), the
            // `data-overflowing` attribute could land on the SearchBox's
            // root while the visible wrapper kept the slot space. A
            // plain div is not a FluentTrigger, so OverflowItem registers
            // its ref directly on the div, measures the div's
            // offsetWidth, and toggles `data-overflowing` on the div
            // which Fluent's `[overflowingItems] [data-overflowing]
            // { display: none }` then collapses to zero width.
            /* @__PURE__ */ jsx(OverflowItem, { id: GridToolbarOverflowId.Search, children: /* @__PURE__ */ jsx("div", { className: styles.searchBoxWrapper, children: hasSearchableColumns ? /* @__PURE__ */ jsx(
              Tooltip,
              {
                relationship: "description",
                withArrow: true,
                positioning: "below-end",
                content: /* @__PURE__ */ jsxs("div", { className: styles.searchTooltipBody, children: [
                  searchableStringColumns.length > 0 && /* @__PURE__ */ jsxs("div", { className: styles.searchTooltipSection, children: [
                    /* @__PURE__ */ jsx("span", { children: t("app.components.grid.search-string-columns-intro") }),
                    /* @__PURE__ */ jsx("div", { className: styles.searchTooltipColumnList, children: searchableStringColumns.map((col) => /* @__PURE__ */ jsx("span", { children: col.displayName }, col.columnName)) })
                  ] }),
                  searchableNumberColumns.length > 0 && /* @__PURE__ */ jsxs("div", { className: styles.searchTooltipSection, children: [
                    /* @__PURE__ */ jsx("span", { children: t("app.components.grid.search-number-columns-intro") }),
                    /* @__PURE__ */ jsx("div", { className: styles.searchTooltipColumnList, children: searchableNumberColumns.map((col) => /* @__PURE__ */ jsx("span", { children: col.displayName }, col.columnName)) })
                  ] })
                ] }),
                children: /* @__PURE__ */ jsx(
                  SearchBox,
                  {
                    className: styles.searchBox,
                    placeholder: t("app.components.grid.search-placeholder"),
                    value: searchText,
                    onChange: (_, data2) => setSearchText(data2.value)
                  }
                )
              }
            ) : (
              // Active view has no searchable columns — render the
              // SearchBox without the tooltip so the input still
              // appears (consistent toolbar geometry) but doesn't
              // advertise hits it can't deliver.
              /* @__PURE__ */ jsx(
                SearchBox,
                {
                  className: styles.searchBox,
                  placeholder: t("app.components.grid.search-placeholder"),
                  value: searchText,
                  onChange: (_, data2) => setSearchText(data2.value)
                }
              )
            ) }) }),
            pendingRowCreates.length > 0 && /* @__PURE__ */ jsxs(
              "div",
              {
                className: styles.pendingIndicator,
                title: `${pendingRowCreates.length} pending create${pendingRowCreates.length === 1 ? "" : "s"}`,
                "aria-label": `${pendingRowCreates.length} pending create${pendingRowCreates.length === 1 ? "" : "s"}`,
                children: [
                  /* @__PURE__ */ jsx(Add16Regular, { className: styles.pendingIconCreate }),
                  /* @__PURE__ */ jsx(
                    CounterBadge,
                    {
                      count: pendingRowCreates.length,
                      size: "small",
                      color: "informative",
                      appearance: "filled"
                    }
                  )
                ]
              }
            ),
            pendingRowUpdates.size > 0 && /* @__PURE__ */ jsxs(
              "div",
              {
                className: styles.pendingIndicator,
                title: `${pendingRowUpdates.size} pending edit${pendingRowUpdates.size === 1 ? "" : "s"}`,
                "aria-label": `${pendingRowUpdates.size} pending edit${pendingRowUpdates.size === 1 ? "" : "s"}`,
                children: [
                  /* @__PURE__ */ jsx(Edit16Regular, { className: styles.pendingIconUpdate }),
                  /* @__PURE__ */ jsx(
                    CounterBadge,
                    {
                      count: pendingRowUpdates.size,
                      size: "small",
                      color: "brand",
                      appearance: "filled"
                    }
                  )
                ]
              }
            ),
            pendingRowAssociates.length > 0 && /* @__PURE__ */ jsxs(
              "div",
              {
                className: styles.pendingIndicator,
                title: `${pendingRowAssociates.length} pending link${pendingRowAssociates.length === 1 ? "" : "s"}`,
                "aria-label": `${pendingRowAssociates.length} pending link${pendingRowAssociates.length === 1 ? "" : "s"}`,
                children: [
                  /* @__PURE__ */ jsx(LinkAdd16Regular, { className: styles.pendingIconCreate }),
                  /* @__PURE__ */ jsx(
                    CounterBadge,
                    {
                      count: pendingRowAssociates.length,
                      size: "small",
                      color: "informative",
                      appearance: "filled"
                    }
                  )
                ]
              }
            ),
            pendingRowDisassociates.length > 0 && /* @__PURE__ */ jsxs(
              "div",
              {
                className: styles.pendingIndicator,
                title: `${pendingRowDisassociates.length} pending unlink${pendingRowDisassociates.length === 1 ? "" : "s"}`,
                "aria-label": `${pendingRowDisassociates.length} pending unlink${pendingRowDisassociates.length === 1 ? "" : "s"}`,
                children: [
                  /* @__PURE__ */ jsx(LinkDismiss16Regular, { className: styles.pendingIconUpdate }),
                  /* @__PURE__ */ jsx(
                    CounterBadge,
                    {
                      count: pendingRowDisassociates.length,
                      size: "small",
                      color: "brand",
                      appearance: "filled"
                    }
                  )
                ]
              }
            ),
            pendingRowDeletes.length > 0 && /* @__PURE__ */ jsxs(
              "div",
              {
                className: styles.pendingIndicator,
                title: `${pendingRowDeletes.length} pending delete${pendingRowDeletes.length === 1 ? "" : "s"}`,
                "aria-label": `${pendingRowDeletes.length} pending delete${pendingRowDeletes.length === 1 ? "" : "s"}`,
                children: [
                  /* @__PURE__ */ jsx(Delete16Regular, { className: styles.pendingIconUpdate }),
                  /* @__PURE__ */ jsx(
                    CounterBadge,
                    {
                      count: pendingRowDeletes.length,
                      size: "small",
                      color: "danger",
                      appearance: "filled"
                    }
                  )
                ]
              }
            ),
            showRefreshButton && (() => {
              const handleRefreshClick = async () => {
                const subtreeDirty = parentMainContext?.isDirty ?? false;
                if (gridIsDirty || subtreeDirty) {
                  const proceed = await warnAboutUnsavedChanges();
                  if (!proceed) return;
                  clearPendingRowUpdates();
                }
                setRefreshing(true);
                try {
                  await refresh();
                } finally {
                  setRefreshing(false);
                }
              };
              return /* @__PURE__ */ jsx(OverflowItem, { id: GridToolbarOverflowId.Refresh, children: /* @__PURE__ */ jsx("div", { className: styles.toolbarItemWrapper, children: /* @__PURE__ */ jsx(
                Button,
                {
                  appearance: "subtle",
                  icon: /* @__PURE__ */ jsx(ArrowClockwise24Regular, {}),
                  "aria-label": t("app.buttons.refresh.label"),
                  title: t("app.buttons.refresh.label"),
                  disabled: refreshing,
                  onClick: handleRefreshClick
                }
              ) }) });
            })(),
            (showSettingsEditableRow || showSettingsPageSizeRow) && /* @__PURE__ */ jsx(OverflowItem, { id: GridToolbarOverflowId.Settings, children: /* @__PURE__ */ jsx("div", { className: styles.toolbarItemWrapper, children: /* @__PURE__ */ jsxs(Popover, { positioning: "below-end", withArrow: true, children: [
              /* @__PURE__ */ jsx(PopoverTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(
                Button,
                {
                  appearance: "subtle",
                  icon: /* @__PURE__ */ jsx(Settings20Regular, {}),
                  "aria-label": t("app.buttons.settings.label"),
                  title: t("app.buttons.settings.label")
                }
              ) }),
              /* @__PURE__ */ jsxs(PopoverSurface, { children: [
                /* @__PURE__ */ jsx("div", { className: styles.settingsHeader, children: t("app.buttons.settings.label") }),
                showSettingsPageSizeRow && /* @__PURE__ */ jsxs("div", { className: styles.settingsRow, children: [
                  /* @__PURE__ */ jsx("span", { className: styles.settingsRowLabel, children: t("app.components.grid.page-size") }),
                  /* @__PURE__ */ jsx(
                    Dropdown,
                    {
                      className: styles.settingsPageSizeDropdown,
                      "aria-label": t("app.components.grid.page-size"),
                      value: String(pageSize),
                      selectedOptions: [String(pageSize)],
                      onOptionSelect: (_, data2) => {
                        if (data2.optionValue) {
                          const next = Number(data2.optionValue);
                          if (Number.isFinite(next) && next > 0) handlePageSizeChange(next);
                        }
                      },
                      children: pageSizes.map((size) => /* @__PURE__ */ jsx(Option, { value: String(size), text: String(size), children: String(size) }, size))
                    }
                  )
                ] }),
                showSettingsEditableRow && (inlineEditDisabled ? /* @__PURE__ */ jsx(
                  Tooltip,
                  {
                    relationship: "description",
                    withArrow: true,
                    content: t("app.components.grid.editable-disabled-tooltip"),
                    children: /* @__PURE__ */ jsx(
                      Switch,
                      {
                        label: t("app.components.grid.editable"),
                        checked: editable,
                        disabled: true
                      }
                    )
                  }
                ) : /* @__PURE__ */ jsx(
                  Switch,
                  {
                    label: t("app.components.grid.editable"),
                    checked: editable,
                    onChange: (_, data2) => handleEditableToggle(data2.checked)
                  }
                ))
              ] })
            ] }) }) }),
            /* @__PURE__ */ jsxs(GridToolbarOverflowMenu, { ariaLabel: t("app.components.grid.more-actions"), children: [
              toolbarChildren !== null && /* @__PURE__ */ jsx(OverflowMenuItem, { itemId: GridToolbarOverflowId.Actions, children: /* @__PURE__ */ jsx("div", { className: styles.menuActionRow, children: toolbarChildren }) }),
              allowSearch && /* @__PURE__ */ jsx(OverflowMenuItem, { itemId: GridToolbarOverflowId.Search, children: /* @__PURE__ */ jsx("div", { className: styles.menuActionRow, children: /* @__PURE__ */ jsx(
                SearchBox,
                {
                  className: styles.menuSearchBox,
                  placeholder: t("app.components.grid.search-placeholder"),
                  value: searchText,
                  onChange: (_, data2) => setSearchText(data2.value),
                  contentBefore: /* @__PURE__ */ jsx(Search20Regular, {})
                }
              ) }) }),
              showRefreshButton && /* @__PURE__ */ jsx(OverflowMenuItem, { itemId: GridToolbarOverflowId.Refresh, children: /* @__PURE__ */ jsx(
                MenuItem,
                {
                  icon: /* @__PURE__ */ jsx(ArrowClockwise20Regular, {}),
                  disabled: refreshing,
                  onClick: async () => {
                    const subtreeDirty = parentMainContext?.isDirty ?? false;
                    if (gridIsDirty || subtreeDirty) {
                      const proceed = await warnAboutUnsavedChanges();
                      if (!proceed) return;
                      clearPendingRowUpdates();
                    }
                    setRefreshing(true);
                    try {
                      await refresh();
                    } finally {
                      setRefreshing(false);
                    }
                  },
                  children: t("app.buttons.refresh.label")
                }
              ) }),
              (showSettingsEditableRow || showSettingsPageSizeRow) && /* @__PURE__ */ jsxs(OverflowMenuItem, { itemId: GridToolbarOverflowId.Settings, children: [
                showSettingsPageSizeRow && /* @__PURE__ */ jsxs("div", { className: styles.menuActionRow, children: [
                  /* @__PURE__ */ jsx("span", { className: styles.settingsRowLabel, children: t("app.components.grid.page-size") }),
                  /* @__PURE__ */ jsx(
                    Dropdown,
                    {
                      "aria-label": t("app.components.grid.page-size"),
                      value: String(pageSize),
                      selectedOptions: [String(pageSize)],
                      onOptionSelect: (_, data2) => {
                        if (data2.optionValue) {
                          const next = Number(data2.optionValue);
                          if (Number.isFinite(next) && next > 0) handlePageSizeChange(next);
                        }
                      },
                      children: pageSizes.map((size) => /* @__PURE__ */ jsx(Option, { value: String(size), text: String(size), children: String(size) }, size))
                    }
                  )
                ] }),
                showSettingsEditableRow && /* @__PURE__ */ jsx("div", { className: styles.menuActionRow, children: inlineEditDisabled ? /* @__PURE__ */ jsx(
                  Tooltip,
                  {
                    relationship: "description",
                    withArrow: true,
                    content: t("app.components.grid.editable-disabled-tooltip"),
                    children: /* @__PURE__ */ jsx(
                      Switch,
                      {
                        label: t("app.components.grid.editable"),
                        checked: editable,
                        disabled: true
                      }
                    )
                  }
                ) : /* @__PURE__ */ jsx(
                  Switch,
                  {
                    label: t("app.components.grid.editable"),
                    checked: editable,
                    onChange: (_, data2) => handleEditableToggle(data2.checked)
                  }
                ) })
              ] })
            ] })
          ] }) })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: styles.bodyArea, children: [
          isLoading ? /* @__PURE__ */ jsx("div", { className: styles.statusFill, role: "status", "aria-live": "polite", children: /* @__PURE__ */ jsx(Spinner, { label: t("app.components.grid.loading") }) }) : error ? /* @__PURE__ */ jsx(
            "div",
            {
              className: mergeClasses(styles.statusFill, styles.statusFillError),
              role: "alert",
              children: error.message || t("app.components.grid.load-records-error")
            }
          ) : /* @__PURE__ */ jsxs("div", { className: styles.tableContainer, ref: tableContainerRef, children: [
            /* @__PURE__ */ jsxs(
              "table",
              {
                className: styles.table,
                style: {
                  width: `${table.getTotalSize() + (selectionMode !== "none" ? 50 : 0) + (gridIsDirty ? 50 : 0)}px`
                },
                children: [
                  (selectionMode !== "none" || gridIsDirty) && /* @__PURE__ */ jsxs("colgroup", { children: [
                    selectionMode !== "none" && /* @__PURE__ */ jsx("col", { style: { width: "50px" } }),
                    gridIsDirty && /* @__PURE__ */ jsx("col", { style: { width: "50px" } })
                  ] }),
                  /* @__PURE__ */ jsx("thead", { children: table.getHeaderGroups().map((headerGroup) => /* @__PURE__ */ jsxs("tr", { className: styles.headerRow, children: [
                    selectionMode !== "none" && /* @__PURE__ */ jsx("th", { className: mergeClasses(styles.headerCell, styles.selectCell), children: selectionMode === "multiple" && /* @__PURE__ */ jsx(
                      Checkbox,
                      {
                        "aria-label": t("app.components.grid.select-all-rows"),
                        checked: table.getIsAllRowsSelected() ? true : table.getIsSomeRowsSelected() ? "mixed" : false,
                        onChange: (_, data2) => table.toggleAllRowsSelected(!!data2.checked)
                      }
                    ) }),
                    gridIsDirty && /* @__PURE__ */ jsx(
                      "th",
                      {
                        className: mergeClasses(styles.headerCell, styles.pendingCell),
                        "aria-label": t("app.components.grid.pending-operation")
                      }
                    ),
                    headerGroup.headers.map((header) => {
                      const columnName = header.column.id;
                      const userSize = columnSizing[columnName];
                      const declaredCol = declaredColumnsByName.get(columnName);
                      const templateCol = templateColumnsById.get(columnName);
                      const declaredWidth = declaredCol?.width ?? templateCol?.width;
                      const viewWidth = resolvedColumnsByName.get(columnName)?.width;
                      const widthValue = typeof userSize === "number" ? `${userSize}px` : declaredWidth !== void 0 ? typeof declaredWidth === "number" ? `${declaredWidth}px` : declaredWidth : typeof viewWidth === "number" ? `${viewWidth}px` : void 0;
                      const declaredAlign = header.column.columnDef.meta?.align;
                      const headerStyle = {
                        ...widthValue !== void 0 && { width: widthValue },
                        ...declaredAlign && {
                          textAlign: declaredAlign === "end" ? "right" : declaredAlign === "center" ? "center" : "left"
                        }
                      };
                      const effectiveCol = effectiveColumnsByName.get(columnName);
                      const sortable = effectiveCol?.isSortable ?? false;
                      const headerTooltip = effectiveCol?.tooltip ?? void 0;
                      const sortIndex = sort.findIndex((d) => d.columnName === columnName);
                      const sortDirective = sortIndex >= 0 ? sort[sortIndex] : void 0;
                      const SortIcon = sortDirective ? sortDirective.descending ? ArrowSortDown16Regular : ArrowSortUp16Regular : null;
                      const showSortPosition = sortDirective && sort.length > 1;
                      return /* @__PURE__ */ jsxs(
                        "th",
                        {
                          className: mergeClasses(
                            styles.headerCell,
                            sortable && styles.headerCellSortable
                          ),
                          style: headerStyle,
                          "aria-sort": sortDirective ? sortDirective.descending ? "descending" : "ascending" : sortable ? "none" : void 0,
                          title: headerTooltip ?? (sortable ? t("app.components.grid.sort-hint") : void 0),
                          onClick: sortable ? (e) => {
                            if (resizingRef.current) return;
                            handleSortToggle(columnName, e.shiftKey);
                          } : void 0,
                          children: [
                            /* @__PURE__ */ jsxs("span", { className: styles.headerCellInner, children: [
                              /* @__PURE__ */ jsx("span", { className: styles.headerCellLabel, children: (() => {
                                const headerRenderer = header.column.columnDef.header;
                                return typeof headerRenderer === "function" ? headerRenderer(header.getContext()) : headerRenderer;
                              })() }),
                              SortIcon && /* @__PURE__ */ jsx(SortIcon, { className: styles.sortIcon, "aria-hidden": "true" }),
                              showSortPosition && /* @__PURE__ */ jsx("span", { className: styles.sortPosition, "aria-hidden": "true", children: sortIndex + 1 })
                            ] }),
                            /* @__PURE__ */ jsx(
                              "div",
                              {
                                role: "separator",
                                "aria-orientation": "vertical",
                                "aria-label": t("app.components.grid.resize-column"),
                                className: mergeClasses(
                                  styles.resizeHandle,
                                  header.column.getIsResizing() && styles.resizeHandleActive
                                ),
                                onMouseDown: (e) => {
                                  e.stopPropagation();
                                  resizingRef.current = true;
                                  setTimeout(() => {
                                    resizingRef.current = false;
                                  }, 0);
                                  header.getResizeHandler()(e);
                                },
                                onTouchStart: (e) => {
                                  e.stopPropagation();
                                  resizingRef.current = true;
                                  setTimeout(() => {
                                    resizingRef.current = false;
                                  }, 0);
                                  header.getResizeHandler()(e);
                                },
                                onClick: (e) => e.stopPropagation()
                              }
                            )
                          ]
                        },
                        header.id
                      );
                    })
                  ] }, headerGroup.id)) }),
                  /* @__PURE__ */ jsx("tbody", { children: !isLoading && !error && table.getRowModel().rows.map((row) => {
                    const isSelected = row.getIsSelected();
                    const rowId = row.original.id;
                    const isPendingCreate = rowId !== void 0 && pendingCreateIds.has(rowId);
                    const isPendingAssociate = rowId !== void 0 && !isPendingCreate && pendingAssociateIds.has(rowId);
                    const isPendingDisassociate = rowId !== void 0 && !isPendingCreate && !isPendingAssociate && pendingDisassociateIds.has(rowId);
                    const isPendingDelete = rowId !== void 0 && !isPendingCreate && !isPendingAssociate && !isPendingDisassociate && pendingDeleteIds.has(rowId);
                    const isPendingUpdate = rowId !== void 0 && !isPendingCreate && !isPendingAssociate && !isPendingDisassociate && !isPendingDelete && pendingRowUpdates.has(rowId);
                    const isHighlightMuted = (() => {
                      if (!dataSource || !dataSource.highlight) return false;
                      const { column, value } = dataSource.highlight;
                      const property = row.original.properties?.[column];
                      if (!property) return true;
                      return readColumnRawValue(property) !== value;
                    })();
                    const rowDoubleClickAffordance = isPendingCreate ? hasCreateReopenHandler : hasOpenHandler;
                    const handleRowDoubleClick = allowOpenOnRowDoubleClick && rowDoubleClickAffordance ? () => dispatchOpen(row.original) : void 0;
                    const handleRowClick = selectFromEntireRow && selectionMode !== "none" ? (ev) => {
                      const target = ev.target;
                      if (target?.closest(
                        'a, button, input, select, textarea, [role="button"], [role="link"]'
                      )) {
                        return;
                      }
                      row.toggleSelected(!isSelected);
                    } : void 0;
                    const isRowInlineEditable = editable && !isPendingCreate && !isPendingAssociate && !!row.original.id && !!row.original.tableName;
                    const rowBody = /* @__PURE__ */ jsxs(Fragment, { children: [
                      selectionMode !== "none" && /* @__PURE__ */ jsx(
                        "td",
                        {
                          className: mergeClasses(styles.bodyCell, styles.selectCell),
                          onClick: (e) => e.stopPropagation(),
                          children: selectionMode === "single" ? /* @__PURE__ */ jsx(
                            Radio,
                            {
                              "aria-label": t("app.components.grid.select-row"),
                              name: radioGroupName,
                              value: row.id,
                              checked: isSelected,
                              onChange: () => row.toggleSelected(true),
                              tabIndex: editable ? -1 : void 0
                            }
                          ) : /* @__PURE__ */ jsx(
                            Checkbox,
                            {
                              "aria-label": t("app.components.grid.select-row"),
                              checked: isSelected,
                              onChange: (_, data2) => row.toggleSelected(!!data2.checked),
                              tabIndex: editable ? -1 : void 0
                            }
                          )
                        }
                      ),
                      gridIsDirty && /* @__PURE__ */ jsx("td", { className: mergeClasses(styles.bodyCell, styles.pendingCell), children: isPendingCreate ? /* @__PURE__ */ jsx(
                        Add16Regular,
                        {
                          className: styles.pendingIconCreate,
                          "aria-label": t("app.components.grid.pending-operation-create")
                        }
                      ) : isPendingAssociate ? /* @__PURE__ */ jsx(
                        LinkAdd16Regular,
                        {
                          className: styles.pendingIconCreate,
                          "aria-label": t("app.components.grid.pending-operation-link")
                        }
                      ) : isPendingDisassociate ? /* @__PURE__ */ jsx(
                        LinkDismiss16Regular,
                        {
                          className: styles.pendingIconUpdate,
                          "aria-label": t("app.components.grid.pending-operation-unlink")
                        }
                      ) : isPendingDelete ? /* @__PURE__ */ jsx(
                        Delete16Regular,
                        {
                          className: styles.pendingIconUpdate,
                          "aria-label": t("app.components.grid.pending-operation-delete")
                        }
                      ) : isPendingUpdate ? /* @__PURE__ */ jsx(
                        Edit16Regular,
                        {
                          className: styles.pendingIconUpdate,
                          "aria-label": t("app.components.grid.pending-operation-update")
                        }
                      ) : null }),
                      row.getVisibleCells().map((cell) => {
                        const cellAlign = cell.column.columnDef.meta?.align;
                        const cellStyle = cellAlign ? {
                          textAlign: cellAlign === "end" ? "right" : cellAlign === "center" ? "center" : "left"
                        } : void 0;
                        const cellRenderer = cell.column.columnDef.cell;
                        const cellContent = typeof cellRenderer === "function" ? cellRenderer(cell.getContext()) : cellRenderer;
                        return /* @__PURE__ */ jsx(
                          "td",
                          {
                            className: styles.bodyCell,
                            ...cellStyle && { style: cellStyle },
                            children: cellContent
                          },
                          cell.id
                        );
                      })
                    ] });
                    return /* @__PURE__ */ jsx(
                      "tr",
                      {
                        className: mergeClasses(
                          styles.bodyRow,
                          isSelected && styles.bodyRowSelected,
                          handleRowClick !== void 0 && styles.bodyRowClickable,
                          isHighlightMuted && styles.bodyRowMuted
                        ),
                        ...handleRowDoubleClick !== void 0 && {
                          onDoubleClick: handleRowDoubleClick
                        },
                        ...handleRowClick !== void 0 && {
                          onClick: handleRowClick
                        },
                        children: isRowInlineEditable && row.original.id ? /* @__PURE__ */ jsx(
                          RecordContext,
                          {
                            table: row.original.tableName,
                            id: row.original.id,
                            loadedRecord: row.original,
                            children: rowBody
                          }
                        ) : rowBody
                      },
                      row.id
                    );
                  }) })
                ]
              }
            ),
            displayedData.length === 0 && /* @__PURE__ */ jsx("div", { className: styles.emptyStateRow, children: t("app.components.grid.empty-content") }),
            isVirtualize && hasMoreRowsToLoad && // No spinner here: the full-body `refetchScrim` overlay below is the
            // single load indicator. Rendering a `size="tiny"` spinner in the
            // sentinel as well meant a deps-change refetch (refresh / sort /
            // search / view switch) — which resets the accumulator to empty and
            // floats this sentinel to the top of the now-empty body — showed two
            // spinners at once: this small one near the top plus the large
            // centered scrim. The sentinel div stays (the IntersectionObserver
            // still observes it to drive infinite-scroll paging); only its
            // spinner is gone.
            /* @__PURE__ */ jsx("div", { ref: loadMoreSentinelRef, className: styles.loadMoreSentinel })
          ] }),
          (isRefetching || isEditableTransitionPending) && /* @__PURE__ */ jsx("div", { className: styles.refetchScrim, role: "status", "aria-live": "polite", children: /* @__PURE__ */ jsx(Spinner, { size: "large" }) })
        ] }),
        !hidePaging && !isVirtualize && !isLoading && !error && (data.length > 0 || page > 1) && /* @__PURE__ */ jsx(
          MainGridPaging,
          {
            page,
            pageSize,
            totalCount,
            dataLength: data.length,
            onPageChange: handlePageChange,
            onPageSizeChange: handlePageSizeChange,
            pageSizes,
            showPageSize: allowChangingPageSize && !isNarrowViewport
          }
        ),
        !hidePaging && isVirtualize && !isLoading && !error && data.length > 0 && /* @__PURE__ */ jsx(MainGridVirtualizeFooter, { loadedCount: data.length, totalCount })
      ]
    }
  ) });
}
var VIEW_TYPE_PUBLIC = 0;
var useLookupFormStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalS,
    width: "100%",
    // Fill the dialog's scrollable body so the grid can stretch to the dialog
    // height. minHeight:0 lets this flex item shrink below its content height so
    // the grid's own scroll region — not this container — absorbs row overflow.
    flex: "1 1 auto",
    minHeight: 0
  },
  // Picker row — label + dropdown laid out horizontally.
  // `<FluentStack Orientation="Horizontal">` around the table-type select.
  pickerRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    flexWrap: "wrap"
  },
  pickerLabel: {
    color: tokens.colorNeutralForeground2
  },
  pickerDropdown: {
    minWidth: "200px"
  }
});
function LookupForm({
  tableNames,
  defaultTable,
  viewIds,
  selectionMode = "single",
  onSelectedRecordsChange,
  selectedRecords,
  pageSize = 10,
  filters,
  className,
  style,
  gridClassName,
  gridStyle
}) {
  const styles = useLookupFormStyles();
  const t = useT();
  if (tableNames.length === 0) {
    throw new Error("LookupForm: `tableNames` must contain at least one table.");
  }
  const initialTable = useMemo(() => {
    if (defaultTable && tableNames.includes(defaultTable)) return defaultTable;
    return tableNames[0];
  }, [defaultTable, tableNames]);
  const [selectedTable, setSelectedTable] = useState(initialTable);
  const viewsResult = useViewsForTable(selectedTable);
  const viewsStatus = viewsResult.status;
  const viewsData = viewsResult.data;
  const allowedViews = useMemo(() => {
    if (viewsStatus !== QueryStatus.Success || !viewsData) return [];
    const publicViews = viewsData.filter((v) => v.type === VIEW_TYPE_PUBLIC);
    const allow = viewIds?.[selectedTable];
    if (!allow || allow.length === 0) return publicViews;
    const allowSet = new Set(allow);
    return publicViews.filter((v) => allowSet.has(v.id));
  }, [viewsStatus, viewsData, viewIds, selectedTable]);
  const allowedViewIds = useMemo(() => allowedViews.map((v) => v.id), [allowedViews]);
  const defaultViewId = useMemo(
    () => (allowedViews.find((v) => v.isDefault) ?? allowedViews[0])?.id,
    [allowedViews]
  );
  const handleTableChange = (next) => {
    if (next === selectedTable) return;
    setSelectedTable(next);
    onSelectedRecordsChange?.([]);
  };
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-lookup-form", styles.root, className), style, children: [
    tableNames.length > 1 && /* @__PURE__ */ jsxs("div", { className: styles.pickerRow, children: [
      /* @__PURE__ */ jsx(Label, { className: styles.pickerLabel, htmlFor: "ppp-lookup-form-table", children: t("app.components.lookup-form.table-type") }),
      /* @__PURE__ */ jsx(
        Dropdown,
        {
          id: "ppp-lookup-form-table",
          className: styles.pickerDropdown,
          value: tableLabel(t, selectedTable),
          selectedOptions: [selectedTable],
          onOptionSelect: (_, data) => {
            if (data.optionValue) handleTableChange(data.optionValue);
          },
          children: tableNames.map((name) => {
            const label = tableLabel(t, name);
            return /* @__PURE__ */ jsx(Option, { value: name, text: label, children: label }, name);
          })
        }
      )
    ] }),
    allowedViews.length > 0 && /* @__PURE__ */ jsx(
      MainGrid,
      {
        tableName: selectedTable,
        viewIds: allowedViewIds,
        ...defaultViewId ? { defaultViewId } : {},
        selectionMode,
        selectFromEntireRow: true,
        fullSize: true,
        pageSize,
        ...filters !== void 0 && filters.length > 0 ? { filters } : {},
        ...onSelectedRecordsChange ? { onSelectedRecordsChange } : {},
        ...selectedRecords !== void 0 ? { selectedRecords } : {},
        ...gridClassName !== void 0 ? { className: gridClassName } : {},
        ...gridStyle !== void 0 ? { style: gridStyle } : {}
      },
      selectedTable
    )
  ] });
}
function tableLabel(t, tableName) {
  const key = `tables.${tableName}.label`;
  const resolved = t(key);
  return resolved === key ? tableName : resolved;
}
var useLookupDialogStyles = makeStyles({
  // Override Fluent's default dialog width — lookup dialogs need most of
  // the viewport so the embedded grid has room.
  // `style="--dialog-width: 95% !important"`. The flex column + explicit
  // height-constraints chain (surface → scrollableBody) is the load-
  // bearing piece for keeping the footer pinned at the bottom and the
  // body scrollable when the grid is taller than the surface allows.
  surface: {
    maxWidth: "95vw",
    width: "95vw",
    display: "flex",
    flexDirection: "column"
  },
  // Title row — DialogTitle keeps Fluent's heading typography (it
  // renders an `<h2>` with the right aria semantics), and the close
  // button sits on the right via flex. Wrapping in a row is necessary
  // because DialogTitle's intrinsic `action` slot only positions
  // correctly inside a `<DialogBody>` grid — without that wrapper, the
  // action element renders inline after the title text. Owning the row
  // ourselves keeps the X reliably in the top-right.
  titleRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    columnGap: tokens.spacingHorizontalS,
    flex: "0 0 auto"
  },
  titleText: {
    flex: "1 1 auto",
    minWidth: 0
  },
  titleClose: {
    flex: "0 0 auto"
  },
  // Scrollable body region — flex 1 so it expands to fill the space
  // between title and footer, `minHeight: 0` to let it shrink past its
  // content's intrinsic height (otherwise the grid pushes the surface
  // taller than the dialog's maxHeight and the footer scrolls off
  // screen). `overflow: auto` is what turns this into the actual scroll
  // container.
  scrollableBody: {
    flex: "1 1 auto",
    minHeight: 0,
    // Flex column so the LookupForm child (flex:1 1 auto) actually fills this
    // region. Without it this is a display:block scroll container, so the form —
    // and the fullSize grid inside it — collapse to content height and sit at the
    // top, leaving empty space below the grid when there are only a few rows.
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    overflowX: "hidden",
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS
  },
  // Footer region. `flex: 0 0 auto` keeps it pinned at the bottom of the
  // surface regardless of body size; the inner flex with
  // `justify-content: space-between` lays the selected-records readout
  // on the left and the action buttons on the right.
  footer: {
    flex: "0 0 auto",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    columnGap: tokens.spacingHorizontalM,
    paddingTop: tokens.spacingVerticalM,
    marginTop: tokens.spacingVerticalS,
    borderTop: `1px solid ${tokens.colorNeutralStroke2}`
  },
  selectedText: {
    color: tokens.colorNeutralForeground2,
    fontSize: tokens.fontSizeBase200,
    flex: "1 1 auto",
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    textAlign: "left"
  },
  footerButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    flex: "0 0 auto"
  }
});
function LookupDialog({
  hidden = true,
  onHiddenChange,
  title,
  actionLabel,
  onActionClicked,
  onSelectedRecordsChange,
  minHeight = "600px",
  maxHeight = "95vh",
  className,
  style,
  ...lookupFormProps
}) {
  const styles = useLookupDialogStyles();
  const t = useT();
  const [selected, setSelected] = useState([]);
  const handleSelectedRecordsChange = useCallback(
    (records) => {
      setSelected((prev) => {
        if (prev.length === records.length && prev.every((r, i) => r === records[i])) {
          return prev;
        }
        return records;
      });
      onSelectedRecordsChange?.(records);
    },
    [onSelectedRecordsChange]
  );
  const close = () => onHiddenChange?.(true);
  const handleActionClicked = () => {
    onActionClicked?.(selected);
    close();
  };
  const tableNameForSelection = selected[0]?.tableName;
  const tableMetaQuery = useTableMetadata(tableNameForSelection ?? "", {
    enabled: !!tableNameForSelection
  });
  const selectedSummary = useMemo(() => {
    if (selected.length === 0) {
      return t("app.messages.no-records-selected");
    }
    const primaryNameColumn = tableMetaQuery.data?.primaryNameColumn;
    if (!primaryNameColumn) return t("app.messages.no-records-selected");
    const emptyName = t("app.messages.empty-primary-name");
    const names = selected.map((record) => {
      const value = resolveColumnDisplayValue(record, primaryNameColumn);
      return value || emptyName;
    });
    return names.join(", ");
  }, [selected, tableMetaQuery.data, t]);
  const action = actionLabel ?? t("app.buttons.ok.label");
  const cancel = t("app.buttons.cancel.label");
  const selectedRecordsLabel = t("app.components.lookup-form.selected-records");
  return /* @__PURE__ */ jsx(
    Dialog,
    {
      open: !hidden,
      onOpenChange: (_, data) => {
        if (!data.open) close();
      },
      modalType: "modal",
      children: /* @__PURE__ */ jsxs(
        DialogSurface,
        {
          className: mergeClasses("ppp-lookup-dialog", styles.surface, className),
          style: { minHeight, maxHeight, ...style },
          children: [
            /* @__PURE__ */ jsxs("div", { className: styles.titleRow, children: [
              /* @__PURE__ */ jsx(DialogTitle, { className: styles.titleText, children: title }),
              /* @__PURE__ */ jsx(
                Button,
                {
                  className: styles.titleClose,
                  appearance: "subtle",
                  icon: /* @__PURE__ */ jsx(Dismiss24Regular, {}),
                  "aria-label": cancel,
                  onClick: close
                }
              )
            ] }),
            /* @__PURE__ */ jsx("div", { className: styles.scrollableBody, children: /* @__PURE__ */ jsx(
              LookupForm,
              {
                ...lookupFormProps,
                onSelectedRecordsChange: handleSelectedRecordsChange
              }
            ) }),
            /* @__PURE__ */ jsxs("div", { className: styles.footer, children: [
              /* @__PURE__ */ jsxs("div", { className: styles.selectedText, children: [
                selectedRecordsLabel,
                " ",
                selectedSummary
              ] }),
              /* @__PURE__ */ jsxs("div", { className: styles.footerButtons, children: [
                /* @__PURE__ */ jsx(
                  Button,
                  {
                    appearance: "primary",
                    icon: /* @__PURE__ */ jsx(LinkAdd20Regular, {}),
                    disabled: selected.length === 0,
                    onClick: handleActionClicked,
                    children: action
                  }
                ),
                /* @__PURE__ */ jsx(Button, { onClick: close, autoFocus: true, children: cancel })
              ] })
            ] })
          ]
        }
      )
    }
  );
}
var SEARCH_DEBOUNCE_MS2 = 300;
var NULL_CHOICE_VALUE = "__null__";
var LookupEditorType = {
  /**
   * Default. Debounced server-side typeahead via Fluent {@link Combobox}.
   * Use this whenever the target table has more records than would
   * comfortably fit in a flat list.
   */
  AutoComplete: "autoComplete",
  /**
   * Pre-fetched top-N records rendered as a Fluent {@link Dropdown}. No
   * typing — the consumer just picks from the visible list. Best for
   * small / bounded target tables (configuration lookups, status owners,
   * etc.). Cap controlled by {@link LookupEditProps.maxRecordsReturned}.
   */
  Dropdown: "dropdown",
  /**
   * Pre-fetched top-N records rendered as a Fluent {@link RadioGroup}. Same
   * data shape as `Dropdown`; a "(none)" radio can be added on the front via
   * {@link LookupEditProps.displayNullChoice}.
   */
  RadioButtons: "radioButtons"
};
var useLookupStyles = makeStyles({
  // Listbox sizing — min/max-height are dynamic (driven by the
  // `popupMinHeight` / `popupMaxHeight` props) and applied via inline
  // style on the slot, so only the always-on bits live here. Inline
  // style is used for size because Fluent's own Listbox class can carry
  // sizing rules with similar specificity to our Griffel class — inline
  // style beats both. The explicit `padding-top: 0` eliminates the gap
  // above the sticky polymorphic header where scrolling options would
  // otherwise briefly bleed through before disappearing behind the
  // header. (Fluent's Listbox applies a small top inset by default;
  // zeroing it lets the sticky header touch the listbox's top edge
  // exactly.)
  listbox: {
    overflowY: "auto",
    paddingTop: "0"
  },
  // Polymorphic target-table picker rendered inside the Combobox's listbox
  // (above the options). The inner
  // Dropdown uses `inlinePopup` so its option list renders as a DOM
  // descendant of the trigger rather than being portaled to body — that
  // keeps the inner popup INSIDE the outer Combobox's tree, so clicking an
  // inner option isn't treated as an "outside click" that would dismiss
  // the outer Combobox.
  // The wrapper's `onMouseDown` preventDefault is the second half of the
  // trick: mousedown on the inner Dropdown trigger (or its options) would
  // otherwise pull focus out of the outer Combobox's input and the outer
  // popup would blur-close before the click registered. preventDefault on
  // mousedown blocks the focus shift without blocking the subsequent click
  // event, so the inner Dropdown still opens and selects as usual.
  // `position: sticky; top: 0` pins the header at the top of the scrolling
  // listbox so it stays visible while the user scrolls through options.
  // The background fill is required because sticky elements still allow
  // content to scroll BEHIND them — without an opaque fill, options would
  // bleed through.
  targetPickerHeader: {
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    marginBottom: tokens.spacingVerticalXXS,
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS,
    position: "sticky",
    top: 0,
    backgroundColor: tokens.colorNeutralBackground1,
    zIndex: 1
  },
  targetPickerLabel: {
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase200,
    whiteSpace: "nowrap",
    flex: "0 0 auto"
  },
  targetPickerControl: {
    flex: "1 1 auto",
    minWidth: "0"
  },
  statusOption: {
    color: tokens.colorNeutralForeground3,
    fontStyle: "italic"
  },
  loadingOption: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS
  },
  // Multi-column option template — one row per result, view columns
  // stacked vertically. The first column is bold (the "primary" line);
  // subsequent columns are normal weight + dimmer.
  // option template (`FluentStack Orientation="Vertical"` with
  // bold-first-column styling).
  optionStack: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "2px",
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalXS
  },
  optionRowPrimary: {
    fontWeight: tokens.fontWeightSemibold
  },
  optionRowSecondary: {
    color: tokens.colorNeutralForeground2,
    fontSize: tokens.fontSizeBase200
  },
  optionNull: {
    color: tokens.colorNeutralForeground4,
    fontStyle: "italic"
  },
  // Sticky footer hosting the Advanced Search button. Mirrors the
  // sticky-top behavior of `targetPickerHeader` but pinned at the bottom
  // of the listbox so the button stays visible while scrolling through
  // results. Same `onMouseDown` preventDefault trick applies in the JSX
  // (block focus shift that would dismiss the outer Combobox before the
  // click registers).
  advancedSearchFooter: {
    display: "flex",
    justifyContent: "flex-end",
    padding: tokens.spacingHorizontalS,
    borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground1,
    position: "sticky",
    bottom: 0,
    zIndex: 1
  }
});
function LookupEdit({
  columnName,
  label,
  description,
  displayLabelWhenAvailable = true,
  descriptionLocation = DescriptionLocation.Tooltip,
  displayValidationErrorMessage = true,
  required,
  readOnly,
  disabled,
  isVisible = true,
  className,
  style,
  id,
  editorType = LookupEditorType.AutoComplete,
  maxRecordsReturned = 20,
  placeholder,
  defaultTable,
  displayNullChoice = true,
  radioButtonOrientation = ChoiceOrientation.Vertical,
  popupMaxHeight = "250px",
  popupMinHeight = "150px",
  defaultViewId,
  viewIds,
  validate
}) {
  const { value: lookupValue, setValue: rawSetLookupValue } = useLookupColumn(columnName);
  const { record } = useRecordContext();
  const metadata = useColumnMetadata(columnName);
  const styles = useLookupStyles();
  const { ppp, tableMetadataCache } = usePowerPortalsPro();
  const t = useT();
  const resolvedLabel = label ?? getDisplayLabel(metadata, columnName, record?.tableName, t);
  const resolvedDescription = description ?? getDisplayDescription(metadata, columnName, record?.tableName, t);
  const resolvedRequired = required ?? isMetadataRequired(metadata);
  const { readOnly: resolvedReadOnly, disabled: resolvedDisabled } = resolveEditState(
    metadata,
    record,
    readOnly,
    disabled
  );
  const setLookupValue = useGuardedSetValue(
    rawSetLookupValue,
    resolvedReadOnly,
    resolvedDisabled
  );
  const lookupMeta = getLookupMetadata(metadata);
  const targetTables = lookupMeta?.targetTables ?? [];
  const isPolymorphic = targetTables.length > 1;
  const [selectedTargetTable, setSelectedTargetTable] = useState(void 0);
  const effectiveTargetTable = selectedTargetTable ?? (defaultTable && targetTables.includes(defaultTable) ? defaultTable : void 0) ?? lookupValue?.tableName ?? targetTables[0];
  const targetMetaQuery = useTableMetadata(effectiveTargetTable ?? "", {
    enabled: Boolean(effectiveTargetTable)
  });
  const primaryIdColumn = targetMetaQuery.data?.primaryIdColumn;
  const primaryNameColumn = targetMetaQuery.data?.primaryNameColumn;
  const viewsQuery = useViewsForTable(effectiveTargetTable ?? "", {
    enabled: Boolean(effectiveTargetTable)
  });
  const lookupView = useMemo(() => {
    const views = viewsQuery.data;
    if (!views || views.length === 0) return void 0;
    if (defaultViewId) {
      return views.find((v) => v.id === defaultViewId);
    }
    return views.find((v) => {
      const t2 = v.type;
      return typeof t2 === "number" && (t2 & 64) === 64;
    });
  }, [viewsQuery.data, defaultViewId]);
  const viewColumnNames = useMemo(() => {
    if (lookupView?.columns && lookupView.columns.length > 0) {
      return lookupView.columns.map((c) => c.columnName);
    }
    return primaryNameColumn ? [primaryNameColumn] : [];
  }, [lookupView, primaryNameColumn]);
  const viewColumnMetadata = useMemo(() => {
    const m = /* @__PURE__ */ new Map();
    const cols = targetMetaQuery.data?.columns ?? [];
    for (const c of cols) m.set(c.columnName, c);
    return m;
  }, [targetMetaQuery.data]);
  const [query, setQuery] = useState(
    editorType === LookupEditorType.AutoComplete ? null : ""
  );
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [comboboxOpen, setComboboxOpen] = useState(false);
  useEffect(() => {
    if (editorType !== LookupEditorType.AutoComplete && query === null) {
      setQuery("");
    }
  }, [editorType, query]);
  const abortRef = useRef(null);
  useEffect(() => {
    if (query === null) return;
    if (!effectiveTargetTable || !primaryIdColumn || !primaryNameColumn) return;
    const timer = setTimeout(() => {
      abortRef.current?.abort();
      const controller = new AbortController();
      abortRef.current = controller;
      setLoading(true);
      setError(null);
      const searchRequest = lookupView ? {
        viewId: lookupView.id,
        searchText: query,
        sorts: [{ columnName: primaryNameColumn, descending: false }],
        pageNumber: 1,
        pageSize: maxRecordsReturned
      } : {
        fetchXml: buildMinimalFetchXml(
          effectiveTargetTable,
          primaryIdColumn,
          primaryNameColumn,
          viewColumnNames
        ),
        searchText: query,
        sorts: [{ columnName: primaryNameColumn, descending: false }],
        pageNumber: 1,
        pageSize: maxRecordsReturned
      };
      ppp.loadGridAsync(searchRequest, controller.signal).then((resp) => {
        if (controller.signal.aborted) return;
        const mapped = resp.tableRecords.map((r) => {
          const nameCol = r.properties?.[primaryNameColumn];
          return {
            id: r.id ?? "",
            name: nameCol?.value ?? "",
            tableName: r.tableName,
            record: r
          };
        });
        setResults(mapped);
      }).catch((e) => {
        if (controller.signal.aborted) return;
        setError(e instanceof Error ? e.message : "Search failed");
        setResults([]);
      }).finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });
    }, SEARCH_DEBOUNCE_MS2);
    return () => {
      clearTimeout(timer);
    };
  }, [
    query,
    effectiveTargetTable,
    primaryIdColumn,
    primaryNameColumn,
    maxRecordsReturned,
    ppp,
    viewColumnNames,
    lookupView
  ]);
  useEffect(() => () => abortRef.current?.abort(), []);
  const validationErrors = useColumnValidation(
    columnName,
    {
      kind: "string",
      required: resolvedRequired,
      label: resolvedLabel,
      value: lookupValue?.id ?? null
    },
    validate
  );
  if (!isVisible) return null;
  const showInfoIcon = descriptionLocation === DescriptionLocation.Tooltip && resolvedDescription !== void 0;
  const fieldHint = descriptionLocation === DescriptionLocation.BelowControl ? resolvedDescription ?? null : null;
  const labelSlot = displayLabelWhenAvailable ? {
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedLabel,
      showInfoIcon && /* @__PURE__ */ jsx(DescriptionIcon, { description: resolvedDescription, ariaLabel: resolvedLabel })
    ] })
  } : null;
  const fieldValidationProps = buildFieldValidationProps(
    validationErrors,
    displayValidationErrorMessage
  );
  const isInactive = resolvedDisabled || resolvedReadOnly;
  const onPickRecord = (pickedId) => {
    if (!pickedId) {
      setLookupValue(null);
      return;
    }
    const picked = results.find((r) => r.id === pickedId);
    if (picked) {
      setLookupValue({
        id: picked.id,
        name: picked.name,
        tableName: picked.tableName
      });
    }
  };
  const [dialogHidden, setDialogHidden] = useState(true);
  const dialogTitle = useMemo(
    () => t("app.messages.select-lookup-value", [resolvedLabel]),
    [t, resolvedLabel]
  );
  const onAdvancedSearchClicked = () => {
    setComboboxOpen(false);
    setDialogHidden(false);
  };
  const onDialogActionClicked = async (records) => {
    if (records.length !== 1) {
      setDialogHidden(true);
      return;
    }
    const record2 = records[0];
    if (!record2.id) {
      setDialogHidden(true);
      return;
    }
    let nameColumn = record2.tableName === effectiveTargetTable ? primaryNameColumn : void 0;
    if (!nameColumn) {
      try {
        const meta = await tableMetadataCache.getAsync(record2.tableName);
        nameColumn = meta?.primaryNameColumn;
      } catch {
      }
    }
    const name = nameColumn ? resolveColumnDisplayValue(record2, nameColumn) : null;
    setLookupValue({
      id: record2.id,
      name: name ?? "",
      tableName: record2.tableName
    });
    if (record2.tableName !== effectiveTargetTable && targetTables.includes(record2.tableName)) {
      setSelectedTargetTable(record2.tableName);
    }
    setDialogHidden(true);
  };
  const onTargetTableChange = (next) => {
    if (next === effectiveTargetTable) return;
    setSelectedTargetTable(next);
    setResults([]);
    setError(null);
    setQuery("");
    setComboboxOpen(true);
  };
  let control;
  if (editorType === LookupEditorType.RadioButtons) {
    control = renderRadioGroup({
      id,
      className,
      style,
      lookupValue,
      results,
      loading,
      error,
      displayNullChoice,
      radioButtonOrientation,
      isInactive,
      resolvedRequired,
      onPick: onPickRecord,
      t,
      styles
    });
  } else if (editorType === LookupEditorType.Dropdown) {
    control = renderDropdown({
      id,
      className,
      style,
      lookupValue,
      results,
      loading,
      error,
      isInactive,
      placeholder,
      popupMaxHeight,
      popupMinHeight,
      viewColumnNames,
      viewColumnMetadata,
      onPick: onPickRecord,
      styles,
      t
    });
  } else {
    control = renderAutoComplete({
      id,
      className,
      style,
      lookupValue,
      results,
      loading,
      error,
      isInactive,
      placeholder,
      popupMaxHeight,
      popupMinHeight,
      query,
      setQuery,
      open: comboboxOpen,
      setOpen: setComboboxOpen,
      onPick: onPickRecord,
      // Target picker is part of the AutoComplete row — pass everything it
      // needs to render and route changes back.
      isPolymorphic,
      targetTables,
      effectiveTargetTable,
      onTargetTableChange,
      // Multi-column option template inputs — view-loaded column list +
      // type-metadata map for display-value resolution.
      viewColumnNames,
      viewColumnMetadata,
      onAdvancedSearchClicked,
      t,
      styles
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Field,
      {
        className: mergeClasses("ppp-lookup-edit"),
        label: labelSlot,
        hint: fieldHint,
        required: resolvedRequired,
        ...fieldValidationProps,
        children: control
      }
    ),
    editorType === LookupEditorType.AutoComplete && targetTables.length > 0 && /* @__PURE__ */ jsx(
      LookupDialog,
      {
        hidden: dialogHidden,
        onHiddenChange: setDialogHidden,
        title: dialogTitle,
        tableNames: targetTables,
        ...effectiveTargetTable !== void 0 && { defaultTable: effectiveTargetTable },
        selectionMode: "single",
        ...viewIds !== void 0 && { viewIds },
        actionLabel: t("app.buttons.select.label"),
        onActionClicked: onDialogActionClicked
      }
    )
  ] });
}
function renderAutoComplete(input) {
  const {
    id,
    className,
    style,
    lookupValue,
    results,
    loading,
    error,
    isInactive,
    placeholder,
    popupMaxHeight,
    popupMinHeight,
    query,
    setQuery,
    open,
    setOpen,
    onPick,
    isPolymorphic,
    targetTables,
    effectiveTargetTable,
    onTargetTableChange,
    viewColumnNames,
    viewColumnMetadata,
    onAdvancedSearchClicked,
    t,
    styles
  } = input;
  const displayValue = query !== null ? query : lookupValue?.name ?? "";
  const selectedOptions = lookupValue?.id ? [lookupValue.id] : [];
  return /* @__PURE__ */ jsxs(
    Combobox,
    {
      id,
      className,
      style,
      clearable: true,
      ...placeholder !== void 0 && { placeholder },
      value: displayValue,
      selectedOptions,
      disabled: isInactive,
      open,
      expandIcon: /* @__PURE__ */ jsx(Search20Regular, {}),
      positioning: {
        position: "below",
        align: "start"
      },
      listbox: {
        className: styles.listbox,
        style: { maxHeight: popupMaxHeight, minHeight: popupMinHeight }
      },
      onChange: (e) => {
        setQuery(e.target.value);
      },
      onOpenChange: (_, data) => {
        setOpen(data.open);
        if (data.open && query === null) {
          if (lookupValue === void 0) {
            setQuery("");
          }
        } else if (!data.open) {
          setQuery(null);
        }
      },
      onOptionSelect: (_, data) => {
        if (data.optionValue && targetTables.includes(data.optionValue)) {
          return;
        }
        onPick(data.optionValue ?? null);
        setQuery(null);
      },
      children: [
        isPolymorphic && effectiveTargetTable && /* @__PURE__ */ jsxs(
          "div",
          {
            className: styles.targetPickerHeader,
            onMouseDown: (e) => e.preventDefault(),
            children: [
              /* @__PURE__ */ jsx("span", { className: styles.targetPickerLabel, children: tTargetPickerLabel(t) }),
              /* @__PURE__ */ jsx(
                Dropdown,
                {
                  size: "small",
                  inlinePopup: true,
                  className: styles.targetPickerControl,
                  selectedOptions: [effectiveTargetTable],
                  value: tableLabel2(t, effectiveTargetTable),
                  onOptionSelect: (event, data) => {
                    event.stopPropagation();
                    if (data.optionValue) onTargetTableChange(data.optionValue);
                  },
                  onOpenChange: (event) => {
                    event.stopPropagation();
                  },
                  children: targetTables.map((name) => /* @__PURE__ */ jsx(Option, { value: name, text: tableLabel2(t, name), children: tableLabel2(t, name) }, name))
                }
              )
            ]
          }
        ),
        renderListboxContents({
          loading,
          error,
          results,
          lookupValue,
          viewColumnNames,
          viewColumnMetadata,
          // Highlight what the user typed. `query` is null when the popup
          // just opened with no query — the highlighter treats null as "no
          // highlight" so the initial top-N list renders plain.
          searchText: query,
          styles,
          t
        }),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: styles.advancedSearchFooter,
            onMouseDown: (e) => e.preventDefault(),
            children: /* @__PURE__ */ jsx(
              Button,
              {
                size: "small",
                icon: /* @__PURE__ */ jsx(Search20Regular, {}),
                onClick: onAdvancedSearchClicked,
                children: t("app.buttons.advanced-search.label")
              }
            )
          }
        )
      ]
    }
  );
}
function renderDropdown(input) {
  const {
    id,
    className,
    style,
    lookupValue,
    results,
    loading,
    error,
    isInactive,
    placeholder,
    popupMaxHeight,
    popupMinHeight,
    viewColumnNames,
    viewColumnMetadata,
    onPick,
    styles,
    t
  } = input;
  const selectedOptions = lookupValue?.id ? [lookupValue.id] : [];
  return /* @__PURE__ */ jsx(
    Dropdown,
    {
      id,
      className,
      style,
      clearable: true,
      ...placeholder !== void 0 && { placeholder },
      value: lookupValue?.name ?? "",
      selectedOptions,
      disabled: isInactive,
      expandIcon: /* @__PURE__ */ jsx(Search20Regular, {}),
      positioning: {
        position: "below",
        align: "start"
      },
      listbox: {
        className: styles.listbox,
        style: { maxHeight: popupMaxHeight, minHeight: popupMinHeight }
      },
      onOptionSelect: (_, data) => {
        onPick(data.optionValue ?? null);
      },
      children: renderListboxContents({
        loading,
        error,
        results,
        lookupValue,
        viewColumnNames,
        viewColumnMetadata,
        // Dropdown mode has no typed query, so nothing to highlight.
        searchText: null,
        styles,
        t
      })
    }
  );
}
function renderRadioGroup(input) {
  const {
    id,
    className,
    style,
    lookupValue,
    results,
    loading,
    error,
    displayNullChoice,
    radioButtonOrientation,
    isInactive,
    resolvedRequired,
    onPick,
    t,
    styles
  } = input;
  const groupValue = lookupValue?.id ?? (displayNullChoice ? NULL_CHOICE_VALUE : "");
  return /* @__PURE__ */ jsxs("div", { className, style, children: [
    loading && /* @__PURE__ */ jsxs("div", { className: styles.loadingOption, children: [
      /* @__PURE__ */ jsx(Spinner, { size: "extra-tiny" }),
      /* @__PURE__ */ jsx("span", { className: styles.statusOption, children: t("app.components.lookup-edit.searching") })
    ] }),
    error && !loading && /* @__PURE__ */ jsx("div", { className: styles.statusOption, children: error }),
    /* @__PURE__ */ jsxs(
      RadioGroup,
      {
        id,
        value: groupValue,
        layout: radioButtonOrientation === ChoiceOrientation.Horizontal ? "horizontal" : "vertical",
        disabled: isInactive,
        required: resolvedRequired,
        onChange: (_, data) => {
          if (data.value === NULL_CHOICE_VALUE) {
            onPick(null);
            return;
          }
          onPick(data.value);
        },
        children: [
          displayNullChoice && /* @__PURE__ */ jsx(
            Radio,
            {
              value: NULL_CHOICE_VALUE,
              label: tNullChoice(t)
            },
            NULL_CHOICE_VALUE
          ),
          results.map((r) => /* @__PURE__ */ jsx(
            Radio,
            {
              value: r.id,
              label: r.name || t("app.components.lookup-edit.unnamed-record")
            },
            r.id
          ))
        ]
      }
    )
  ] });
}
function renderListboxContents(input) {
  const {
    loading,
    error,
    results,
    lookupValue,
    viewColumnNames,
    viewColumnMetadata,
    searchText,
    styles,
    t
  } = input;
  const showCommittedAsFallback = lookupValue !== void 0 && !results.some((r) => r.id === lookupValue.id);
  const isMultiColumn = viewColumnNames.length > 1;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    loading && /* @__PURE__ */ jsx(
      Option,
      {
        value: "__loading__",
        text: t("app.components.lookup-edit.searching"),
        disabled: true,
        className: styles.statusOption,
        children: /* @__PURE__ */ jsxs("div", { className: styles.loadingOption, children: [
          /* @__PURE__ */ jsx(Spinner, { size: "extra-tiny" }),
          /* @__PURE__ */ jsx("span", { children: t("app.components.lookup-edit.searching") })
        ] })
      },
      "__loading__"
    ),
    error && !loading && /* @__PURE__ */ jsx(
      Option,
      {
        value: "__error__",
        text: error,
        disabled: true,
        className: styles.statusOption,
        children: error
      },
      "__error__"
    ),
    !loading && !error && results.length === 0 && // Two empty states: "Type to search…" when the popup is open
    // but the user hasn't typed anything yet (no search has run);
    // "No matches" when a search ran and returned zero rows. The
    // searchText prop is `null` only in the AutoComplete case where
    // the popup just opened over a committed value — we deliberately
    // skip the auto-browse search there so the existing entry stays
    // visible. See `onOpenChange` in `renderAutoComplete`.
    /* @__PURE__ */ jsx(
      Option,
      {
        value: "__empty__",
        text: searchText === null ? "Type to search\u2026" : "No matches",
        disabled: true,
        className: styles.statusOption,
        children: searchText === null ? "Type to search\u2026" : "No matches"
      },
      "__empty__"
    ),
    results.map(
      (r) => isMultiColumn ? /* @__PURE__ */ jsx(Option, { value: r.id, text: r.name, children: /* @__PURE__ */ jsx("div", { className: styles.optionStack, children: viewColumnNames.map((colName, i) => {
        const value = resolveColumnDisplayValue(
          r.record,
          colName,
          viewColumnMetadata.get(colName)
        );
        if (value === null || value === "") {
          if (i === 0) {
            return /* @__PURE__ */ jsx(
              "span",
              {
                className: `${styles.optionRowPrimary} ${styles.optionNull}`,
                children: "(no name)"
              },
              colName
            );
          }
          return null;
        }
        const rowClass = i === 0 ? styles.optionRowPrimary : styles.optionRowSecondary;
        return /* @__PURE__ */ jsx("span", { className: rowClass, children: /* @__PURE__ */ jsx(Highlighter, { text: value, searchText }) }, colName);
      }) }) }, r.id) : (
        // Single-column path: keep the v0 layout (one line per option)
        // so the popup stays compact when there's no view to expand to.
        /* @__PURE__ */ jsx(Option, { value: r.id, text: r.name, children: r.name ? /* @__PURE__ */ jsx(Highlighter, { text: r.name, searchText }) : /* @__PURE__ */ jsx("span", { className: styles.statusOption, children: "(no name)" }) }, r.id)
      )
    ),
    showCommittedAsFallback && /* @__PURE__ */ jsx(
      Option,
      {
        value: lookupValue.id,
        text: lookupValue.name ?? "",
        style: { display: "none" },
        children: lookupValue.name ?? ""
      },
      lookupValue.id
    )
  ] });
}
function tableLabel2(t, tableName) {
  const key = `tables.${tableName}.label`;
  const resolved = t(key);
  return resolved === key ? tableName : resolved;
}
function tNullChoice(t) {
  return t("app.null-choice-label");
}
function tTargetPickerLabel(t) {
  const key = "app.messages.lookup-target-label";
  const resolved = t(key);
  return resolved === key ? "Search:" : resolved;
}
var XML_ESCAPES = {
  "<": "&lt;",
  ">": "&gt;",
  "&": "&amp;",
  "'": "&apos;",
  '"': "&quot;"
};
function escapeXmlAttribute(value) {
  return value.replace(/[<>&'"]/g, (c) => XML_ESCAPES[c] ?? c);
}
function buildMinimalFetchXml(targetTable, primaryIdColumn, primaryNameColumn, additionalColumns) {
  const extras = Array.from(
    new Set(
      additionalColumns.filter(
        (c) => c !== primaryIdColumn && c !== primaryNameColumn && !c.includes(".")
      )
    )
  );
  const extraAttrs = extras.map((c) => `<attribute name="${escapeXmlAttribute(c)}" />`).join("");
  return `<fetch><entity name="${escapeXmlAttribute(targetTable)}"><attribute name="${escapeXmlAttribute(primaryIdColumn)}" /><attribute name="${escapeXmlAttribute(primaryNameColumn)}" />` + extraAttrs + `</entity></fetch>`;
}
function buildFilter(parentRecord, relationshipName, mode) {
  return {
    $type: "RelationshipFilter",
    parentRecord: {
      tableName: parentRecord.tableName,
      id: getRecordReferenceId(parentRecord)
    },
    relationshipName,
    mode
  };
}
function buildRequests(parentRecord, relationshipName, relatedTableName, pendingAdds, pendingRemoveIds, initialSelection) {
  if (!relatedTableName) return [];
  if (pendingAdds.length === 0 && pendingRemoveIds.length === 0) return [];
  const requests = [];
  const parentRef = {
    tableName: parentRecord.tableName,
    id: getRecordReferenceId(parentRecord)
  };
  if (pendingAdds.length > 0) {
    const associate = {
      $type: "AssociateRequest",
      record: parentRef,
      relationshipName,
      relatedRecords: pendingAdds.map((r) => ({
        tableName: r.source.tableName,
        id: r.id
      }))
    };
    requests.push(associate);
  }
  if (pendingRemoveIds.length > 0) {
    const removedRecords = initialSelection.filter((r) => pendingRemoveIds.includes(r.id)).map((r) => ({ tableName: r.source.tableName, id: r.id }));
    if (removedRecords.length > 0) {
      const disassociate = {
        $type: "DisassociateRequest",
        record: parentRef,
        relationshipName,
        relatedRecords: removedRecords
      };
      requests.push(disassociate);
    }
  }
  return requests;
}
function resolveDisplayName(record, primaryNameColumn) {
  const formatted = record.formattedValues?.[primaryNameColumn];
  if (formatted && formatted.length > 0) return formatted;
  const raw = record.properties?.[primaryNameColumn];
  if (raw && typeof raw === "object" && "value" in raw) {
    const v = raw.value;
    if (typeof v === "string" && v.length > 0) return v;
  }
  return void 0;
}
var ManyToManyLookupEditorType = {
  /** Fluent `TagPicker` — selected records render as removable chips above the input. */
  TagPicker: "tagPicker",
  /** Fluent `Combobox` in `multiselect` mode — selected records render comma-separated. */
  Combobox: "combobox"
};
var VIEW_TYPE_PUBLIC2 = 0;
var DEFAULT_MAX_RECORDS_RETURNED = 20;
var SEARCH_DEBOUNCE_MS3 = 300;
var useStyles4 = makeStyles({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalXS,
    width: "100%"
  },
  // Dropdown list — caps the internal height + enables scrolling so the
  // popup can't grow off the bottom of the viewport when there are many
  // suggestions. `paddingTop: 0` / `paddingBottom: 0` remove Fluent's
  // default vertical insets so the sticky view-picker header and the
  // sticky Advanced Search footer sit flush against the list edges
  // (otherwise scrolling rows are briefly visible inside the padding
  // strip before being clipped behind the sticky element). The actual
  // min-height / max-height values come from the component's
  // `popupMinHeight` / `popupMaxHeight` props, applied inline on the slot.
  dropdownList: {
    overflowY: "auto",
    paddingTop: "0",
    paddingBottom: "0"
  },
  labelRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalXS
  },
  control: {
    width: "100%"
  },
  // Sticky-header view picker. Mirrors slot on the
  // autocomplete — only shown when there are multiple views to choose from.
  // `position: sticky` keeps it pinned while the user scrolls suggestions.
  // The background fill avoids see-through against scrolling rows.
  viewPickerHeader: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: tokens.colorNeutralBackground1,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    display: "flex",
    flexDirection: "column",
    padding: tokens.spacingHorizontalS
  },
  // Sticky-footer Advanced Search button inside the picker dropdown.
  // Mirrors the LookupEdit footer + the in
  // ManyToManyLookupEdit.razor.
  advancedSearchFooter: {
    position: "sticky",
    bottom: 0,
    backgroundColor: tokens.colorNeutralBackground1,
    borderTop: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    display: "flex",
    justifyContent: "flex-end",
    padding: tokens.spacingHorizontalS
  },
  inlineSpinner: {
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM
  },
  emptyOption: {
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    color: tokens.colorNeutralForeground3,
    fontStyle: "italic"
  },
  // Multi-column option row — one vertical stack per row. The Fluent
  // option chrome (focus ring, hover state) wraps this so the rows still
  // behave like single options.
  optionStack: {
    display: "flex",
    flexDirection: "column",
    rowGap: "2px",
    width: "100%"
  },
  optionFirstLine: {
    fontWeight: tokens.fontWeightSemibold
  },
  optionSubLine: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground2
  },
  // Empty-value placeholder rendered when a column has no value for this
  // row. Muted styling so it doesn't compete with real values.
  nullValue: {
    color: tokens.colorNeutralForeground3,
    fontStyle: "italic"
  }
});
function ManyToManyLookupEdit({
  relationshipName,
  editorType = ManyToManyLookupEditorType.TagPicker,
  label,
  description,
  descriptionLocation = DescriptionLocation.Tooltip,
  defaultViewId,
  viewIds,
  maxRecordsReturned = DEFAULT_MAX_RECORDS_RETURNED,
  popupMaxHeight = "320px",
  popupMinHeight,
  minimumNumberOfItems,
  maximumNumberOfItems,
  required,
  disabled = false,
  readOnly = false,
  displayLabelWhenAvailable = true,
  displayValidationErrorMessage = true,
  isVisible = true,
  className,
  style,
  id
}) {
  const styles = useStyles4();
  const t = useT();
  const { ppp } = usePowerPortalsPro();
  const { record: parentRecord } = useRecordContext();
  const mainContext = useMainContext();
  const parentMetadataQuery = useTableMetadata(parentRecord?.tableName ?? "", {
    enabled: !!parentRecord?.tableName
  });
  const parentMetadata = parentMetadataQuery.data;
  const relatedTableName = useMemo(() => {
    if (!parentMetadata) return void 0;
    const mtm = parentMetadata.manyToMany?.find((x) => x.relationshipName === relationshipName);
    if (!mtm) return void 0;
    return parentMetadata.tableName === mtm.table1 ? mtm.table2 : mtm.table1;
  }, [parentMetadata, relationshipName]);
  const relatedMetadataQuery = useTableMetadata(relatedTableName ?? "", {
    enabled: !!relatedTableName
  });
  const relatedPrimaryName = relatedMetadataQuery.data?.primaryNameColumn;
  const viewsForTable = useViewsForTable(relatedTableName ?? "", {
    enabled: !!relatedTableName
  });
  const resolvedViews = useMemo(() => {
    if (!viewsForTable.data) return [];
    const allowList = viewIds && viewIds.length > 0 ? new Set(viewIds) : null;
    return viewsForTable.data.filter((v) => v.type === VIEW_TYPE_PUBLIC2 && v.fetchXml && v.fetchXml.length > 0).filter((v) => allowList ? allowList.has(v.id) : true).slice().sort((a, b) => a.name.localeCompare(b.name));
  }, [viewsForTable.data, viewIds]);
  const [selectedViewId, setSelectedViewId] = useState(void 0);
  const lastSeededViewListRef = useRef(void 0);
  useEffect(() => {
    if (resolvedViews.length === 0) return;
    if (lastSeededViewListRef.current === resolvedViews) return;
    lastSeededViewListRef.current = resolvedViews;
    const defaultMatch = defaultViewId ? resolvedViews.find((v) => v.id === defaultViewId) : void 0;
    const tableDefault = resolvedViews.find((v) => v.isDefault);
    const chosen = defaultMatch ?? tableDefault ?? resolvedViews[0];
    if (chosen) setSelectedViewId(chosen.id);
  }, [resolvedViews, defaultViewId]);
  const [initialSelection, setInitialSelection] = useState([]);
  const [pendingAdds, setPendingAdds] = useState([]);
  const [pendingRemoveIds, setPendingRemoveIds] = useState([]);
  const currentSelection = useMemo(() => {
    const removed = new Set(pendingRemoveIds);
    const kept = initialSelection.filter((r) => !removed.has(r.id));
    return [...kept, ...pendingAdds];
  }, [initialSelection, pendingAdds, pendingRemoveIds]);
  const selectedIds = useMemo(
    () => new Set(currentSelection.map((r) => r.id)),
    [currentSelection]
  );
  const parentRefId = getRecordReferenceId(parentRecord);
  const canQuery = !!parentRecord && !!parentRefId && !!relatedTableName && !!relatedPrimaryName && !!selectedViewId;
  const initialLoadRequest = useMemo(() => {
    if (!canQuery || !parentRecord) {
      return { fetchXml: '<fetch><entity name="placeholder"/></fetch>' };
    }
    return {
      viewId: selectedViewId,
      filters: [
        buildFilter(
          parentRecord,
          relationshipName,
          RelationshipFilterMode.IncludeExistingRecords
        )
      ],
      pageSize: 500
      // initial-selection load — return up to 500 records associated to this parent.
    };
  }, [canQuery, parentRecord, selectedViewId, relationshipName]);
  const initialLoad = useGridData(initialLoadRequest, { enabled: canQuery });
  const resolvedColumns = useMemo(() => {
    return initialLoad.data?.columns ?? [];
  }, [initialLoad.data?.columns]);
  const primaryNameColumn = useMemo(() => {
    const flagged = resolvedColumns.find((c) => c.isPrimaryName);
    if (flagged) return flagged.columnName;
    return relatedPrimaryName;
  }, [resolvedColumns, relatedPrimaryName]);
  const lastSeededRecordIdRef = useRef(void 0);
  const lastSeededViewIdRef = useRef(void 0);
  useEffect(() => {
    if (initialLoad.status !== QueryStatus.Success || !initialLoad.data) return;
    if (!primaryNameColumn || !parentRecord) return;
    if (lastSeededRecordIdRef.current === parentRefId && lastSeededViewIdRef.current === selectedViewId) {
      return;
    }
    lastSeededRecordIdRef.current = parentRefId;
    lastSeededViewIdRef.current = selectedViewId;
    const seeded = initialLoad.data.tableRecords.map((r) => ({
      id: r.id,
      displayName: resolveDisplayName(r, primaryNameColumn) ?? "",
      source: r
    }));
    setInitialSelection(seeded);
    setPendingAdds([]);
    setPendingRemoveIds([]);
  }, [initialLoad.status, initialLoad.data, parentRecord, primaryNameColumn, selectedViewId]);
  const [query, setQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setDebouncedQuery(query), SEARCH_DEBOUNCE_MS3);
    return () => clearTimeout(timer);
  }, [query]);
  useEffect(() => {
    if (!canQuery || !parentRecord || !selectedViewId) return;
    const controller = new AbortController();
    setSearchLoading(true);
    const trimmed = debouncedQuery.trim();
    const request = {
      viewId: selectedViewId,
      ...trimmed.length > 0 && { searchText: trimmed },
      filters: [
        buildFilter(
          parentRecord,
          relationshipName,
          RelationshipFilterMode.ExcludeExistingRecords
        )
      ],
      pageSize: maxRecordsReturned
    };
    ppp.loadGridAsync(request, controller.signal).then((resp) => {
      if (controller.signal.aborted) return;
      const nameColumn = resp.columns.find((c) => c.isPrimaryName)?.columnName ?? primaryNameColumn ?? "";
      setSearchResults(
        resp.tableRecords.map((r) => ({
          id: r.id,
          displayName: resolveDisplayName(r, nameColumn) ?? "",
          source: r
        }))
      );
    }).catch((err) => {
      if (controller.signal.aborted) return;
      console.warn("[ManyToManyLookupEdit] autocomplete fetch failed", err);
    }).finally(() => {
      if (!controller.signal.aborted) setSearchLoading(false);
    });
    return () => controller.abort();
  }, [
    canQuery,
    parentRecord,
    selectedViewId,
    relationshipName,
    debouncedQuery,
    maxRecordsReturned,
    primaryNameColumn,
    ppp
  ]);
  const addRecord = useCallback(
    (rec) => {
      if (selectedIds.has(rec.id)) return;
      const wasInitial = initialSelection.some((r) => r.id === rec.id);
      if (wasInitial) {
        setPendingRemoveIds((prev) => prev.filter((id2) => id2 !== rec.id));
      } else {
        setPendingAdds((prev) => [...prev, rec]);
      }
    },
    [initialSelection, selectedIds]
  );
  const removeRecord = useCallback(
    (recordId) => {
      const isPendingAdd = pendingAdds.some((r) => r.id === recordId);
      if (isPendingAdd) {
        setPendingAdds((prev) => prev.filter((r) => r.id !== recordId));
        return;
      }
      setPendingRemoveIds((prev) => prev.includes(recordId) ? prev : [...prev, recordId]);
    },
    [pendingAdds]
  );
  const selectionCount = currentSelection.length;
  const minError = minimumNumberOfItems !== void 0 && selectionCount < minimumNumberOfItems ? t("app.errors.value-min-count", [minimumNumberOfItems]) : null;
  const maxError = maximumNumberOfItems !== void 0 && selectionCount > maximumNumberOfItems ? t("app.errors.value-max-count", [maximumNumberOfItems]) : null;
  const validationError = minError ?? maxError;
  const isDirty = pendingAdds.length > 0 || pendingRemoveIds.length > 0;
  const pendingAddsRef = useRef(pendingAdds);
  pendingAddsRef.current = pendingAdds;
  const pendingRemoveIdsRef = useRef(pendingRemoveIds);
  pendingRemoveIdsRef.current = pendingRemoveIds;
  const initialSelectionRef = useRef(initialSelection);
  initialSelectionRef.current = initialSelection;
  const validationRef = useRef(validationError);
  validationRef.current = validationError;
  const isDirtyRef = useRef(isDirty);
  isDirtyRef.current = isDirty;
  useEffect(() => {
    if (!mainContext || !parentRecord) return;
    return mainContext.registerDescendant({
      // Ref-backed getter so dirty transitions don't tear the
      // registration down + re-create it (which would cascade context
      // re-renders and disrupt focus in any open inline editors). The
      // notify effect below pokes the parent on actual transitions.
      isDirty: () => isDirtyRef.current,
      getRequests: () => buildRequests(
        parentRecord,
        relationshipName,
        relatedTableName,
        pendingAddsRef.current,
        pendingRemoveIdsRef.current,
        initialSelectionRef.current
      ),
      validate: () => validationRef.current === null,
      refresh: async () => {
        setPendingAdds([]);
        setPendingRemoveIds([]);
        lastSeededRecordIdRef.current = void 0;
        lastSeededViewIdRef.current = void 0;
      },
      // Cancel/Discard: just drop the pending adds/removes; the
      // seed-guard refs stay so the initial selection (already loaded
      // from the server) is what the editor renders after reset.
      resetState: () => {
        setPendingAdds([]);
        setPendingRemoveIds([]);
      }
    });
  }, [mainContext?.registerDescendant, parentRecord, relationshipName, relatedTableName]);
  const mainContextRef = useRef(mainContext);
  mainContextRef.current = mainContext;
  useEffect(() => {
    mainContextRef.current?.notifyDescendantDirtyChanged();
  }, [isDirty]);
  const [dialogHidden, setDialogHidden] = useState(true);
  const openAdvancedSearch = () => setDialogHidden(false);
  const onDialogActionClicked = useCallback(
    (records) => {
      if (!primaryNameColumn) return;
      for (const r of records) {
        if (!r.id) continue;
        addRecord({
          id: r.id,
          displayName: resolveDisplayName(r, primaryNameColumn) ?? "",
          source: r
        });
      }
    },
    [addRecord, primaryNameColumn]
  );
  const advancedSearchAllowList = useMemo(() => {
    if (!relatedTableName) return void 0;
    if (!viewIds || viewIds.length === 0) return void 0;
    return { [relatedTableName]: viewIds };
  }, [relatedTableName, viewIds]);
  if (!isVisible) return null;
  if (!parentRecord) return null;
  const interactionDisabled = disabled || readOnly;
  const resolvedRequired = required ?? (minimumNumberOfItems !== void 0 && minimumNumberOfItems > 0);
  const suggestions = searchResults.filter((r) => !selectedIds.has(r.id));
  const renderInput = {
    id,
    disabled: interactionDisabled,
    currentSelection,
    suggestions,
    searchLoading,
    query,
    onQueryChange: setQuery,
    onPick: addRecord,
    onUnpick: removeRecord,
    onAdvancedSearchClicked: openAdvancedSearch,
    resolvedColumns,
    resolvedViews,
    selectedViewId,
    onViewChange: setSelectedViewId,
    popupMaxHeight,
    popupMinHeight,
    styles,
    t
  };
  const editorTypeRendered = editorType === ManyToManyLookupEditorType.Combobox ? renderCombobox(renderInput) : renderTagPicker(renderInput);
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-many-to-many-lookup-edit", className), style, children: [
    /* @__PURE__ */ jsx(
      Field,
      {
        ...displayLabelWhenAvailable && label !== void 0 && { label },
        ...descriptionLocation === DescriptionLocation.BelowControl && description !== void 0 && {
          hint: description
        },
        ...resolvedRequired && { required: true },
        ...validationError && {
          validationState: "error",
          ...displayValidationErrorMessage && { validationMessage: validationError }
        },
        children: /* @__PURE__ */ jsxs("div", { className: styles.wrapper, children: [
          description && descriptionLocation === DescriptionLocation.Tooltip && /* @__PURE__ */ jsx("div", { className: styles.labelRow, children: /* @__PURE__ */ jsx(DescriptionIcon, { description }) }),
          editorTypeRendered
        ] })
      }
    ),
    relatedTableName && !dialogHidden && /* @__PURE__ */ jsx(
      LookupDialog,
      {
        hidden: false,
        onHiddenChange: setDialogHidden,
        title: label ?? relatedTableName,
        tableNames: [relatedTableName],
        ...advancedSearchAllowList !== void 0 && { viewIds: advancedSearchAllowList },
        selectionMode: "multiple",
        actionLabel: t("app.buttons.link.label"),
        onActionClicked: onDialogActionClicked
      }
    )
  ] });
}
function renderOptionContent({
  record,
  resolvedColumns,
  fallbackText,
  query,
  styles
}) {
  if (resolvedColumns.length === 0) {
    return /* @__PURE__ */ jsx(Highlighter, { text: fallbackText, searchText: query });
  }
  return /* @__PURE__ */ jsx("div", { className: styles.optionStack, children: resolvedColumns.map((col, idx) => {
    const value = resolveColumnDisplayValue(record, col.columnName);
    const isFirst = idx === 0;
    if (!value || value.trim().length === 0) {
      return /* @__PURE__ */ jsx(
        "span",
        {
          className: `${isFirst ? styles.optionFirstLine : styles.optionSubLine} ${styles.nullValue}`,
          children: "[NULL]"
        },
        col.columnName
      );
    }
    return /* @__PURE__ */ jsx(
      Highlighter,
      {
        text: value,
        searchText: query,
        className: isFirst ? styles.optionFirstLine : styles.optionSubLine
      },
      col.columnName
    );
  }) });
}
function renderViewPicker(input) {
  const { resolvedViews, selectedViewId, onViewChange, styles, t } = input;
  if (resolvedViews.length <= 1) return null;
  const selectedView = resolvedViews.find((v) => v.id === selectedViewId);
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: styles.viewPickerHeader,
      onMouseDown: (e) => e.preventDefault(),
      children: /* @__PURE__ */ jsx(
        Dropdown,
        {
          size: "small",
          inlinePopup: true,
          "aria-label": t("app.components.view-selector.view-name"),
          selectedOptions: selectedViewId ? [selectedViewId] : [],
          value: selectedView?.name ?? "",
          onOptionSelect: (event, data) => {
            event.stopPropagation();
            if (data.optionValue) onViewChange(data.optionValue);
          },
          onOpenChange: (event) => {
            event.stopPropagation();
          },
          children: resolvedViews.map((v) => /* @__PURE__ */ jsx(Option, { value: v.id, text: v.name, children: v.name }, v.id))
        }
      )
    }
  );
}
function renderTagPicker(input) {
  const {
    id,
    disabled,
    currentSelection,
    suggestions,
    searchLoading,
    query,
    onQueryChange,
    onPick,
    onUnpick,
    onAdvancedSearchClicked,
    resolvedColumns,
    resolvedViews,
    popupMaxHeight,
    popupMinHeight,
    styles,
    t
  } = input;
  const selectedIds = currentSelection.map((r) => r.id);
  const viewIdSet = new Set(resolvedViews.map((v) => v.id));
  return /* @__PURE__ */ jsxs(
    TagPicker,
    {
      disabled,
      selectedOptions: selectedIds,
      positioning: {
        position: "below",
        align: "start"
      },
      onOptionSelect: (_, data) => {
        const next = new Set(
          data.selectedOptions.filter((id2) => !viewIdSet.has(id2))
        );
        const previous = new Set(selectedIds);
        for (const newId of next) {
          if (previous.has(newId)) continue;
          const found = suggestions.find((r) => r.id === newId);
          if (found) onPick(found);
        }
        for (const oldId of previous) {
          if (!next.has(oldId)) onUnpick(oldId);
        }
        onQueryChange("");
      },
      children: [
        /* @__PURE__ */ jsxs(TagPickerControl, { className: styles.control, children: [
          /* @__PURE__ */ jsx(TagPickerGroup, { children: currentSelection.map((r) => /* @__PURE__ */ jsx(
            Tag,
            {
              value: r.id,
              shape: "rounded",
              dismissible: true,
              dismissIcon: { "aria-label": t("app.buttons.remove.label") },
              children: r.displayName
            },
            r.id
          )) }),
          /* @__PURE__ */ jsx(
            TagPickerInput,
            {
              id,
              "aria-label": t("app.components.lookup-edit.search-placeholder"),
              value: query,
              onChange: (e) => onQueryChange(e.target.value)
            }
          )
        ] }),
        /* @__PURE__ */ jsxs(
          TagPickerList,
          {
            className: styles.dropdownList,
            style: {
              maxHeight: popupMaxHeight,
              ...popupMinHeight !== void 0 && { minHeight: popupMinHeight }
            },
            children: [
              renderViewPicker(input),
              searchLoading && /* @__PURE__ */ jsx("div", { className: styles.inlineSpinner, children: /* @__PURE__ */ jsx(Spinner, { size: "tiny" }) }),
              !searchLoading && suggestions.length === 0 && /* @__PURE__ */ jsx("div", { className: styles.emptyOption, children: t("app.components.lookup-edit.no-matches") }),
              suggestions.map((r) => (
                // `text` is what Fluent uses for accessibility (announced by
                // screen readers, falls back to the input when the option is
                // matched against typed text); pass the primary-name line so
                // the announcement matches the visual primary line.
                /* @__PURE__ */ jsx(TagPickerOption, { value: r.id, text: r.displayName, children: renderOptionContent({
                  record: r.source,
                  resolvedColumns,
                  fallbackText: r.displayName,
                  query,
                  styles
                }) }, r.id)
              )),
              /* @__PURE__ */ jsx("div", { className: styles.advancedSearchFooter, onMouseDown: (e) => e.preventDefault(), children: /* @__PURE__ */ jsx(
                Button,
                {
                  appearance: "subtle",
                  icon: /* @__PURE__ */ jsx(Search20Regular, {}),
                  onClick: onAdvancedSearchClicked,
                  children: t("app.buttons.advanced-search.label")
                }
              ) })
            ]
          }
        )
      ]
    }
  );
}
function renderCombobox(input) {
  const {
    id,
    disabled,
    currentSelection,
    suggestions,
    searchLoading,
    query,
    onQueryChange,
    onPick,
    onUnpick,
    onAdvancedSearchClicked,
    resolvedColumns,
    resolvedViews,
    popupMaxHeight,
    popupMinHeight,
    styles,
    t
  } = input;
  const selectedIds = currentSelection.map((r) => r.id);
  const viewIdSet = new Set(resolvedViews.map((v) => v.id));
  return /* @__PURE__ */ jsxs(
    Combobox,
    {
      id,
      multiselect: true,
      disabled: disabled || void 0,
      value: query,
      selectedOptions: selectedIds,
      positioning: {
        position: "below",
        align: "start"
      },
      listbox: {
        className: styles.dropdownList,
        style: {
          maxHeight: popupMaxHeight,
          ...popupMinHeight !== void 0 && { minHeight: popupMinHeight }
        }
      },
      onChange: (e) => onQueryChange(e.target.value),
      onOptionSelect: (_, data) => {
        const previous = new Set(selectedIds);
        const next = new Set(
          data.selectedOptions.filter((id2) => !viewIdSet.has(id2))
        );
        for (const newId of next) {
          if (previous.has(newId)) continue;
          const found = suggestions.find((r) => r.id === newId);
          if (found) onPick(found);
        }
        for (const oldId of previous) {
          if (!next.has(oldId)) onUnpick(oldId);
        }
        onQueryChange("");
      },
      className: styles.control,
      children: [
        renderViewPicker(input),
        currentSelection.map((r) => /* @__PURE__ */ jsx(Option, { value: r.id, text: r.displayName, children: r.displayName }, r.id)),
        searchLoading && /* @__PURE__ */ jsx("div", { className: styles.inlineSpinner, children: /* @__PURE__ */ jsx(Spinner, { size: "tiny" }) }),
        !searchLoading && suggestions.length === 0 && /* @__PURE__ */ jsx("div", { className: styles.emptyOption, children: t("app.components.lookup-edit.no-matches") }),
        suggestions.map((r) => /* @__PURE__ */ jsx(Option, { value: r.id, text: r.displayName, children: renderOptionContent({
          record: r.source,
          resolvedColumns,
          fallbackText: r.displayName,
          query,
          styles
        }) }, r.id)),
        /* @__PURE__ */ jsx("div", { className: styles.advancedSearchFooter, onMouseDown: (e) => e.preventDefault(), children: /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "subtle",
            icon: /* @__PURE__ */ jsx(Search20Regular, {}),
            onClick: onAdvancedSearchClicked,
            children: t("app.buttons.advanced-search.label")
          }
        ) })
      ]
    }
  );
}
var useStyles5 = makeStyles({
  titleRow: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS
  },
  iconSuccess: { color: tokens.colorStatusSuccessForeground1 },
  iconWarning: { color: tokens.colorStatusWarningForeground1 },
  iconError: { color: tokens.colorStatusDangerForeground1 },
  iconInfo: { color: tokens.colorBrandForeground1 },
  iconConfirmation: { color: tokens.colorBrandForeground1 }
});
var DEFAULT_TITLE_KEYS = {
  success: "app.components.dialog.success-title",
  warning: "app.components.dialog.warning-title",
  error: "app.components.dialog.error-title",
  info: "app.components.dialog.information-title",
  confirmation: "app.components.dialog.confirmation-title"
};
function FluentDialogProvider({ children }) {
  const styles = useStyles5();
  const t = useT();
  const [queue, setQueue] = useState([]);
  const current = queue[0];
  const dialogService = useMemo(() => {
    function enqueue(variant, message, options) {
      return new Promise((resolve) => {
        setQueue((prev) => [
          ...prev,
          {
            variant,
            message,
            ...options?.title !== void 0 && { title: options.title },
            ...options?.primaryText !== void 0 && { primaryText: options.primaryText },
            ...options?.secondaryText !== void 0 && {
              secondaryText: options.secondaryText
            },
            resolve
          }
        ]);
      });
    }
    return {
      showSuccessAsync: (m, o) => enqueue("success", m, o),
      showWarningAsync: (m, o) => enqueue("warning", m, o),
      showErrorAsync: (m, o) => enqueue("error", m, o),
      showInfoAsync: (m, o) => enqueue("info", m, o),
      showConfirmationAsync: (m, o) => enqueue("confirmation", m, o)
    };
  }, []);
  const dismiss = useCallback(
    (cancelled) => {
      if (!current) return;
      current.resolve({ cancelled });
      setQueue((prev) => prev.slice(1));
    },
    [current]
  );
  return /* @__PURE__ */ jsxs(DialogServiceProvider, { value: dialogService, children: [
    children,
    current && /* @__PURE__ */ jsx(
      Dialog,
      {
        open: true,
        onOpenChange: (_, data) => {
          if (!data.open) {
            dismiss(current.variant === "confirmation");
          }
        },
        modalType: "modal",
        children: /* @__PURE__ */ jsx(DialogSurface, { children: /* @__PURE__ */ jsxs(DialogBody, { children: [
          /* @__PURE__ */ jsx(DialogTitle, { children: /* @__PURE__ */ jsxs("div", { className: styles.titleRow, children: [
            /* @__PURE__ */ jsx(VariantIcon, { variant: current.variant, styles }),
            /* @__PURE__ */ jsx("span", { children: current.title ?? t(DEFAULT_TITLE_KEYS[current.variant]) })
          ] }) }),
          /* @__PURE__ */ jsx(DialogContent, { children: /* @__PURE__ */ jsx("div", { dangerouslySetInnerHTML: { __html: current.message } }) }),
          /* @__PURE__ */ jsxs(DialogActions, { children: [
            current.variant === "confirmation" && /* @__PURE__ */ jsx(Button, { appearance: "secondary", onClick: () => dismiss(true), children: current.secondaryText ?? t("app.buttons.no.label") }),
            /* @__PURE__ */ jsx(Button, { appearance: "primary", onClick: () => dismiss(false), children: current.primaryText ?? t(current.variant === "confirmation" ? "app.buttons.yes.label" : "app.buttons.ok.label") })
          ] })
        ] }) })
      }
    )
  ] });
}
function VariantIcon({
  variant,
  styles
}) {
  switch (variant) {
    case "success":
      return /* @__PURE__ */ jsx(CheckmarkCircle24Regular, { className: styles.iconSuccess });
    case "warning":
      return /* @__PURE__ */ jsx(Warning24Regular, { className: styles.iconWarning });
    case "error":
      return /* @__PURE__ */ jsx(DismissCircle24Regular, { className: styles.iconError });
    case "info":
      return /* @__PURE__ */ jsx(Info24Regular, { className: styles.iconInfo });
    case "confirmation":
      return /* @__PURE__ */ jsx(QuestionCircle24Regular, { className: styles.iconConfirmation });
  }
}
var ThemeMode = {
  Light: "light",
  Dark: "dark",
  System: "system"
};
var TextDirection = {
  Ltr: "ltr",
  Rtl: "rtl"
};
var ThemeContext = createContext(null);
var ThemeContextProvider = ThemeContext.Provider;
function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error(
      "useTheme() was called outside <PowerPortalsProThemeProvider>. Wrap your app in the provider at the same level you mount <FluentProvider>."
    );
  }
  return ctx;
}
var OFFICE_ACCENT_DEFINITIONS = [
  { name: "default", hex: "#036ac4", officeColorIndex: 0, officeColorNames: ["Default"] },
  { name: "access", hex: "#a4373a", officeColorIndex: 1, officeColorNames: ["Access"] },
  { name: "booking", hex: "#00a99d", officeColorIndex: 2, officeColorNames: ["Booking"] },
  {
    name: "exchange",
    hex: "#0078d4",
    officeColorIndex: 3,
    officeColorNames: ["Exchange", "OneDrive", "SharePoint", "Skype", "Windows"]
  },
  { name: "excel", hex: "#217346", officeColorIndex: 4, officeColorNames: ["Excel"] },
  { name: "group-me", hex: "#00bcf2", officeColorIndex: 5, officeColorNames: ["GroupMe"] },
  { name: "office", hex: "#d83b01", officeColorIndex: 6, officeColorNames: ["Office"] },
  { name: "one-note", hex: "#7719aa", officeColorIndex: 8, officeColorNames: ["OneNote"] },
  { name: "outlook", hex: "#0f6cbd", officeColorIndex: 9, officeColorNames: ["Outlook"] },
  {
    name: "planner",
    hex: "#31752f",
    officeColorIndex: 10,
    officeColorNames: ["Planner", "Project"]
  },
  { name: "power-apps", hex: "#742774", officeColorIndex: 11, officeColorNames: ["PowerApps"] },
  { name: "power-bi", hex: "#f2c811", officeColorIndex: 12, officeColorNames: ["PowerBI"] },
  { name: "power-point", hex: "#b7472a", officeColorIndex: 13, officeColorNames: ["PowerPoint"] },
  { name: "publisher", hex: "#077568", officeColorIndex: 15, officeColorNames: ["Publisher"] },
  { name: "stream", hex: "#bc1948", officeColorIndex: 18, officeColorNames: ["Stream"] },
  { name: "sway", hex: "#008272", officeColorIndex: 19, officeColorNames: ["Sway"] },
  { name: "teams", hex: "#6264a7", officeColorIndex: 20, officeColorNames: ["Teams"] },
  { name: "visio", hex: "#3955a3", officeColorIndex: 21, officeColorNames: ["Visio"] },
  { name: "word", hex: "#2b579a", officeColorIndex: 23, officeColorNames: ["Word"] },
  { name: "yammer", hex: "#106ebe", officeColorIndex: 24, officeColorNames: ["Yammer"] }
];
var STOPS = [
  10,
  20,
  30,
  40,
  50,
  60,
  70,
  80,
  90,
  100,
  110,
  120,
  130,
  140,
  150,
  160
];
function lightnessForStop(stop, baseLightness) {
  if (stop === 80) return baseLightness;
  if (stop < 80) {
    const t2 = (stop - 10) / 70;
    return 8 + (baseLightness - 8) * t2;
  }
  const t = (stop - 80) / 80;
  return Math.min(97, baseLightness + (95 - baseLightness) * t);
}
function hexToHsl(hex) {
  const cleaned = hex.replace(/^#/, "");
  const r = parseInt(cleaned.slice(0, 2), 16) / 255;
  const g = parseInt(cleaned.slice(2, 4), 16) / 255;
  const b = parseInt(cleaned.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let s = 0;
  let h = 0;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
        break;
      case g:
        h = ((b - r) / d + 2) / 6;
        break;
      case b:
        h = ((r - g) / d + 4) / 6;
        break;
    }
  }
  return [h * 360, s * 100, l * 100];
}
function hslToHex(h, s, l) {
  const hue = (h % 360 + 360) % 360;
  const sat = Math.max(0, Math.min(100, s)) / 100;
  const lum = Math.max(0, Math.min(100, l)) / 100;
  const c = (1 - Math.abs(2 * lum - 1)) * sat;
  const x = c * (1 - Math.abs(hue / 60 % 2 - 1));
  const m = lum - c / 2;
  let r = 0;
  let g = 0;
  let b = 0;
  if (hue < 60) {
    r = c;
    g = x;
  } else if (hue < 120) {
    r = x;
    g = c;
  } else if (hue < 180) {
    g = c;
    b = x;
  } else if (hue < 240) {
    g = x;
    b = c;
  } else if (hue < 300) {
    r = x;
    b = c;
  } else {
    r = c;
    b = x;
  }
  const toHex = (v) => Math.round((v + m) * 255).toString(16).padStart(2, "0");
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}
function hexToBrandVariants(hex) {
  const [h, s, baseL] = hexToHsl(hex);
  const variants = {};
  for (const stop of STOPS) {
    variants[stop] = hslToHex(h, s, lightnessForStop(stop, baseL));
  }
  return variants;
}
function relativeLuminance(hex) {
  const clean = hex.replace(/^#/, "");
  const r = parseInt(clean.slice(0, 2), 16) / 255;
  const g = parseInt(clean.slice(2, 4), 16) / 255;
  const b = parseInt(clean.slice(4, 6), 16) / 255;
  const toLinear = (c) => c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  return 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);
}
function foregroundForBrandBg(brandHex) {
  return relativeLuminance(brandHex) > 0.4 ? "#000000" : "#ffffff";
}
var OFFICE_ACCENT_THEMES = (() => {
  const map = {};
  for (const { name, hex } of OFFICE_ACCENT_DEFINITIONS) {
    const variants = hexToBrandVariants(hex);
    const light = createLightTheme(variants);
    const dark = createDarkTheme(variants);
    light.colorNeutralForegroundOnBrand = foregroundForBrandBg(variants[80]);
    dark.colorNeutralForegroundOnBrand = foregroundForBrandBg(variants[70]);
    map[name] = { light, dark };
  }
  map.default = { light: webLightTheme, dark: webDarkTheme };
  map.teams = { light: teamsLightTheme, dark: teamsDarkTheme };
  return map;
})();
var OFFICE_COLOR_NAME_TO_ACCENT = (() => {
  const map = {};
  for (const def of OFFICE_ACCENT_DEFINITIONS) {
    for (const enumName of def.officeColorNames) {
      map[enumName] = def.name;
    }
  }
  return map;
})();
var OFFICE_ACCENT_HEX_TO_NAME = (() => {
  const map = {};
  for (const def of OFFICE_ACCENT_DEFINITIONS) {
    map[def.hex.toLowerCase()] = def.name;
  }
  return map;
})();
function normalizeHex(raw) {
  const lower = raw.trim().toLowerCase();
  if (/^#[0-9a-f]{6}$/.test(lower)) return lower;
  if (/^#[0-9a-f]{3}$/.test(lower)) {
    return `#${lower[1]}${lower[1]}${lower[2]}${lower[2]}${lower[3]}${lower[3]}`;
  }
  return null;
}
function officeColorValueToAccentName(raw) {
  if (!raw) return null;
  const hex = normalizeHex(raw);
  if (hex !== null) return OFFICE_ACCENT_HEX_TO_NAME[hex] ?? null;
  return OFFICE_COLOR_NAME_TO_ACCENT[raw.trim()] ?? null;
}
var BUILT_IN_ACCENTS = OFFICE_ACCENT_THEMES;
var useGlobalBodyStyles = makeStaticStyles({
  // Fluent's `webDarkTheme.colorNeutralBackground4` (#0a0a0a) — same
  // token the side nav rail uses, so the body and rail share one
  // continuous surface in dark mode.
  "body.ppp-theme-dark": {
    backgroundColor: "#0a0a0a",
    color: "#ffffff"
  },
  // Fluent's `webLightTheme.colorNeutralBackground2` (#fafafa) — a
  // hair off pure white, mirroring what most Fluent v9 demo apps
  // use as their page background in light mode.
  "body.ppp-theme-light": {
    backgroundColor: "#fafafa",
    color: "#242424"
  }
});
var DEFAULT_MODE_STORAGE_KEY = "ppp-theme-mode";
var DEFAULT_ACCENT_STORAGE_KEY = "ppp-theme-accent";
var DEFAULT_DIRECTION_STORAGE_KEY = "ppp-theme-direction";
function readStoredMode(storageKey) {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(storageKey);
    if (raw === ThemeMode.Light || raw === ThemeMode.Dark || raw === ThemeMode.System) {
      return raw;
    }
    return null;
  } catch {
    return null;
  }
}
function readStoredString(storageKey) {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(storageKey);
  } catch {
    return null;
  }
}
function readStoredDirection(storageKey) {
  const raw = readStoredString(storageKey);
  return raw === TextDirection.Ltr || raw === TextDirection.Rtl ? raw : null;
}
function writeStored(storageKey, value) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(storageKey, value);
  } catch {
  }
}
function getSystemPrefersDark() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}
function PowerPortalsProThemeProvider({
  children,
  defaultMode = ThemeMode.System,
  defaultAccentColor = "default",
  defaultTextDirection = TextDirection.Ltr,
  customAccents,
  storageKey = DEFAULT_MODE_STORAGE_KEY,
  style,
  fluentProviderProps
}) {
  const accentStorageKey = storageKey === DEFAULT_MODE_STORAGE_KEY ? DEFAULT_ACCENT_STORAGE_KEY : `${storageKey}-accent`;
  const directionStorageKey = storageKey === DEFAULT_MODE_STORAGE_KEY ? DEFAULT_DIRECTION_STORAGE_KEY : `${storageKey}-direction`;
  const accentMap = useMemo(
    () => ({ ...BUILT_IN_ACCENTS, ...customAccents }),
    // Stringified keys = stable identity for the customAccents map
    // when its contents don't actually change (a consumer passing
    // a fresh inline object literal each render is common).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [customAccents ? Object.keys(customAccents).join("|") : ""]
  );
  const availableAccents = useMemo(
    () => Object.keys(accentMap),
    [accentMap]
  );
  const [mode, setModeState] = useState(
    () => readStoredMode(storageKey) ?? defaultMode
  );
  const [accentColor, setAccentColorState] = useState(() => {
    const stored = readStoredString(accentStorageKey);
    if (stored && stored in accentMap) return stored;
    return defaultAccentColor in accentMap ? defaultAccentColor : "default";
  });
  const [textDirection, setTextDirectionState] = useState(
    () => readStoredDirection(directionStorageKey) ?? defaultTextDirection
  );
  const [systemPrefersDark, setSystemPrefersDark] = useState(
    () => getSystemPrefersDark()
  );
  useEffect(() => {
    if (typeof window === "undefined") return void 0;
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = (event) => setSystemPrefersDark(event.matches);
    if (media.addEventListener) {
      media.addEventListener("change", handler);
      return () => media.removeEventListener("change", handler);
    }
    media.addListener(handler);
    return () => media.removeListener(handler);
  }, []);
  const isDark = useMemo(() => {
    if (mode === ThemeMode.Dark) return true;
    if (mode === ThemeMode.Light) return false;
    return systemPrefersDark;
  }, [mode, systemPrefersDark]);
  useGlobalBodyStyles();
  useEffect(() => {
    if (typeof document === "undefined") return;
    document.body.classList.toggle("ppp-theme-dark", isDark);
    document.body.classList.toggle("ppp-theme-light", !isDark);
  }, [isDark]);
  const setMode = useCallback(
    (next) => {
      setModeState(next);
      writeStored(storageKey, next);
    },
    [storageKey]
  );
  const setAccentColor = useCallback(
    (next) => {
      if (!(next in accentMap)) return;
      setAccentColorState(next);
      writeStored(accentStorageKey, next);
    },
    [accentMap, accentStorageKey]
  );
  const setTextDirection = useCallback(
    (next) => {
      setTextDirectionState(next);
      writeStored(directionStorageKey, next);
    },
    [directionStorageKey]
  );
  const accentColors = useMemo(() => {
    const map = {};
    for (const [name, pair] of Object.entries(accentMap)) {
      map[name] = pair.light.colorBrandBackground;
    }
    return map;
  }, [accentMap]);
  const value = useMemo(
    () => ({
      mode,
      isDark,
      setMode,
      accentColor,
      setAccentColor,
      availableAccents,
      accentColors,
      textDirection,
      setTextDirection
    }),
    [
      mode,
      isDark,
      setMode,
      accentColor,
      setAccentColor,
      availableAccents,
      accentColors,
      textDirection,
      setTextDirection
    ]
  );
  const accentPair = accentMap[accentColor] ?? accentMap.default ?? BUILT_IN_ACCENTS.default;
  const resolvedTheme = isDark ? accentPair.dark : accentPair.light;
  return /* @__PURE__ */ jsx(ThemeContextProvider, { value, children: /* @__PURE__ */ jsx(
    FluentProvider,
    {
      theme: resolvedTheme,
      dir: textDirection,
      ...style && { style },
      ...fluentProviderProps,
      children
    }
  ) });
}
var MODE_ORDER = [
  ThemeMode.Light,
  ThemeMode.Dark,
  ThemeMode.System
];
function ThemeSelector({ readOnly, label, width }) {
  const { mode, setMode } = useTheme();
  const t = useT();
  const labelId = useId();
  const optionLabel = useCallback(
    (m) => t(`app.components.theme-selector.mode.${m}`),
    [t]
  );
  const handleOptionSelect = (_event, data) => {
    const next = data.optionValue;
    if (next === ThemeMode.Light || next === ThemeMode.Dark || next === ThemeMode.System) {
      setMode(next);
    }
  };
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: "ppp-theme-selector",
      label: label ?? t("app.components.theme-selector.theme-label"),
      id: labelId,
      children: /* @__PURE__ */ jsx(
        Dropdown,
        {
          "aria-labelledby": labelId,
          value: optionLabel(mode),
          selectedOptions: [mode],
          onOptionSelect: handleOptionSelect,
          disabled: readOnly,
          ...width && { style: { width } },
          children: MODE_ORDER.map((m) => /* @__PURE__ */ jsx(Option, { value: m, text: optionLabel(m), children: optionLabel(m) }, m))
        }
      )
    }
  );
}
var useStyles6 = makeStyles({
  // Color swatch rendered as the first child of each `<Option>`. Sized
  // to align with single-line text (14px ≈ text height at the dropdown's
  // default font size). The neutral-stroke border keeps a very light
  // accent (e.g. PowerBI yellow) visible against the dropdown panel's
  // white background.
  swatch: {
    display: "inline-block",
    width: "14px",
    height: "14px",
    borderRadius: tokens.borderRadiusSmall,
    marginRight: tokens.spacingHorizontalS,
    verticalAlign: "middle",
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    flexShrink: 0
  }
});
function ThemeColorSelector({
  readOnly,
  label,
  width,
  accentLabels
}) {
  const { accentColor, setAccentColor, availableAccents, accentColors } = useTheme();
  const t = useT();
  const labelId = useId();
  const styles = useStyles6();
  const optionLabel = useCallback(
    (accent) => {
      const override = accentLabels?.[accent];
      if (override !== void 0) return override;
      const key = `app.components.theme-color-selector.accent.${accent}`;
      const resolved = t(key);
      return resolved === key ? accent : resolved;
    },
    [t, accentLabels]
  );
  const handleOptionSelect = (_event, data) => {
    const next = data.optionValue;
    if (next && availableAccents.includes(next)) {
      setAccentColor(next);
    }
  };
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: "ppp-theme-color-selector",
      label: label ?? t("app.components.theme-color-selector.color-label"),
      id: labelId,
      children: /* @__PURE__ */ jsx(
        Dropdown,
        {
          "aria-labelledby": labelId,
          value: optionLabel(accentColor),
          selectedOptions: [accentColor],
          onOptionSelect: handleOptionSelect,
          disabled: readOnly,
          ...width && { style: { width } },
          children: availableAccents.map((accent) => {
            const swatch = accentColors[accent];
            return /* @__PURE__ */ jsxs(Option, { value: accent, text: optionLabel(accent), children: [
              swatch && /* @__PURE__ */ jsx(
                "span",
                {
                  className: styles.swatch,
                  style: { backgroundColor: swatch },
                  "aria-hidden": "true"
                }
              ),
              optionLabel(accent)
            ] }, accent);
          })
        }
      )
    }
  );
}
var DIRECTION_ORDER = [
  TextDirection.Ltr,
  TextDirection.Rtl
];
function ThemeTextDirection({
  readOnly,
  label,
  width
}) {
  const { textDirection, setTextDirection } = useTheme();
  const t = useT();
  const labelId = useId();
  const optionLabel = useCallback(
    (dir) => t(`app.components.theme-text-direction.direction.${dir}`),
    [t]
  );
  const handleOptionSelect = (_event, data) => {
    const next = data.optionValue;
    if (next === TextDirection.Ltr || next === TextDirection.Rtl) {
      setTextDirection(next);
    }
  };
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: "ppp-theme-text-direction",
      label: label ?? t("app.components.theme-text-direction.direction-label"),
      id: labelId,
      children: /* @__PURE__ */ jsx(
        Dropdown,
        {
          "aria-labelledby": labelId,
          value: optionLabel(textDirection),
          selectedOptions: [textDirection],
          onOptionSelect: handleOptionSelect,
          disabled: readOnly,
          ...width && { style: { width } },
          children: DIRECTION_ORDER.map((dir) => /* @__PURE__ */ jsx(Option, { value: dir, text: optionLabel(dir), children: optionLabel(dir) }, dir))
        }
      )
    }
  );
}
function resolveDisplayName2(locale, displayNative) {
  if (typeof Intl === "undefined" || typeof Intl.DisplayNames === "undefined") {
    return locale;
  }
  try {
    const native = new Intl.DisplayNames([locale], { type: "language" }).of(locale);
    if (!displayNative) {
      const english2 = new Intl.DisplayNames(["en"], { type: "language" }).of(locale);
      return english2 ?? locale;
    }
    const english = new Intl.DisplayNames(["en"], { type: "language" }).of(locale);
    if (!native) return english ?? locale;
    if (!english || english === native) return native;
    return `${native} (${english})`;
  } catch {
    return locale;
  }
}
function LanguageDropdown({
  supportedLocales,
  label,
  displayNativeLanguage = true,
  width,
  readOnly,
  persistToCookie = true
}) {
  const { locale, setLocale } = useLocale();
  const t = useT();
  const labelId = useId();
  const urlCultureStrategy = useUrlCultureStrategy();
  const defaultLocale = useDefaultLocale();
  const serverLocales = useSupportedLocales({ enabled: urlCultureStrategy !== void 0 });
  const discovered = useSupportedLocales({ enabled: supportedLocales === void 0 });
  const effectiveLocales = supportedLocales ?? (discovered.status === QueryStatus.Success ? discovered.data : null);
  const options = useMemo(() => {
    const list = effectiveLocales ? [...effectiveLocales] : [locale];
    if (!list.includes(locale)) list.push(locale);
    return list.map((value) => ({
      value,
      label: resolveDisplayName2(value, displayNativeLanguage)
    })).sort((a, b) => a.label.localeCompare(b.label));
  }, [effectiveLocales, locale, displayNativeLanguage]);
  const handleOptionSelect = useCallback(
    (_event, data) => {
      const next = data.optionValue;
      if (!next || next === locale) return;
      if (persistToCookie) setAspNetCultureCookie(next);
      if (urlCultureStrategy && urlCultureStrategy !== "CookieOnly" && defaultLocale && serverLocales.data && typeof window !== "undefined") {
        const path = buildLocalePath({
          strategy: urlCultureStrategy,
          locale: next,
          defaultLocale,
          pathname: window.location.pathname,
          supportedLocales: serverLocales.data
        });
        window.location.assign(`${path}${window.location.search}${window.location.hash}`);
        return;
      }
      setLocale(next);
    },
    [locale, setLocale, persistToCookie, urlCultureStrategy, defaultLocale, serverLocales.data]
  );
  const currentLabel = options.find((o) => o.value === locale)?.label ?? resolveDisplayName2(locale, displayNativeLanguage);
  return /* @__PURE__ */ jsx(
    Field,
    {
      className: mergeClasses("ppp-language-dropdown"),
      label: label ?? t("app.language-label"),
      id: labelId,
      children: /* @__PURE__ */ jsx(
        Dropdown,
        {
          "aria-labelledby": labelId,
          value: currentLabel,
          selectedOptions: [locale],
          onOptionSelect: handleOptionSelect,
          disabled: readOnly || options.length <= 1,
          ...width && { style: { width } },
          children: options.map((option) => /* @__PURE__ */ jsx(Option, { value: option.value, text: option.label, children: option.label }, option.value))
        }
      )
    }
  );
}
var useStyles7 = makeStyles({
  trigger: {
    backgroundColor: "transparent",
    border: "none",
    padding: 0,
    cursor: "pointer",
    borderRadius: "50%",
    // Keep the focus ring snug around the avatar without the
    // default Fluent button-style padding distorting the circular
    // hit-target.
    ":focus-visible": {
      outline: `2px solid ${tokens.colorStrokeFocus2}`,
      outlineOffset: "2px"
    }
  },
  popoverBody: {
    minWidth: "260px",
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalS,
    padding: tokens.spacingVerticalM
  },
  identity: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalM
  },
  identityText: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0
  },
  identityLabel: {
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase200
  },
  identityValue: {
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  actions: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalXS
  }
});
function ProfileMainMenu({
  accountUrl,
  accountLabel,
  headerSlot,
  footerSlot,
  anonymousContent,
  signInUrl = "/login"
}) {
  const auth = useAuth();
  const styles = useStyles7();
  const t = useT();
  const handleLogout = useCallback(async () => {
    try {
      await auth.logout();
    } catch {
    }
  }, [auth]);
  const handleSwitchIdentity = useCallback(async () => {
    try {
      const response = await auth.switchIdentity();
      if (response.result === SwitchIdentityResult.Switched) {
        window.location.reload();
      }
    } catch {
    }
  }, [auth]);
  if (auth.status === AuthStatus.Loading) {
    return /* @__PURE__ */ jsx(Avatar, { className: "ppp-profile-main-menu", size: 28, "aria-label": t("app.messages.record-loading") });
  }
  if (auth.status === AuthStatus.Anonymous) {
    if (anonymousContent !== void 0) return /* @__PURE__ */ jsx(Fragment, { children: anonymousContent });
    return /* @__PURE__ */ jsx(
      Button,
      {
        as: "a",
        href: signInUrl,
        appearance: "subtle",
        icon: /* @__PURE__ */ jsx(ArrowExit20Regular, {}),
        className: "ppp-profile-main-menu",
        children: t("app.buttons.login.label")
      }
    );
  }
  const email = auth.user.email ?? auth.user.userName ?? "";
  const initials = email.length > 0 ? email[0].toUpperCase() : "?";
  const resolvedAccountLabel = accountLabel ?? t("app.components.profile-main-menu.account");
  const signedInAsLabel = t("app.components.profile-main-menu.signed-in-as");
  const logoutLabel = t("app.buttons.logout.label");
  const altIdentityTableName = auth.user.altIdentityTableName;
  const switchIdentityLabel = altIdentityTableName ? t(
    "app.components.profile-main-menu.switch-to",
    [
      altIdentityTableName === "systemuser" ? t("app.components.profile-main-menu.alt-kind-systemuser") : t("app.components.profile-main-menu.alt-kind-contact")
    ]
  ) : null;
  return /* @__PURE__ */ jsxs(Menu, { children: [
    /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        className: mergeClasses("ppp-profile-main-menu", styles.trigger),
        "aria-label": email || logoutLabel,
        children: /* @__PURE__ */ jsx(Avatar, { size: 28, initials, name: email })
      }
    ) }),
    /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsxs("div", { className: styles.popoverBody, children: [
      headerSlot,
      /* @__PURE__ */ jsxs("div", { className: styles.identity, children: [
        /* @__PURE__ */ jsx(Avatar, { size: 40, initials, name: email }),
        /* @__PURE__ */ jsxs("div", { className: styles.identityText, children: [
          /* @__PURE__ */ jsx("span", { className: styles.identityLabel, children: signedInAsLabel }),
          /* @__PURE__ */ jsx("span", { className: styles.identityValue, title: email, children: email })
        ] })
      ] }),
      /* @__PURE__ */ jsx(Divider, {}),
      /* @__PURE__ */ jsxs(MenuList, { className: styles.actions, children: [
        accountUrl && /* @__PURE__ */ jsx(
          MenuItem,
          {
            icon: /* @__PURE__ */ jsx(PersonEdit20Regular, {}),
            onClick: () => {
              window.location.href = accountUrl;
            },
            children: resolvedAccountLabel
          }
        ),
        switchIdentityLabel && /* @__PURE__ */ jsx(
          MenuItem,
          {
            icon: /* @__PURE__ */ jsx(ArrowSwap20Regular, {}),
            onClick: handleSwitchIdentity,
            children: switchIdentityLabel
          }
        ),
        /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(SignOut20Regular, {}), onClick: handleLogout, children: logoutLabel })
      ] }),
      footerSlot && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Divider, {}),
        footerSlot
      ] })
    ] }) })
  ] });
}
var usePanelStyles = makeStyles({
  // Vertical stack of setting sections with consistent gap. Matches the
  // panel body the SiteSettingsButton's drawer renders, but extracted
  // so consumers can mount it elsewhere (a dedicated /settings page, a
  // tab inside profile-management, an embedded preferences card).
  body: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalL
  }
});
function SiteSettingsPanel({
  allowLanguageChange = true,
  allowThemeChange = true,
  allowColorChange = true,
  allowRightToLeftChange = false,
  supportedLocales,
  accentLabels,
  className,
  style
}) {
  const styles = usePanelStyles();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: mergeClasses("ppp-site-settings-panel", styles.body, className),
      style,
      children: [
        allowLanguageChange && /* @__PURE__ */ jsx(
          LanguageDropdown,
          {
            ...supportedLocales && { supportedLocales },
            width: "100%"
          }
        ),
        allowThemeChange && /* @__PURE__ */ jsx(ThemeSelector, { width: "100%" }),
        allowColorChange && /* @__PURE__ */ jsx(
          ThemeColorSelector,
          {
            width: "100%",
            ...accentLabels && { accentLabels }
          }
        ),
        allowRightToLeftChange && /* @__PURE__ */ jsx(ThemeTextDirection, { width: "100%" })
      ]
    }
  );
}
var useStyles8 = makeStyles({
  // Wraps the standalone panel inside the drawer body to add the small
  // top inset that the popover's title visually expects. The panel
  // itself stays inset-free so it doesn't carry extra padding when
  // mounted elsewhere (a dedicated /settings page, a tab in an account
  // dashboard).
  body: {
    paddingTop: tokens.spacingVerticalM
  }
});
function SiteSettingsButton({
  allowLanguageChange = true,
  allowThemeChange = true,
  allowColorChange = true,
  allowRightToLeftChange = false,
  supportedLocales,
  buttonAppearance = "subtle",
  accentLabels
}) {
  const t = useT();
  const styles = useStyles8();
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);
  const label = t("app.site-settings-label");
  const panelTitle = t("app.components.site-settings-panel.label");
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Tooltip, { content: label, relationship: "label", children: /* @__PURE__ */ jsx(
      Button,
      {
        type: "button",
        appearance: buttonAppearance,
        icon: /* @__PURE__ */ jsx(Settings20Regular, {}),
        "aria-label": label,
        onClick: () => setOpen(true),
        className: "ppp-site-settings-button"
      }
    ) }),
    /* @__PURE__ */ jsxs(
      OverlayDrawer,
      {
        position: "end",
        open,
        onOpenChange: (_, data) => setOpen(data.open),
        children: [
          /* @__PURE__ */ jsx(DrawerHeader, { children: /* @__PURE__ */ jsx(
            DrawerHeaderTitle,
            {
              action: /* @__PURE__ */ jsx(
                Button,
                {
                  appearance: "subtle",
                  "aria-label": t("app.buttons.cancel.label"),
                  icon: /* @__PURE__ */ jsx(Dismiss24Regular, {}),
                  onClick: close
                }
              ),
              children: panelTitle
            }
          ) }),
          /* @__PURE__ */ jsx(DrawerBody, { children: /* @__PURE__ */ jsx(
            SiteSettingsPanel,
            {
              className: styles.body,
              allowLanguageChange,
              allowThemeChange,
              allowColorChange,
              allowRightToLeftChange,
              ...supportedLocales && { supportedLocales },
              ...accentLabels && { accentLabels }
            }
          ) })
        ]
      }
    )
  ] });
}
function LogoutButton({
  label,
  icon,
  appearance = "subtle",
  disabled,
  onLoggedOut,
  onError,
  className
}) {
  const auth = useAuth();
  const t = useT();
  const resolvedLabel = label ?? t("app.buttons.logout.label");
  const resolvedIcon = icon === void 0 ? /* @__PURE__ */ jsx(SignOut20Regular, {}) : icon;
  const handleClick = useCallback(async () => {
    try {
      await auth.logout();
      if (onLoggedOut) await onLoggedOut();
    } catch (err) {
      if (onError) {
        await onError(err);
      }
    }
  }, [auth, onLoggedOut, onError]);
  return /* @__PURE__ */ jsx(
    Button,
    {
      type: "button",
      appearance,
      disabled: disabled === true,
      onClick: handleClick,
      ...resolvedIcon !== null && { icon: resolvedIcon },
      className: mergeClasses("ppp-logout-button", className),
      children: resolvedLabel
    }
  );
}
var useMenuBarStyles = makeStyles({
  // `overflow: hidden` + `min-width: 0` is what lets the Overflow primitive
  // measure correctly — without `min-width: 0`, the container's intrinsic
  // min-content (sum of children's min sizes) prevents it from being narrower
  // than its content in a flex-row parent, so overflow never triggers. With
  // it, the primitive can shrink the container and decide which items fit.
  // `column-gap` puts a consistent spacing between items without producing a
  // leading / trailing margin. Same shape as the existing `toolbarOverflow`
  // in `main-grid-styles.ts` (the other Overflow-based toolbar in this lib).
  // `min-height` is critical: the Overflow primitive observes the container
  // via ResizeObserver. With `overflow: hidden` and no `min-height`, a single
  // mis-step where the algorithm marks items as overflowing (briefly common
  // during initial mount as async refs/measurements settle) sets
  // `display: none` on every item via `[data-overflowing] { display: none }`,
  // which collapses the container's height to 0. That height delta re-fires
  // the ResizeObserver, the algorithm runs against a now-empty container,
  // and the visible/hidden state can oscillate before settling in the
  // "all hidden" state — leaving the bar empty in the DOM. Pinning the
  // height to a Fluent medium-button (~32px) breaks the feedback loop: the
  // container's height never changes when items toggle, the observer fires
  // only on real layout changes, and the algorithm settles correctly with
  // items visible.
  root: {
    display: "flex",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    minWidth: 0,
    minHeight: "32px",
    overflow: "hidden"
  },
  // Plain `<div>` wrapper around each child that gives `<OverflowItem>` a
  // guaranteed ref target. `<OverflowItem>` is a trigger-only component — it
  // clones its child and forwards a ref to it; the Overflow primitive uses
  // that ref to measure the item. Most of our context-action buttons
  // (SaveContextButton, RefreshContextButton, DeleteContextButton, …) are
  // plain function components that DON'T accept refs, so without this wrapper
  // the primitive can't measure them, treats them as not-fitting, and hides
  // everything. A `<div>` with `display: flex` (not `inline-flex` on a
  // `<span>` — the established `toolbarSlot` pattern in `main-grid-styles.ts`
  // uses div+flex and that's the proven shape) is a guaranteed measurement
  // surface and works for any consumer child regardless of whether it uses
  // forwardRef.
  itemSlot: {
    display: "flex",
    alignItems: "center"
  },
  // The popover stacks overflow items vertically
  // `<FluentStack Orientation="Vertical">` inside the `<FluentPopover>`.
  popoverItems: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalS,
    alignItems: "flex-start"
  }
});
function MenuBar({ children, className, style, overflowLabel }) {
  const styles = useMenuBarStyles();
  const items = Children.toArray(children).filter(isValidElement).map((element, idx) => ({
    id: `ppp-menubar-item-${idx}`,
    element
  }));
  return /* @__PURE__ */ jsx(Overflow, { children: /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-menu-bar", styles.root, className), style, children: [
    items.map(({ id, element }) => /* @__PURE__ */ jsx(OverflowItem, { id, children: /* @__PURE__ */ jsx("div", { className: styles.itemSlot, children: element }) }, id)),
    items.length > 0 && /* @__PURE__ */ jsx(OverflowPopover, { items, popoverItemsClass: styles.popoverItems, overflowLabel })
  ] }) });
}
function OverflowPopover({ items, popoverItemsClass, overflowLabel }) {
  const { ref, isOverflowing, overflowCount } = useOverflowMenu();
  if (!isOverflowing) return null;
  return /* @__PURE__ */ jsxs(Popover, { children: [
    /* @__PURE__ */ jsx(PopoverTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(
      Button,
      {
        ref,
        appearance: "subtle",
        icon: /* @__PURE__ */ jsx(MoreVerticalRegular, {}),
        "aria-label": overflowLabel ?? `${overflowCount} more items`
      }
    ) }),
    /* @__PURE__ */ jsx(PopoverSurface, { children: /* @__PURE__ */ jsx("div", { className: popoverItemsClass, children: items.map((item) => /* @__PURE__ */ jsx(OverflowPopoverItem, { ...item }, item.id)) }) })
  ] });
}
function OverflowPopoverItem({ id, element }) {
  const isVisible = useIsOverflowItemVisible(id);
  if (isVisible) return null;
  return element;
}
var useNavMenuStyles = makeStyles({
  // Width + border so the side rail sits next to the body in PageLayout's
  // navigation slot. Width default
  // Background is intentionally NOT set here — `PageLayout`'s
  // `navigation` grid-area paints the rail's background so the colour
  // covers the entire vertical extent of the side band regardless of
  // how short the actual nav content is. Painting it on the `<Nav>`
  // element instead left a hard horizontal edge mid-page in dark mode
  // (the painted region ended where the last `<NavItem>` ended, with
  // a different lighter colour bleeding through below).
  nav: {
    minWidth: "250px",
    maxWidth: "320px",
    height: "100%",
    borderRight: `1px solid ${tokens.colorNeutralStroke2}`,
    // Paint the rail directly on `<Nav>` so the full vertical extent
    // of the side band is uniform. `colorNeutralBackground4` matches the
    // background tone Fluent's `<NavSubItem>` ships with — the rail's
    // empty area and its items now share one continuous surface
    // instead of showing a horizontal seam between Fluent's default
    // outer-Nav background and the inner-item background.
    backgroundColor: tokens.colorNeutralBackground4
  },
  // Inline icon for sub-items. Fluent UI 9's <NavSubItem> doesn't have a
  // dedicated `icon` slot (sub-items are text-only in the Fluent design
  // language), so we render the icon as a leading inline-flex span inside
  // the link's content. Width is fixed so labels still align vertically
  // across rows whether their icon is present or not.
  subItemIcon: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    // Accent-coloured icons. Fluent icons fill with currentColor, so
    // coloring the wrapper tints the glyph.
    color: tokens.colorBrandForeground1,
    // Size the <svg> directly. Fluent's icon components set their own font-size, so a
    // font-size on this wrapper span never reaches them — only sizing the SVG actually
    // enlarges the glyph. No marginRight: the row's flex gap on .ppp-nav-item is the
    // only icon-to-label spacing.
    "& svg": {
      width: "20px",
      height: "20px",
      fontSize: "20px"
    }
  }
});
var useNavMenuDarkSurfaceStyles = makeStaticStyles({
  "body.ppp-theme-dark .ppp-nav-menu": {
    "--colorNeutralBackground4": "var(--colorNeutralBackground2)",
    "--colorNeutralBackground4Hover": "var(--colorNeutralBackground2Hover)",
    "--colorNeutralBackground4Pressed": "var(--colorNeutralBackground2Pressed)"
  }
});
var useNavSelectedStyles = makeStaticStyles({
  // Every nav item gets a stacking context so the highlight pseudo (z-index:-1)
  // paints behind the label yet stays contained to the item (not behind the rail).
  // Both pseudo-elements are defined on every item at opacity 0 and fade to 1 on
  // the active one, so selecting/deselecting a route eases the highlight + marker
  // in and out instead of popping.
  // Category header label matches the nav items (primary foreground / white in dark),
  // not Fluent's secondary grey. Colouring the root sets the label (and the expand
  // chevron, which inherits); the icon slot below keeps its own accent colour.
  ".ppp-nav-menu .fui-NavCategoryItem": {
    color: "var(--colorNeutralForeground1)",
    // Fluent's item reset top-aligns the row (alignItems: flex-start), which floats the
    // icon above the text baseline. Center it so the glyph sits level with the label.
    alignItems: "center"
  },
  // Parent (category) header icons. Fluent's icon slot sets no font-size, so the
  // resizable category icons render at the inherited text size (~14px) and look tiny.
  // Size the <svg> directly to match the sub-item icons; bump the slot's min box so the
  // larger glyph isn't clipped by its overflow:hidden.
  ".ppp-nav-menu .fui-NavCategoryItem__icon": {
    minWidth: "20px",
    minHeight: "20px",
    // Accent-tint the category icons to match the sub-item icons (Fluent icons fill
    // with currentColor, so colouring the slot tints the glyph).
    color: "var(--colorBrandForeground1)"
  },
  ".ppp-nav-menu .fui-NavCategoryItem__icon svg": {
    width: "20px",
    height: "20px",
    fontSize: "20px"
  },
  ".ppp-nav-menu .ppp-nav-item": {
    position: "relative",
    zIndex: 0,
    // Center icon with the label vertically (Fluent's reset top-aligns via flex-start).
    alignItems: "center",
    // Nav item label uses the primary foreground (white in dark mode) instead of
    // Fluent's secondary grey. The icon keeps its own brand colour (set on the icon
    // span, which wins for the glyph). Theme-aware: dark text in light mode.
    color: "var(--colorNeutralForeground1)",
    // Tighten the row. Fluent defaults to a wide icon-to-label flex gap
    // (spacingVerticalL ~16px) plus the icon's own margin and a deep 46px sub-item
    // indent, which reads as too spread out. Pull the label in (8px gap), trim the
    // vertical padding so items sit closer together, and reduce the indent.
    gap: "var(--spacingHorizontalM)",
    // +1px over spacingVerticalS on each side: grows the row pitch by 2px AND, because
    // the highlight pill insets a fixed 2px from the row edges, grows the pill height
    // by 2px to match.
    paddingTop: "calc(var(--spacingVerticalS) + 1px)",
    paddingBottom: "calc(var(--spacingVerticalS) + 1px)",
    paddingInlineStart: "32px"
  },
  // Neutralize Fluent's full-bleed hover background on the row (it paints
  // `colorNeutralBackground4Hover` edge-to-edge on the <a>). Keeping the item at the
  // rail colour on hover means only our inset, rounded highlight (::before) shows
  // same geometry as the selected state, not an edge-to-edge shade.
  ".ppp-nav-menu .ppp-nav-item:hover": {
    backgroundColor: "var(--colorNeutralBackground4)"
  },
  // Row highlight: an inset, rounded rectangle behind the label. `::before` (Fluent
  // uses `::after` for its indicator, never `::before`, so no collision). Inset on
  // all sides + rounded corners give the padded "pill". Hover and selected use the
  // SAME shade — the marker is what distinguishes the active route.
  // Tracks the dark-surface remap above. z-index:-1 (contained by the
  // item's z-index:0 context) keeps it behind the label.
  ".ppp-nav-menu .ppp-nav-item::before": {
    content: '""',
    position: "absolute",
    top: "2px",
    bottom: "2px",
    insetInlineStart: "3px",
    insetInlineEnd: "3px",
    margin: 0,
    borderRadius: "var(--borderRadiusMedium)",
    backgroundColor: "var(--colorNeutralBackground4Hover)",
    zIndex: -1,
    opacity: 0,
    transition: "opacity 0.2s ease-in-out"
  },
  // Themed accent marker: short rounded bar a couple of px in from the rail's
  // inline-start edge (left in LTR, right in RTL), inset top+bottom so it clears the
  // highlight's rounded corners. Reuses Fluent's indicator slot (`::after`) but
  // re-anchors it (`margin:0` kills Fluent's negative offset) and drives the fade
  // ourselves via opacity (`animationName:none` disables Fluent's own background
  // keyframe so our brand colour + fade win).
  ".ppp-nav-menu .ppp-nav-item::after": {
    content: '""',
    position: "absolute",
    insetInlineStart: "6px",
    insetInlineEnd: "auto",
    top: "10px",
    bottom: "10px",
    width: "3px",
    height: "auto",
    margin: 0,
    animationName: "none",
    borderRadius: "var(--borderRadiusCircular)",
    backgroundColor: "var(--colorBrandStroke1)",
    opacity: 0,
    transition: "opacity 0.2s ease-in-out"
  },
  // Hover fades the highlight in (lighter Hover shade from the base ::before); the
  // marker (::after) stays hidden since hover isn't the active route.
  ".ppp-nav-menu .ppp-nav-item:hover::before": {
    opacity: 1
  },
  // Selected shows the same highlight as hover, plus the accent marker (::after).
  '.ppp-nav-menu .ppp-nav-item[aria-current="page"]::before': {
    opacity: 1
  },
  '.ppp-nav-menu .ppp-nav-item[aria-current="page"]::after': {
    opacity: 1
  }
});
function NavMenu({ children, width, className, style }) {
  const styles = useNavMenuStyles();
  useNavMenuDarkSurfaceStyles();
  useNavSelectedStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const { allRoutes, defaultOpen } = useMemo(
    () => collectNavTree(children),
    [children]
  );
  const selectedValue = useMemo(
    () => bestRouteMatch(allRoutes, location.pathname),
    [allRoutes, location.pathname]
  );
  const handleSelect = (_, data) => {
    const value = data.value;
    if (typeof value === "string" && value.startsWith("/")) {
      navigate(value);
    }
  };
  const navStyle = width ? { ...style, minWidth: width, maxWidth: width } : style;
  return /* @__PURE__ */ jsx(
    Nav,
    {
      selectedValue: selectedValue ?? "",
      onNavItemSelect: handleSelect,
      defaultOpenCategories: defaultOpen,
      className: mergeClasses("ppp-nav-menu", styles.nav, className),
      style: navStyle,
      children
    }
  );
}
function NavGroup({ label, icon, value, children }) {
  const groupValue = value ?? `group:${label}`;
  return /* @__PURE__ */ jsxs(NavCategory, { value: groupValue, children: [
    icon !== void 0 ? /* @__PURE__ */ jsx(NavCategoryItem, { icon, children: label }) : /* @__PURE__ */ jsx(NavCategoryItem, { children: label }),
    /* @__PURE__ */ jsx(NavSubItemGroup, { children })
  ] });
}
function NavItem({ to, icon, children }) {
  const styles = useNavMenuStyles();
  const navigate = useNavigate();
  const handleClick = (e) => {
    if (e.defaultPrevented) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    navigate(to);
  };
  return /* @__PURE__ */ jsxs(NavSubItem, { as: "a", value: to, href: to, onClick: handleClick, className: "ppp-nav-item", children: [
    icon !== void 0 && /* @__PURE__ */ jsx("span", { className: styles.subItemIcon, children: icon }),
    children
  ] });
}
function collectNavTree(children) {
  const allRoutes = [];
  const defaultOpen = [];
  const visit = (nodes) => {
    Children.forEach(nodes, (child) => {
      if (!isValidElement(child)) return;
      if (child.type === NavGroup) {
        const props = child.props;
        const value = props.value ?? `group:${props.label}`;
        if (props.defaultExpanded) defaultOpen.push(value);
        visit(props.children);
        return;
      }
      if (child.type === NavItem) {
        const props = child.props;
        allRoutes.push({
          to: props.to,
          match: props.match ?? (props.to === "/" ? "exact" : "prefix")
        });
        return;
      }
      const wrapperChildren = child.props.children;
      if (wrapperChildren !== void 0) visit(wrapperChildren);
    });
  };
  visit(children);
  return { allRoutes, defaultOpen };
}
function bestRouteMatch(routes, pathname) {
  const normalize = (p) => p.length > 1 && p.endsWith("/") ? p.slice(0, -1) : p;
  const target = normalize(pathname);
  let best;
  let bestLen = -1;
  for (const { to, match } of routes) {
    const route = normalize(to);
    const matches = route === target || match === "prefix" && (route === "/" || target.startsWith(route + "/"));
    if (matches && route.length > bestLen) {
      best = to;
      bestLen = route.length;
    }
  }
  return best;
}
var useStyles9 = makeStyles({
  // Shared scrim look. Both global (full-screen) and scoped variants reuse
  // these so the visual feel is identical — only the positioning differs.
  // Theme-aware translucent backdrop drawn via a `::before` pseudo-element
  // so the spinner + description above stay at full opacity (the same
  // pattern the grid's refetch scrim uses). `colorNeutralBackground2` matches
  // token and swaps with FluentDesignTheme's
  // light/dark state — light gray in light theme, near-black in dark
  // theme — so the overlay reads as a soft neutral tint instead of a
  // hardcoded black film over whatever's behind. `pointerEvents: 'auto'`
  // blocks accidental clicks on the dimmed content underneath.
  scrim: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    rowGap: tokens.spacingVerticalM,
    pointerEvents: "auto",
    "::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      backgroundColor: tokens.colorNeutralBackground2,
      opacity: 0.7,
      zIndex: -1
    }
  },
  global: {
    position: "fixed",
    inset: 0,
    // Above Fluent's Dialog backdrop (which sits ~1000) so the
    // overlay covers any open dialog when both happen simultaneously
    // (rare, but a save triggered from a dialog would land here).
    zIndex: 2e3
  },
  scoped: {
    position: "absolute",
    inset: 0,
    // Below the global overlay so a global save during a scoped load
    // visually layers on top.
    zIndex: 100
  },
  description: {
    // Foreground reads against `colorNeutralBackground2`, NOT a brand-
    // colored backdrop — so use the standard neutral foreground token
    // (was `colorNeutralForegroundOnBrand`, which is the white-on-blue
    // pairing that mismatched the new neutral scrim).
    color: tokens.colorNeutralForeground1,
    fontWeight: tokens.fontWeightSemibold
  },
  scopedHost: {
    position: "relative"
  }
});
function FluentOverlayProvider({ children }) {
  const ctxValue = useOverlayServiceState();
  return /* @__PURE__ */ jsxs(OverlayServiceProvider, { value: ctxValue, children: [
    children,
    /* @__PURE__ */ jsx(GlobalOverlayLayer, {})
  ] });
}
function GlobalOverlayLayer() {
  const styles = useStyles9();
  const overlay = useOverlayForTarget(void 0);
  if (!overlay) return null;
  return /* @__PURE__ */ jsx(ScrimContent, { overlay, className: mergeClasses(styles.scrim, styles.global) });
}
function FluentOverlayTarget({
  targetId,
  children,
  className,
  style
}) {
  const styles = useStyles9();
  const overlay = useOverlayForTarget(targetId);
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-overlay-target", styles.scopedHost, className), style, children: [
    children,
    overlay && /* @__PURE__ */ jsx(ScrimContent, { overlay, className: mergeClasses(styles.scrim, styles.scoped) })
  ] });
}
function ScrimContent({ overlay, className }) {
  const styles = useStyles9();
  const showProgress = overlay.showProgress !== false;
  return /* @__PURE__ */ jsxs("div", { className, role: "status", "aria-live": "polite", children: [
    showProgress && /* @__PURE__ */ jsx(Spinner, { size: "large" }),
    overlay.description && /* @__PURE__ */ jsx("span", { className: styles.description, children: overlay.description })
  ] });
}
var useStyles10 = makeStyles({
  // Centered placeholder used while prefixes are being fetched. Same
  // shape as the spinner blocks in `<NewRecordGridButton>` /
  // `<OpenRecordGridButton>` dialogs (~160px min height + vertical
  // centering) so a boundary swap doesn't pop the surrounding layout
  // around. Consumers wanting a tighter / inline fallback can pass
  // their own `fallback` prop.
  fallback: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "160px",
    rowGap: tokens.spacingVerticalM
  }
});
function LocalizationBoundary({
  prefixes,
  fallback,
  children
}) {
  const styles = useStyles10();
  const resolvedPrefixes = prefixes ?? EMPTY_PREFIXES;
  const { locale } = useLocale();
  useLocalization(resolvedPrefixes);
  const isLoaded = useLocalizationLoaded(resolvedPrefixes);
  const [ready, setReady] = useState(false);
  const lastLocaleRef = useRef(locale);
  useEffect(() => {
    if (locale !== lastLocaleRef.current) {
      lastLocaleRef.current = locale;
      setReady(false);
      return;
    }
    if (isLoaded && !ready) {
      setReady(true);
    }
  }, [isLoaded, locale, ready]);
  if (ready) return /* @__PURE__ */ jsx(Fragment, { children });
  if (fallback !== void 0) return /* @__PURE__ */ jsx(Fragment, { children: fallback });
  return /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-localization-boundary", styles.fallback), role: "status", "aria-live": "polite", children: /* @__PURE__ */ jsx(Spinner, { size: "medium" }) });
}
var EMPTY_PREFIXES = Object.freeze([]);
var useStyles11 = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalL,
    maxWidth: "760px"
  },
  targets: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalXS
  },
  resultRow: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalM,
    flexWrap: "wrap"
  },
  cultureCell: { minWidth: "80px" },
  muted: { color: tokens.colorNeutralForeground2 }
});
function readFileAsBase642(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = String(reader.result);
      const comma = result.indexOf(",");
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}
function downloadBase64(fileName, base64, contentType) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  const url = URL.createObjectURL(new Blob([bytes], { type: contentType }));
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  URL.revokeObjectURL(url);
}
function detectSourceLanguage(fileName) {
  const withoutExt = fileName.replace(/\.[^.]+$/, "");
  const parts = withoutExt.split(".");
  const candidate = parts.length >= 2 ? parts[parts.length - 1] : void 0;
  if (candidate === void 0) return void 0;
  const language = candidate.split("-")[0] ?? "";
  return /^[a-zA-Z]{2,3}$/.test(language) ? candidate : void 0;
}
function isSameLanguage(a, b) {
  const primary = (code) => code.trim().split("-")[0]?.toLowerCase() ?? "";
  const primaryA = primary(a);
  return primaryA.length > 0 && primaryA === primary(b);
}
function LocalizationTranslator({ className }) {
  const styles = useStyles11();
  const t = useT();
  const { ppp } = usePowerPortalsPro();
  const [availability, setAvailability] = useState(null);
  const [availabilityError, setAvailabilityError] = useState();
  const [fileName, setFileName] = useState();
  const [fileBase64, setFileBase64] = useState();
  const [sourceLanguage, setSourceLanguage] = useState("");
  const [selectedTargets, setSelectedTargets] = useState([]);
  const [isDragOver, setIsDragOver] = useState(false);
  const [isTranslating, setIsTranslating] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState();
  const inputRef = useRef(null);
  useEffect(() => {
    let cancelled = false;
    ppp.getTranslationAvailabilityAsync().then((value) => {
      if (!cancelled) setAvailability(value);
    }).catch((reason) => {
      if (!cancelled) setAvailabilityError(reason instanceof Error ? reason.message : String(reason));
    });
    return () => {
      cancelled = true;
    };
  }, [ppp]);
  const onFile = useCallback(async (file) => {
    const base64 = await readFileAsBase642(file);
    setFileName(file.name);
    setFileBase64(base64);
    setResult(null);
    const detected = detectSourceLanguage(file.name);
    if (detected) setSourceLanguage(detected);
  }, []);
  const onInputChange = useCallback(
    (ev) => {
      const file = ev.target.files?.[0];
      if (file) void onFile(file);
      ev.target.value = "";
    },
    [onFile]
  );
  const toggleTarget = useCallback((cultureCode, checked) => {
    setSelectedTargets(
      (prev) => checked ? [...prev, cultureCode] : prev.filter((code) => code !== cultureCode)
    );
  }, []);
  useEffect(() => {
    setSelectedTargets((prev) => {
      const filtered = prev.filter((code) => !isSameLanguage(code, sourceLanguage));
      return filtered.length === prev.length ? prev : filtered;
    });
  }, [sourceLanguage]);
  const canTranslate = !!fileBase64 && selectedTargets.length > 0 && sourceLanguage.trim().length > 0 && !isTranslating;
  const onTranslate = useCallback(async () => {
    if (!fileBase64 || !fileName) return;
    setIsTranslating(true);
    setResult(null);
    setError(void 0);
    try {
      const value = await ppp.translateLocalizationFileAsync({
        sourceLanguage: sourceLanguage.trim(),
        targetCultureCodes: [...selectedTargets],
        fileName,
        sourceContent: fileBase64
      });
      setResult(value);
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : String(reason));
    } finally {
      setIsTranslating(false);
    }
  }, [ppp, fileBase64, fileName, sourceLanguage, selectedTargets]);
  let content;
  if (availabilityError !== void 0) {
    content = /* @__PURE__ */ jsx(MessageBar, { intent: "error", children: /* @__PURE__ */ jsx(MessageBarBody, { children: t("app.localization-admin.load-failed", [availabilityError]) }) });
  } else if (!availability) {
    content = /* @__PURE__ */ jsx(Spinner, {});
  } else if (!availability.isConfigured) {
    content = null;
  } else if (!availability.isSolutionInstalled) {
    content = /* @__PURE__ */ jsx(MessageBar, { intent: "info", children: /* @__PURE__ */ jsx(MessageBarBody, { children: /* @__PURE__ */ jsx(
      "span",
      {
        dangerouslySetInnerHTML: {
          __html: t("app.localization-admin.translate-solution-missing")
        }
      }
    ) }) });
  } else {
    const dropZoneStyle = {
      border: `1px dashed ${isDragOver ? tokens.colorBrandStroke1 : tokens.colorNeutralStroke1}`,
      borderRadius: tokens.borderRadiusMedium,
      padding: tokens.spacingVerticalXL,
      textAlign: "center",
      cursor: "pointer",
      backgroundColor: isDragOver ? tokens.colorNeutralBackground1Hover : void 0
    };
    content = /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Title3, { children: t("app.localization-admin.translate-title") }),
      /* @__PURE__ */ jsx(Text, { children: t("app.localization-admin.translate-description") }),
      /* @__PURE__ */ jsxs(
        "div",
        {
          style: dropZoneStyle,
          role: "button",
          tabIndex: 0,
          onClick: () => inputRef.current?.click(),
          onKeyDown: (ev) => {
            if (ev.key === "Enter" || ev.key === " ") {
              ev.preventDefault();
              inputRef.current?.click();
            }
          },
          onDragOver: (ev) => {
            ev.preventDefault();
            setIsDragOver(true);
          },
          onDragLeave: () => setIsDragOver(false),
          onDrop: (ev) => {
            ev.preventDefault();
            setIsDragOver(false);
            const file = ev.dataTransfer.files?.[0];
            if (file) void onFile(file);
          },
          children: [
            /* @__PURE__ */ jsx("input", { ref: inputRef, type: "file", accept: ".json,.js", hidden: true, onChange: onInputChange }),
            /* @__PURE__ */ jsx(Text, { children: fileName ?? t("app.localization-admin.translate-upload-prompt") })
          ]
        }
      ),
      /* @__PURE__ */ jsx(
        Field,
        {
          label: t("app.localization-admin.translate-source-language"),
          hint: t("app.localization-admin.translate-source-language-hint"),
          children: /* @__PURE__ */ jsx(Input, { value: sourceLanguage, onChange: (_, data) => setSourceLanguage(data.value) })
        }
      ),
      /* @__PURE__ */ jsx(
        Field,
        {
          label: t("app.localization-admin.translate-target-languages"),
          hint: t("app.localization-admin.translate-target-languages-hint"),
          children: /* @__PURE__ */ jsx("div", { className: styles.targets, children: availability.targetLanguages.map((language) => {
            const isSource = isSameLanguage(language.cultureCode, sourceLanguage);
            return /* @__PURE__ */ jsx(
              Checkbox,
              {
                label: language.isSupportedByProvider ? language.displayName : `${language.displayName} ${t("app.localization-admin.translate-unsupported-suffix")}`,
                checked: selectedTargets.includes(language.cultureCode),
                disabled: !language.isSupportedByProvider || isSource,
                onChange: (_, data) => toggleTarget(language.cultureCode, data.checked === true)
              },
              language.cultureCode
            );
          }) })
        }
      ),
      /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Button, { appearance: "primary", disabled: !canTranslate, onClick: () => void onTranslate(), children: isTranslating ? t("app.localization-admin.translating") : t("app.localization-admin.translate-button") }) }),
      error !== void 0 && /* @__PURE__ */ jsx(MessageBar, { intent: "error", children: /* @__PURE__ */ jsx(MessageBarBody, { children: t("app.localization-admin.translate-failed", [error]) }) }),
      result && /* @__PURE__ */ jsxs("div", { className: styles.root, children: [
        result.files.map((file) => /* @__PURE__ */ jsxs("div", { className: styles.resultRow, children: [
          /* @__PURE__ */ jsx(Text, { weight: "semibold", className: styles.cultureCell, children: file.targetCultureCode }),
          /* @__PURE__ */ jsx(Text, { className: styles.muted, children: t("app.localization-admin.translate-summary", [file.translatedCount, file.reusedCount]) }),
          /* @__PURE__ */ jsx(
            Button,
            {
              size: "small",
              onClick: () => downloadBase64(file.fileName, file.content, "application/json"),
              children: file.fileName
            }
          )
        ] }, file.targetCultureCode)),
        /* @__PURE__ */ jsxs("div", { className: styles.resultRow, children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              appearance: "primary",
              onClick: () => downloadBase64(result.zipFileName, result.zipContent, "application/zip"),
              children: t("app.localization-admin.translate-download-all")
            }
          ),
          /* @__PURE__ */ jsx(Text, { className: styles.muted, children: t("app.localization-admin.translate-summary", [result.totalTranslated, result.totalReused]) })
        ] })
      ] })
    ] });
  }
  return /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-localization-translator", styles.root, className), children: content });
}
var PPP_HEADER_CLASS = "ppp-header";
var useHeaderStyles = makeStyles({
  // Single source of truth for the framework's header-band visual
  // treatment. Mirrors token-for-token
  // any change here propagates automatically to every consumer
  // (`<Section>` header bands, future `<MainGrid>` toolbars, future
  // `<MenuBar>` headers, standalone consumer usage). The mapping from
  // calibrated for visual parity:
  // --neutral-layer-4 → tokens.colorNeutralBackground5
  // --neutral-stroke-rest → tokens.colorNeutralStroke1
  // --control-corner-radius → tokens.borderRadiusMedium
  // 2*--design-unit (8px) → tokens.spacingVerticalS
  // 3*--design-unit (12px) → tokens.spacingHorizontalM
  // Corners are rounded unconditionally. The rounding is invisible
  // without a parent border to align against, so unbordered consumers
  // (e.g. an unbordered `<Section>`) pay nothing visually. Bordered
  // consumers get the flush-against-border-radius look.
  root: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    backgroundColor: tokens.colorNeutralBackground5,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderTopLeftRadius: tokens.borderRadiusMedium,
    borderTopRightRadius: tokens.borderRadiusMedium,
    // h-tag margin reset —.
    // Lets consumers write `<Header><h2>Title</h2></Header>` without
    // browser-default heading margins pushing the title off-center.
    "& h1, & h2, & h3, & h4, & h5, & h6": { margin: 0 }
  }
});
function Header({ children, className, style, ...rest }) {
  const styles = useHeaderStyles();
  return /* @__PURE__ */ jsx(
    "header",
    {
      ...rest,
      className: mergeClasses(styles.root, PPP_HEADER_CLASS, className),
      style,
      children
    }
  );
}
var SectionColumnOrientation = {
  Vertical: "vertical",
  Horizontal: "horizontal"
};
var useSectionStyles = makeStyles({
  section: {
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    boxSizing: "border-box"
  },
  // Optional outer border, applied to <Section> when `borderVisible` is on.
  sectionBorder: {
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    width: "100%"
  },
  // (Header / Footer band chrome moved to `layout/header.tsx` and
  // `layout/footer.tsx` as the framework-wide source of truth. Section
  // composes with `<Header>` / `<Footer>` so a CSS change there
  // propagates here without per-component edits.)
  // The flex row that wraps the columns. Wraps to a new line when there
  // isn't enough horizontal space for the columns' min-widths. Gap is a
  // literal 15px — no Fluent token equals 15px.
  body: {
    display: "flex",
    flexDirection: "row",
    columnGap: "15px",
    rowGap: "15px",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    flexWrap: "wrap"
  },
  bodyBorderedSection: {
    padding: "0 1rem"
  },
  // A single column. Default flex weight 3.4 — single-Section columns
  // get the full content width.
  column: {
    flex: "3.4 1 0%",
    display: "block",
    boxSizing: "border-box",
    backgroundColor: tokens.colorNeutralBackground1
  },
  columnBorder: {
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    width: "100%"
  },
  // Combined-state margins between the column and the section's own
  // header / border / footer.
  columnMarginTop: { marginTop: "1rem" },
  columnMarginBottom: { marginBottom: "1rem" },
  columnContent: {
    width: "100%",
    padding: "1rem"
  },
  // Inner flex container for the column's children. Vertical (column)
  // stacking is the default for forms; horizontal is the alternate for
  // toolbars or filter rows.
  columnContentStack: {
    display: "flex",
    width: "100%",
    flexWrap: "wrap"
  }
});
function SectionColumn(_props) {
  return null;
}
function Section({
  children,
  header,
  footer,
  headerText,
  footerText,
  borderVisible = false,
  columnCount,
  columnMinWidth = "340px",
  className,
  style,
  childContentClassName,
  childContentStyle,
  headerClassName,
  headerStyle,
  footerClassName,
  footerStyle,
  id
}) {
  const styles = useSectionStyles();
  if (columnCount !== void 0 && (columnCount < 1 || columnCount > 4)) {
    throw new Error(
      `Section: 'columnCount' must be between 1 and 4 inclusive (got ${columnCount}).`
    );
  }
  const columns = [];
  Children.forEach(children, (child) => {
    if (isValidElement(child) && child.type === SectionColumn) {
      columns.push(child.props);
    }
  });
  const effectiveCount = columnCount ?? columns.length;
  const headerNode = resolveHeaderSlot(header, headerText);
  const footerNode = resolveFooterSlot(footer, footerText);
  const hasHeader = headerNode !== void 0;
  const hasFooter = footerNode !== void 0;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      id,
      className: mergeClasses(
        "ppp-section",
        styles.section,
        borderVisible && styles.sectionBorder,
        className
      ),
      style,
      children: [
        hasHeader && /* @__PURE__ */ jsx(
          Header,
          {
            ...headerClassName !== void 0 && { className: headerClassName },
            ...headerStyle !== void 0 && { style: headerStyle },
            children: headerNode
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: mergeClasses(
              "ppp-section-body",
              styles.body,
              borderVisible && styles.bodyBorderedSection,
              childContentClassName
            ),
            style: childContentStyle,
            children: Array.from({ length: effectiveCount }).map((_, i) => {
              const col = columns[i];
              if (!col) {
                return /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: mergeClasses("ppp-section-column", styles.column),
                    style: { minWidth: columnMinWidth }
                  },
                  `__empty_${i}`
                );
              }
              return /* @__PURE__ */ jsx(
                SectionColumnRenderer,
                {
                  column: col,
                  columnMinWidth,
                  sectionHasHeader: hasHeader,
                  sectionHasFooter: hasFooter,
                  sectionHasBorder: borderVisible
                },
                i
              );
            })
          }
        ),
        hasFooter && /* @__PURE__ */ jsx(
          Footer,
          {
            ...footerClassName !== void 0 && { className: footerClassName },
            ...footerStyle !== void 0 && { style: footerStyle },
            children: footerNode
          }
        )
      ]
    }
  );
}
function resolveHeaderSlot(node, text) {
  if (node !== void 0) return node;
  if (text !== void 0 && text.trim() !== "") return /* @__PURE__ */ jsx("h5", { children: text });
  return void 0;
}
function resolveFooterSlot(node, text) {
  if (node !== void 0) return node;
  if (text !== void 0 && text.trim() !== "") return text;
  return void 0;
}
function SectionColumnRenderer({
  column,
  columnMinWidth,
  sectionHasHeader,
  sectionHasFooter,
  sectionHasBorder
}) {
  const styles = useSectionStyles();
  const {
    children,
    header,
    footer,
    headerText,
    footerText,
    borderVisible = true,
    columnContentOrientation = SectionColumnOrientation.Vertical,
    horizontalGap = 10,
    verticalGap = 10,
    width,
    className,
    style
  } = column;
  const headerNode = resolveHeaderSlot(header, headerText);
  const footerNode = resolveFooterSlot(footer, footerText);
  const hasColumnHeader = headerNode !== void 0;
  const wantsMarginTop = sectionHasHeader && hasColumnHeader || sectionHasHeader && borderVisible || sectionHasBorder && borderVisible;
  const wantsMarginBottom = sectionHasFooter && borderVisible || sectionHasBorder && borderVisible;
  const flexStyle = {
    minWidth: columnMinWidth,
    ...width !== void 0 ? { flex: `${width} 1 0%` } : {},
    ...style
  };
  const stackStyle = {
    columnGap: `${verticalGap}px`,
    rowGap: `${horizontalGap}px`,
    flexDirection: columnContentOrientation === SectionColumnOrientation.Horizontal ? "row" : "column"
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: mergeClasses(
        "ppp-section-column",
        styles.column,
        borderVisible && styles.columnBorder,
        wantsMarginTop && styles.columnMarginTop,
        wantsMarginBottom && styles.columnMarginBottom,
        className
      ),
      style: flexStyle,
      children: [
        hasColumnHeader && /* @__PURE__ */ jsx(Header, { children: headerNode }),
        /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-section-column-content", styles.columnContent), children: /* @__PURE__ */ jsx(
          "div",
          {
            className: mergeClasses(
              "ppp-section-column-content-stack",
              styles.columnContentStack
            ),
            style: stackStyle,
            children
          }
        ) }),
        footerNode !== void 0 && /* @__PURE__ */ jsx(Footer, { children: footerNode })
      ]
    }
  );
}
var useStyles12 = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalL
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalM,
    flexWrap: "wrap"
  },
  lastReloaded: {
    opacity: 0.7,
    fontSize: tokens.fontSizeBase200
  },
  configList: {
    display: "grid",
    gridTemplateColumns: "max-content 1fr",
    columnGap: tokens.spacingHorizontalL,
    rowGap: tokens.spacingVerticalXS,
    margin: 0
  },
  configTerm: {
    margin: 0,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground2
  },
  configValue: { margin: 0 },
  // Horizontal scroll viewport so widening any column past the panel width
  // scrolls instead of clipping — mirrors the Blazor grid-scroll wrapper.
  gridScroll: { overflowX: "auto", width: "100%" },
  numericCell: { textAlign: "right", fontVariantNumeric: "tabular-nums" },
  // The '#' (load order) column only ever holds a 1–2 digit number — keep it narrow.
  orderCell: {
    width: "35px",
    minWidth: "35px",
    maxWidth: "35px",
    textAlign: "right",
    fontVariantNumeric: "tabular-nums"
  },
  // 'Source' values are often long absolute file paths / web-resource names with no
  // spaces — cap the width and let them wrap (break mid-token) instead of overflowing.
  sourceCell: {
    width: "320px",
    maxWidth: "320px",
    whiteSpace: "normal",
    overflowWrap: "anywhere",
    wordBreak: "break-word"
  },
  overriding: { color: "var(--accent-foreground-rest, var(--accent-fill-rest))" },
  failed: { color: tokens.colorPaletteRedForeground1 },
  skipped: { opacity: 0.6 },
  downloadCell: {
    display: "flex",
    flexWrap: "wrap",
    gap: tokens.spacingHorizontalXS
  },
  mergedButtons: {
    display: "flex",
    flexWrap: "wrap",
    gap: tokens.spacingHorizontalS
  },
  sectionBody: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalS,
    width: "100%"
  }
});
var KIND_KEY = { 0: "tablemetadata", 1: "webresource", 2: "folderfile" };
var STATUS_KEY = { 0: "loaded", 1: "failed", 2: "skipped" };
var toNumber = (value) => Number(value);
function downloadBytes(fileName, data, contentType = "application/json") {
  const url = URL.createObjectURL(new Blob([new Uint8Array(data)], { type: contentType }));
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  URL.revokeObjectURL(url);
}
function LocalizationAdmin({ className }) {
  const styles = useStyles12();
  const t = useT();
  const { ppp } = usePowerPortalsPro();
  const [overview, setOverview] = useState(null);
  const [loadError, setLoadError] = useState();
  const [isReloading, setIsReloading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [message, setMessage] = useState();
  const loadOverview = useCallback(async () => {
    try {
      const value = await ppp.getLocalizationOverviewAsync();
      setOverview(value);
      setLoadError(void 0);
    } catch (reason) {
      setOverview(null);
      setLoadError(reason instanceof Error ? reason.message : String(reason));
    }
  }, [ppp]);
  useEffect(() => {
    void loadOverview();
  }, [loadOverview]);
  const onReload = useCallback(async () => {
    setIsReloading(true);
    setMessage(void 0);
    try {
      const result = await ppp.clearCacheAsync("StringLocalizer");
      if (result === null) {
        setMessage({ intent: "error", text: t("app.localization-admin.reload-not-found") });
        return;
      }
      if (!result.succeeded) {
        setMessage({
          intent: "error",
          text: t("app.localization-admin.reload-failed", [result.error ?? ""])
        });
        return;
      }
      await loadOverview();
      setMessage({
        intent: "success",
        text: t("app.localization-admin.reload-success", [toNumber(result.elapsedMs)])
      });
    } catch (reason) {
      setMessage({
        intent: "error",
        text: t("app.localization-admin.reload-failed", [
          reason instanceof Error ? reason.message : String(reason)
        ])
      });
    } finally {
      setIsReloading(false);
    }
  }, [ppp, t, loadOverview]);
  const runDownload = useCallback(
    async (fetch2) => {
      setIsDownloading(true);
      setMessage(void 0);
      try {
        const download = await fetch2();
        if (download === null || download.data.length === 0) {
          setMessage({ intent: "warning", text: t("app.localization-admin.download-empty") });
          return;
        }
        downloadBytes(download.fileName, download.data);
      } catch (reason) {
        setMessage({
          intent: "error",
          text: t("app.localization-admin.download-failed", [
            reason instanceof Error ? reason.message : String(reason)
          ])
        });
      } finally {
        setIsDownloading(false);
      }
    },
    [t]
  );
  const onDownloadSource = useCallback(
    (sourceId, culture) => void runDownload(() => ppp.downloadLocalizationSourceAsync(sourceId, culture)),
    [ppp, runDownload]
  );
  const onDownloadMerged = useCallback(
    (culture) => void runDownload(() => ppp.downloadMergedLocalizationsAsync(culture)),
    [ppp, runDownload]
  );
  const availableCultures = useMemo(() => {
    if (!overview) return [];
    const set = /* @__PURE__ */ new Set();
    for (const load of overview.sourceLoads) for (const culture of load.cultures) set.add(culture);
    return [...set].sort((a, b) => a.localeCompare(b, void 0, { sensitivity: "base" }));
  }, [overview]);
  let content;
  if (loadError !== void 0) {
    content = /* @__PURE__ */ jsx(MessageBar, { intent: "error", children: /* @__PURE__ */ jsx(MessageBarBody, { children: t("app.localization-admin.load-failed", [loadError]) }) });
  } else if (!overview) {
    content = /* @__PURE__ */ jsx(Spinner, {});
  } else {
    const config = overview.configuration;
    content = /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: styles.toolbar, children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "primary",
            disabled: isReloading,
            icon: isReloading ? /* @__PURE__ */ jsx(Spinner, { size: "tiny" }) : /* @__PURE__ */ jsx(ArrowSyncRegular, {}),
            onClick: () => void onReload(),
            children: isReloading ? t("app.localization-admin.reloading") : t("app.localization-admin.reload")
          }
        ),
        overview.lastReloadedOn != null && /* @__PURE__ */ jsx("span", { className: styles.lastReloaded, children: t("app.localization-admin.last-reloaded", [
          new Date(overview.lastReloadedOn).toLocaleString()
        ]) })
      ] }),
      message && /* @__PURE__ */ jsx(MessageBar, { intent: message.intent, children: /* @__PURE__ */ jsx(MessageBarBody, { children: message.text }) }),
      /* @__PURE__ */ jsx(Section, { headerText: t("app.localization-admin.configuration-title"), borderVisible: true, children: /* @__PURE__ */ jsx(SectionColumn, { children: /* @__PURE__ */ jsxs("div", { className: styles.sectionBody, children: [
        /* @__PURE__ */ jsx(Text, { children: t("app.localization-admin.configuration-description") }),
        /* @__PURE__ */ jsxs("dl", { className: mergeClasses("ppp-localization-admin-config", styles.configList), children: [
          /* @__PURE__ */ jsx(
            ConfigRow,
            {
              styles,
              label: t("app.localization-admin.config-mode"),
              value: config.localizeAllAvailableTables ? t("app.localization-admin.config-mode-all") : t("app.localization-admin.config-mode-configured")
            }
          ),
          !config.localizeAllAvailableTables && /* @__PURE__ */ jsx(
            ConfigRow,
            {
              styles,
              label: t("app.localization-admin.config-tables"),
              value: config.tablesToLocalize.length > 0 ? config.tablesToLocalize.join(", ") : t("app.localization-admin.config-none")
            }
          ),
          /* @__PURE__ */ jsx(
            ConfigRow,
            {
              styles,
              label: t("app.localization-admin.config-web-resources"),
              value: config.webResourcePathPattern
            }
          ),
          /* @__PURE__ */ jsx("dt", { className: styles.configTerm, children: t("app.localization-admin.config-directories") }),
          /* @__PURE__ */ jsx("dd", { className: styles.configValue, children: config.localizationDirectories.length > 0 ? config.localizationDirectories.map((dir) => /* @__PURE__ */ jsx("div", { children: dir }, dir)) : t("app.localization-admin.config-none") }),
          config.localizationFiles.length > 0 && /* @__PURE__ */ jsx(
            ConfigRow,
            {
              styles,
              label: t("app.localization-admin.config-files"),
              value: config.localizationFiles.join(", ")
            }
          ),
          /* @__PURE__ */ jsx(
            ConfigRow,
            {
              styles,
              label: t("app.localization-admin.config-default-culture"),
              value: config.defaultCulture
            }
          )
        ] })
      ] }) }) }),
      /* @__PURE__ */ jsx(LocalizationTranslator, {}),
      availableCultures.length > 0 && /* @__PURE__ */ jsx(Section, { headerText: t("app.localization-admin.download-merged-title"), borderVisible: true, children: /* @__PURE__ */ jsx(SectionColumn, { children: /* @__PURE__ */ jsxs("div", { className: styles.sectionBody, children: [
        /* @__PURE__ */ jsx(Text, { children: t("app.localization-admin.download-merged-description") }),
        /* @__PURE__ */ jsx("div", { className: styles.mergedButtons, children: availableCultures.map((culture) => /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "outline",
            disabled: isDownloading,
            icon: /* @__PURE__ */ jsx(ArrowDownloadRegular, {}),
            onClick: () => onDownloadMerged(culture),
            children: culture
          },
          culture
        )) })
      ] }) }) }),
      /* @__PURE__ */ jsx(Section, { headerText: t("app.localization-admin.sources-title"), borderVisible: true, children: /* @__PURE__ */ jsx(SectionColumn, { children: /* @__PURE__ */ jsxs("div", { className: styles.sectionBody, children: [
        /* @__PURE__ */ jsx(Text, { children: t("app.localization-admin.sources-description") }),
        overview.sourceLoads.length === 0 ? /* @__PURE__ */ jsx(MessageBar, { intent: "info", children: /* @__PURE__ */ jsx(MessageBarBody, { children: t("app.localization-admin.sources-empty") }) }) : /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-localization-admin-grid-scroll", styles.gridScroll), children: /* @__PURE__ */ jsxs(Table, { size: "small", "aria-label": t("app.localization-admin.sources-title"), children: [
          /* @__PURE__ */ jsx(TableHeader, { children: /* @__PURE__ */ jsxs(TableRow, { children: [
            /* @__PURE__ */ jsx(TableHeaderCell, { className: styles.orderCell, children: t("app.localization-admin.column-order") }),
            /* @__PURE__ */ jsx(TableHeaderCell, { children: t("app.localization-admin.column-kind") }),
            /* @__PURE__ */ jsx(TableHeaderCell, { className: styles.sourceCell, children: t("app.localization-admin.column-source") }),
            /* @__PURE__ */ jsx(TableHeaderCell, { children: t("app.localization-admin.column-cultures") }),
            /* @__PURE__ */ jsx(TableHeaderCell, { children: t("app.localization-admin.column-keys") }),
            /* @__PURE__ */ jsx(TableHeaderCell, { children: t("app.localization-admin.column-overriding") }),
            /* @__PURE__ */ jsx(TableHeaderCell, { children: t("app.localization-admin.column-duration") }),
            /* @__PURE__ */ jsx(TableHeaderCell, { children: t("app.localization-admin.column-status") }),
            /* @__PURE__ */ jsx(TableHeaderCell, { children: t("app.localization-admin.column-download") })
          ] }) }),
          /* @__PURE__ */ jsx(TableBody, { children: overview.sourceLoads.map((load) => /* @__PURE__ */ jsx(
            SourceRow,
            {
              load,
              styles,
              t,
              isDownloading,
              onDownloadSource
            },
            `${load.loadOrder}-${load.sourceId}`
          )) })
        ] }) })
      ] }) }) })
    ] });
  }
  return /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-localization-admin", styles.root, className), children: content });
}
function ConfigRow({ styles, label, value }) {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("dt", { className: styles.configTerm, children: label }),
    /* @__PURE__ */ jsx("dd", { className: styles.configValue, children: value })
  ] });
}
function SourceRow({
  load,
  styles,
  t,
  isDownloading,
  onDownloadSource
}) {
  const kindKey = KIND_KEY[Number(load.kind)] ?? "tablemetadata";
  const statusValue = Number(load.status);
  const statusKey = STATUS_KEY[statusValue] ?? "loaded";
  const statusText = t(`app.localization-admin.status-${statusKey}`);
  const overriding = toNumber(load.keysOverriding);
  return /* @__PURE__ */ jsxs(TableRow, { children: [
    /* @__PURE__ */ jsx(TableCell, { className: styles.orderCell, children: toNumber(load.loadOrder) }),
    /* @__PURE__ */ jsx(TableCell, { children: t(`app.localization-admin.kind-${kindKey}`) }),
    /* @__PURE__ */ jsx(TableCell, { className: styles.sourceCell, children: load.displayName }),
    /* @__PURE__ */ jsx(TableCell, { children: load.cultures.length > 0 ? load.cultures.join(", ") : "\u2014" }),
    /* @__PURE__ */ jsx(TableCell, { className: styles.numericCell, children: toNumber(load.keysContributed) }),
    /* @__PURE__ */ jsx(TableCell, { className: styles.numericCell, children: overriding > 0 ? /* @__PURE__ */ jsx("span", { className: styles.overriding, children: overriding }) : overriding }),
    /* @__PURE__ */ jsx(TableCell, { className: styles.numericCell, children: toNumber(load.durationMs).toLocaleString() }),
    /* @__PURE__ */ jsx(TableCell, { children: statusValue === 1 && load.error ? /* @__PURE__ */ jsx(Tooltip, { content: load.error, relationship: "description", children: /* @__PURE__ */ jsx("span", { className: styles.failed, children: statusText }) }) : statusValue === 2 ? /* @__PURE__ */ jsx("span", { className: styles.skipped, children: statusText }) : statusText }),
    /* @__PURE__ */ jsx(TableCell, { children: load.cultures.length === 0 ? /* @__PURE__ */ jsx("span", { className: styles.skipped, children: "\u2014" }) : /* @__PURE__ */ jsx("div", { className: styles.downloadCell, children: load.cultures.map((culture) => /* @__PURE__ */ jsx(
      Tooltip,
      {
        content: t("app.localization-admin.download-source-tooltip", [culture]),
        relationship: "label",
        children: /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "subtle",
            size: "small",
            disabled: isDownloading,
            icon: /* @__PURE__ */ jsx(ArrowDownloadRegular, {}),
            onClick: () => onDownloadSource(load.sourceId, culture),
            children: culture
          }
        )
      },
      culture
    )) }) })
  ] });
}
var useStyles13 = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalM,
    maxWidth: "760px"
  },
  individual: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalS
  },
  cacheRow: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalM,
    flexWrap: "wrap"
  },
  cacheButton: { minWidth: "220px", flex: "0 0 auto" },
  muted: { color: tokens.colorNeutralForeground2, fontSize: tokens.fontSizeBase200 }
});
var toMs = (value) => Number(value);
function CacheAdmin({ className }) {
  const styles = useStyles13();
  const t = useT();
  const { ppp } = usePowerPortalsPro();
  const [cacheNames, setCacheNames] = useState([]);
  const [isLoadingNames, setIsLoadingNames] = useState(true);
  const [isClearingAll, setIsClearingAll] = useState(false);
  const [clearingName, setClearingName] = useState();
  const [message, setMessage] = useState();
  const isBusy = isClearingAll || clearingName !== void 0;
  useEffect(() => {
    let cancelled = false;
    ppp.getCacheNamesAsync().then((names) => {
      if (!cancelled) {
        setCacheNames(
          [...names].sort((a, b) => a.localeCompare(b, void 0, { sensitivity: "base" }))
        );
      }
    }).catch((reason) => {
      if (!cancelled) {
        setMessage({
          intent: "warning",
          text: t("app.cache-admin.load-failed", [reason instanceof Error ? reason.message : String(reason)])
        });
      }
    }).finally(() => {
      if (!cancelled) setIsLoadingNames(false);
    });
    return () => {
      cancelled = true;
    };
  }, [ppp, t]);
  const onClearAll = useCallback(async () => {
    setIsClearingAll(true);
    setMessage(void 0);
    try {
      const results = await ppp.clearAllCachesAsync();
      const failed = results.filter((r) => !r.succeeded);
      const totalMs = results.reduce((sum, r) => sum + toMs(r.elapsedMs), 0);
      if (failed.length === 0) {
        setMessage({ intent: "success", text: t("app.cache-admin.clear-all-success", [results.length, totalMs]) });
      } else {
        setMessage({
          intent: "warning",
          text: t("app.cache-admin.clear-all-partial", [
            results.length - failed.length,
            results.length,
            failed.length
          ])
        });
      }
    } catch (reason) {
      setMessage({
        intent: "error",
        text: t("app.cache-admin.clear-all-error", [reason instanceof Error ? reason.message : String(reason)])
      });
    } finally {
      setIsClearingAll(false);
    }
  }, [ppp, t]);
  const onClearOne = useCallback(
    async (name) => {
      setClearingName(name);
      setMessage(void 0);
      try {
        const result = await ppp.clearCacheAsync(name);
        if (result === null) {
          setMessage({ intent: "warning", text: t("app.cache-admin.clear-one-not-found", [name]) });
        } else if (result.succeeded) {
          setMessage({
            intent: "success",
            text: t("app.cache-admin.clear-one-success", [result.name, toMs(result.elapsedMs)])
          });
        } else {
          setMessage({
            intent: "error",
            text: t("app.cache-admin.clear-one-failed", [result.name, result.error ?? ""])
          });
        }
      } catch (reason) {
        setMessage({
          intent: "error",
          text: t("app.cache-admin.clear-all-error", [reason instanceof Error ? reason.message : String(reason)])
        });
      } finally {
        setClearingName(void 0);
      }
    },
    [ppp, t]
  );
  const rows = useMemo(
    () => cacheNames.map((name) => {
      const descKey = `app.cache-descriptions.${name}`;
      const desc = t(descKey);
      return { name, description: desc === descKey ? void 0 : desc };
    }),
    [cacheNames, t]
  );
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-cache-admin", styles.root, className), children: [
    /* @__PURE__ */ jsx(Title3, { children: t("app.cache-admin.title") }),
    /* @__PURE__ */ jsx(Text, { children: t("app.cache-admin.description") }),
    message && /* @__PURE__ */ jsx(MessageBar, { intent: message.intent, children: /* @__PURE__ */ jsx(MessageBarBody, { children: message.text }) }),
    /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
      Button,
      {
        appearance: "primary",
        disabled: isBusy,
        icon: isClearingAll ? /* @__PURE__ */ jsx(Spinner, { size: "tiny" }) : /* @__PURE__ */ jsx(ArrowSyncRegular, {}),
        onClick: () => void onClearAll(),
        children: isClearingAll ? t("app.cache-admin.clear-all-running") : t("app.cache-admin.clear-all-button")
      }
    ) }),
    isLoadingNames ? /* @__PURE__ */ jsx(Spinner, { size: "small", label: t("app.cache-admin.loading") }) : rows.length > 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Divider, {}),
      /* @__PURE__ */ jsx(Title3, { children: t("app.cache-admin.clear-individual-title") }),
      /* @__PURE__ */ jsx(Text, { className: styles.muted, children: t("app.cache-admin.clear-individual-description") }),
      /* @__PURE__ */ jsx("div", { className: styles.individual, children: rows.map(({ name, description }) => {
        const isThisRunning = clearingName === name;
        return /* @__PURE__ */ jsxs("div", { className: styles.cacheRow, children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              appearance: "outline",
              className: styles.cacheButton,
              disabled: isBusy,
              icon: isThisRunning ? /* @__PURE__ */ jsx(Spinner, { size: "tiny" }) : /* @__PURE__ */ jsx(ArrowSyncRegular, {}),
              onClick: () => void onClearOne(name),
              children: isThisRunning ? t("app.cache-admin.clear-all-running") : name
            }
          ),
          description && /* @__PURE__ */ jsx(Text, { className: styles.muted, children: description })
        ] }, name);
      }) })
    ] }) : null
  ] });
}
var useStyles14 = makeStyles({
  list: {
    margin: 0,
    paddingLeft: tokens.spacingHorizontalXL,
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalXXS
  }
});
function ValidationSummary({
  title,
  columns,
  className,
  style
}) {
  const styles = useStyles14();
  const t = useT();
  const validation = useValidationContext();
  const resolvedTitle = title === void 0 ? t("app.errors.form-validation-errors") : title;
  if (!validation) return null;
  const entries = columns ? Array.from(validation.errors.entries()).filter(([col]) => columns.includes(col)) : Array.from(validation.errors.entries());
  const items = entries.flatMap(
    ([col, errs]) => errs.map((message, idx) => ({ key: `${col}:${idx}`, message }))
  );
  if (items.length === 0) return null;
  return /* @__PURE__ */ jsx(
    MessageBar,
    {
      intent: "error",
      icon: /* @__PURE__ */ jsx(ErrorCircle20Regular, {}),
      className,
      style,
      children: /* @__PURE__ */ jsxs(MessageBarBody, { children: [
        resolvedTitle && /* @__PURE__ */ jsx(MessageBarTitle, { children: resolvedTitle }),
        /* @__PURE__ */ jsx("ul", { className: styles.list, children: items.map((item) => /* @__PURE__ */ jsx("li", { children: item.message }, item.key)) })
      ] })
    }
  );
}
function SaveContextButton({
  disabled,
  onBeforeSave,
  onSaved,
  onError,
  label,
  appearance = "subtle"
}) {
  const ctx = useMainContext();
  const validation = useValidationContext();
  const dialog = useDialogService();
  const runWithOverlay = useRunWithOverlay();
  const t = useT();
  const [saving, setSaving] = useState(false);
  const resolvedLabel = label ?? t("app.buttons.save.label");
  const handleClick = useCallback(async () => {
    if (!ctx) return;
    setSaving(true);
    try {
      if (onBeforeSave) await onBeforeSave();
      if (ctx.forceSuccessfulValidationBeforeSave && validation && !await validation.validateAll()) {
        return;
      }
      await runWithOverlay({ description: t("app.messages.record-save") }, () => ctx.saveAll());
      if (onSaved) await onSaved();
    } catch (err) {
      if (onError) {
        await onError(err);
      } else {
        await dialog.showErrorAsync(err instanceof Error ? err.message : String(err), {
          title: t("app.errors.record-save")
        });
      }
    } finally {
      setSaving(false);
    }
  }, [ctx, validation, dialog, runWithOverlay, t, onBeforeSave, onSaved, onError]);
  const isDisabled = !ctx || !ctx.isDirty || saving || disabled === true;
  return /* @__PURE__ */ jsx(
    Button,
    {
      type: "button",
      className: "ppp-save-context-button",
      appearance,
      icon: /* @__PURE__ */ jsx(Save24Regular, {}),
      disabled: isDisabled,
      onClick: handleClick,
      children: resolvedLabel
    }
  );
}
function RefreshContextButton({
  disabled,
  onBeforeRefresh,
  onRefreshed,
  onError,
  label,
  appearance = "subtle"
}) {
  const ctx = useMainContext();
  const dialog = useDialogService();
  const warn = useWarnAboutUnsavedChanges();
  const runWithOverlay = useRunWithOverlay();
  const t = useT();
  const [refreshing, setRefreshing] = useState(false);
  const resolvedLabel = label ?? t("app.buttons.refresh.label");
  const handleClick = useCallback(async () => {
    if (!ctx) return;
    setRefreshing(true);
    try {
      if (onBeforeRefresh) await onBeforeRefresh();
      if (ctx.isDirty) {
        const proceed = await warn();
        if (!proceed) return;
      }
      await runWithOverlay(
        { description: t("app.messages.record-loading") },
        () => ctx.refreshAll()
      );
      if (onRefreshed) await onRefreshed();
    } catch (err) {
      if (onError) {
        await onError(err);
      } else {
        await dialog.showErrorAsync(err instanceof Error ? err.message : String(err), {
          title: t("app.errors.generic-error")
        });
      }
    } finally {
      setRefreshing(false);
    }
  }, [ctx, dialog, warn, runWithOverlay, t, onBeforeRefresh, onRefreshed, onError]);
  const isDisabled = !ctx || refreshing || disabled === true;
  return /* @__PURE__ */ jsx(
    Button,
    {
      type: "button",
      className: "ppp-refresh-context-button",
      appearance,
      icon: /* @__PURE__ */ jsx(ArrowClockwise24Regular, {}),
      disabled: isDisabled,
      onClick: handleClick,
      children: resolvedLabel
    }
  );
}
function DeleteContextButton({
  disabled,
  onBeforeDelete,
  onDeleted,
  onError,
  label,
  appearance = "subtle"
}) {
  const { ppp } = usePowerPortalsPro();
  const ctx = useRecordContext();
  const dialog = useDialogService();
  const runWithOverlay = useRunWithOverlay();
  const t = useT();
  const [deleting, setDeleting] = useState(false);
  const resolvedLabel = label ?? t("app.buttons.delete.label");
  const record = ctx.record;
  const canDelete = record?.permissions !== void 0 && (record.permissions & TableSecurityPermission.Delete) === TableSecurityPermission.Delete;
  const handleClick = useCallback(async () => {
    if (!record || !canDelete || !record.id || !record.tableName) return;
    const recordTableName = record.tableName;
    const recordId = record.id;
    setDeleting(true);
    try {
      await ctx.runBeforeDelete();
      if (onBeforeDelete) await onBeforeDelete();
      const result = await dialog.showConfirmationAsync(
        t("app.messages.delete-record-confirmation"),
        {
          title: t("app.messages.delete-title"),
          primaryText: t("app.buttons.delete.label"),
          secondaryText: t("app.buttons.cancel.label")
        }
      );
      if (result.cancelled) return;
      await runWithOverlay(
        { description: t("app.messages.deleting-record") },
        () => ppp.deleteRecordAsync(recordTableName, recordId)
      );
      if (onDeleted) {
        await onDeleted();
      } else {
        window.history.back();
      }
    } catch (err) {
      if (onError) {
        await onError(err);
      } else {
        await dialog.showErrorAsync(err instanceof Error ? err.message : String(err), {
          title: t("app.errors.record-delete")
        });
      }
    } finally {
      setDeleting(false);
    }
  }, [ppp, ctx, record, canDelete, dialog, runWithOverlay, t, onBeforeDelete, onDeleted, onError]);
  const isDisabled = !record || !canDelete || deleting || disabled === true;
  return /* @__PURE__ */ jsx(
    Button,
    {
      type: "button",
      className: "ppp-delete-context-button",
      appearance,
      icon: /* @__PURE__ */ jsx(Delete24Regular, {}),
      disabled: isDisabled,
      onClick: handleClick,
      children: resolvedLabel
    }
  );
}
var GridButtonRole = {
  /**
   * Creates a new record. Receives the grid's pending-create
   * re-open dispatch when a row in `pendingRowCreates` is clicked,
   * so the user's in-progress new record is edited via the same
   * form/wizard it was created in.
   */
  Create: "create",
  /**
   * Opens an existing (server-persisted) record for read or edit.
   * Receives the grid's row-click dispatch for any row that carries
   * a real Dataverse id (not the `__pending-create-` prefix).
   */
  Open: "open",
  /** Deletes a record. */
  Delete: "delete",
  /**
   * Anything that doesn't fit the create/open/delete taxonomy
   * refresh, link/unlink, custom export, etc. The grid doesn't
   * dispatch row-level interactions to `'other'` buttons; they're
   * triggered exclusively by their own click handlers.
   */
  Other: "other"
};
var GRID_BUTTON_ROLE_MARKER = /* @__PURE__ */ Symbol.for("@powerportalspro/grid-button-role");
function setGridButtonRole(Component, role) {
  Component[GRID_BUTTON_ROLE_MARKER] = role;
}
function getGridButtonRoleFromElement(node) {
  if (!isValidElement(node)) return null;
  const props = node.props;
  const propRole = props?.gridButtonRole;
  if (propRole === GridButtonRole.Create || propRole === GridButtonRole.Open || propRole === GridButtonRole.Delete || propRole === GridButtonRole.Other) {
    return propRole;
  }
  const type = node.type;
  return type?.[GRID_BUTTON_ROLE_MARKER] ?? null;
}
function findFirstButtonOfRole(children, role) {
  let found = null;
  function visit(node) {
    if (found) return;
    Children.forEach(node, (child) => {
      if (found) return;
      if (!isValidElement(child)) return;
      const childRole = getGridButtonRoleFromElement(child);
      if (childRole === role) {
        found = child;
        return;
      }
      const props = child.props;
      if (props?.children !== void 0 && childRole === null) {
        visit(props.children);
      }
    });
  }
  visit(children);
  return found;
}

// src/buttons/grid-button-behavior.ts
var GridButtonBehavior = {
  /** Always shown / enabled regardless of selection. */
  Always: "always",
  /** Only when zero rows are selected (e.g. New / Link). */
  NoneSelected: "none-selected",
  /** Only when exactly one row is selected (e.g. single-record Edit / Navigate). */
  OnlyOneSelected: "only-one-selected",
  /** Only when two or more rows are selected (e.g. multi-edit, bulk delete). */
  MoreThanOneSelected: "more-than-one-selected",
  /** Whenever at least one row is selected (Delete / Unlink). */
  OneOrMoreSelected: "one-or-more-selected"
};
function evaluateGridButtonBehavior(behavior, selectionCount) {
  switch (behavior) {
    case GridButtonBehavior.Always:
      return true;
    case GridButtonBehavior.NoneSelected:
      return selectionCount === 0;
    case GridButtonBehavior.OnlyOneSelected:
      return selectionCount === 1;
    case GridButtonBehavior.MoreThanOneSelected:
      return selectionCount > 1;
    case GridButtonBehavior.OneOrMoreSelected:
      return selectionCount >= 1;
    default:
      return false;
  }
}
function GridButton({
  onClick,
  label,
  icon,
  visibilityBehavior = GridButtonBehavior.Always,
  enabledBehavior = GridButtonBehavior.Always,
  disabled,
  tooltip,
  appearance = "subtle",
  onError
}) {
  const grid = useGridContext();
  const selectionCount = grid.selectedRecords.length;
  const [working, setWorking] = useState(false);
  const handleClick = useCallback(async () => {
    setWorking(true);
    try {
      await onClick(grid);
    } catch (err) {
      if (onError) {
        await onError(err);
      } else {
        throw err;
      }
    } finally {
      setWorking(false);
    }
  }, [grid, onClick, onError]);
  if (!evaluateGridButtonBehavior(visibilityBehavior, selectionCount)) {
    return null;
  }
  const enabledBySelection = evaluateGridButtonBehavior(enabledBehavior, selectionCount);
  const isDisabled = disabled === true || working || !enabledBySelection;
  const iconProps = icon !== void 0 ? { icon } : {};
  const button = /* @__PURE__ */ jsx(
    Button,
    {
      type: "button",
      className: "ppp-grid-button",
      appearance,
      ...iconProps,
      disabled: isDisabled,
      onClick: handleClick,
      children: label
    }
  );
  if (tooltip) {
    return /* @__PURE__ */ jsx(Tooltip, { content: tooltip, relationship: "label", children: button });
  }
  return button;
}
function NavigateRecordGridButton({
  url,
  title,
  icon,
  buttonEnabledBehavior = GridButtonBehavior.Always,
  buttonVisibleBehavior = GridButtonBehavior.Always,
  enabled,
  onClick,
  onNavigate,
  appearance
}) {
  const grid = useGridContext();
  const selectionCount = grid.selectedRecords.length;
  const visible = useMemo(
    () => evaluateGridButtonBehavior(buttonVisibleBehavior, selectionCount),
    [buttonVisibleBehavior, selectionCount]
  );
  const behaviorEnabled = useMemo(
    () => evaluateGridButtonBehavior(buttonEnabledBehavior, selectionCount),
    [buttonEnabledBehavior, selectionCount]
  );
  const resolvedEnabled = enabled ?? behaviorEnabled;
  const handleClick = useCallback(async () => {
    const ids = grid.selectedRecords.map((r) => (r.id ?? "").replace(/[{}]/g, "")).filter((id) => id.length > 0).join(",");
    const seedUrl = url.replace(/\{0\}/g, ids);
    const context = {
      gridContext: grid,
      url: seedUrl
    };
    if (onClick) await onClick(context);
    if (!context.url) return;
    if (onNavigate) {
      onNavigate(context.url);
    } else {
      window.location.assign(context.url);
    }
  }, [grid, url, onClick, onNavigate]);
  if (!visible) return null;
  return /* @__PURE__ */ jsx(
    GridButton,
    {
      label: title,
      onClick: handleClick,
      disabled: !resolvedEnabled,
      ...icon !== void 0 && { icon },
      ...appearance !== void 0 && { appearance }
    }
  );
}
setGridButtonRole(NavigateRecordGridButton, GridButtonRole.Other);
function RefreshGridButton({
  disabled,
  onBeforeRefresh,
  onRefreshed,
  onError,
  label,
  appearance
}) {
  const t = useT();
  const warnAboutUnsavedChanges = useWarnAboutUnsavedChanges();
  const resolvedLabel = label ?? t("app.buttons.refresh.label");
  const handleClick = useCallback(
    async (grid) => {
      if (grid.isDirty) {
        const proceed = await warnAboutUnsavedChanges();
        if (!proceed) return;
        grid.clearPendingRowUpdates();
      }
      if (onBeforeRefresh) await onBeforeRefresh();
      await grid.refresh();
      if (onRefreshed) await onRefreshed();
    },
    [warnAboutUnsavedChanges, onBeforeRefresh, onRefreshed]
  );
  return /* @__PURE__ */ jsx(
    GridButton,
    {
      label: resolvedLabel,
      icon: /* @__PURE__ */ jsx(ArrowClockwise24Regular, {}),
      onClick: handleClick,
      ...appearance !== void 0 && { appearance },
      ...disabled !== void 0 && { disabled },
      ...onError !== void 0 && { onError }
    }
  );
}
function NavigateNewRecordGridButton({
  url,
  onClick,
  onNavigate,
  disabled,
  label,
  appearance
}) {
  const grid = useGridContext();
  const t = useT();
  const resolvedLabel = label ?? t("app.buttons.new.label");
  const sampledPermissions = grid.tablePermissions;
  const createDeniedByPermissions = sampledPermissions !== void 0 && (sampledPermissions & TableSecurityPermission.Create) !== TableSecurityPermission.Create;
  const isDisabled = disabled === true || grid.selectedRecords.length > 0 || createDeniedByPermissions;
  const handleClick = useCallback(async () => {
    const resolved = typeof url === "function" ? url(grid) : url;
    const context = {
      gridContext: grid,
      url: resolved
    };
    if (onClick) await onClick(context);
    if (!context.url) return;
    if (onNavigate) {
      onNavigate(context.url);
    } else {
      window.location.assign(context.url);
    }
  }, [url, onClick, onNavigate, grid]);
  return /* @__PURE__ */ jsx(
    GridButton,
    {
      label: resolvedLabel,
      icon: /* @__PURE__ */ jsx(Add20Regular, {}),
      onClick: handleClick,
      disabled: isDisabled,
      ...appearance !== void 0 && { appearance }
    }
  );
}
setGridButtonRole(NavigateNewRecordGridButton, GridButtonRole.Create);
function NavigateOpenRecordGridButton({
  urlFor,
  onClick,
  onNavigate,
  disabled,
  label,
  appearance
}) {
  const grid = useGridContext();
  const t = useT();
  const resolvedLabel = label ?? t("app.buttons.open.label");
  const isDisabled = disabled === true || grid.selectedRecords.length !== 1;
  const navigateForRecord = useCallback(
    async (record) => {
      const resolved = urlFor(record, grid);
      const context = {
        gridContext: grid,
        record,
        url: resolved
      };
      if (onClick) await onClick(context);
      if (!context.url) return;
      if (onNavigate) {
        onNavigate(context.url);
      } else {
        window.location.assign(context.url);
      }
    },
    [urlFor, onClick, onNavigate, grid]
  );
  const { registerOpenHandler } = grid;
  useEffect(() => {
    return registerOpenHandler(navigateForRecord);
  }, [registerOpenHandler, navigateForRecord]);
  const handleClick = useCallback(() => {
    const record = grid.selectedRecords[0];
    if (!record) return;
    navigateForRecord(record);
  }, [grid, navigateForRecord]);
  return /* @__PURE__ */ jsx(
    GridButton,
    {
      label: resolvedLabel,
      icon: /* @__PURE__ */ jsx(Edit20Regular, {}),
      onClick: handleClick,
      disabled: isDisabled,
      ...appearance !== void 0 && { appearance }
    }
  );
}
setGridButtonRole(NavigateOpenRecordGridButton, GridButtonRole.Open);
var useDialogStyles = makeStyles({
  // Loading state replaces the form entirely while the record fetch is in
  // flight — NOT a scrim over the form, because the per-column edit
  // components mount and run their validators on first render. If they
  // mount against an undefined record they immediately report
  // "required field empty" errors that flicker visible for the duration
  // of the load. Gating on `status === Success` keeps the form out of
  // the tree until there's a real record to bind to.
  loadingArea: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "160px",
    rowGap: tokens.spacingVerticalM
  }
});
function OpenRecordGridButton({
  children,
  behavior = "withGridContext",
  location = "center",
  disabled,
  label,
  appearance,
  dialogTitle,
  onSaved,
  onError,
  forceSuccessfulValidationBeforeSave
}) {
  const grid = useGridContext();
  const t = useT();
  const resolvedLabel = label ?? (grid.selectedRecords.length > 1 ? t("app.buttons.edit.label") : t("app.buttons.open.label"));
  const [recordToEdit, setRecordToEdit] = useState(null);
  const [multiEditRecords, setMultiEditRecords] = useState(null);
  const selected = grid.selectedRecords[0];
  const isSelectedPendingCreate = !!selected?.id && selected.id.startsWith("__pending-create-");
  const anySelectedPendingCreate = grid.selectedRecords.some(
    (r) => !!r.id && r.id.startsWith("__pending-create-")
  );
  const hasReadOnAllSelected = grid.selectedRecords.length > 0 && grid.selectedRecords.every(
    (r) => !!r.id && !!r.tableName && !!r.permissions && (r.permissions & 1) === 1
  );
  const canOpenSelected = grid.selectedRecords.length === 1 ? isSelectedPendingCreate || !!selected?.id && !!selected?.tableName && !!selected?.permissions && (selected.permissions & 1) === 1 : hasReadOnAllSelected && !anySelectedPendingCreate;
  const isDisabled = disabled === true || grid.selectedRecords.length === 0 || !canOpenSelected;
  const openForSelected = useCallback(() => {
    if (grid.selectedRecords.length === 1 && selected) {
      if (isSelectedPendingCreate) {
        grid.dispatchOpen(selected);
        return;
      }
      setRecordToEdit(selected);
    } else if (grid.selectedRecords.length > 1) {
      setMultiEditRecords(grid.selectedRecords);
    }
  }, [grid, selected, isSelectedPendingCreate]);
  const openForRecord = useCallback((record) => {
    if (!record.id || !record.tableName) return;
    if (record.id.startsWith("__pending-create-")) return;
    setRecordToEdit(record);
  }, []);
  const closeDialog = useCallback(() => {
    setRecordToEdit(null);
    setMultiEditRecords(null);
  }, []);
  const validationOverride = forceSuccessfulValidationBeforeSave !== void 0 ? { forceSuccessfulValidationBeforeSave } : {};
  const multiEditTableName = multiEditRecords?.[0]?.tableName;
  const multiEditInitialRecord = useMemo(
    () => multiEditTableName ? { tableName: multiEditTableName } : void 0,
    [multiEditTableName]
  );
  const { registerOpenHandler } = grid;
  useEffect(() => {
    return registerOpenHandler(openForRecord);
  }, [registerOpenHandler, openForRecord]);
  const handleOpenChange = useCallback(
    (_evt, data) => {
      if (!data.open) {
        setRecordToEdit(null);
        setMultiEditRecords(null);
      }
    },
    []
  );
  const open = recordToEdit !== null || multiEditRecords !== null;
  const dialogSurfaceStyle = location === "panel" ? {
    margin: 0,
    marginLeft: "auto",
    maxWidth: "480px",
    width: "100%",
    height: "100vh",
    maxHeight: "100vh",
    borderRadius: 0
  } : void 0;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      GridButton,
      {
        label: resolvedLabel,
        icon: /* @__PURE__ */ jsx(Edit20Regular, {}),
        onClick: openForSelected,
        visibilityBehavior: GridButtonBehavior.OneOrMoreSelected,
        disabled: isDisabled,
        ...appearance !== void 0 && { appearance }
      }
    ),
    open && recordToEdit?.id && recordToEdit.tableName && // Standard edit branch — RecordContext fetches the record from
    // the server and DialogInner routes the save through the normal
    // update queue OR immediate save flow.
    // Any already-queued dirty cols from a prior dialog session land
    // on RecordContext as `initialPendingChanges`. RecordContext seeds
    // `pendingChanges` with them after the server load — so
    // `loadedRecord` stays as the unmodified server fetch and
    // `pendingChanges` carries the work-in-progress. The crucial
    // property: when the user reverts a column back to the server
    // value in the dialog, `setColumnValue`'s baseline-match check
    // sees `loadedRecord[col]` and `newValue` collide and drops the
    // column from `pendingChanges`. Dialog Save then ships an empty
    // dirty set and the queue entry gets deleted — net-zero edits
    // resolve cleanly.
    // `OpenRecordGridButton.razor.cs` flow: load fresh, copy
    // `GetChangedProperties` over, `ResetState()` to mark clean.
    /* @__PURE__ */ jsx(Dialog, { open, onOpenChange: handleOpenChange, modalType: "modal", children: /* @__PURE__ */ jsx(DialogSurface, { style: dialogSurfaceStyle, children: /* @__PURE__ */ jsx(
      RecordContext,
      {
        table: recordToEdit.tableName,
        id: recordToEdit.id,
        ...(() => {
          const queued = grid.pendingRowUpdates.get(recordToEdit.id);
          return queued ? { initialPendingChanges: queued.dirty } : {};
        })(),
        children: /* @__PURE__ */ jsx(
          DialogInner,
          {
            behavior,
            gridTableName: recordToEdit.tableName,
            gridRecordId: recordToEdit.id,
            dialogTitle,
            onClose: closeDialog,
            onSaved,
            onError,
            queueRowUpdate: grid.queueRowUpdate,
            gridRefresh: grid.refresh,
            ...validationOverride,
            children: typeof children === "function" ? children() : children
          }
        )
      }
    ) }) }),
    open && multiEditRecords && multiEditRecords.length > 0 && multiEditRecords[0]?.tableName && // Multi-edit branch — bound to an empty record (`tableName` only,
    // no id). RecordContext sees the missing id and enters create
    // mode, but DialogInner's `multiEditTargets` short-circuits the
    // standard save path: it extracts the dirty columns from the
    // form and broadcasts them to every target record via an
    // ExecuteMultiple batch (immediate mode) or N queueRowUpdate
    // calls (withGridContext mode). The empty `initialRecord` is
    // important — without it, RecordContext would synthesize one
    // and the form would start from server-supplied defaults that
    // we'd then accidentally write to every row.
    // `OpenRecordGridButton.razor.cs::EditButtonClicked` which
    // builds a bare `new TableRecord { TableName = ... }` for the
    // multi-select branch.
    /* @__PURE__ */ jsx(Dialog, { open, onOpenChange: handleOpenChange, modalType: "modal", children: /* @__PURE__ */ jsx(DialogSurface, { style: dialogSurfaceStyle, children: /* @__PURE__ */ jsx(
      RecordContext,
      {
        table: multiEditRecords[0].tableName,
        ...multiEditInitialRecord && { initialRecord: multiEditInitialRecord },
        children: /* @__PURE__ */ jsx(
          DialogInner,
          {
            behavior,
            gridTableName: multiEditRecords[0].tableName,
            gridRecordId: "",
            dialogTitle,
            onClose: closeDialog,
            onSaved,
            onError,
            queueRowUpdate: grid.queueRowUpdate,
            gridRefresh: grid.refresh,
            ...validationOverride,
            multiEditTargets: multiEditRecords,
            children: typeof children === "function" ? children() : children
          }
        )
      }
    ) }) })
  ] });
}
setGridButtonRole(OpenRecordGridButton, GridButtonRole.Open);
function DialogInner({
  children,
  behavior,
  gridTableName,
  gridRecordId,
  dialogTitle,
  onClose,
  onSaved,
  onError,
  queueRowUpdate,
  gridRefresh,
  multiEditTargets,
  forceSuccessfulValidationBeforeSave
}) {
  const ctx = useRecordContext();
  const innerMainContext = useMainContext();
  const validation = useValidationContext();
  const dialogSvc = useDialogService();
  const runWithOverlay = useRunWithOverlay();
  const { ppp } = usePowerPortalsPro();
  const t = useT();
  const styles = useDialogStyles();
  const [saving, setSaving] = useState(false);
  const isMultiEdit = !!multiEditTargets && multiEditTargets.length > 0;
  const enforceValidation = isMultiEdit ? false : forceSuccessfulValidationBeforeSave ?? innerMainContext?.forceSuccessfulValidationBeforeSave ?? true;
  const isRecordReady = ctx.status === QueryStatus.Success && ctx.record !== void 0;
  const primaryNameColumn = ctx.tableMetadata?.primaryNameColumn;
  const primaryNameValue = primaryNameColumn !== void 0 && primaryNameColumn !== null ? ctx.record?.properties?.[primaryNameColumn]?.value : void 0;
  const resolvedTitle = dialogTitle ?? (isMultiEdit ? t("app.messages.edit-multiple") : void 0) ?? primaryNameValue ?? t("app.buttons.open.label");
  const handleSave = useCallback(async () => {
    setSaving(true);
    try {
      if (enforceValidation && validation && !await validation.validateAll()) {
        return;
      }
      if (multiEditTargets && multiEditTargets.length > 0) {
        const dirty = /* @__PURE__ */ new Map();
        if (ctx.record) {
          for (const columnName of ctx.dirtyColumns) {
            const value = ctx.record.properties?.[columnName];
            dirty.set(columnName, value ?? null);
          }
        }
        if (dirty.size === 0) {
          if (onSaved) await onSaved();
          onClose();
          return;
        }
        if (behavior === "immediately") {
          await runWithOverlay(
            {
              description: multiEditTargets.length === 1 ? t("app.messages.record-save") : t("app.messages.updating-records")
            },
            async () => {
              const properties = {};
              for (const [col, val] of dirty) {
                if (val !== null) properties[col] = val;
              }
              const requests = multiEditTargets.map(
                (target) => ({
                  $type: "UpdateRequest",
                  record: {
                    tableName: target.tableName,
                    ...target.id !== void 0 && { id: target.id },
                    properties
                  }
                })
              );
              await ppp.executeMultipleAsync(requests, { returnResponses: false });
            }
          );
          await gridRefresh();
        } else {
          for (const target of multiEditTargets) {
            if (!target.id || !target.tableName) continue;
            queueRowUpdate({
              tableName: target.tableName,
              recordId: target.id,
              dirty
            });
          }
        }
      } else if (behavior === "immediately") {
        await runWithOverlay(
          { description: t("app.messages.record-save") },
          () => ctx.save()
        );
        await gridRefresh();
      } else {
        const dirty = /* @__PURE__ */ new Map();
        if (ctx.record) {
          for (const columnName of ctx.dirtyColumns) {
            const value = ctx.record.properties?.[columnName];
            dirty.set(columnName, value ?? null);
          }
        }
        queueRowUpdate({
          tableName: gridTableName,
          recordId: gridRecordId,
          dirty
        });
      }
      if (onSaved) await onSaved();
      onClose();
    } catch (err) {
      if (onError) {
        await onError(err);
      } else {
        await dialogSvc.showErrorAsync(
          err instanceof Error ? err.message : String(err),
          { title: t("app.errors.record-save") }
        );
      }
    } finally {
      setSaving(false);
    }
  }, [
    ctx,
    validation,
    behavior,
    runWithOverlay,
    t,
    dialogSvc,
    queueRowUpdate,
    gridRefresh,
    gridTableName,
    gridRecordId,
    onClose,
    onSaved,
    onError,
    multiEditTargets,
    isMultiEdit,
    enforceValidation,
    ppp
  ]);
  return /* @__PURE__ */ jsxs(DialogBody, { children: [
    /* @__PURE__ */ jsx(DialogTitle, { children: resolvedTitle }),
    /* @__PURE__ */ jsx(DialogContent, { children: isRecordReady ? children : /* @__PURE__ */ jsx("div", { className: styles.loadingArea, role: "status", "aria-live": "polite", children: /* @__PURE__ */ jsx(Spinner, { size: "large", label: t("app.messages.record-loading") }) }) }),
    /* @__PURE__ */ jsxs(DialogActions, { children: [
      /* @__PURE__ */ jsx(Button, { appearance: "secondary", onClick: onClose, disabled: saving, children: t("app.buttons.cancel.label") }),
      /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "primary",
          onClick: handleSave,
          disabled: saving || !isRecordReady || !ctx.isDirty,
          children: t("app.buttons.save.label")
        }
      )
    ] })
  ] });
}
var PAGE_MARKER = /* @__PURE__ */ Symbol.for("@powerportalspro/wizard-record-page");
function WizardRecordPage({
  children,
  forceSuccessfulValidationBeforeSave = true
}) {
  const validation = useValidationContext();
  const { handleStep } = useWizard();
  handleStep(async () => {
    if (!forceSuccessfulValidationBeforeSave || !validation) return;
    const isValid = await validation.validateAll();
    if (!isValid) {
      throw new Error("validation-failed");
    }
  });
  return /* @__PURE__ */ jsx(Fragment, { children });
}
WizardRecordPage[PAGE_MARKER] = true;
function isWizardRecordPageElement(node) {
  if (!isValidElement(node)) return false;
  const type = node.type;
  return !!type && type[PAGE_MARKER] === true;
}
var useStyles15 = makeStyles({
  shell: {
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    minHeight: 0,
    rowGap: tokens.spacingVerticalM
  },
  stepper: {
    flex: "0 0 auto",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalS,
    paddingBottom: tokens.spacingVerticalM,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`
  },
  stepperItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalXS,
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase200
  },
  stepperItemActive: {
    color: tokens.colorBrandForeground1,
    fontWeight: tokens.fontWeightSemibold
  },
  stepperItemCompleted: {
    color: tokens.colorNeutralForeground2
  },
  stepperDot: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: tokens.colorNeutralBackground3,
    color: "inherit"
  },
  stepperDotActive: {
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralForegroundOnBrand
  },
  stepperDotCompleted: {
    backgroundColor: tokens.colorPaletteGreenBackground2,
    color: tokens.colorPaletteGreenForeground2
  },
  stepperSeparator: {
    flex: "1 1 auto",
    height: "1px",
    backgroundColor: tokens.colorNeutralStroke2
  },
  body: {
    flex: "1 1 auto",
    minHeight: 0,
    display: "flex",
    flexDirection: "column"
  },
  footer: {
    flex: "0 0 auto",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    columnGap: tokens.spacingHorizontalM,
    paddingTop: tokens.spacingVerticalM,
    borderTop: `1px solid ${tokens.colorNeutralStroke2}`
  },
  footerLeft: {
    display: "flex",
    flexDirection: "row",
    columnGap: tokens.spacingHorizontalS
  },
  footerRight: {
    display: "flex",
    flexDirection: "row",
    columnGap: tokens.spacingHorizontalS
  }
});
function WizardRecordForm({
  children,
  table,
  id,
  initialRecord,
  loadedRecord,
  onCompleted,
  skipSave,
  onError,
  finishLabel,
  onCancel,
  cancelLabel,
  stepperVisibility = "hidden"
}) {
  const pageProps = useMemo(() => {
    const props = [];
    Children.forEach(children, (child) => {
      if (isWizardRecordPageElement(child)) {
        props.push({
          ...child.props.label !== void 0 && { label: child.props.label }
        });
      }
    });
    return props;
  }, [children]);
  const recordContextProps = {
    table,
    ...id !== void 0 && { id },
    ...initialRecord !== void 0 && { initialRecord },
    ...loadedRecord !== void 0 && { loadedRecord },
    children: null
  };
  return /* @__PURE__ */ jsx(RecordContext, { ...recordContextProps, children: /* @__PURE__ */ jsx(
    WizardRecordFormInner,
    {
      pageProps,
      ...onCompleted !== void 0 && { onCompleted },
      ...skipSave !== void 0 && { skipSave },
      ...onError !== void 0 && { onError },
      ...finishLabel !== void 0 && { finishLabel },
      ...onCancel !== void 0 && { onCancel },
      ...cancelLabel !== void 0 && { cancelLabel },
      stepperVisibility,
      isCreate: id === void 0 || id === "" || id === "00000000-0000-0000-0000-000000000000",
      children
    }
  ) });
}
function WizardRecordFormInner({
  children,
  pageProps,
  onCompleted,
  skipSave,
  onError,
  finishLabel,
  onCancel,
  cancelLabel,
  stepperVisibility,
  isCreate
}) {
  const styles = useStyles15();
  return /* @__PURE__ */ jsx("div", { className: mergeClasses("ppp-wizard-record-form", styles.shell), children: /* @__PURE__ */ jsx(
    Wizard,
    {
      wrapper: /* @__PURE__ */ jsx("div", { className: styles.body }),
      footer: /* @__PURE__ */ jsx(
        WizardFooter,
        {
          pageProps,
          stepperVisibility,
          isCreate,
          ...onCompleted !== void 0 && { onCompleted },
          ...skipSave !== void 0 && { skipSave },
          ...onError !== void 0 && { onError },
          ...finishLabel !== void 0 && { finishLabel },
          ...onCancel !== void 0 && { onCancel },
          ...cancelLabel !== void 0 && { cancelLabel }
        }
      ),
      children
    }
  ) });
}
function WizardFooter({
  pageProps,
  stepperVisibility,
  isCreate,
  onCompleted,
  skipSave,
  onError,
  finishLabel,
  onCancel,
  cancelLabel
}) {
  const styles = useStyles15();
  const t = useT();
  const recordContext = useRecordContext();
  const wizard = useWizard();
  const handleFinish = useCallback(async () => {
    try {
      if (!skipSave) {
        await recordContext.save();
      }
      if (onCompleted && recordContext.record) {
        await onCompleted(recordContext.record);
      }
    } catch (err) {
      if (onError) {
        await onError(err);
      } else {
        console.error("[WizardRecordForm] save failed", err);
        throw err;
      }
    }
  }, [recordContext, skipSave, onCompleted, onError]);
  const resolvedFinishLabel = finishLabel ?? (isCreate ? t("app.buttons.create.label") : t("app.buttons.save.label"));
  const resolvedCancelLabel = cancelLabel ?? t("app.buttons.cancel.label");
  const previousLabel = t("app.buttons.previous.label");
  const nextLabel = t("app.buttons.next.label");
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    stepperVisibility === "visible" && pageProps.length > 0 && /* @__PURE__ */ jsx("div", { className: styles.stepper, children: pageProps.map((p, i) => {
      const isActive = i === wizard.activeStep;
      const isCompleted = i < wizard.activeStep;
      const itemClass = mergeClasses(
        styles.stepperItem,
        isActive && styles.stepperItemActive,
        isCompleted && styles.stepperItemCompleted
      );
      const dotClass = mergeClasses(
        styles.stepperDot,
        isActive && styles.stepperDotActive,
        isCompleted && styles.stepperDotCompleted
      );
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        i > 0 && /* @__PURE__ */ jsx("span", { className: styles.stepperSeparator, "aria-hidden": "true" }, `sep-${i}`),
        /* @__PURE__ */ jsxs("span", { className: itemClass, children: [
          /* @__PURE__ */ jsx("span", { className: dotClass, children: i + 1 }),
          p.label && /* @__PURE__ */ jsx("span", { children: p.label })
        ] }, i)
      ] });
    }) }),
    /* @__PURE__ */ jsxs("div", { className: styles.footer, children: [
      /* @__PURE__ */ jsx("div", { className: styles.footerLeft, children: onCancel && /* @__PURE__ */ jsx(Button, { onClick: onCancel, disabled: wizard.isLoading, children: resolvedCancelLabel }) }),
      /* @__PURE__ */ jsxs("div", { className: styles.footerRight, children: [
        !wizard.isFirstStep && /* @__PURE__ */ jsx(
          Button,
          {
            onClick: () => {
              void wizard.previousStep();
            },
            disabled: wizard.isLoading,
            children: previousLabel
          }
        ),
        wizard.isLastStep ? /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "primary",
            onClick: () => {
              void handleFinish();
            },
            disabled: wizard.isLoading,
            ...wizard.isLoading && { icon: /* @__PURE__ */ jsx(Spinner, { size: "tiny" }) },
            children: resolvedFinishLabel
          }
        ) : /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "primary",
            onClick: () => {
              void wizard.nextStep();
            },
            disabled: wizard.isLoading,
            ...wizard.isLoading && { icon: /* @__PURE__ */ jsx(Spinner, { size: "tiny" }) },
            children: nextLabel
          }
        )
      ] })
    ] })
  ] });
}
var useDialogStyles2 = makeStyles({
  loadingArea: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "160px",
    rowGap: tokens.spacingVerticalM
  }
});
function NewRecordGridButton({
  children,
  behavior = "withGridContext",
  location = "center",
  disabled,
  label,
  appearance,
  dialogTitle,
  initialValues,
  onSaved,
  onError,
  forceSuccessfulValidationBeforeSave
}) {
  const grid = useGridContext();
  const t = useT();
  const resolvedLabel = label ?? t("app.buttons.new.label");
  const sampledPermissions = grid.tablePermissions;
  const createDeniedByPermissions = sampledPermissions !== void 0 && (sampledPermissions & TableSecurityPermission.Create) !== TableSecurityPermission.Create;
  const isDisabled = disabled === true || createDeniedByPermissions;
  const [open, setOpen] = useState(false);
  const [reopenState, setReopenState] = useState(null);
  const openDialog = useCallback(() => {
    setReopenState(null);
    setOpen(true);
  }, []);
  const closeDialog = useCallback(() => {
    setOpen(false);
    setReopenState(null);
  }, []);
  const handleOpenChange = useCallback(
    (_evt, data) => {
      setOpen(data.open);
      if (!data.open) setReopenState(null);
    },
    []
  );
  const { registerCreateReopenHandler } = grid;
  const pendingRowCreatesRef = useRef(grid.pendingRowCreates);
  pendingRowCreatesRef.current = grid.pendingRowCreates;
  const handleReopen = useCallback(
    (_synthetic, queueIndex) => {
      const queued = pendingRowCreatesRef.current[queueIndex];
      if (!queued) return;
      setReopenState({ index: queueIndex, record: queued.record });
      setOpen(true);
    },
    []
  );
  useEffect(() => {
    return registerCreateReopenHandler(handleReopen);
  }, [registerCreateReopenHandler, handleReopen]);
  const tableName = grid.tableName ?? "";
  const parentTableMetadataQuery = useTableMetadata(
    grid.parentRecord?.tableName ?? "",
    { enabled: !!grid.parentRecord?.tableName }
  );
  const parentTableMetadata = parentTableMetadataQuery.data;
  const initialRecord = useMemo(() => {
    const properties = {};
    const parent = grid.parentRecord;
    const relationshipName = grid.relationshipName;
    const parentRefId = parent ? getRecordReferenceId(parent) : void 0;
    if (parentRefId && parent?.tableName && relationshipName && parentTableMetadata) {
      const oneToMany = parentTableMetadata.oneToMany?.find(
        (rel) => rel.relationshipName === relationshipName
      );
      if (oneToMany?.referencingTableColumn) {
        const parentPrimaryName = parentTableMetadata.primaryNameColumn;
        const parentName = parentPrimaryName && parent.properties ? parent.properties[parentPrimaryName]?.value ?? null : null;
        const fkValue = {
          $type: 6,
          tableName: parent.tableName,
          value: parentRefId,
          ...parentName !== null && { name: parentName }
        };
        properties[oneToMany.referencingTableColumn] = fkValue;
      }
    }
    if (initialValues) {
      for (const [col, val] of initialValues) {
        properties[col] = val;
      }
    }
    return { tableName, properties };
  }, [tableName, grid.parentRecord, grid.relationshipName, parentTableMetadata, initialValues]);
  const resolvedChildren = typeof children === "function" ? children() : children;
  const isWizardMode = useMemo(() => {
    let found = false;
    Children.forEach(resolvedChildren, (child) => {
      if (isWizardRecordPageElement(child)) found = true;
    });
    return found;
  }, [resolvedChildren]);
  const effectiveInitialRecord = reopenState ? reopenState.record : initialRecord;
  const effectiveBehavior = reopenState !== null ? "withGridContext" : behavior;
  const handleWizardCompleted = useCallback(
    async (record) => {
      try {
        if (reopenState !== null) {
          grid.updatePendingRowCreate(reopenState.index, { record });
        } else if (behavior === "withGridContext") {
          grid.queueRowCreate({ record });
        } else {
          await grid.refresh();
        }
        closeDialog();
        if (onSaved) await onSaved();
      } catch (err) {
        if (onError) await onError(err);
        else throw err;
      }
    },
    [reopenState, behavior, grid, closeDialog, onSaved, onError]
  );
  const dialogQueueRowCreate = useMemo(() => {
    if (reopenState === null) return grid.queueRowCreate;
    const idx = reopenState.index;
    return (create) => grid.updatePendingRowCreate(idx, create);
  }, [reopenState, grid.queueRowCreate, grid.updatePendingRowCreate]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      GridButton,
      {
        label: resolvedLabel,
        icon: /* @__PURE__ */ jsx(Add20Regular, {}),
        onClick: openDialog,
        disabled: isDisabled,
        ...appearance !== void 0 && { appearance }
      }
    ),
    open && tableName && /* @__PURE__ */ jsx(Dialog, { open, onOpenChange: handleOpenChange, modalType: "modal", children: /* @__PURE__ */ jsx(
      DialogSurface,
      {
        style: location === "panel" ? {
          margin: 0,
          marginLeft: "auto",
          maxWidth: "480px",
          width: "100%",
          height: "100vh",
          maxHeight: "100vh",
          borderRadius: 0
        } : void 0,
        children: isWizardMode ? /* @__PURE__ */ jsx(
          WizardRecordForm,
          {
            table: tableName,
            initialRecord: effectiveInitialRecord,
            onCancel: closeDialog,
            onCompleted: handleWizardCompleted,
            skipSave: effectiveBehavior === "withGridContext",
            children: resolvedChildren
          }
        ) : /* @__PURE__ */ jsx(RecordContext, { table: tableName, initialRecord: effectiveInitialRecord, children: /* @__PURE__ */ jsx(
          DialogInner2,
          {
            behavior: effectiveBehavior,
            dialogTitle,
            onClose: closeDialog,
            onSaved,
            onError,
            queueRowCreate: dialogQueueRowCreate,
            gridRefresh: grid.refresh,
            ...forceSuccessfulValidationBeforeSave !== void 0 && {
              forceSuccessfulValidationBeforeSave
            },
            children: resolvedChildren
          }
        ) })
      }
    ) })
  ] });
}
setGridButtonRole(NewRecordGridButton, GridButtonRole.Create);
function DialogInner2({
  children,
  behavior,
  dialogTitle,
  onClose,
  onSaved,
  onError,
  queueRowCreate,
  gridRefresh,
  forceSuccessfulValidationBeforeSave
}) {
  const ctx = useRecordContext();
  const innerMainContext = useMainContext();
  const validation = useValidationContext();
  const dialogSvc = useDialogService();
  const runWithOverlay = useRunWithOverlay();
  const t = useT();
  const styles = useDialogStyles2();
  const [saving, setSaving] = useState(false);
  const enforceValidation = forceSuccessfulValidationBeforeSave ?? innerMainContext?.forceSuccessfulValidationBeforeSave ?? true;
  const isRecordReady = ctx.status === QueryStatus.Success && ctx.record !== void 0;
  const resolvedTitle = dialogTitle ?? t("app.buttons.new.label");
  const handleSave = useCallback(async () => {
    setSaving(true);
    try {
      if (enforceValidation && validation && !await validation.validateAll()) return;
      if (behavior === "immediately") {
        await runWithOverlay(
          { description: t("app.messages.creating-record") },
          () => ctx.save()
        );
        await gridRefresh();
      } else {
        if (ctx.record) {
          queueRowCreate({ record: ctx.record });
        }
      }
      if (onSaved) await onSaved();
      onClose();
    } catch (err) {
      if (onError) {
        await onError(err);
      } else {
        await dialogSvc.showErrorAsync(
          err instanceof Error ? err.message : String(err),
          { title: t("app.errors.create-record") }
        );
      }
    } finally {
      setSaving(false);
    }
  }, [
    ctx,
    validation,
    behavior,
    runWithOverlay,
    t,
    dialogSvc,
    queueRowCreate,
    gridRefresh,
    onClose,
    onSaved,
    onError,
    enforceValidation
  ]);
  return /* @__PURE__ */ jsxs(DialogBody, { children: [
    /* @__PURE__ */ jsx(DialogTitle, { children: resolvedTitle }),
    /* @__PURE__ */ jsx(DialogContent, { children: isRecordReady ? children : /* @__PURE__ */ jsx("div", { className: styles.loadingArea, role: "status", "aria-live": "polite", children: /* @__PURE__ */ jsx(Spinner, { size: "large", label: t("app.messages.record-loading") }) }) }),
    /* @__PURE__ */ jsxs(DialogActions, { children: [
      /* @__PURE__ */ jsx(Button, { appearance: "secondary", onClick: onClose, disabled: saving, children: t("app.buttons.cancel.label") }),
      /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "primary",
          onClick: handleSave,
          disabled: saving || !isRecordReady || !ctx.isDirty,
          children: t("app.buttons.save.label")
        }
      )
    ] })
  ] });
}
function DeleteRecordGridButton({
  disabled,
  onBeforeDelete,
  onDeleted,
  onError,
  label,
  appearance,
  mode = "individually",
  behavior = "withGridContext"
}) {
  const { ppp } = usePowerPortalsPro();
  const dialog = useDialogService();
  const t = useT();
  const resolvedLabel = label ?? t("app.buttons.delete.label");
  const handleClick = useCallback(
    async (grid) => {
      const selectionCount = grid.selectedRecords.length;
      if (selectionCount === 0) return;
      if (onBeforeDelete) await onBeforeDelete();
      const message = t("app.messages.delete-records-confirmation", [
        selectionCount
      ]);
      const result = await dialog.showConfirmationAsync(message, {
        title: t("app.messages.delete-title"),
        primaryText: t("app.buttons.delete.label"),
        secondaryText: t("app.buttons.cancel.label")
      });
      if (result.cancelled) return;
      const targets = grid.selectedRecords.slice();
      const targetRefs = targets.filter((r) => r.id && r.tableName).map((r) => ({ tableName: r.tableName, id: r.id }));
      if (behavior === "withGridContext") {
        grid.queueRowDeletes(targetRefs);
        await grid.clearSelection();
      } else if (mode === "bulk") {
        const requests = targetRefs.map((ref) => ({
          $type: "DeleteRequest",
          record: ref
        }));
        if (requests.length > 0) {
          await ppp.executeMultipleAsync(requests, { returnResponses: false });
        }
        await grid.refresh();
      } else {
        for (const ref of targetRefs) {
          await ppp.deleteRecordAsync(ref.tableName, ref.id);
        }
        await grid.refresh();
      }
      if (onDeleted) {
        await onDeleted(
          targets.map((r) => ({
            ...r.tableName !== void 0 && { tableName: r.tableName },
            ...r.id !== void 0 && { id: r.id }
          }))
        );
      }
    },
    [ppp, dialog, t, onBeforeDelete, onDeleted, mode, behavior]
  );
  const additionallyDisabled = usePermissionGate();
  const effectiveOnError = useCallback(
    async (err) => {
      if (onError) {
        await onError(err);
        return;
      }
      await dialog.showErrorAsync(err instanceof Error ? err.message : String(err), {
        title: t("app.errors.record-delete")
      });
    },
    [dialog, t, onError]
  );
  return /* @__PURE__ */ jsx(
    GridButton,
    {
      label: resolvedLabel,
      icon: /* @__PURE__ */ jsx(Delete20Regular, {}),
      onClick: handleClick,
      visibilityBehavior: GridButtonBehavior.OneOrMoreSelected,
      enabledBehavior: GridButtonBehavior.OneOrMoreSelected,
      disabled: disabled === true || additionallyDisabled,
      onError: effectiveOnError,
      ...appearance !== void 0 && { appearance }
    }
  );
}
function usePermissionGate() {
  const grid = useGridContext();
  return !grid.selectedRecords.every((r) => {
    if (r.id?.startsWith("__pending-create-")) return true;
    return ((r.permissions ?? 0) & TableSecurityPermission.Delete) === TableSecurityPermission.Delete;
  });
}
setGridButtonRole(DeleteRecordGridButton, GridButtonRole.Delete);
function LinkExistingRecordGridButton({
  behavior = "withGridContext",
  mode = "individually",
  disabled,
  label,
  appearance,
  dialogTitle,
  onLinked,
  onError
}) {
  const { ppp } = usePowerPortalsPro();
  const grid = useGridContext();
  const dialog = useDialogService();
  const t = useT();
  const resolvedLabel = label ?? t("app.buttons.link-existing.label");
  const [open, setOpen] = useState(false);
  const [working, setWorking] = useState(false);
  const isSubGrid = !!grid.parentRecord && !!grid.relationshipName;
  const isDisabled = disabled === true || working || !isSubGrid;
  const parentRecord = grid.parentRecord;
  const relationshipName = grid.relationshipName;
  const dialogFilters = useMemo(() => {
    if (!parentRecord || !relationshipName) return void 0;
    if (!getRecordReferenceId(parentRecord)) return void 0;
    return [
      buildFilter(parentRecord, relationshipName, RelationshipFilterMode.ExcludeExistingRecords)
    ];
  }, [parentRecord, relationshipName]);
  const openDialog = useCallback(() => setOpen(true), []);
  const closeDialog = useCallback(() => setOpen(false), []);
  const handleAction = useCallback(
    async (selectedRecords) => {
      if (selectedRecords.length === 0) {
        closeDialog();
        return;
      }
      const parent = grid.parentRecord;
      const rel = grid.relationshipName;
      const parentRefId = parent ? getRecordReferenceId(parent) : void 0;
      if (!parentRefId || !parent?.tableName || !rel) {
        closeDialog();
        return;
      }
      const parentRef = {
        tableName: parent.tableName,
        id: parentRefId
      };
      setWorking(true);
      try {
        const existingIds = /* @__PURE__ */ new Set();
        for (const r of grid.pendingRowAssociates) {
          if (r.id) existingIds.add(r.id);
        }
        const pendingDisassociateIds = /* @__PURE__ */ new Set();
        for (const r of grid.pendingRowDisassociates) {
          if (r.id) pendingDisassociateIds.add(r.id);
        }
        for (const r of grid.loadedRecords) {
          if (r.id && !pendingDisassociateIds.has(r.id)) existingIds.add(r.id);
        }
        const linkable = [];
        for (const r of selectedRecords) {
          if (!r.id || !r.tableName) continue;
          if (existingIds.has(r.id)) continue;
          linkable.push(r);
        }
        if (linkable.length === 0) {
          closeDialog();
          return;
        }
        if (behavior === "withGridContext") {
          grid.queueRowAssociates(linkable);
        } else {
          const refs = linkable.map((r) => ({
            tableName: r.tableName,
            id: r.id
          }));
          const requests = [];
          if (mode === "bulk") {
            const req = {
              $type: "AssociateRequest",
              record: parentRef,
              relationshipName: rel,
              relatedRecords: refs
            };
            requests.push(req);
          } else {
            for (const ref of refs) {
              const req = {
                $type: "AssociateRequest",
                record: parentRef,
                relationshipName: rel,
                relatedRecords: [ref]
              };
              requests.push(req);
            }
          }
          await ppp.executeMultipleAsync(requests, { returnResponses: false });
          await grid.refresh();
        }
        closeDialog();
        if (onLinked) await onLinked(linkable);
      } catch (err) {
        if (onError) {
          await onError(err);
        } else {
          await dialog.showErrorAsync(err instanceof Error ? err.message : String(err), {
            title: t("app.errors.linking-records")
          });
        }
      } finally {
        setWorking(false);
      }
    },
    [behavior, mode, grid, ppp, dialog, t, onLinked, onError, closeDialog]
  );
  const tableNameLabel = grid.tableName ? t(`tables.${grid.tableName}.label`) : "";
  const resolvedDialogTitle = dialogTitle ?? t("app.components.lookup-form.title", [tableNameLabel]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      GridButton,
      {
        label: resolvedLabel,
        icon: /* @__PURE__ */ jsx(LinkAdd20Regular, {}),
        onClick: openDialog,
        disabled: isDisabled,
        ...appearance !== void 0 && { appearance }
      }
    ),
    grid.tableName && /* @__PURE__ */ jsx(
      LookupDialog,
      {
        hidden: !open,
        onHiddenChange: (hidden) => {
          if (hidden) closeDialog();
        },
        title: resolvedDialogTitle,
        tableNames: [grid.tableName],
        selectionMode: "multiple",
        actionLabel: t("app.buttons.link.label"),
        onActionClicked: handleAction,
        ...dialogFilters !== void 0 && { filters: dialogFilters }
      }
    )
  ] });
}
function UnlinkExistingRecordGridButton({
  behavior = "withGridContext",
  mode = "individually",
  disabled,
  label,
  appearance,
  onUnlinked,
  onError
}) {
  const { ppp } = usePowerPortalsPro();
  const dialog = useDialogService();
  const t = useT();
  const resolvedLabel = label ?? t("app.buttons.unlink.label");
  const gridForGate = useGridContext();
  const isSubGrid = !!gridForGate.parentRecord && !!gridForGate.relationshipName;
  const handleClick = useCallback(
    async (grid) => {
      const selectionCount = grid.selectedRecords.length;
      if (selectionCount === 0) return;
      const parent = grid.parentRecord;
      const rel = grid.relationshipName;
      const parentRefId = parent ? getRecordReferenceId(parent) : void 0;
      if (!parentRefId || !parent?.tableName || !rel) return;
      const parentRef = {
        tableName: parent.tableName,
        id: parentRefId
      };
      const message = selectionCount === 1 ? t("app.messages.unlink-record-confirmation") : t("app.messages.unlink-records-confirmation", [selectionCount]);
      const result = await dialog.showConfirmationAsync(message, {
        title: t("app.messages.unlink-title"),
        primaryText: t("app.buttons.unlink.label"),
        secondaryText: t("app.buttons.cancel.label")
      });
      if (result.cancelled) return;
      const refs = [];
      for (const r of grid.selectedRecords) {
        if (!r.id || !r.tableName) continue;
        refs.push({ tableName: r.tableName, id: r.id });
      }
      if (behavior === "withGridContext") {
        grid.queueRowDisassociates(refs);
      } else {
        const requests = [];
        if (mode === "bulk") {
          const req = {
            $type: "DisassociateRequest",
            record: parentRef,
            relationshipName: rel,
            relatedRecords: refs
          };
          requests.push(req);
        } else {
          for (const ref of refs) {
            const req = {
              $type: "DisassociateRequest",
              record: parentRef,
              relationshipName: rel,
              relatedRecords: [ref]
            };
            requests.push(req);
          }
        }
        await ppp.executeMultipleAsync(requests, { returnResponses: false });
        await grid.refresh();
      }
      if (onUnlinked) await onUnlinked(refs);
    },
    [behavior, mode, ppp, dialog, t, onUnlinked]
  );
  const effectiveOnError = useCallback(
    async (err) => {
      if (onError) {
        await onError(err);
        return;
      }
      await dialog.showErrorAsync(err instanceof Error ? err.message : String(err), {
        title: t("app.errors.unlinking-records")
      });
    },
    [dialog, t, onError]
  );
  return /* @__PURE__ */ jsx(
    GridButton,
    {
      label: resolvedLabel,
      icon: /* @__PURE__ */ jsx(LinkDismiss20Regular, {}),
      onClick: handleClick,
      visibilityBehavior: GridButtonBehavior.OneOrMoreSelected,
      enabledBehavior: GridButtonBehavior.OneOrMoreSelected,
      disabled: disabled === true || !isSubGrid,
      onError: effectiveOnError,
      ...appearance !== void 0 && { appearance }
    }
  );
}
function SubGrid({ relationshipName, record: explicitRecord, className, ...mainGridProps }) {
  const ctx = useRecordContextOptional();
  const parentRecord = explicitRecord ?? ctx?.record;
  const hasDataSource = mainGridProps.dataSource !== void 0;
  const parentRefId = parentRecord ? getRecordReferenceId(parentRecord) : void 0;
  const filters = useMemo(() => {
    if (hasDataSource) return null;
    if (!parentRecord?.tableName || !parentRefId) return null;
    return [
      {
        $type: "RelationshipFilter",
        parentRecord: { tableName: parentRecord.tableName, id: parentRefId },
        relationshipName
        // `mode` left at the server's default (IncludeExistingRecords)
        // — the SubGrid case wants "records currently related to this
        // parent." `ExcludeExistingRecords` is for the
        // ManyToManyLookupEdit autocomplete pool, not this surface.
      }
    ];
  }, [hasDataSource, parentRecord?.tableName, parentRefId, relationshipName]);
  if (!parentRecord?.tableName || !parentRefId) return null;
  return /* @__PURE__ */ jsx(
    MainGrid,
    {
      ...mainGridProps,
      ...filters && { filters },
      parentRecord,
      relationshipName,
      className: mergeClasses("ppp-sub-grid", className)
    }
  );
}

// src/grids/file-grid-helpers.ts
function ensureFileColumnInView(view, fileColumn) {
  const alreadyInColumns = view.columns.some((c) => c.columnName === fileColumn);
  const alreadyInFetchXml = fetchXmlHasAttribute(view.fetchXml, fileColumn);
  if (alreadyInColumns && alreadyInFetchXml) return view;
  const columns = alreadyInColumns ? view.columns : [...view.columns, { columnName: fileColumn, width: 250 }];
  const fetchXml = alreadyInFetchXml ? view.fetchXml : addFetchXmlAttribute(view.fetchXml, fileColumn);
  return { ...view, columns, fetchXml };
}
function fetchXmlHasAttribute(fetchXml, attributeName) {
  const doc = parseFetchXml(fetchXml);
  if (!doc) return false;
  const entity = doc.querySelector("entity");
  if (!entity) return false;
  return Array.from(entity.children).some(
    (child) => child.tagName === "attribute" && child.getAttribute("name") === attributeName
  );
}
function addFetchXmlAttribute(fetchXml, attributeName) {
  const doc = parseFetchXml(fetchXml);
  if (!doc) return fetchXml;
  const entity = doc.querySelector("entity");
  if (!entity) return fetchXml;
  const attr = doc.createElement("attribute");
  attr.setAttribute("name", attributeName);
  entity.appendChild(attr);
  return new XMLSerializer().serializeToString(doc);
}
function parseFetchXml(fetchXml) {
  try {
    const doc = new DOMParser().parseFromString(fetchXml, "application/xml");
    if (doc.getElementsByTagName("parsererror").length > 0) return null;
    return doc;
  } catch {
    return null;
  }
}
function isExtensionAllowed(fileName, allowedExtensions) {
  if (!allowedExtensions || allowedExtensions.length === 0) return true;
  const ext = getFileExtension(fileName);
  if (!ext) return false;
  return allowedExtensions.map((x) => x.replace(/^\./, "").toLowerCase()).includes(ext);
}
function isExtensionBlocked(fileName, blockedExtensions) {
  return blockedExtensions.has(getFileExtension(fileName));
}
var useFileGridStyles = makeStyles({
  // Outer wrapper that receives the drag events. `position: relative`
  // anchors the dropzone overlay; full width matches the inner grid's
  // natural sizing.
  wrapper: {
    position: "relative",
    width: "100%",
    minWidth: 0
  },
  // Soft accent outline drawn while a drag is in progress. `outline`
  // (not `border`) is used so no extra layout space is taken, avoiding
  // a 2px jitter when the user crosses the grid boundary mid-drag.
  wrapperDragActive: {
    outlineWidth: "2px",
    outlineStyle: "dashed",
    outlineColor: tokens.colorBrandStroke1,
    outlineOffset: "-2px"
  },
  // Full-bleed translucent overlay shown only while dragging. The
  // overlay itself is `pointer-events: none` so the underlying drop
  // handlers on the wrapper still receive the events — the overlay
  // is purely visual feedback.
  dropZone: {
    position: "absolute",
    inset: 0,
    zIndex: 10,
    pointerEvents: "none",
    backgroundColor: tokens.colorBrandBackground2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: tokens.colorBrandForeground1,
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase400
  },
  // Centered card inside the overlay — icon stacked above the prompt
  // text. Sits on a solid panel so the prompt is readable regardless
  // of the rows underneath.
  dropZoneInner: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    rowGap: tokens.spacingVerticalS,
    paddingTop: tokens.spacingVerticalL,
    paddingBottom: tokens.spacingVerticalL,
    paddingLeft: tokens.spacingHorizontalXXL,
    paddingRight: tokens.spacingHorizontalXXL,
    backgroundColor: tokens.colorNeutralBackground1,
    borderRadius: tokens.borderRadiusMedium,
    boxShadow: tokens.shadow8,
    pointerEvents: "none"
  },
  // Hidden file inputs — kept in the DOM so the Upload / Replace
  // buttons can `.click()` them, but never visible. `display: none`
  // works fine here; Safari/Chrome both fire the OS picker correctly
  // from a programmatic click on a hidden input.
  hiddenInput: {
    display: "none"
  },
  // Full-bleed busy scrim shown while uploads / downloads / replace
  // operations are in flight. `position: absolute` over the wrapper
  // (which is `position: relative`) so the spinner pins above the
  // grid without scrolling with it. Above the dropzone overlay
  // (zIndex 10) so a slow upload after a drop is visible.
  busyOverlay: {
    position: "absolute",
    inset: 0,
    zIndex: 11,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: tokens.colorNeutralBackgroundAlpha
  }
});
function GridButtons({ children, className, style }) {
  const styles = useMainGridStyles();
  return /* @__PURE__ */ jsx("div", { className: mergeClasses(styles.buttonsBar, className), style, children });
}
var DEFAULT_MAX_FILE_SIZE_BYTES = 128 * 1024 * 1024;
var MAX_FILES_PER_UPLOAD = 1e3;
function GridContextBridge({
  contextRef
}) {
  const ctx = useGridContext();
  contextRef.current = ctx;
  return null;
}
function FileGrid(props) {
  const {
    tableName,
    fileColumn,
    autoAddFileColumnIfMissingFromView = true,
    allowDownloadAll = true,
    maxFileSizeBytes = DEFAULT_MAX_FILE_SIZE_BYTES,
    allowedExtensions,
    onUploadRecordAsync,
    transformViewAsync,
    children,
    className,
    style,
    // Forwarded MainGrid props with FileGrid-friendly defaults.
    selectionMode = "multiple",
    selectFromEntireRow = true,
    pageSize = 50,
    ...forwardedMainGridProps
  } = props;
  const styles = useFileGridStyles();
  const t = useT();
  const dialog = useDialogService();
  const { ppp } = usePowerPortalsPro();
  const mainContext = useMainContext();
  const tableMetadata = useTableMetadata(tableName);
  const organizationSettings = useOrganizationSettings();
  const effectiveMaxFileSizeBytes = useMemo(() => {
    let cap = maxFileSizeBytes;
    const columnMeta = tableMetadata.data?.columns?.find(
      (c) => c.columnName === fileColumn
    );
    const columnMaxKb = columnMeta?.maxSizeInKB;
    if (columnMaxKb !== void 0 && columnMaxKb !== null) {
      const kb = typeof columnMaxKb === "string" ? Number(columnMaxKb) : columnMaxKb;
      if (Number.isFinite(kb) && kb > 0) {
        cap = Math.min(cap, kb * 1024);
      }
    }
    const envMaxRaw = organizationSettings.data?.maxUploadFileSizeInBytes;
    const envMax = typeof envMaxRaw === "string" ? Number(envMaxRaw) : envMaxRaw;
    if (typeof envMax === "number" && Number.isFinite(envMax) && envMax > 0) {
      cap = Math.min(cap, envMax);
    }
    return cap;
  }, [
    maxFileSizeBytes,
    tableMetadata.data,
    fileColumn,
    organizationSettings.data
  ]);
  const blockedExtensions = useMemo(() => {
    return new Set(organizationSettings.data?.blockedFileExtensions ?? []);
  }, [organizationSettings.data]);
  const uploadInputRef = useRef(null);
  const replaceInputRef = useRef(null);
  const gridContextRef = useRef(null);
  const dragDepthRef = useRef(0);
  const [dragActive, setDragActive] = useState(false);
  const [busy, setBusy] = useState(false);
  const replaceTargetRef = useRef(null);
  const accept = useMemo(() => {
    if (!allowedExtensions || allowedExtensions.length === 0) return void 0;
    return allowedExtensions.map((e) => e.startsWith(".") ? e : `.${e}`).join(",");
  }, [allowedExtensions]);
  const composedTransformViewAsync = useMemo(() => {
    if (!autoAddFileColumnIfMissingFromView && !transformViewAsync) return void 0;
    return async (view) => {
      const withFile = autoAddFileColumnIfMissingFromView ? ensureFileColumnInView(view, fileColumn) : view;
      return transformViewAsync ? await transformViewAsync(withFile) : withFile;
    };
  }, [autoAddFileColumnIfMissingFromView, fileColumn, transformViewAsync]);
  const showError = useCallback(
    (message, title) => {
      void dialog.showErrorAsync(message, title ? { title } : void 0);
    },
    [dialog]
  );
  const filterAndReportExtensions = useCallback(
    (files) => {
      const ok = [];
      for (const file of files) {
        if (file.size > effectiveMaxFileSizeBytes) {
          showError(
            t("app.components.file-grid.file-too-large", [
              file.name,
              file.size,
              effectiveMaxFileSizeBytes
            ])
          );
          continue;
        }
        if (isExtensionBlocked(file.name, blockedExtensions)) {
          showError(
            t("app.components.file-grid.extension-blocked", [
              file.name,
              getFileExtension(file.name)
            ])
          );
          continue;
        }
        if (!isExtensionAllowed(file.name, allowedExtensions)) {
          showError(
            t("app.components.file-grid.extension-not-allowed", [
              file.name,
              (allowedExtensions ?? []).join(", ")
            ])
          );
          continue;
        }
        ok.push(file);
      }
      return ok;
    },
    [
      allowedExtensions,
      blockedExtensions,
      effectiveMaxFileSizeBytes,
      showError,
      t
    ]
  );
  const buildDefaultUploadRecord = useCallback(
    (fileName, base64) => {
      const fileValue = {
        $type: "FileValue",
        fileName,
        id: EMPTY_GUID,
        value: base64
      };
      return {
        tableName,
        properties: { [fileColumn]: fileValue }
      };
    },
    [fileColumn, tableName]
  );
  const uploadFiles = useCallback(
    async (files) => {
      const grid = gridContextRef.current;
      const accepted = filterAndReportExtensions(files);
      if (accepted.length === 0) return;
      setBusy(true);
      try {
        const records = [];
        for (const { name, bytes } of accepted) {
          const base64 = bytesToBase642(bytes);
          const record = onUploadRecordAsync ? await onUploadRecordAsync(name, bytes) : buildDefaultUploadRecord(name, base64);
          records.push(record);
        }
        if (records.length === 0) return;
        if (mainContext) {
          for (const record of records) {
            grid?.queueRowCreate({ record });
          }
          await grid?.refresh();
        } else {
          for (const record of records) {
            await ppp.createRecordAsync(record);
          }
          await grid?.refresh();
        }
      } catch (err) {
        showError(
          err instanceof Error ? err.message : String(err),
          t("app.components.file-grid.upload-failed-title")
        );
      } finally {
        setBusy(false);
      }
    },
    [
      buildDefaultUploadRecord,
      filterAndReportExtensions,
      mainContext,
      onUploadRecordAsync,
      ppp,
      showError,
      t
    ]
  );
  const onUploadInputChange = useCallback(
    async (ev) => {
      const fileList = ev.target.files;
      if (!fileList) return;
      const picked = Array.from(fileList).slice(0, MAX_FILES_PER_UPLOAD);
      ev.target.value = "";
      const payloads = [];
      for (const f of picked) {
        const buf = await f.arrayBuffer();
        payloads.push({ name: f.name, size: f.size, bytes: new Uint8Array(buf) });
      }
      await uploadFiles(payloads);
    },
    [uploadFiles]
  );
  const onReplaceInputChange = useCallback(
    async (ev) => {
      const target = replaceTargetRef.current;
      replaceTargetRef.current = null;
      const file = ev.target.files?.[0];
      ev.target.value = "";
      if (!target || !file) return;
      if (file.size > effectiveMaxFileSizeBytes) {
        showError(
          t("app.components.file-grid.file-too-large", [
            file.name,
            file.size,
            effectiveMaxFileSizeBytes
          ])
        );
        return;
      }
      if (isExtensionBlocked(file.name, blockedExtensions)) {
        showError(
          t("app.components.file-grid.extension-blocked", [
            file.name,
            getFileExtension(file.name)
          ])
        );
        return;
      }
      if (!isExtensionAllowed(file.name, allowedExtensions)) {
        showError(
          t("app.components.file-grid.extension-not-allowed", [
            file.name,
            (allowedExtensions ?? []).join(", ")
          ])
        );
        return;
      }
      const grid = gridContextRef.current;
      setBusy(true);
      try {
        const base64 = await readFileAsBase64(file);
        const fileValue = {
          $type: "FileValue",
          fileName: file.name,
          id: target.id ?? EMPTY_GUID,
          value: base64
        };
        if (mainContext && target.id) {
          grid?.queueRowUpdate({
            tableName,
            recordId: target.id,
            dirty: /* @__PURE__ */ new Map([[fileColumn, fileValue]])
          });
          await grid?.refresh();
        } else if (target.id) {
          const update = {
            tableName,
            id: target.id,
            properties: { [fileColumn]: fileValue }
          };
          await ppp.updateRecordAsync(update);
          await grid?.refresh();
        }
      } catch (err) {
        showError(
          err instanceof Error ? err.message : String(err),
          t("app.components.file-grid.replace-failed-title")
        );
      } finally {
        setBusy(false);
      }
    },
    [
      allowedExtensions,
      blockedExtensions,
      effectiveMaxFileSizeBytes,
      fileColumn,
      mainContext,
      ppp,
      showError,
      t,
      tableName
    ]
  );
  const downloadRecords = useCallback(
    async (records) => {
      const ids = records.map((r) => r.id).filter((id) => !!id);
      if (ids.length === 0) {
        showError(
          t("app.components.file-grid.no-records-selected"),
          t("app.components.file-grid.nothing-to-download-title")
        );
        return;
      }
      setBusy(true);
      try {
        if (ids.length === 1) {
          const onlyId = ids[0];
          const info = await ppp.getFileInfoAsync(tableName, onlyId, fileColumn, true);
          if (!info.fileName || !info.fileData) {
            showError(t("app.components.file-grid.no-file-attached"));
            return;
          }
          triggerBlobDownload(base64ToBytes(info.fileData), info.fileName);
          return;
        }
        const archive = await ppp.createFileArchiveAsync({
          tableName,
          columnName: fileColumn,
          recordIds: ids
          // Format/responseFormat default server-side (Zip / BinaryStream).
        });
        if (archive.data.length === 0) {
          showError(t("app.components.file-grid.no-files-attached"));
          return;
        }
        triggerBlobDownload(archive.data, archive.fileName);
      } catch (err) {
        showError(
          err instanceof Error ? err.message : String(err),
          t("app.components.file-grid.download-failed-title")
        );
      } finally {
        setBusy(false);
      }
    },
    [fileColumn, ppp, showError, t, tableName]
  );
  const onDragEnter = useCallback((e) => {
    e.preventDefault();
    dragDepthRef.current += 1;
    if (dragDepthRef.current === 1) setDragActive(true);
  }, []);
  const onDragOver = useCallback((e) => {
    e.preventDefault();
  }, []);
  const onDragLeave = useCallback((e) => {
    e.preventDefault();
    dragDepthRef.current = Math.max(0, dragDepthRef.current - 1);
    if (dragDepthRef.current === 0) setDragActive(false);
  }, []);
  const onDrop = useCallback(
    async (e) => {
      e.preventDefault();
      dragDepthRef.current = 0;
      setDragActive(false);
      const fileList = e.dataTransfer?.files;
      if (!fileList || fileList.length === 0) return;
      const grid = gridContextRef.current;
      const canCreate = hasPermission(grid?.tablePermissions, TableSecurityPermission.Create);
      if (grid?.tablePermissions !== void 0 && !canCreate) return;
      const picked = Array.from(fileList).slice(0, MAX_FILES_PER_UPLOAD);
      const payloads = [];
      for (const f of picked) {
        const buf = await f.arrayBuffer();
        payloads.push({ name: f.name, size: f.size, bytes: new Uint8Array(buf) });
      }
      await uploadFiles(payloads);
    },
    [uploadFiles]
  );
  useEffect(() => {
    const onDocDragEnd = () => {
      dragDepthRef.current = 0;
      setDragActive(false);
    };
    document.addEventListener("dragend", onDocDragEnd);
    return () => document.removeEventListener("dragend", onDocDragEnd);
  }, []);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: mergeClasses(
        "ppp-file-grid",
        styles.wrapper,
        dragActive && styles.wrapperDragActive,
        className
      ),
      style,
      onDragEnter,
      onDragOver,
      onDragLeave,
      onDrop,
      children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            ref: uploadInputRef,
            type: "file",
            multiple: true,
            className: styles.hiddenInput,
            accept,
            onChange: onUploadInputChange
          }
        ),
        /* @__PURE__ */ jsx(
          "input",
          {
            ref: replaceInputRef,
            type: "file",
            className: styles.hiddenInput,
            accept,
            onChange: onReplaceInputChange
          }
        ),
        /* @__PURE__ */ jsxs(
          MainGrid,
          {
            tableName,
            selectionMode,
            selectFromEntireRow,
            pageSize,
            ...composedTransformViewAsync !== void 0 && {
              transformViewAsync: composedTransformViewAsync
            },
            ...forwardedMainGridProps,
            children: [
              /* @__PURE__ */ jsx(GridContextBridge, { contextRef: gridContextRef }),
              /* @__PURE__ */ jsxs(GridButtons, { children: [
                /* @__PURE__ */ jsx(
                  UploadGridButton,
                  {
                    onClick: () => uploadInputRef.current?.click()
                  }
                ),
                /* @__PURE__ */ jsx(
                  ReplaceGridButton,
                  {
                    onClick: (record) => {
                      replaceTargetRef.current = record;
                      replaceInputRef.current?.click();
                    }
                  }
                ),
                allowDownloadAll && /* @__PURE__ */ jsx(DownloadGridButton, { onDownload: downloadRecords }),
                /* @__PURE__ */ jsx(DeleteRecordGridButton, {}),
                children
              ] })
            ]
          }
        ),
        dragActive && /* @__PURE__ */ jsx("div", { className: styles.dropZone, children: /* @__PURE__ */ jsxs("div", { className: styles.dropZoneInner, children: [
          /* @__PURE__ */ jsx(ArrowUpload32Regular, {}),
          /* @__PURE__ */ jsx("span", { children: t("app.components.file-grid.drop-files-prompt") })
        ] }) }),
        busy && /* @__PURE__ */ jsx("div", { className: styles.busyOverlay, children: /* @__PURE__ */ jsx(Spinner, { size: "medium" }) })
      ]
    }
  );
}
var useButtonStyles = makeStyles({
  // Inline-flex so the icon + text stay tight and the tooltip wraps
  // the entire button (Fluent's <Tooltip> wraps its child outright).
  button: { minWidth: "unset" }
});
function UploadGridButton({ onClick }) {
  const t = useT();
  const buttonStyles = useButtonStyles();
  const grid = useGridContext();
  const selectionCount = grid.selectedRecords.length;
  if (selectionCount > 0) return null;
  if (grid.tablePermissions !== void 0 && !hasPermission(grid.tablePermissions, TableSecurityPermission.Create)) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    Tooltip,
    {
      relationship: "label",
      content: t("app.components.file-grid.upload-tooltip"),
      children: /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "subtle",
          icon: /* @__PURE__ */ jsx(ArrowUpload24Regular, {}),
          onClick,
          className: buttonStyles.button,
          children: t("app.components.file-grid.upload-label")
        }
      )
    }
  );
}
function ReplaceGridButton({
  onClick
}) {
  const t = useT();
  const buttonStyles = useButtonStyles();
  const grid = useGridContext();
  if (grid.selectedRecords.length !== 1) return null;
  const target = grid.selectedRecords[0];
  if (!target || !target.id) return null;
  if (grid.tablePermissions !== void 0 && !hasPermission(grid.tablePermissions, TableSecurityPermission.Write)) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    Tooltip,
    {
      relationship: "label",
      content: t("app.components.file-grid.replace-tooltip"),
      children: /* @__PURE__ */ jsx(
        Button,
        {
          appearance: "subtle",
          icon: /* @__PURE__ */ jsx(ArrowSync24Regular, {}),
          onClick: () => onClick(target),
          className: buttonStyles.button,
          children: t("app.components.file-grid.replace-label")
        }
      )
    }
  );
}
function DownloadGridButton({
  onDownload
}) {
  const t = useT();
  const buttonStyles = useButtonStyles();
  const grid = useGridContext();
  const selectionCount = grid.selectedRecords.length;
  const label = selectionCount > 0 ? t("app.components.file-grid.download-selected-label") : t("app.components.file-grid.download-all-label");
  const tooltip = selectionCount > 0 ? t("app.components.file-grid.download-selected-tooltip") : t("app.components.file-grid.download-all-tooltip");
  const onClick = useCallback(() => {
    const target = selectionCount > 0 ? grid.selectedRecords : grid.loadedRecords;
    void onDownload(target);
  }, [grid.loadedRecords, grid.selectedRecords, onDownload, selectionCount]);
  return /* @__PURE__ */ jsx(Tooltip, { relationship: "label", content: tooltip, children: /* @__PURE__ */ jsx(
    Button,
    {
      appearance: "subtle",
      icon: /* @__PURE__ */ jsx(DrawerArrowDownload24Regular, {}),
      onClick,
      className: buttonStyles.button,
      children: label
    }
  ) });
}
function bytesToBase642(bytes) {
  const CHUNK = 32768;
  let binary = "";
  for (let i = 0; i < bytes.length; i += CHUNK) {
    binary += String.fromCharCode(...bytes.subarray(i, i + CHUNK));
  }
  return btoa(binary);
}
function hasPermission(bitmask, required) {
  if (bitmask === void 0) return false;
  return (bitmask & required) === required;
}
var clamp = (n, min, max) => Math.min(Math.max(n, min), max);
function useResizablePane({
  defaultWidth,
  minWidth,
  maxWidth,
  storageKey
}) {
  const [width, setWidth] = useState(() => {
    if (storageKey && typeof window !== "undefined") {
      try {
        const raw = window.localStorage.getItem(storageKey);
        if (raw !== null) {
          const n = Number.parseFloat(raw);
          if (Number.isFinite(n)) return clamp(n, minWidth, maxWidth);
        }
      } catch {
      }
    }
    return clamp(defaultWidth, minWidth, maxWidth);
  });
  const [isResizing, setIsResizing] = useState(false);
  const dragRef = useRef(null);
  const widthRef = useRef(width);
  widthRef.current = width;
  const persist = useCallback(
    (w) => {
      if (storageKey && typeof window !== "undefined") {
        try {
          window.localStorage.setItem(storageKey, String(Math.round(w)));
        } catch {
        }
      }
    },
    [storageKey]
  );
  const onPointerDown = useCallback((e) => {
    if (e.button !== 0) return;
    const el = e.currentTarget;
    el.setPointerCapture(e.pointerId);
    dragRef.current = {
      startX: e.clientX,
      startWidth: widthRef.current,
      rtl: getComputedStyle(el).direction === "rtl"
    };
    setIsResizing(true);
    e.preventDefault();
  }, []);
  const onPointerMove = useCallback(
    (e) => {
      const drag = dragRef.current;
      if (!drag) return;
      const delta = e.clientX - drag.startX;
      setWidth(clamp(drag.startWidth + (drag.rtl ? -delta : delta), minWidth, maxWidth));
    },
    [minWidth, maxWidth]
  );
  const endDrag = useCallback(
    (e) => {
      if (!dragRef.current) return;
      if (e.currentTarget.hasPointerCapture(e.pointerId)) {
        e.currentTarget.releasePointerCapture(e.pointerId);
      }
      dragRef.current = null;
      setIsResizing(false);
      persist(widthRef.current);
    },
    [persist]
  );
  const onDoubleClick = useCallback(() => {
    const next = clamp(defaultWidth, minWidth, maxWidth);
    setWidth(next);
    persist(next);
  }, [defaultWidth, minWidth, maxWidth, persist]);
  return {
    width,
    isResizing,
    handleProps: { onPointerDown, onPointerMove, onPointerUp: endDrag, onDoubleClick }
  };
}
var PageLayoutNestingContext = createContext({ isNested: false });
var usePageLayoutStyles = makeStyles({
  // Top-level layout — fills the viewport. The `:has()` carve-out in
  // `mainContent` below handles the "nested layout inside this body"
  // case by suppressing the outer body's padding when an inner layout
  // is detected (so nested layouts don't get doubled padding).
  root: {
    position: "relative",
    display: "grid",
    gridTemplateColumns: "auto minmax(0, 1fr)",
    gridTemplateRows: "auto 1fr auto",
    // Lets the PageLayout shrink when it's nested inside another
    // PageLayout's `<main>` (the outer main is a grid item; without
    // `min-width: 0` on this inner root the outer's `minmax(0, 1fr)`
    // track wouldn't be honored once content tries to grow wider).
    minWidth: 0,
    gridTemplateAreas: `
      'header header'
      'navigation main'
      'footer footer'
    `,
    height: "100vh",
    minHeight: "100vh",
    // Mobile uses dynamic viewport units so iOS Safari's collapsing URL
    // bar doesn't clip the footer behind it.
    "@media (max-width: 767.97px)": {
      height: "100dvh",
      minHeight: "100dvh"
    }
  },
  // Child layout — fills its parent's body area, not the viewport.
  childRoot: {
    height: "100%",
    minHeight: "100%"
  },
  // Resizable nav: the first track is driven by the `--ppp-nav-width` custom property
  // (set inline from the hook's clamped width) instead of `auto`. On mobile the nav
  // reflows and the handle hides, so revert to the content-sized `auto` track there
  // a stylesheet media query can override the inline custom-property-based track,
  // which an inline `gridTemplateColumns` couldn't.
  rootResizable: {
    gridTemplateColumns: "var(--ppp-nav-width) minmax(0, 1fr)",
    "@media (max-width: 767.97px)": {
      gridTemplateColumns: "auto minmax(0, 1fr)"
    }
  },
  // Applied to the root only while a drag is in progress: kills text selection and
  // forces the resize cursor everywhere so it doesn't flicker as the pointer leaves
  // the thin handle mid-drag.
  rootResizing: {
    userSelect: "none",
    cursor: "col-resize"
  },
  // When resizable, the unified `--ppp-nav-max-width` token still caps the element
  // the px track owns the width, but the cap (sourced from `maxNavigationWidth`)
  // lets a consumer rein in how wide the rail can be dragged from a single property.
  // Mobile reverts to 35vw via the media query since resizing is disabled there.
  navigationResizable: {
    maxWidth: "var(--ppp-nav-max-width, none)",
    "@media (max-width: 767.97px)": {
      maxWidth: "35vw"
    },
    // A NavMenu rail clamps itself to 250–320px (its standalone default). Inside a
    // resizable layout that cap fights the drag — the track keeps growing but the rail
    // stops widening at ~320px. Let it fill the user-sized track instead; PageLayout's
    // min/max nav width are the real bounds here. Descendant specificity (0,2,0) beats
    // NavMenu's atomic root class, so this wins without !important.
    "& .ppp-nav-menu": {
      minWidth: 0,
      maxWidth: "none",
      width: "100%"
    }
  },
  // Drag handle. Placed in the `main` area at its inline-start edge (the nav/main
  // boundary) rather than the nav's inline-end edge, so it never overlaps the nav's
  // scrollbar. Spans the middle grid row only (stretches within `main`), so it doesn't
  // cover the header/footer. Transparent until hover/active.
  resizeHandle: {
    gridArea: "main",
    justifySelf: "start",
    alignSelf: "stretch",
    width: "6px",
    zIndex: 2,
    cursor: "col-resize",
    backgroundColor: "transparent",
    // Stop touch drags from scrolling the page while resizing.
    touchAction: "none",
    transitionProperty: "background-color",
    transitionDuration: tokens.durationFaster,
    ":hover": {
      backgroundColor: tokens.colorNeutralStroke1Hover
    },
    // No handle on mobile — the nav track reverts to `auto` and isn't user-sized.
    "@media (max-width: 767.97px)": {
      display: "none"
    }
  },
  resizeHandleActive: {
    backgroundColor: tokens.colorBrandStroke1
  },
  // PageLayout-specific CONTEXT overrides on top of the canonical
  // `<Header>` styling (`layout/header.tsx`). These override the
  // background + border + corner radius + padding to produce the
  // page-level header look that
  // `.page-layout header { ... }` rules — taller (min-height 50),
  // accent-colored 2px bottom border (vs Section's neutral 1px),
  // wider horizontal padding. Grid-area placement is the structural
  // concern PageLayout owns regardless of which component renders
  // inside.
  header: {
    gridArea: "header",
    backgroundColor: tokens.colorNeutralBackground3,
    borderBottom: `2px solid ${tokens.colorBrandStroke1}`,
    // PageLayout's header sits at the top of the viewport — no rounding
    // because there's nothing above it to wrap around.
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    minHeight: "50px",
    paddingLeft: tokens.spacingHorizontalL,
    paddingRight: tokens.spacingHorizontalL
  },
  // Child layouts get a thinner border so the visual weight doesn't
  // stack when one PageLayout's body contains another.
  childHeader: {
    borderBottomWidth: "1px"
  },
  navigation: {
    gridArea: "navigation",
    overflowY: "auto",
    // Unified element cap, sourced from `maxNavigationWidth` via the
    // `--ppp-nav-max-width` inline custom property. Defaults to 35vw when the
    // token isn't set (defensive — the component always seeds it).
    maxWidth: "var(--ppp-nav-max-width, 35vw)"
  },
  main: {
    gridArea: "main",
    overflowY: "auto",
    // CSS Grid items default to `min-width: auto`, which makes them as
    // wide as their content's intrinsic min size — overriding the
    // outer grid's `minmax(0, 1fr)` track when content is wider than
    // the viewport. Without `min-width: 0` here, a wide descendant
    // (e.g., a MainGrid full of data columns whose summed widths
    // exceed the viewport) drags the whole main column past the right
    // edge and every sibling inside the body inherits that wider
    // width — multi-line MessageBars, headers, etc. then wrap (or
    // don't) at viewport-relative positions that look wrong. With
    // `min-width: 0`, the main column respects the track's 1fr cap,
    // and the descendant's own scroll container (the grid's
    // `tableContainer` has `overflow: auto`) handles its internal
    // horizontal overflow without involving the page.
    minWidth: 0,
    // Default padding for the body. Suppressed via the `:has()` rule
    // below when a nested PageLayout lives inside; that prevents the
    // outer body's padding from double-wrapping the inner layout's
    // header/nav/footer.
    padding: `1.3rem 1.25rem 1.25rem 1.25rem`,
    "@media (max-width: 767.97px)": {
      padding: "0.75rem"
    },
    // When a descendant is itself a PageLayout (detected by the root
    // class below), drop the outer body's padding so the inner
    // layout's bands sit flush against the outer layout's main edges.
    "&:has(.ppp-page-layout-root)": {
      padding: 0
    }
  },
  // PageLayout-specific CONTEXT overrides for the bottom-of-viewport
  // footer band. Same approach as `header` above — overrides the
  // canonical `<Footer>` styling (`layout/footer.tsx`) only where
  // PageLayout needs different visual treatment.
  // `.page-layout footer { ... }` rules: Background3 instead of
  // Background2, no top-border (the body/footer background contrast is
  // enough), no rounded corners (sitting flush at the viewport bottom).
  footer: {
    gridArea: "footer",
    flexDirection: "row",
    backgroundColor: tokens.colorNeutralBackground3,
    borderTop: "none",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS
  }
});
function PageLayout({
  header,
  navigation,
  body,
  footer,
  headerVisible = true,
  navigationVisible = true,
  footerVisible = true,
  className,
  style,
  headerClassName,
  headerStyle,
  navigationClassName,
  navigationStyle,
  bodyClassName,
  bodyStyle,
  footerClassName,
  footerStyle,
  scrollResetKey,
  enableNavigationResizing = true,
  defaultNavigationWidth = 280,
  minNavigationWidth = 200,
  maxNavigationWidth = 480,
  persistNavigationWidth = true,
  navigationResizeStorageKey = "ppp-page-layout-nav-width",
  navigationResizeHandleLabel = "Resize navigation"
}) {
  const styles = usePageLayoutStyles();
  const { isNested } = useContext(PageLayoutNestingContext);
  const mainRef = useRef(null);
  const resizable = enableNavigationResizing && navigationVisible && navigation !== void 0;
  const {
    width: navWidth,
    isResizing,
    handleProps
  } = useResizablePane({
    defaultWidth: defaultNavigationWidth,
    minWidth: minNavigationWidth,
    maxWidth: maxNavigationWidth,
    // Persistence opt-out: when `persistNavigationWidth` is false, drop the storage
    // key so the hook never reads from / writes to localStorage. Matches the
    // C# `PersistNavigationWidth` flag's contract.
    ...persistNavigationWidth ? { storageKey: navigationResizeStorageKey } : {}
  });
  useEffect(() => {
    if (scrollResetKey === void 0) return;
    mainRef.current?.scrollTo(0, 0);
  }, [scrollResetKey]);
  const rootClass = mergeClasses(
    "ppp-page-layout-root",
    styles.root,
    isNested && styles.childRoot,
    resizable && styles.rootResizable,
    resizable && isResizing && styles.rootResizing,
    className
  );
  const headerClass = mergeClasses(
    styles.header,
    isNested && styles.childHeader,
    headerClassName
  );
  const navMaxWidthVar = maxNavigationWidth > 0 ? `${maxNavigationWidth}px` : "auto";
  const rootStyle = {
    ...style,
    "--ppp-nav-max-width": navMaxWidthVar,
    ...resizable ? { "--ppp-nav-width": `${navWidth}px` } : {}
  };
  return /* @__PURE__ */ jsx(PageLayoutNestingContext.Provider, { value: { isNested: true }, children: /* @__PURE__ */ jsxs("div", { className: rootClass, style: rootStyle, children: [
    header !== void 0 && headerVisible && /* @__PURE__ */ jsx(Header, { className: headerClass, ...headerStyle && { style: headerStyle }, children: header }),
    navigation !== void 0 && navigationVisible && /* @__PURE__ */ jsx(
      "nav",
      {
        className: mergeClasses(
          styles.navigation,
          resizable && styles.navigationResizable,
          navigationClassName
        ),
        style: navigationStyle,
        children: navigation
      }
    ),
    body !== void 0 && /* @__PURE__ */ jsx(
      "main",
      {
        ref: mainRef,
        className: mergeClasses(styles.main, bodyClassName),
        style: bodyStyle,
        children: body
      }
    ),
    resizable && /* @__PURE__ */ jsx(
      "div",
      {
        role: "separator",
        "aria-orientation": "vertical",
        "aria-label": navigationResizeHandleLabel,
        className: mergeClasses(styles.resizeHandle, isResizing && styles.resizeHandleActive),
        ...handleProps
      }
    ),
    footer !== void 0 && footerVisible && /* @__PURE__ */ jsx(
      Footer,
      {
        className: mergeClasses(styles.footer, footerClassName),
        ...footerStyle && { style: footerStyle },
        children: footer
      }
    )
  ] }) });
}
var PPP_BODY_CLASS = "ppp-body";
var useBodyStyles = makeStyles({
  // Single source of truth for the framework's body-area visual
  // treatment. `.ppp-body` defines
  // only `padding: calc(--design-unit * 3px)` (12px on all sides) and
  // nothing else. The component is intentionally lightweight: no
  // background, no border, no flex — just inset padding so content
  // doesn't butt against parent edges. Consumers and parent layouts
  // own the surrounding visual treatment (Section's border / radius,
  // PageLayout's grid placement, etc.).
  // Token mapping:
  // 3*--design-unit (12px) → tokens.spacingHorizontalM (12px)
  root: {
    padding: tokens.spacingHorizontalM
  }
});
function Body({ children, className, style, ...rest }) {
  const styles = useBodyStyles();
  return /* @__PURE__ */ jsx(
    "main",
    {
      ...rest,
      className: mergeClasses(styles.root, PPP_BODY_CLASS, className),
      style,
      children
    }
  );
}
function RouterUnsavedChangesGuard() {
  const guard = useUnsavedChangesGuard();
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) => guard.isAnyDirty && currentLocation.pathname !== nextLocation.pathname
  );
  useEffect(() => {
    if (blocker.state !== "blocked") return;
    let cancelled = false;
    (async () => {
      const proceed = await guard.warn();
      if (cancelled) return;
      if (proceed) blocker.proceed();
      else blocker.reset();
    })();
    return () => {
      cancelled = true;
    };
  }, [blocker, guard]);
  return null;
}

// src/charts/palette.ts
function readVariable(name, scope) {
  const fromScope = window.getComputedStyle(scope).getPropertyValue(name).trim();
  if (fromScope.length > 0) return fromScope;
  const fromHtml = window.getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  if (fromHtml.length > 0) return fromHtml;
  return window.getComputedStyle(document.body).getPropertyValue(name).trim();
}
function pickFirst(scope, ...names) {
  for (const name of names) {
    const value = readVariable(name, scope);
    if (value && value.length > 0) {
      return value;
    }
  }
  return "";
}
function getChartPalette(scope) {
  const textColor = pickFirst(
    scope,
    "--colorNeutralForeground1",
    "--neutral-foreground-rest",
    "--neutral-foreground-1-rest"
  ) || "#666666";
  const gridColor = pickFirst(
    scope,
    "--colorNeutralStroke3",
    "--neutral-stroke-divider-rest",
    "--neutral-stroke-rest"
  ) || "rgba(128, 128, 128, 0.2)";
  const accentColor = pickFirst(
    scope,
    "--accent-fill-rest",
    "--colorBrandBackground",
    "--accent-foreground-rest"
  ) || "#0078d4";
  const seriesColors = [
    accentColor,
    "#d13438",
    // red
    "#107c10",
    // green
    "#ffb900",
    // yellow
    "#5c2d91",
    // purple
    "#008272",
    // teal
    "#d83b01",
    // orange
    "#e3008c",
    // pink / magenta
    "#4f6bed",
    // cornflower
    "#498205",
    // forest
    "#00cc6a",
    // seafoam
    "#7160e8",
    // lavender
    "#8e562e",
    // brown
    "#a4262c",
    // burgundy
    "#3a96dd",
    // lightBlue
    "#0099bc"
    // cyan
  ];
  return { textColor, gridColor, accentColor, seriesColors };
}
function toTranslucent(color, alpha) {
  if (!color || color.trim().length === 0) return color;
  const trimmed = color.trim();
  if (trimmed.startsWith("#") && trimmed.length === 7) {
    const r = parseInt(trimmed.slice(1, 3), 16);
    const g = parseInt(trimmed.slice(3, 5), 16);
    const b = parseInt(trimmed.slice(5, 7), 16);
    if (Number.isFinite(r) && Number.isFinite(g) && Number.isFinite(b)) {
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
  }
  const rgbMatch = trimmed.match(/^rgb\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)\s*\)$/i);
  if (rgbMatch) {
    return `rgba(${rgbMatch[1]}, ${rgbMatch[2]}, ${rgbMatch[3]}, ${alpha})`;
  }
  return trimmed;
}
function useFluentChartPalette(scopeRef) {
  const [palette, setPalette] = useState(null);
  useEffect(() => {
    let active = true;
    const readPalette = () => {
      if (!active) return;
      const scope = scopeRef.current;
      if (!scope) return;
      setPalette((prev) => {
        const next = getChartPalette(scope);
        if (prev && samePalette(prev, next)) return prev;
        return next;
      });
    };
    readPalette();
    const observer = new MutationObserver(readPalette);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class", "style"],
      subtree: true
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class", "style"]
    });
    return () => {
      active = false;
      observer.disconnect();
    };
  }, [scopeRef]);
  return palette;
}
function samePalette(a, b) {
  if (a.textColor !== b.textColor) return false;
  if (a.gridColor !== b.gridColor) return false;
  if (a.accentColor !== b.accentColor) return false;
  if (a.seriesColors.length !== b.seriesColors.length) return false;
  for (let i = 0; i < a.seriesColors.length; i++) {
    if (a.seriesColors[i] !== b.seriesColors[i]) return false;
  }
  return true;
}
var RADIAL_CHART_TYPES = /* @__PURE__ */ new Set([
  ChartType.Pie,
  ChartType.Doughnut,
  ChartType.PolarArea,
  ChartType.Radar,
  ChartType.Funnel
]);
var useStyles16 = makeStyles({
  // The wrapper uses Fluent design tokens directly so the rounded bordered
  // look picks up theme changes. `colorNeutralBackground1` (white in light,
  // grey[16] in dark) matches the Blazor FluentUIChart's
  // `--neutral-fill-layer-rest` surface, so the two stacks render an identical
  // white panel in light mode — the earlier `colorNeutralCardBackground` showed
  // a faint grey against the white page.
  border: {
    backgroundColor: tokens.colorNeutralBackground1,
    // `colorNeutralStroke1` (not the lighter Stroke2) so the outline carries the
    // same visible weight as the Blazor chart's `--neutral-stroke-rest` border —
    // Stroke2 reads a touch lighter than the Blazor outline side-by-side.
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusLarge,
    padding: tokens.spacingHorizontalM,
    boxSizing: "border-box",
    overflow: "hidden"
  }
});
function applyPaletteToDatasets(source, palette, chartType) {
  const seriesColors = palette.seriesColors.length > 0 ? palette.seriesColors : [palette.accentColor];
  const isRadial = RADIAL_CHART_TYPES.has(chartType);
  return source.map((original, i) => {
    const points = original.data ?? [];
    const label = original.label ?? "";
    if (isRadial) {
      const themedData = points.map((point, j) => {
        const color2 = seriesColors[j % seriesColors.length] ?? palette.accentColor;
        const p = point;
        return {
          ...point,
          backgroundColor: p.backgroundColor ?? toTranslucent(color2, 0.6),
          borderColor: p.borderColor ?? color2
        };
      });
      const dataset2 = {
        label,
        data: themedData,
        // Default to 1px border to match, whose
        // C# default is `BorderWidth = 1`. Chart.js treats undefined
        // as 0 — no border drawn — which made the React version look
        // borderless next to.
        borderWidth: original.borderWidth ?? 1
      };
      return dataset2;
    }
    const color = seriesColors[i % seriesColors.length] ?? palette.accentColor;
    const dataset = {
      label,
      data: points,
      backgroundColor: original.backgroundColor ?? toTranslucent(color, 0.5),
      borderColor: original.borderColor ?? color,
      // 1px default — see the radial
      // branch above for rationale.
      borderWidth: original.borderWidth ?? 1
    };
    return dataset;
  });
}
function FluentUIChartImpl(props, ref) {
  const {
    type = ChartType.Bar,
    labels,
    datasets,
    width,
    height = "400px",
    yAxisPrefix,
    yAxisSuffix,
    xAxisPrefix,
    xAxisSuffix,
    title,
    stacked,
    legendPosition,
    enableAnimation,
    orientation,
    showBorder = true,
    onElementClick
  } = props;
  const styles = useStyles16();
  const containerRef = useRef(null);
  const palette = useFluentChartPalette(containerRef);
  const themedDatasets = useMemo(() => {
    if (!palette) return datasets;
    return applyPaletteToDatasets(datasets, palette, type);
  }, [datasets, palette, type]);
  const theme = useMemo(() => {
    if (!palette) {
      return assembleTheme(
        void 0,
        yAxisPrefix,
        yAxisSuffix,
        xAxisPrefix,
        xAxisSuffix,
        title,
        stacked,
        legendPosition,
        enableAnimation,
        orientation
      );
    }
    return assembleTheme(
      palette,
      yAxisPrefix,
      yAxisSuffix,
      xAxisPrefix,
      xAxisSuffix,
      title,
      stacked,
      legendPosition,
      enableAnimation,
      orientation
    );
  }, [
    palette,
    yAxisPrefix,
    yAxisSuffix,
    xAxisPrefix,
    xAxisSuffix,
    title,
    stacked,
    legendPosition,
    enableAnimation,
    orientation
  ]);
  const innerRef = useRef(null);
  useImperativeHandle(
    ref,
    () => ({
      exportAsImage: () => innerRef.current?.exportAsImage() ?? null
    }),
    []
  );
  const chartProps = {
    type,
    labels,
    datasets: themedDatasets,
    height
  };
  if (width !== void 0) chartProps.width = width;
  if (theme !== void 0) chartProps.theme = theme;
  if (onElementClick !== void 0) chartProps.onElementClick = onElementClick;
  return /* @__PURE__ */ jsx("div", { ref: containerRef, className: mergeClasses("ppp-fluent-ui-chart", showBorder ? styles.border : void 0), children: /* @__PURE__ */ jsx(Chart, { ref: innerRef, ...chartProps }) });
}
var FluentUIChart = forwardRef(FluentUIChartImpl);
function assembleTheme(palette, yAxisPrefix, yAxisSuffix, xAxisPrefix, xAxisSuffix, title, stacked, legendPosition, enableAnimation, orientation) {
  const theme = {};
  if (palette?.textColor) theme.textColor = palette.textColor;
  if (palette?.gridColor) theme.gridColor = palette.gridColor;
  if (yAxisPrefix !== void 0) theme.yAxisPrefix = yAxisPrefix;
  if (yAxisSuffix !== void 0) theme.yAxisSuffix = yAxisSuffix;
  if (xAxisPrefix !== void 0) theme.xAxisPrefix = xAxisPrefix;
  if (xAxisSuffix !== void 0) theme.xAxisSuffix = xAxisSuffix;
  if (title !== void 0) theme.title = title;
  if (stacked !== void 0) theme.stacked = stacked;
  if (legendPosition !== void 0) theme.legendPosition = legendPosition;
  if (enableAnimation !== void 0) theme.enableAnimation = enableAnimation;
  if (orientation !== void 0) theme.indexAxis = toIndexAxis(orientation);
  return Object.keys(theme).length > 0 ? theme : void 0;
}
var useStyles17 = makeStyles({
  // Outer container — flex column so the view selector, message bar, and
  // chart fill share the caller's height budget.
  root: {
    position: "relative",
    display: "flex",
    flexDirection: "column"
  },
  toolbar: {
    position: "absolute",
    top: "4px",
    right: "4px",
    zIndex: 1,
    display: "flex",
    gap: "2px"
  },
  toolbarButton: {
    minWidth: "auto"
  },
  viewSelector: {
    marginBottom: tokens.spacingVerticalS,
    maxWidth: "300px",
    flex: "0 0 auto"
  },
  // `min-height: 0` + `grid-template-rows: 1fr` resolves the inner chart's
  // `height: 100%` against a definite size — required so the `ppp-chart-
  // fill` slot lays out correctly inside a flex column.
  chartFill: {
    flex: "1 1 auto",
    minHeight: 0,
    display: "grid",
    gridTemplateRows: "1fr"
  },
  empty: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: tokens.colorNeutralForeground3,
    fontStyle: "italic"
  },
  loadingOverlay: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.15)",
    zIndex: 2,
    pointerEvents: "all"
  }
});
var DataverseChart = forwardRef(
  function DataverseChart2(props, ref) {
    const {
      dataSource,
      aggregationIndex = 0,
      crossFilterMode = "highlight",
      type,
      width,
      height = "400px",
      yAxisPrefix,
      yAxisSuffix,
      xAxisPrefix,
      xAxisSuffix,
      title,
      stacked,
      legendPosition,
      enableAnimation,
      orientation,
      onElementClick,
      showRefreshButton = true,
      showExportButton = true,
      showBorder = true,
      viewIds,
      defaultViewId
    } = props;
    const chartSource = dataSource instanceof DataverseChartDataSource ? dataSource : void 0;
    const viewDs = dataSource instanceof DataverseChartDataSource ? void 0 : dataSource;
    const styles = useStyles17();
    const t = useT();
    const { ppp, viewMetadataCache } = usePowerPortalsPro();
    const [data, setData] = useState({ labels: [], datasets: [] });
    const [error, setError] = useState(null);
    const [initialLoading, setInitialLoading] = useState(true);
    const [refreshing, setRefreshing] = useState(false);
    const [selectedViewId, setSelectedViewId] = useState(
      defaultViewId ?? viewIds?.[0]
    );
    const [viewOptions, setViewOptions] = useState([]);
    const chartRef = useRef(null);
    const loadVersionRef = useRef(0);
    useEffect(() => {
      if (!chartSource) return;
      const viewToApply = defaultViewId ?? viewIds?.[0];
      if (viewToApply) {
        applyViewIdToSource(chartSource, viewToApply);
      }
    }, [chartSource]);
    const loadAsync = useCallback(
      async (signal) => {
        if (!chartSource) return;
        const version = ++loadVersionRef.current;
        try {
          const result = await chartSource.loadAsync(ppp, signal);
          if (version === loadVersionRef.current) {
            setData(result);
            setError(null);
          }
        } catch (e) {
          if (version === loadVersionRef.current) {
            setError(e instanceof Error ? e.message : String(e));
          }
        }
      },
      [chartSource, ppp]
    );
    useEffect(() => {
      const controller = new AbortController();
      let cancelled = false;
      (async () => {
        await loadAsync(controller.signal);
        if (!cancelled) {
          setInitialLoading(false);
        }
      })();
      return () => {
        cancelled = true;
        controller.abort();
      };
    }, [loadAsync]);
    useEffect(() => {
      if (!viewIds || viewIds.length === 0) {
        setViewOptions([]);
        return;
      }
      let cancelled = false;
      (async () => {
        const resolved = await Promise.all(
          viewIds.map(async (id) => {
            try {
              const view = await viewMetadataCache.getAsync(id);
              return { id, displayName: view?.displayName ?? view?.name ?? id };
            } catch {
              return { id, displayName: id };
            }
          })
        );
        if (!cancelled) setViewOptions(resolved);
      })();
      return () => {
        cancelled = true;
      };
    }, [viewIds, viewMetadataCache]);
    const handleRefresh = useCallback(async () => {
      if (viewDs) {
        await viewDs.refresh();
        return;
      }
      setRefreshing(true);
      try {
        await loadAsync();
      } finally {
        setRefreshing(false);
      }
    }, [viewDs, loadAsync]);
    const handleExport = useCallback(() => {
      const dataUri = chartRef.current?.exportAsImage();
      if (!dataUri) return;
      const link = document.createElement("a");
      link.href = dataUri;
      link.download = "chart.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }, []);
    const handleViewChange = useCallback(
      async (viewId) => {
        if (!chartSource) return;
        setSelectedViewId(viewId);
        applyViewIdToSource(chartSource, viewId);
        setRefreshing(true);
        try {
          await loadAsync();
        } finally {
          setRefreshing(false);
        }
      },
      [chartSource, loadAsync]
    );
    useImperativeHandle(
      ref,
      () => ({
        exportAsImage: () => chartRef.current?.exportAsImage() ?? null
      }),
      []
    );
    const effectiveData = viewDs ? viewDs.aggregationResults[aggregationIndex] ?? { labels: [], datasets: [] } : data;
    const labels = effectiveData.labels ?? [];
    const rawDatasets = effectiveData.datasets ?? [];
    const datasets = useMemo(() => {
      const highlight = viewDs?.highlight;
      const groupByColumn = viewDs?.aggregations[aggregationIndex]?.groupBy?.column;
      if (!highlight || !groupByColumn) return rawDatasets;
      return rawDatasets.map((dataset) => ({
        ...dataset,
        data: (dataset.data ?? []).map((point) => {
          const dvpt = point;
          const pointValue = readColumnRawValue(dvpt.record?.properties?.[groupByColumn]);
          if (pointValue === highlight.value) return point;
          return { ...point, backgroundColor: "rgba(160, 160, 160, 0.3)" };
        })
      }));
    }, [rawDatasets, viewDs?.highlight, viewDs?.aggregations, aggregationIndex]);
    const hasData = datasets.length > 0 && datasets.some((d) => (d.data?.length ?? 0) > 0);
    const handleElementClick = useCallback(
      (args) => {
        if (viewDs && crossFilterMode === "highlight") {
          const aggregation = viewDs.aggregations[aggregationIndex];
          const column = aggregation?.groupBy?.column;
          if (column) {
            const point = args.dataPoint;
            const rawValue = readColumnRawValue(point?.record?.properties?.[column]);
            if (rawValue !== void 0) {
              const current = viewDs.highlight;
              if (current && current.column === column && current.value === rawValue) {
                viewDs.setHighlight(void 0);
              } else {
                viewDs.setHighlight({ column, value: rawValue });
              }
            }
          }
        }
        onElementClick?.(args);
      },
      [viewDs, crossFilterMode, aggregationIndex, onElementClick]
    );
    const effectiveError = viewDs ? viewDs.error ? String(viewDs.error.message ?? viewDs.error) : null : error;
    const effectiveInitialLoading = viewDs ? viewDs.status === "loading" && viewDs.aggregationResults.length === 0 : initialLoading;
    const effectiveRefreshing = viewDs ? viewDs.isFetchingAggregations : refreshing;
    const rootStyle = {};
    if (width !== void 0) rootStyle.width = width;
    if (height !== void 0) rootStyle.height = height;
    const innerChartProps = {
      labels,
      datasets,
      width: "100%",
      height: "100%",
      showBorder
    };
    if (type !== void 0) innerChartProps.type = type;
    if (yAxisPrefix !== void 0) innerChartProps.yAxisPrefix = yAxisPrefix;
    if (yAxisSuffix !== void 0) innerChartProps.yAxisSuffix = yAxisSuffix;
    if (xAxisPrefix !== void 0) innerChartProps.xAxisPrefix = xAxisPrefix;
    if (xAxisSuffix !== void 0) innerChartProps.xAxisSuffix = xAxisSuffix;
    if (title !== void 0) innerChartProps.title = title;
    if (stacked !== void 0) innerChartProps.stacked = stacked;
    if (legendPosition !== void 0) innerChartProps.legendPosition = legendPosition;
    if (enableAnimation !== void 0) innerChartProps.enableAnimation = enableAnimation;
    if (orientation !== void 0) innerChartProps.orientation = orientation;
    innerChartProps.onElementClick = handleElementClick;
    return /* @__PURE__ */ jsxs("div", { className: mergeClasses("ppp-dataverse-chart", styles.root), style: rootStyle, children: [
      effectiveError && !effectiveInitialLoading && /* @__PURE__ */ jsx(MessageBar, { intent: "error", children: /* @__PURE__ */ jsx(MessageBarBody, { children: effectiveError }) }),
      (showExportButton || showRefreshButton) && /* @__PURE__ */ jsxs("div", { className: styles.toolbar, children: [
        showExportButton && /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "subtle",
            icon: /* @__PURE__ */ jsx(ArrowDownload24Regular, {}),
            title: t("app.components.chart.download-image-tooltip"),
            onClick: handleExport,
            className: styles.toolbarButton
          }
        ),
        showRefreshButton && /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "subtle",
            icon: /* @__PURE__ */ jsx(ArrowClockwise24Regular, {}),
            title: t("app.components.chart.refresh-data-tooltip"),
            disabled: effectiveRefreshing,
            onClick: () => void handleRefresh(),
            className: styles.toolbarButton
          }
        )
      ] }),
      viewOptions.length > 0 && /* @__PURE__ */ jsx("div", { className: styles.viewSelector, children: /* @__PURE__ */ jsx(
        Dropdown,
        {
          value: viewOptions.find((v) => v.id === selectedViewId)?.displayName ?? "",
          selectedOptions: selectedViewId ? [selectedViewId] : [],
          onOptionSelect: (_e, option) => {
            if (option.optionValue) void handleViewChange(option.optionValue);
          },
          children: viewOptions.map((v) => /* @__PURE__ */ jsx(Option, { value: v.id, children: v.displayName }, v.id))
        }
      ) }),
      /* @__PURE__ */ jsx("div", { className: styles.chartFill, children: hasData ? /* @__PURE__ */ jsx(FluentUIChart, { ref: chartRef, ...innerChartProps }) : !effectiveInitialLoading && effectiveError === null ? /* @__PURE__ */ jsx("div", { className: styles.empty, children: t("app.components.chart.no-data") }) : null }),
      (effectiveInitialLoading || effectiveRefreshing) && /* @__PURE__ */ jsx("div", { className: styles.loadingOverlay, children: /* @__PURE__ */ jsx(Spinner, {}) })
    ] });
  }
);
function applyViewIdToSource(source, viewId) {
  if (source instanceof AggregateDataverseChartDataSource) {
    source.viewId = viewId;
  } else if (source instanceof ViewDataverseChartDataSource) {
    source.viewId = viewId;
  }
}

// src/index.ts
var VERSION = "0.1.0";

export { Body, BoolEdit, BoolEditorType, CacheAdmin, ChoiceEdit, ChoiceEditorType, ChoiceInvalidValueBehavior, ChoiceOrientation, ChoiceValueSort, ColumnDisplayValue, ColumnEdit, DataverseChart, DateTimeEdit, DateTimeEditorType, DeleteContextButton, DeleteRecordGridButton, DescriptionLocation, FileEdit, FileGrid, FileViewer, FluentDialogProvider, FluentOverlayProvider, FluentOverlayTarget, FluentUIChart, Footer, GridButton, GridButtonBehavior, GridButtonRole, GridButtons, GridColumn, GridColumns, GridTemplateColumn, Header, Highlighter, ImageEdit, ImageViewer, LabelPosition, LanguageDropdown, LinkExistingRecordGridButton, LocalizationAdmin, LocalizationBoundary, LocalizationTranslator, LogoutButton, LookupDialog, LookupEdit, LookupEditorType, LookupForm, MainGrid, ManyToManyLookupEdit, ManyToManyLookupEditorType, MaskedTextField, MemoEdit, MenuBar, MoneyEdit, MultiSelectChoiceEdit, NavGroup, NavItem, NavMenu, NavigateNewRecordGridButton, NavigateOpenRecordGridButton, NavigateRecordGridButton, NewRecordGridButton, NumberEdit, OFFICE_ACCENT_DEFINITIONS, OFFICE_ACCENT_HEX_TO_NAME, OFFICE_ACCENT_THEMES, OFFICE_COLOR_NAME_TO_ACCENT, OpenRecordGridButton, PageLayout, PagingMode, PowerPortalsProThemeProvider, ProfileMainMenu, RefreshContextButton, RefreshGridButton, RouterUnsavedChangesGuard, SaveContextButton, Section, SectionColumn, SectionColumnOrientation, SiteSettingsButton, SiteSettingsPanel, SubGrid, TextDirection, TextEdit, ThemeColorSelector, ThemeMode, ThemeSelector, ThemeTextDirection, UnlinkExistingRecordGridButton, VERSION, ValidationSummary, ViewSort, WizardRecordForm, WizardRecordPage, evaluateGridButtonBehavior, findFirstButtonOfRole, getCellRenderer, getChartPalette, getChoiceMetadata, getDisplayDescription, getDisplayLabel, getEditComponentForMetadata, getEditComponentForType, getGridButtonRoleFromElement, getLookupMetadata, getNumberLimits, getRendererTypeForMetadata, getStringMaxLength, isColumnSortable, isMetadataReadOnly, isMetadataRequired, isNewRecord, officeColorValueToAccentName, resolveColumnDisplayValue, setGridButtonRole, splitHighlightSegments, toTranslucent, useBoolColumn, useChoiceColumn, useDateColumn, useFileColumn, useFluentChartPalette, useGridContext, useLookupColumn, useMoneyColumn, useMultiSelectChoiceColumn, useNumberColumn, useStringColumn, useTheme };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map